function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8e22"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8e22"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $jN4Ph = parcelRequire("jN4Ph");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $jN4Ph.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $jN4Ph.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $jN4Ph.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $jN4Ph.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $jN4Ph.unstable_now, $0b2e6adb871a3b94$var$ec = $jN4Ph.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $jN4Ph.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $jN4Ph.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $jN4Ph.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $jN4Ph.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $jN4Ph.unstable_scheduleCallback($jN4Ph.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("jN4Ph", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2ZUhe"));

});
parcelRequire.register("2ZUhe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $22eceeba251b2de5$export$c4744153514ff05d, (v) => $22eceeba251b2de5$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $22eceeba251b2de5$export$3e506c1ccc9cc1a7, (v) => $22eceeba251b2de5$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $22eceeba251b2de5$export$e26fe2ed2fa76875, (v) => $22eceeba251b2de5$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $22eceeba251b2de5$export$502329bbf4b505b1, (v) => $22eceeba251b2de5$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $22eceeba251b2de5$export$6e3807111c4874c4, (v) => $22eceeba251b2de5$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $22eceeba251b2de5$export$c27134553091fb3a, (v) => $22eceeba251b2de5$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $22eceeba251b2de5$export$33ee1acdc04fd2a2, (v) => $22eceeba251b2de5$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $22eceeba251b2de5$export$b00a404bbd5edef2, (v) => $22eceeba251b2de5$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $22eceeba251b2de5$export$8352ce38b91d0c62, (v) => $22eceeba251b2de5$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $22eceeba251b2de5$export$d66a1c1c77bd778b, (v) => $22eceeba251b2de5$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $22eceeba251b2de5$export$d3dfb8e4810cb555, (v) => $22eceeba251b2de5$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $22eceeba251b2de5$export$839f9183b0465a69, (v) => $22eceeba251b2de5$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $22eceeba251b2de5$export$72fdf0e06517287b, (v) => $22eceeba251b2de5$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $22eceeba251b2de5$export$4b844e58a3e414b4, (v) => $22eceeba251b2de5$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $22eceeba251b2de5$export$816d2913ae6b83b1, (v) => $22eceeba251b2de5$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $22eceeba251b2de5$export$61bcfe829111a1d0, (v) => $22eceeba251b2de5$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $22eceeba251b2de5$export$7ee8c9beb337bc3f, (v) => $22eceeba251b2de5$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $22eceeba251b2de5$export$b5836b71941fa3ed, (v) => $22eceeba251b2de5$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $22eceeba251b2de5$export$cf845f2c119da08a, (v) => $22eceeba251b2de5$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22eceeba251b2de5$export$c4744153514ff05d;
var $22eceeba251b2de5$export$3e506c1ccc9cc1a7;
var $22eceeba251b2de5$export$e26fe2ed2fa76875;
var $22eceeba251b2de5$export$502329bbf4b505b1;
var $22eceeba251b2de5$export$6e3807111c4874c4;
var $22eceeba251b2de5$export$c27134553091fb3a;
var $22eceeba251b2de5$export$33ee1acdc04fd2a2;
var $22eceeba251b2de5$export$b00a404bbd5edef2;
var $22eceeba251b2de5$export$8352ce38b91d0c62;
var $22eceeba251b2de5$export$d66a1c1c77bd778b;
var $22eceeba251b2de5$export$d3dfb8e4810cb555;
var $22eceeba251b2de5$export$839f9183b0465a69;
var $22eceeba251b2de5$export$72fdf0e06517287b;
var $22eceeba251b2de5$export$4b844e58a3e414b4;
var $22eceeba251b2de5$export$816d2913ae6b83b1;
var $22eceeba251b2de5$export$61bcfe829111a1d0;
var $22eceeba251b2de5$export$7ee8c9beb337bc3f;
var $22eceeba251b2de5$export$b5836b71941fa3ed;
var $22eceeba251b2de5$export$cf845f2c119da08a;
"use strict";
function $22eceeba251b2de5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $22eceeba251b2de5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $22eceeba251b2de5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $22eceeba251b2de5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $22eceeba251b2de5$var$g(C, c)) n < e && 0 > $22eceeba251b2de5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $22eceeba251b2de5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $22eceeba251b2de5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $22eceeba251b2de5$var$l = performance;
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$l.now();
    };
} else {
    var $22eceeba251b2de5$var$p = Date, $22eceeba251b2de5$var$q = $22eceeba251b2de5$var$p.now();
    $22eceeba251b2de5$export$c4744153514ff05d = function() {
        return $22eceeba251b2de5$var$p.now() - $22eceeba251b2de5$var$q;
    };
}
var $22eceeba251b2de5$var$r = [], $22eceeba251b2de5$var$t = [], $22eceeba251b2de5$var$u = 1, $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = 3, $22eceeba251b2de5$var$z = !1, $22eceeba251b2de5$var$A = !1, $22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$D = "function" === typeof setTimeout ? setTimeout : null, $22eceeba251b2de5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $22eceeba251b2de5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $22eceeba251b2de5$var$G(a) {
    for(var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t); null !== b;){
        if (null === b.callback) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t);
        else if (b.startTime <= a) $22eceeba251b2de5$var$k($22eceeba251b2de5$var$t), b.sortIndex = b.expirationTime, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, b);
        else break;
        b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
    }
}
function $22eceeba251b2de5$var$H(a) {
    $22eceeba251b2de5$var$B = !1;
    $22eceeba251b2de5$var$G(a);
    if (!$22eceeba251b2de5$var$A) {
        if (null !== $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r)) $22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J);
        else {
            var b = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== b && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, b.startTime - a);
        }
    }
}
function $22eceeba251b2de5$var$J(a, b) {
    $22eceeba251b2de5$var$A = !1;
    $22eceeba251b2de5$var$B && ($22eceeba251b2de5$var$B = !1, $22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1);
    $22eceeba251b2de5$var$z = !0;
    var c = $22eceeba251b2de5$var$y;
    try {
        $22eceeba251b2de5$var$G(b);
        for($22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r); null !== $22eceeba251b2de5$var$v && (!($22eceeba251b2de5$var$v.expirationTime > b) || a && !$22eceeba251b2de5$var$M());){
            var d = $22eceeba251b2de5$var$v.callback;
            if ("function" === typeof d) {
                $22eceeba251b2de5$var$v.callback = null;
                $22eceeba251b2de5$var$y = $22eceeba251b2de5$var$v.priorityLevel;
                var e = d($22eceeba251b2de5$var$v.expirationTime <= b);
                b = $22eceeba251b2de5$export$c4744153514ff05d();
                "function" === typeof e ? $22eceeba251b2de5$var$v.callback = e : $22eceeba251b2de5$var$v === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
                $22eceeba251b2de5$var$G(b);
            } else $22eceeba251b2de5$var$k($22eceeba251b2de5$var$r);
            $22eceeba251b2de5$var$v = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
        }
        if (null !== $22eceeba251b2de5$var$v) var w = !0;
        else {
            var m = $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t);
            null !== m && $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $22eceeba251b2de5$var$v = null, $22eceeba251b2de5$var$y = c, $22eceeba251b2de5$var$z = !1;
    }
}
var $22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null, $22eceeba251b2de5$var$L = -1, $22eceeba251b2de5$var$P = 5, $22eceeba251b2de5$var$Q = -1;
function $22eceeba251b2de5$var$M() {
    return $22eceeba251b2de5$export$c4744153514ff05d() - $22eceeba251b2de5$var$Q < $22eceeba251b2de5$var$P ? !1 : !0;
}
function $22eceeba251b2de5$var$R() {
    if (null !== $22eceeba251b2de5$var$O) {
        var a = $22eceeba251b2de5$export$c4744153514ff05d();
        $22eceeba251b2de5$var$Q = a;
        var b = !0;
        try {
            b = $22eceeba251b2de5$var$O(!0, a);
        } finally{
            b ? $22eceeba251b2de5$var$S() : ($22eceeba251b2de5$var$N = !1, $22eceeba251b2de5$var$O = null);
        }
    } else $22eceeba251b2de5$var$N = !1;
}
var $22eceeba251b2de5$var$S;
if ("function" === typeof $22eceeba251b2de5$var$F) $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$F($22eceeba251b2de5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $22eceeba251b2de5$var$T = new MessageChannel, $22eceeba251b2de5$var$U = $22eceeba251b2de5$var$T.port2;
    $22eceeba251b2de5$var$T.port1.onmessage = $22eceeba251b2de5$var$R;
    $22eceeba251b2de5$var$S = function() {
        $22eceeba251b2de5$var$U.postMessage(null);
    };
} else $22eceeba251b2de5$var$S = function() {
    $22eceeba251b2de5$var$D($22eceeba251b2de5$var$R, 0);
};
function $22eceeba251b2de5$var$I(a) {
    $22eceeba251b2de5$var$O = a;
    $22eceeba251b2de5$var$N || ($22eceeba251b2de5$var$N = !0, $22eceeba251b2de5$var$S());
}
function $22eceeba251b2de5$var$K(a, b) {
    $22eceeba251b2de5$var$L = $22eceeba251b2de5$var$D(function() {
        a($22eceeba251b2de5$export$c4744153514ff05d());
    }, b);
}
$22eceeba251b2de5$export$3e506c1ccc9cc1a7 = 5;
$22eceeba251b2de5$export$e26fe2ed2fa76875 = 1;
$22eceeba251b2de5$export$502329bbf4b505b1 = 4;
$22eceeba251b2de5$export$6e3807111c4874c4 = 3;
$22eceeba251b2de5$export$c27134553091fb3a = null;
$22eceeba251b2de5$export$33ee1acdc04fd2a2 = 2;
$22eceeba251b2de5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$22eceeba251b2de5$export$8352ce38b91d0c62 = function() {
    $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J));
};
$22eceeba251b2de5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $22eceeba251b2de5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$22eceeba251b2de5$export$d3dfb8e4810cb555 = function() {
    return $22eceeba251b2de5$var$y;
};
$22eceeba251b2de5$export$839f9183b0465a69 = function() {
    return $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r);
};
$22eceeba251b2de5$export$72fdf0e06517287b = function(a) {
    switch($22eceeba251b2de5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $22eceeba251b2de5$var$y;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = b;
    try {
        return a();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$4b844e58a3e414b4 = function() {};
$22eceeba251b2de5$export$816d2913ae6b83b1 = function() {};
$22eceeba251b2de5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $22eceeba251b2de5$var$y;
    $22eceeba251b2de5$var$y = a;
    try {
        return b();
    } finally{
        $22eceeba251b2de5$var$y = c;
    }
};
$22eceeba251b2de5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $22eceeba251b2de5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $22eceeba251b2de5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$t, a), null === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$r) && a === $22eceeba251b2de5$var$h($22eceeba251b2de5$var$t) && ($22eceeba251b2de5$var$B ? ($22eceeba251b2de5$var$E($22eceeba251b2de5$var$L), $22eceeba251b2de5$var$L = -1) : $22eceeba251b2de5$var$B = !0, $22eceeba251b2de5$var$K($22eceeba251b2de5$var$H, c - d))) : (a.sortIndex = e, $22eceeba251b2de5$var$f($22eceeba251b2de5$var$r, a), $22eceeba251b2de5$var$A || $22eceeba251b2de5$var$z || ($22eceeba251b2de5$var$A = !0, $22eceeba251b2de5$var$I($22eceeba251b2de5$var$J)));
    return a;
};
$22eceeba251b2de5$export$b5836b71941fa3ed = $22eceeba251b2de5$var$M;
$22eceeba251b2de5$export$cf845f2c119da08a = function(a) {
    var b = $22eceeba251b2de5$var$y;
    return function() {
        var c = $22eceeba251b2de5$var$y;
        $22eceeba251b2de5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $22eceeba251b2de5$var$y = c;
        }
    };
};

});



parcelRequire.register("02ePV", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $006bb2427792c9b9$export$816aac48d41c2f81, (v) => $006bb2427792c9b9$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $006bb2427792c9b9$export$3bb88615cd12cb3b, (v) => $006bb2427792c9b9$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $006bb2427792c9b9$export$d46163d5c045f347, (v) => $006bb2427792c9b9$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $006bb2427792c9b9$export$8ee75c97f0333f15, (v) => $006bb2427792c9b9$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $006bb2427792c9b9$export$d1c113b83e1f881a, (v) => $006bb2427792c9b9$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $006bb2427792c9b9$export$ff78c4883554845d, (v) => $006bb2427792c9b9$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $006bb2427792c9b9$export$816aac48d41c2f81;
var $006bb2427792c9b9$export$3bb88615cd12cb3b;
var $006bb2427792c9b9$export$d46163d5c045f347;
var $006bb2427792c9b9$export$8ee75c97f0333f15;
var $006bb2427792c9b9$export$d1c113b83e1f881a;
var $006bb2427792c9b9$export$ff78c4883554845d;
"use strict";
$006bb2427792c9b9$export$816aac48d41c2f81 = 1;
$006bb2427792c9b9$export$3bb88615cd12cb3b = 4;
$006bb2427792c9b9$export$d46163d5c045f347 = 16;
$006bb2427792c9b9$export$8ee75c97f0333f15 = 1;
$006bb2427792c9b9$export$d1c113b83e1f881a = 536870912;
$006bb2427792c9b9$export$ff78c4883554845d = 0;

});

parcelRequire.register("8RuUj", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    "use strict";
    var aa = (parcelRequire("acw62")), ba = (parcelRequire("fO90s")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var sa = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var ta = Symbol.iterator;
    function ua(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ta && a[ta] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function va(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ia:
                return "Fragment";
            case ha:
                return "Portal";
            case ka:
                return "Profiler";
            case ja:
                return "StrictMode";
            case oa:
                return "Suspense";
            case pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ma:
                return (a.displayName || "Context") + ".Consumer";
            case la:
                return (a._context.displayName || "Context") + ".Provider";
            case na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case qa:
                return b = a.displayName || null, null !== b ? b : va(a.type) || "Memo";
            case ra:
                b = a._payload;
                a = a._init;
                try {
                    return va(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return va(b);
            case 8:
                return b === ja ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function ya(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function za(a) {
        if (ya(a) !== a) throw Error(n(188));
    }
    function Aa(a) {
        var b = a.alternate;
        if (!b) {
            b = ya(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return za(e), a;
                    if (f === d) return za(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Ba(a) {
        a = Aa(a);
        return null !== a ? Ca(a) : null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ca(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Da(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Da(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a) {
        if (void 0 === $b) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            $b = b && b[1] || "";
        }
        return "\n" + $b + a;
    }
    var bc = !1;
    function cc(a, b) {
        if (!a || bc) return "";
        bc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            bc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? ac(a) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a) {
        return {
            current: a
        };
    }
    function x(a) {
        0 > fc || (a.current = ec[fc], ec[fc] = null, fc--);
    }
    function y(a, b) {
        fc++;
        ec[fc] = a.current;
        a.current = b;
    }
    var hc = {}, A = gc(hc), B = gc(!1), ic = hc;
    function jc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return hc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function kc() {
        x(B);
        x(A);
    }
    function lc(a, b, c) {
        if (A.current !== hc) throw Error(n(168));
        y(A, b);
        y(B, c);
    }
    function mc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, xa(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function nc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || hc;
        ic = A.current;
        y(A, a);
        y(B, B.current);
        return !0;
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = mc(a, b, ic), d.__reactInternalMemoizedMergedChildContext = a, x(B), x(A), y(A, a)) : x(B);
        y(B, c);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (rc(a) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function wc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = vc(h) : (f &= g, 0 !== f && (d = vc(f)));
        } else g = c & ~e, 0 !== g ? d = vc(g) : 0 !== f && (d = vc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - qc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function xc(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - qc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = xc(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function zc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Bc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - qc(b);
        a[b] = c;
    }
    function Cc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - qc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Dc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - qc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var D = 0;
    function Ec(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a) {
        if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
            Oc.onCommitFiberRoot(Nc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Qc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = !1, Uc = !1;
    function Vc(a) {
        null === Sc ? Sc = [
            a
        ] : Sc.push(a);
    }
    function Wc(a) {
        Tc = !0;
        Vc(a);
    }
    function Xc() {
        if (!Uc && null !== Sc) {
            Uc = !0;
            var a = 0, b = D;
            try {
                var c = Sc;
                for(D = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Sc = null;
                Tc = !1;
            } catch (e) {
                throw null !== Sc && (Sc = Sc.slice(a + 1)), Fc(Jc, Xc), e;
            } finally{
                D = b, Uc = !1;
            }
        }
        return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a, b) {
        if (Rc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!dc.call(b, e) || !Rc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function $c(a) {
        switch(a.tag){
            case 5:
                return ac(a.type);
            case 16:
                return ac("Lazy");
            case 13:
                return ac("Suspense");
            case 19:
                return ac("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = cc(a.type, !1), a;
            case 11:
                return a = cc(a.type.render, !1), a;
            case 1:
                return a = cc(a.type, !0), a;
            default:
                return "";
        }
    }
    function ad(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd() {
        ed = dd = cd = null;
    }
    function gd(a, b, c) {
        Ta ? (y(bd, b._currentValue), b._currentValue = c) : (y(bd, b._currentValue2), b._currentValue2 = c);
    }
    function hd(a) {
        var b = bd.current;
        x(bd);
        Ta ? a._currentValue = b : a._currentValue2 = b;
    }
    function id(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function jd(a, b) {
        cd = a;
        ed = dd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (kd = !0), a.firstContext = null);
    }
    function ld(a) {
        var b = Ta ? a._currentValue : a._currentValue2;
        if (ed !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === dd) {
                if (null === cd) throw Error(n(308));
                dd = a;
                cd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else dd = dd.next = a;
        }
        return b;
    }
    var md = null, nd = !1;
    function od(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function pd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function qd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function rd(a, b) {
        var c = a.updateQueue;
        null !== c && (c = c.shared, null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === md ? md = [
            c
        ] : md.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
    }
    function sd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    function td(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ud(a, b, c, d) {
        var e = a.updateQueue;
        nd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var v = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var r = h.lane, z = h.eventTime;
                if ((d & r) === r) {
                    null !== m && (m = m.next = {
                        eventTime: z,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var q = a, N = h;
                        r = b;
                        z = c;
                        switch(N.tag){
                            case 1:
                                q = N.payload;
                                if ("function" === typeof q) {
                                    v = q.call(z, v, r);
                                    break a;
                                }
                                v = q;
                                break a;
                            case 3:
                                q.flags = q.flags & -65537 | 128;
                            case 0:
                                q = N.payload;
                                r = "function" === typeof q ? q.call(z, v, r) : q;
                                if (null === r || void 0 === r) break a;
                                v = ca({}, v, r);
                                break a;
                            case 2:
                                nd = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                        h
                    ] : r.push(h));
                } else z = {
                    eventTime: z,
                    lane: r,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = z, k = v) : m = m.next = z, g |= r;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = v);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            vd |= g;
            a.lanes = g;
            a.memoizedState = v;
        }
    }
    function wd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var xd = (new aa.Component).refs;
    function yd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var Bd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? ya(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = H(), d = zd(a), e = qd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            rd(a, e);
            b = Ad(a, d, c);
            null !== b && sd(b, a, d);
        }
    };
    function Cd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Zc(c, d) || !Zc(e, f) : !0;
    }
    function Dd(a, b, c) {
        var d = !1, e = hc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = ld(f) : (e = C(b) ? ic : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? jc(a, e) : hc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Bd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Ed(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Bd.enqueueReplaceState(b, b.state, null);
    }
    function Fd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = xd;
        od(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = ld(f) : (f = C(b) ? ic : A.current, e.context = jc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Bd.enqueueReplaceState(e, e.state, null), ud(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a, b) {
        Gd[Hd++] = Jd;
        Gd[Hd++] = Id;
        Id = a;
        Jd = b;
    }
    function Qd(a, b, c) {
        Kd[Ld++] = Nd;
        Kd[Ld++] = Od;
        Kd[Ld++] = Md;
        Md = a;
        var d = Nd;
        a = Od;
        var e = 32 - qc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - qc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            Nd = 1 << 32 - qc(b) + e | c << e | d;
            Od = f + a;
        } else Nd = 1 << f | c << e | d, Od = a;
    }
    function Rd(a) {
        null !== a.return && (Pd(a, 1), Qd(a, 1, 0));
    }
    function Sd(a) {
        for(; a === Id;)Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
        for(; a === Md;)Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I = !1, Vd = !1, Wd = null;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = Mb(b), !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = null, !0) : !1;
            case 13:
                b = Hb(b);
                if (null !== b) {
                    var c = null !== Md ? {
                        id: Nd,
                        overflow: Od
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = Yd(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    Td = a;
                    Ud = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function ae(a) {
        if (I) {
            var b = Ud;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    if ($d(a)) throw Error(n(418));
                    b = Lb(c);
                    var d = Td;
                    b && Zd(a, b) ? Xd(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, Td = a);
                }
            } else {
                if ($d(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                I = !1;
                Td = a;
            }
        }
    }
    function be(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Td = a;
    }
    function ce(a) {
        if (!p || a !== Td) return !1;
        if (!I) return be(a), I = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Xb(a.type) && !Oa(a.type, a.memoizedProps))) {
            var b = Ud;
            if (b) {
                if ($d(a)) {
                    for(a = Ud; a;)a = Lb(a);
                    throw Error(n(418));
                }
                for(; b;)Xd(a, b), b = Lb(b);
            }
        }
        be(a);
        if (13 === a.tag) {
            if (!p) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            Ud = Sb(a);
        } else Ud = Td ? Lb(a.stateNode) : null;
        return !0;
    }
    function de() {
        p && (Ud = Td = null, Vd = I = !1);
    }
    function ee(a) {
        null === Wd ? Wd = [
            a
        ] : Wd.push(a);
    }
    function fe(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === xd && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function ge(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function he(a) {
        var b = a._init;
        return b(a._payload);
    }
    function ie(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = je(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = ke(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ia) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === ra && he(f) === b.type)) return d = e(b, c.props), d.ref = fe(a, b, c), d.return = a, d;
            d = le(c.type, c.key, c.props, null, a.mode, d);
            d.ref = fe(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = me(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ne(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function v(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = ke("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case fa:
                        return c = le(b.type, b.key, b.props, null, a.mode, c), c.ref = fe(a, null, b), c.return = a, c;
                    case ha:
                        return b = me(b, a.mode, c), b.return = a, b;
                    case ra:
                        var d = b._init;
                        return v(a, d(b._payload), c);
                }
                if (Ea(b) || ua(b)) return b = ne(b, a.mode, c, null), b.return = a, b;
                ge(a, b);
            }
            return null;
        }
        function r(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case fa:
                        return c.key === e ? k(a, b, c, d) : null;
                    case ha:
                        return c.key === e ? l(a, b, c, d) : null;
                    case ra:
                        return e = c._init, r(a, b, e(c._payload), d);
                }
                if (Ea(c) || ua(c)) return null !== e ? null : m(a, b, c, d, null);
                ge(a, c);
            }
            return null;
        }
        function z(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case ha:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case ra:
                        var f = d._init;
                        return z(a, b, c, f(d._payload), e);
                }
                if (Ea(d) || ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                ge(b, d);
            }
            return null;
        }
        function q(e, g, h, k) {
            for(var l = null, m = null, w = g, u = g = 0, t = null; null !== w && u < h.length; u++){
                w.index > u ? (t = w, w = null) : t = w.sibling;
                var q = r(e, w, h[u], k);
                if (null === q) {
                    null === w && (w = t);
                    break;
                }
                a && w && null === q.alternate && b(e, w);
                g = f(q, g, u);
                null === m ? l = q : m.sibling = q;
                m = q;
                w = t;
            }
            if (u === h.length) return c(e, w), I && Pd(e, u), l;
            if (null === w) {
                for(; u < h.length; u++)w = v(e, h[u], k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
                I && Pd(e, u);
                return l;
            }
            for(w = d(e, w); u < h.length; u++)t = z(w, e, u, h[u], k), null !== t && (a && null !== t.alternate && w.delete(null === t.key ? u : t.key), g = f(t, g, u), null === m ? l = t : m.sibling = t, m = t);
            a && w.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function N(e, g, h, k) {
            var l = ua(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var w = l = null, m = g, u = g = 0, q = null, t = h.next(); null !== m && !t.done; u++, t = h.next()){
                m.index > u ? (q = m, m = null) : q = m.sibling;
                var V = r(e, m, t.value, k);
                if (null === V) {
                    null === m && (m = q);
                    break;
                }
                a && m && null === V.alternate && b(e, m);
                g = f(V, g, u);
                null === w ? l = V : w.sibling = V;
                w = V;
                m = q;
            }
            if (t.done) return c(e, m), I && Pd(e, u), l;
            if (null === m) {
                for(; !t.done; u++, t = h.next())t = v(e, t.value, k), null !== t && (g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
                I && Pd(e, u);
                return l;
            }
            for(m = d(e, m); !t.done; u++, t = h.next())t = z(m, e, u, t.value, k), null !== t && (a && null !== t.alternate && m.delete(null === t.key ? u : t.key), g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function da(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ia && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case fa:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ia) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === ra && he(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = fe(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ia ? (d = ne(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = le(f.type, f.key, f.props, null, a.mode, h), h.ref = fe(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case ha:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = me(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case ra:
                        return l = f._init, da(a, d, l(f._payload), h);
                }
                if (Ea(f)) return q(a, d, f, h);
                if (ua(f)) return N(a, d, f, h);
                ge(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = ke(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return da;
    }
    var oe = ie(!0), pe = ie(!1), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a) {
        if (a === qe) throw Error(n(174));
        return a;
    }
    function ve(a, b) {
        y(te, b);
        y(se, a);
        y(re, qe);
        a = Ga(b);
        x(re);
        y(re, a);
    }
    function we() {
        x(re);
        x(se);
        x(te);
    }
    function xe(a) {
        var b = ue(te.current), c = ue(re.current);
        b = Ha(c, a.type, b);
        c !== b && (y(se, a), y(re, b));
    }
    function ye(a) {
        se.current === a && (x(re), x(se));
    }
    var J = gc(0);
    function ze(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Ib(c) || Jb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ae = [];
    function Be() {
        for(var a = 0; a < Ae.length; a++){
            var b = Ae[a];
            Ta ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K = null, L = null, M = null, Fe = !1, Ge = !1, He = 0, Ie = 0;
    function O() {
        throw Error(n(321));
    }
    function Je(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Rc(a[c], b[c])) return !1;
        return !0;
    }
    function Ke(a, b, c, d, e, f) {
        Ee = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Ce.current = null === a || null === a.memoizedState ? Le : Me;
        a = c(d, e);
        if (Ge) {
            f = 0;
            do {
                Ge = !1;
                He = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Ce.current = Ne;
                a = c(d, e);
            }while (Ge);
        }
        Ce.current = Oe;
        b = null !== L && null !== L.next;
        Ee = 0;
        M = L = K = null;
        Fe = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Pe() {
        var a = 0 !== He;
        He = 0;
        return a;
    }
    function Qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Re() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(n(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Te(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Ee & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var v = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = v, g = d) : k = k.next = v;
                    K.lanes |= m;
                    vd |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Rc(d, b.memoizedState) || (kd = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, vd |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Ue(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Rc(f, b.memoizedState) || (kd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Ve() {}
    function We(a, b) {
        var c = K, d = Re(), e = b(), f = !Rc(d.memoizedState, e);
        f && (d.memoizedState = e, kd = !0);
        d = d.queue;
        Xe(Ye.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            Ze(9, $e.bind(null, c, d, e, b), void 0, null);
            if (null === F) throw Error(n(349));
            0 !== (Ee & 30) || af(c, b, e);
        }
        return e;
    }
    function af(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function $e(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        bf(b) && Ad(a, 1, -1);
    }
    function Ye(a, b, c) {
        return c(function() {
            bf(b) && Ad(a, 1, -1);
        });
    }
    function bf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Rc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function cf(a) {
        var b = Qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Se,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = df.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ze(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function ef() {
        return Re().memoizedState;
    }
    function ff(a, b, c, d) {
        var e = Qe();
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function gf(a, b, c, d) {
        var e = Re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Je(d, g.deps)) {
                e.memoizedState = Ze(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, f, d);
    }
    function hf(a, b) {
        return ff(8390656, 8, a, b);
    }
    function Xe(a, b) {
        return gf(2048, 8, a, b);
    }
    function jf(a, b) {
        return gf(4, 2, a, b);
    }
    function kf(a, b) {
        return gf(4, 4, a, b);
    }
    function lf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function mf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return gf(4, 4, lf.bind(null, b, a), c);
    }
    function nf() {}
    function of(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function qf(a, b) {
        var c = D;
        D = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = De.transition;
        De.transition = {};
        try {
            a(!1), b();
        } finally{
            D = c, De.transition = d;
        }
    }
    function rf() {
        return Re().memoizedState;
    }
    function sf(a, b, c) {
        var d = zd(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        tf(a) ? uf(b, c) : (vf(a, b, c), c = H(), a = Ad(a, d, c), null !== a && wf(a, b, d));
    }
    function df(a, b, c) {
        var d = zd(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (tf(a)) uf(b, e);
        else {
            vf(a, b, e);
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Rc(h, g)) return;
            } catch (k) {} finally{}
            c = H();
            a = Ad(a, d, c);
            null !== a && wf(a, b, d);
        }
    }
    function tf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function uf(a, b) {
        Ge = Fe = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function vf(a, b, c) {
        null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === md ? md = [
            b
        ] : md.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    var Oe = {
        readContext: ld,
        useCallback: O,
        useContext: O,
        useEffect: O,
        useImperativeHandle: O,
        useInsertionEffect: O,
        useLayoutEffect: O,
        useMemo: O,
        useReducer: O,
        useRef: O,
        useState: O,
        useDebugValue: O,
        useDeferredValue: O,
        useTransition: O,
        useMutableSource: O,
        useSyncExternalStore: O,
        useId: O,
        unstable_isNewReconciler: !1
    }, Le = {
        readContext: ld,
        useCallback: function(a, b) {
            Qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: ld,
        useEffect: hf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ff(4194308, 4, lf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ff(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ff(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Qe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: cf,
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = cf(a), c = b[0], d = b[1];
            hf(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = cf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Qe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Qe();
            if (I) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === F) throw Error(n(349));
                0 !== (Ee & 30) || af(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            hf(Ye.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            Ze(9, $e.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Qe(), b = F.identifierPrefix;
            if (I) {
                var c = Od;
                var d = Nd;
                c = (d & ~(1 << 32 - qc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = He++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Ie++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Me = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Te,
        useRef: ef,
        useState: function() {
            return Te(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Te(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Te(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ne = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Ue,
        useRef: ef,
        useState: function() {
            return Ue(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Ue(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Ue(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        try {
            var c = "", d = b;
            do c += $c(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function yf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Bf || (Bf = !0, Cf = d);
            yf(a, b);
        };
        return c;
    }
    function Df(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                yf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            yf(a, b);
            "function" !== typeof d && (null === Ef ? Ef = new Set([
                this
            ]) : Ef.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Ff(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new zf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Gf.bind(null, a, b, c), b.then(a, a));
    }
    function Hf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function If(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = qd(-1, 1), b.tag = 2, rd(c, b))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    function Jf(a) {
        a.flags |= 4;
    }
    function Kf(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) La(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, Mf = function() {}, Nf = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = ue(re.current);
            c = Na(f, c, a, d, e, g);
            (b.updateQueue = c) && Jf(b);
        }
    }, Of = function(a, b, c, d) {
        c !== d && Jf(b);
    };
    else if (Va) {
        Lf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    La(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), La(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Lf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Pf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Pf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        Mf = function(a, b) {
            var c = b.stateNode;
            if (!Kf(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Pf(d, b, !1, !1);
                c.pendingChildren = d;
                Jf(b);
                Bb(a, d);
            }
        };
        Nf = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = Kf(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = ue(re.current), l = null;
                g !== d && (l = Na(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ma(f, c, d, e, k) && Jf(b), b.stateNode = f, a ? Jf(b) : Lf(f, b, !1, !1));
            }
        };
        Of = function(a, b, c, d) {
            c !== d ? (a = ue(te.current), c = ue(re.current), b.stateNode = Pa(d, a, c, b), Jf(b)) : b.stateNode = a.stateNode;
        };
    } else Mf = function() {}, Nf = function() {}, Of = function() {};
    function Qf(a, b) {
        if (!I) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function P(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Rf(a, b, c) {
        var d = b.pendingProps;
        Sd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return P(b), null;
            case 1:
                return C(b.type) && kc(), P(b), null;
            case 3:
                d = b.stateNode;
                we();
                x(B);
                x(A);
                Be();
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) ce(b) ? Jf(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
                Mf(a, b);
                P(b);
                return null;
            case 5:
                ye(b);
                c = ue(te.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) Nf(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        P(b);
                        return null;
                    }
                    a = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(175));
                        a = Pb(b.stateNode, b.type, b.memoizedProps, c, a, b, !Vd);
                        b.updateQueue = a;
                        null !== a && Jf(b);
                    } else {
                        var f = Ka(e, d, c, a, b);
                        Lf(f, b, !1, !1);
                        b.stateNode = f;
                        Ma(f, e, d, c, a) && Jf(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                P(b);
                return null;
            case 6:
                if (a && null != b.stateNode) Of(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = ue(te.current);
                    c = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(176));
                        a = b.stateNode;
                        d = b.memoizedProps;
                        if (c = Qb(a, d, b, !Vd)) {
                            if (e = Td, null !== e) switch(f = 0 !== (e.mode & 1), e.tag){
                                case 3:
                                    Yb(e.stateNode.containerInfo, a, d, f);
                                    break;
                                case 5:
                                    Zb(e.type, e.memoizedProps, e.stateNode, a, d, f);
                            }
                        }
                        c && Jf(b);
                    } else b.stateNode = Pa(d, a, c, b);
                }
                P(b);
                return null;
            case 13:
                x(J);
                d = b.memoizedState;
                if (I && null !== Ud && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                    for(a = Ud; a;)a = Lb(a);
                    de();
                    b.flags |= 98560;
                    return b;
                }
                if (null !== d && null !== d.dehydrated) {
                    d = ce(b);
                    if (null === a) {
                        if (!d) throw Error(n(318));
                        if (!p) throw Error(n(344));
                        a = b.memoizedState;
                        a = null !== a ? a.dehydrated : null;
                        if (!a) throw Error(n(317));
                        Rb(a, b);
                    } else de(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    P(b);
                    return null;
                }
                null !== Wd && (Sf(Wd), Wd = null);
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                d = null !== d;
                c = !1;
                null === a ? ce(b) : c = null !== a.memoizedState;
                d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === Q && (Q = 3) : Tf()));
                null !== b.updateQueue && (b.flags |= 4);
                P(b);
                return null;
            case 4:
                return we(), Mf(a, b), null === a && Xa(b.stateNode.containerInfo), P(b), null;
            case 10:
                return hd(b.type._context), P(b), null;
            case 17:
                return C(b.type) && kc(), P(b), null;
            case 19:
                x(J);
                e = b.memoizedState;
                if (null === e) return P(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Qf(e, !1);
                    else {
                        if (0 !== Q || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = ze(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Qf(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(d = b.child; null !== d;)c = d, e = a, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = e, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, e = f.dependencies, c.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), d = d.sibling;
                                y(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && E() > Uf && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = ze(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Qf(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !I) return P(b), null;
                        } else 2 * E() - e.renderingStartTime > Uf && 1073741824 !== c && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = E(), b.sibling = null, a = J.current, y(J, d ? a & 1 | 2 : a & 1), b;
                P(b);
                return null;
            case 22:
            case 23:
                return Vf(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Wf & 1073741824) && (P(b), Ua && b.subtreeFlags & 6 && (b.flags |= 8192)) : P(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = !1;
    function R(a, b, c, d) {
        b.child = null === a ? pe(b, null, c, d) : oe(b, a.child, c, d);
    }
    function Yf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        jd(b, e);
        d = Ke(a, b, c, d, f, e);
        c = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && c && Rd(b);
        b.flags |= 1;
        R(a, b, d, e);
        return b.child;
    }
    function $f(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !ag(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bg(a, b, f, d, e);
            a = le(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Zc;
            if (c(g, d) && a.ref === b.ref) return Zf(a, b, e);
        }
        b.flags |= 1;
        a = je(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function bg(a, b, c, d, e) {
        if (null !== a && Zc(a.memoizedProps, d) && a.ref === b.ref) {
            if (kd = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (kd = !0);
            else return b.lanes = a.lanes, Zf(a, b, e);
        }
        return cg(a, b, c, d, e);
    }
    function dg(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, y(eg, Wf), Wf |= c;
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, d = null !== f ? f.baseLanes : c, y(eg, Wf), Wf |= d;
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null
            }, b.updateQueue = null, y(eg, Wf), Wf |= a, null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, y(eg, Wf), Wf |= d;
        R(a, b, e, c);
        return b.child;
    }
    function fg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function cg(a, b, c, d, e) {
        var f = C(c) ? ic : A.current;
        f = jc(b, f);
        jd(b, e);
        c = Ke(a, b, c, d, f, e);
        d = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && d && Rd(b);
        b.flags |= 1;
        R(a, b, c, e);
        return b.child;
    }
    function gg(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            nc(b);
        } else f = !1;
        jd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Dd(b, c, d), Fd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = ld(l) : (l = C(c) ? ic : A.current, l = jc(b, l));
            var m = c.getDerivedStateFromProps, v = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            v || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ed(b, g, d, l);
            nd = !1;
            var r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            k = b.memoizedState;
            h !== d || r !== k || B.current || nd ? ("function" === typeof m && (yd(b, c, m, d), k = b.memoizedState), (h = nd || Cd(b, c, h, d, r, k, l)) ? (v || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            pd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : ad(b.type, h);
            g.props = l;
            v = b.pendingProps;
            r = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = ld(k) : (k = C(c) ? ic : A.current, k = jc(b, k));
            var z = c.getDerivedStateFromProps;
            (m = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== v || r !== k) && Ed(b, g, d, k);
            nd = !1;
            r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            var q = b.memoizedState;
            h !== v || r !== q || B.current || nd ? ("function" === typeof z && (yd(b, c, z, d), q = b.memoizedState), (l = nd || Cd(b, c, l, d, r, q, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, q, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, q, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = q), g.props = d, g.state = q, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return hg(a, b, c, d, f, e);
    }
    function hg(a, b, c, d, e, f) {
        fg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && oc(b, c, !1), Zf(a, b, f);
        d = b.stateNode;
        Xf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = oe(b, a.child, null, f), b.child = oe(b, null, h, f)) : R(a, b, h, f);
        b.memoizedState = d.state;
        e && oc(b, c, !0);
        return b.child;
    }
    function ig(a) {
        var b = a.stateNode;
        b.pendingContext ? lc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && lc(a, b.context, !1);
        ve(a, b.containerInfo);
    }
    function jg(a, b, c, d, e) {
        de();
        ee(e);
        b.flags |= 256;
        R(a, b, c, d);
        return b.child;
    }
    var kg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function lg(a) {
        return {
            baseLanes: a,
            cachePool: null
        };
    }
    function mg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        y(J, e & 1);
        if (null === a) {
            ae(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Jb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            e = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, e = {
                mode: "hidden",
                children: e
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = ng(e, d, 0, null), a = ne(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = lg(c), b.memoizedState = kg, a) : og(b, e);
        }
        e = a.memoizedState;
        if (null !== e) {
            h = e.dehydrated;
            if (null !== h) {
                if (g) {
                    if (b.flags & 256) return b.flags &= -257, pg(a, b, c, Error(n(422)));
                    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                    f = d.fallback;
                    e = b.mode;
                    d = ng({
                        mode: "visible",
                        children: d.children
                    }, e, 0, null);
                    f = ne(f, e, c, null);
                    f.flags |= 2;
                    d.return = b;
                    f.return = b;
                    d.sibling = f;
                    b.child = d;
                    0 !== (b.mode & 1) && oe(b, a.child, null, c);
                    b.child.memoizedState = lg(c);
                    b.memoizedState = kg;
                    return f;
                }
                if (0 === (b.mode & 1)) b = pg(a, b, c, null);
                else if (Jb(h)) b = pg(a, b, c, Error(n(419)));
                else if (d = 0 !== (c & a.childLanes), kd || d) {
                    d = F;
                    if (null !== d) {
                        switch(c & -c){
                            case 4:
                                f = 2;
                                break;
                            case 16:
                                f = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                f = 32;
                                break;
                            case 536870912:
                                f = 268435456;
                                break;
                            default:
                                f = 0;
                        }
                        d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                        0 !== d && d !== e.retryLane && (e.retryLane = d, Ad(a, d, -1));
                    }
                    Tf();
                    b = pg(a, b, c, Error(n(421)));
                } else Ib(h) ? (b.flags |= 128, b.child = a.child, b = qg.bind(null, a), Kb(h, b), b = null) : (c = e.treeContext, p && (Ud = Ob(h), Td = b, I = !0, Wd = null, Vd = !1, null !== c && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c.id, Od = c.overflow, Md = b)), b = og(b, b.pendingProps.children), b.flags |= 4096);
                return b;
            }
            if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
                baseLanes: e.baseLanes | c,
                cachePool: null
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
            c = sg(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
        c = sg(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function og(a, b) {
        b = ng({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function sg(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = je(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 1) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (d = b.deletions, null === d ? (b.deletions = [
            a
        ], b.flags |= 16) : d.push(a));
        return b.child = c;
    }
    function rg(a, b, c, d, e) {
        var f = b.mode;
        a = a.child;
        var g = a.sibling, h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = je(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
        null !== g ? d = je(g, d) : (d = ne(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function pg(a, b, c, d) {
        null !== d && ee(d);
        oe(b, a.child, null, c);
        a = og(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function tg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        id(a.return, b, c);
    }
    function ug(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function vg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        R(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && tg(a, c, b);
                else if (19 === a.tag) tg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        y(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ze(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                ug(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ze(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                ug(b, !0, c, null, f);
                break;
            case "together":
                ug(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Zf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        vd |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = je(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = je(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function wg(a, b, c) {
        switch(b.tag){
            case 3:
                ig(b);
                de();
                break;
            case 5:
                xe(b);
                break;
            case 1:
                C(b.type) && nc(b);
                break;
            case 4:
                ve(b, b.stateNode.containerInfo);
                break;
            case 10:
                gd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return y(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return mg(a, b, c);
                    y(J, J.current & 1);
                    a = Zf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                y(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return vg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                y(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, dg(a, b, c);
        }
        return Zf(a, b, c);
    }
    function xg(a, b) {
        Sd(b);
        switch(b.tag){
            case 1:
                return C(b.type) && kc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return we(), x(B), x(A), Be(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ye(b), null;
            case 13:
                x(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    de();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return x(J), null;
            case 4:
                return we(), null;
            case 10:
                return hd(b.type._context), null;
            case 22:
            case 23:
                return Vf(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var yg = !1, zg = !1, Ag = "function" === typeof WeakSet ? WeakSet : Set, S = null;
    function Bg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                T(a, b, d);
            }
            else c.current = null;
        }
    }
    function Cg(a, b, c) {
        try {
            c();
        } catch (d) {
            T(a, b, d);
        }
    }
    var Dg = !1;
    function Eg(a, b) {
        Ia(a.containerInfo);
        for(S = b; null !== S;)if (a = S, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, S = b;
        else for(; null !== S;){
            a = S;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : ad(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ua && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                T(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                S = b;
                break;
            }
            S = a.return;
        }
        c = Dg;
        Dg = !1;
        return c;
    }
    function Fg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Cg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Gg(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Hg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Fa(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Ig(a, b, c) {
        if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
            Oc.onCommitFiberUnmount(Nc, b);
        } catch (g) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a = a.next;
                    do {
                        var e = d, f = e.destroy;
                        e = e.tag;
                        void 0 !== f && (0 !== (e & 2) ? Cg(b, c, f) : 0 !== (e & 4) && Cg(b, c, f));
                        d = d.next;
                    }while (d !== a);
                }
                break;
            case 1:
                Bg(b, c);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (g) {
                    T(b, c, g);
                }
                break;
            case 5:
                Bg(b, c);
                break;
            case 4:
                Ua ? Jg(a, b, c) : Va && Va && (b = b.stateNode.containerInfo, c = zb(b), Cb(b, c));
        }
    }
    function Kg(a, b, c) {
        for(var d = b;;)if (Ig(a, d, c), null === d.child || Ua && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function Lg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Lg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Mg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Ng(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Mg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Og(a) {
        if (Ua) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Mg(b)) break a;
                    b = b.return;
                }
                throw Error(n(160));
            }
            var c = b;
            switch(c.tag){
                case 5:
                    b = c.stateNode;
                    c.flags & 32 && (sb(b), c.flags &= -33);
                    c = Ng(a);
                    Pg(a, c, b);
                    break;
                case 3:
                case 4:
                    b = c.stateNode.containerInfo;
                    c = Ng(a);
                    Qg(a, c, b);
                    break;
                default:
                    throw Error(n(161));
            }
        }
    }
    function Qg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Qg(a, b, c), a = a.sibling; null !== a;)Qg(a, b, c), a = a.sibling;
    }
    function Pg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Pg(a, b, c), a = a.sibling; null !== a;)Pg(a, b, c), a = a.sibling;
    }
    function Jg(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Kg(a, d, c), g ? rb(f, d.stateNode) : qb(f, d.stateNode);
            else if (18 === d.tag) g ? Wb(f, d.stateNode) : Vb(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ig(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function Rg(a, b) {
        if (Ua) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Fg(3, b, b.return);
                    Gg(3, b);
                    Fg(5, b, b.return);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                    return;
                case 12:
                    return;
                case 13:
                    Sg(b);
                    return;
                case 19:
                    Sg(b);
                    return;
                case 17:
                    return;
            }
            throw Error(n(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fg(3, b, b.return);
                Gg(3, b);
                Fg(5, b, b.return);
                return;
            case 12:
                return;
            case 13:
                Sg(b);
                return;
            case 19:
                Sg(b);
                return;
            case 3:
                p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                break;
            case 22:
            case 23:
                return;
        }
        a: if (Va) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(n(163));
        }
    }
    function Sg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ag);
            b.forEach(function(b) {
                var d = Tg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Ug(a, b) {
        for(S = b; null !== S;){
            b = S;
            var c = b.deletions;
            if (null !== c) for(var d = 0; d < c.length; d++){
                var e = c[d];
                try {
                    var f = a;
                    Ua ? Jg(f, e, b) : Kg(f, e, b);
                    var g = e.alternate;
                    null !== g && (g.return = null);
                    e.return = null;
                } catch (wa) {
                    T(e, b, wa);
                }
            }
            c = b.child;
            if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, S = c;
            else for(; null !== S;){
                b = S;
                try {
                    var h = b.flags;
                    h & 32 && Ua && sb(b.stateNode);
                    if (h & 512) {
                        var k = b.alternate;
                        if (null !== k) {
                            var l = k.ref;
                            null !== l && ("function" === typeof l ? l(null) : l.current = null);
                        }
                    }
                    if (h & 8192) switch(b.tag){
                        case 13:
                            if (null !== b.memoizedState) {
                                var m = b.alternate;
                                if (null === m || null === m.memoizedState) Vg = E();
                            }
                            break;
                        case 22:
                            var v = null !== b.memoizedState, r = b.alternate, z = null !== r && null !== r.memoizedState;
                            c = b;
                            if (Ua) {
                                a: if (d = c, e = v, f = null, Ua) for(var q = d;;){
                                    if (5 === q.tag) {
                                        if (null === f) {
                                            f = q;
                                            var N = q.stateNode;
                                            e ? tb(N) : vb(q.stateNode, q.memoizedProps);
                                        }
                                    } else if (6 === q.tag) {
                                        if (null === f) {
                                            var da = q.stateNode;
                                            e ? ub(da) : wb(da, q.memoizedProps);
                                        }
                                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === d) && null !== q.child) {
                                        q.child.return = q;
                                        q = q.child;
                                        continue;
                                    }
                                    if (q === d) break;
                                    for(; null === q.sibling;){
                                        if (null === q.return || q.return === d) break a;
                                        f === q && (f = null);
                                        q = q.return;
                                    }
                                    f === q && (f = null);
                                    q.sibling.return = q.return;
                                    q = q.sibling;
                                }
                            }
                            if (v && !z && 0 !== (c.mode & 1)) {
                                S = c;
                                for(var t = c.child; null !== t;){
                                    for(c = S = t; null !== S;){
                                        d = S;
                                        var w = d.child;
                                        switch(d.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Fg(4, d, d.return);
                                                break;
                                            case 1:
                                                Bg(d, d.return);
                                                var u = d.stateNode;
                                                if ("function" === typeof u.componentWillUnmount) {
                                                    var V = d.return;
                                                    try {
                                                        u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
                                                    } catch (wa) {
                                                        T(d, V, wa);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Bg(d, d.return);
                                                break;
                                            case 22:
                                                if (null !== d.memoizedState) {
                                                    Wg(c);
                                                    continue;
                                                }
                                        }
                                        null !== w ? (w.return = d, S = w) : Wg(c);
                                    }
                                    t = t.sibling;
                                }
                            }
                    }
                    switch(h & 4102){
                        case 2:
                            Og(b);
                            b.flags &= -3;
                            break;
                        case 6:
                            Og(b);
                            b.flags &= -3;
                            Rg(b.alternate, b);
                            break;
                        case 4096:
                            b.flags &= -4097;
                            break;
                        case 4100:
                            b.flags &= -4097;
                            Rg(b.alternate, b);
                            break;
                        case 4:
                            Rg(b.alternate, b);
                    }
                } catch (wa) {
                    T(b, b.return, wa);
                }
                c = b.sibling;
                if (null !== c) {
                    c.return = b.return;
                    S = c;
                    break;
                }
                S = b.return;
            }
        }
    }
    function Xg(a, b, c) {
        S = a;
        Yg(a, b, c);
    }
    function Yg(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== S;){
            var e = S, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || yg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || zg;
                    h = yg;
                    var l = zg;
                    yg = g;
                    if ((zg = k) && !l) for(S = e; null !== S;)g = S, k = g.child, 22 === g.tag && null !== g.memoizedState ? Zg(e) : null !== k ? (k.return = g, S = k) : Zg(e);
                    for(; null !== f;)S = f, Yg(f, b, c), f = f.sibling;
                    S = e;
                    yg = h;
                    zg = l;
                }
                $g(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, S = f) : $g(a, b, c);
        }
    }
    function $g(a) {
        for(; null !== S;){
            var b = S;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            zg || Gg(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !zg) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : ad(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && wd(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Fa(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                wd(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (p && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Ub(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    zg || b.flags & 512 && Hg(b);
                } catch (v) {
                    T(b, b.return, v);
                }
            }
            if (b === a) {
                S = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Wg(a) {
        for(; null !== S;){
            var b = S;
            if (b === a) {
                S = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Zg(a) {
        for(; null !== S;){
            var b = S;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Gg(4, b);
                        } catch (k) {
                            T(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                T(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, g, k);
                        }
                }
            } catch (k) {
                T(b, b.return, k);
            }
            if (b === a) {
                S = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                S = h;
                break;
            }
            S = b.return;
        }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var fh = Symbol.for;
        ah = fh("selector.component");
        bh = fh("selector.has_pseudo_class");
        ch = fh("selector.role");
        dh = fh("selector.test_id");
        eh = fh("selector.text");
    }
    function gh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function hh(a, b) {
        switch(b.$$typeof){
            case ah:
                if (a.type === b.value) return !0;
                break;
            case bh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && hh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case ch:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case eh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case dh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ih(a) {
        switch(a.$$typeof){
            case ah:
                return "<" + (va(a.value) || "Unknown") + ">";
            case bh:
                return ":has(" + (ih(a) || "") + ")";
            case ch:
                return '[role="' + a.value + '"]';
            case eh:
                return '"' + a.value + '"';
            case dh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function jh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && hh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function kh(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        a = jh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U = ea.ReactCurrentBatchConfig, G = 0, F = null, W = null, X = 0, Wf = 0, eg = gc(0), Q = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y = null, Vg = 0, Uf = Infinity;
    function sh() {
        Uf = E() + 500;
    }
    var Bf = !1, Cf = null, Ef = null, th = !1, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H() {
        return 0 !== (G & 6) ? E() : -1 !== yh ? yh : yh = E();
    }
    function zd(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (G & 2) && 0 !== X) return X & -X;
        if (null !== Yc.transition) return 0 === zh && (a = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a), zh;
        a = D;
        return 0 !== a ? a : Ya();
    }
    function Ad(a, b, c) {
        if (50 < wh) throw wh = 0, xh = null, Error(n(185));
        var d = Ah(a, b);
        if (null === d) return null;
        Bc(d, b, c);
        if (0 === (G & 2) || d !== F) d === F && (0 === (G & 2) && (ph |= b), 4 === Q && Bh(d, X)), Z(d, c), 1 === b && 0 === G && 0 === (a.mode & 1) && (sh(), Tc && Xc());
        return d;
    }
    function Ah(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        var c = a.callbackNode;
        yc(a, b);
        var d = wc(a, a === F ? X : 0);
        if (0 === d) null !== c && Gc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Gc(c);
            if (1 === b) 0 === a.tag ? Wc(Ch.bind(null, a)) : Vc(Ch.bind(null, a)), $a ? ab(function() {
                0 === G && Xc();
            }) : Fc(Jc, Xc), c = null;
            else {
                switch(Ec(d)){
                    case 1:
                        c = Jc;
                        break;
                    case 4:
                        c = Kc;
                        break;
                    case 16:
                        c = Lc;
                        break;
                    case 536870912:
                        c = Mc;
                        break;
                    default:
                        c = Lc;
                }
                c = Dh(c, Eh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Eh(a, b) {
        yh = -1;
        zh = 0;
        if (0 !== (G & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Fh() && a.callbackNode !== c) return null;
        var d = wc(a, a === F ? X : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Gh(a, d);
        else {
            b = d;
            var e = G;
            G |= 2;
            var f = Hh();
            if (F !== a || X !== b) sh(), Ih(a, b);
            for(;;)try {
                Jh();
                break;
            } catch (h) {
                Kh(a, h);
            }
            fd();
            mh.current = f;
            G = e;
            null !== W ? b = 0 : (F = null, X = 0, b = Q);
        }
        if (0 !== b) {
            2 === b && (e = zc(a), 0 !== e && (d = e, b = Lh(a, e)));
            if (1 === b) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
            if (6 === b) Bh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Mh(e) && (b = Gh(a, d), 2 === b && (f = zc(a), 0 !== f && (d = f, b = Lh(a, f))), 1 === b)) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Nh(a, Y);
                        break;
                    case 3:
                        Bh(a, d);
                        if ((d & 130023424) === d && (b = Vg + 500 - E(), 10 < b)) {
                            if (0 !== wc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                H();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), b);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 4:
                        Bh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - qc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = E() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), d);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 5:
                        Nh(a, Y);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Z(a, E());
        return a.callbackNode === c ? Eh.bind(null, a) : null;
    }
    function Lh(a, b) {
        var c = rh;
        a.current.memoizedState.isDehydrated && (Ih(a, b).flags |= 256);
        a = Gh(a, b);
        2 !== a && (b = Y, Y = c, null !== b && Sf(b));
        return a;
    }
    function Sf(a) {
        null === Y ? Y = a : Y.push.apply(Y, a);
    }
    function Mh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Rc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Bh(a, b) {
        b &= ~qh;
        b &= ~ph;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - qc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Ch(a) {
        if (0 !== (G & 6)) throw Error(n(327));
        Fh();
        var b = wc(a, 0);
        if (0 === (b & 1)) return Z(a, E()), null;
        var c = Gh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = zc(a);
            0 !== d && (b = d, c = Lh(a, d));
        }
        if (1 === c) throw c = oh, Ih(a, 0), Bh(a, b), Z(a, E()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Nh(a, Y);
        Z(a, E());
        return null;
    }
    function Oh(a) {
        null !== uh && 0 === uh.tag && 0 === (G & 6) && Fh();
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            if (U.transition = null, D = 1, a) return a();
        } finally{
            D = d, U.transition = c, G = b, 0 === (G & 6) && Xc();
        }
    }
    function Vf() {
        Wf = eg.current;
        x(eg);
    }
    function Ih(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Sa && (a.timeoutHandle = Sa, Ra(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            Sd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && kc();
                    break;
                case 3:
                    we();
                    x(B);
                    x(A);
                    Be();
                    break;
                case 5:
                    ye(d);
                    break;
                case 4:
                    we();
                    break;
                case 13:
                    x(J);
                    break;
                case 19:
                    x(J);
                    break;
                case 10:
                    hd(d.type._context);
                    break;
                case 22:
                case 23:
                    Vf();
            }
            c = c.return;
        }
        F = a;
        W = a = je(a.current, null);
        X = Wf = b;
        Q = 0;
        oh = null;
        qh = ph = vd = 0;
        Y = rh = null;
        if (null !== md) {
            for(b = 0; b < md.length; b++)if (c = md[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            md = null;
        }
        return a;
    }
    function Kh(a, b) {
        do {
            var c = W;
            try {
                fd();
                Ce.current = Oe;
                if (Fe) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Fe = !1;
                }
                Ee = 0;
                M = L = K = null;
                Ge = !1;
                He = 0;
                nh.current = null;
                if (null === c || null === c.return) {
                    Q = 1;
                    oh = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = X;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, v = m.tag;
                        if (0 === (m.mode & 1) && (0 === v || 11 === v || 15 === v)) {
                            var r = m.alternate;
                            r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var z = Hf(g);
                        if (null !== z) {
                            z.flags &= -257;
                            If(z, g, h, f, b);
                            z.mode & 1 && Ff(f, l, b);
                            b = z;
                            k = l;
                            var q = b.updateQueue;
                            if (null === q) {
                                var N = new Set;
                                N.add(k);
                                b.updateQueue = N;
                            } else q.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Ff(f, l, b);
                                Tf();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (I && h.mode & 1) {
                        var da = Hf(g);
                        if (null !== da) {
                            0 === (da.flags & 65536) && (da.flags |= 256);
                            If(da, g, h, f, b);
                            ee(k);
                            break a;
                        }
                    }
                    f = k;
                    4 !== Q && (Q = 2);
                    null === rh ? rh = [
                        f
                    ] : rh.push(f);
                    k = xf(k, h);
                    h = g;
                    do {
                        switch(h.tag){
                            case 3:
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var t = Af(h, k, b);
                                td(h, t);
                                break a;
                            case 1:
                                f = k;
                                var w = h.type, u = h.stateNode;
                                if (0 === (h.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ef || !Ef.has(u)))) {
                                    h.flags |= 65536;
                                    b &= -b;
                                    h.lanes |= b;
                                    var V = Df(h, f, b);
                                    td(h, V);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                Ph(c);
            } catch (wa) {
                b = wa;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Hh() {
        var a = mh.current;
        mh.current = Oe;
        return null === a ? Oe : a;
    }
    function Tf() {
        if (0 === Q || 3 === Q || 2 === Q) Q = 4;
        null === F || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F, X);
    }
    function Gh(a, b) {
        var c = G;
        G |= 2;
        var d = Hh();
        F === a && X === b || Ih(a, b);
        for(;;)try {
            Qh();
            break;
        } catch (e) {
            Kh(a, e);
        }
        fd();
        G = c;
        mh.current = d;
        if (null !== W) throw Error(n(261));
        F = null;
        X = 0;
        return Q;
    }
    function Qh() {
        for(; null !== W;)Rh(W);
    }
    function Jh() {
        for(; null !== W && !Hc();)Rh(W);
    }
    function Rh(a) {
        var b = Sh(a.alternate, a, Wf);
        a.memoizedProps = a.pendingProps;
        null === b ? Ph(a) : W = b;
        nh.current = null;
    }
    function Ph(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Rf(c, b, Wf), null !== c) {
                    W = c;
                    return;
                }
            } else {
                c = xg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    W = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    Q = 6;
                    W = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === Q && (Q = 5);
    }
    function Nh(a, b) {
        var c = D, d = U.transition;
        try {
            U.transition = null, D = 1, Th(a, b, c);
        } finally{
            U.transition = d, D = c;
        }
        return null;
    }
    function Th(a, b, c) {
        do Fh();
        while (null !== uh);
        if (0 !== (G & 6)) throw Error(n(327));
        var d = a.finishedWork, e = a.finishedLanes;
        if (null === d) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (d === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = d.lanes | d.childLanes;
        Cc(a, f);
        a === F && (W = F = null, X = 0);
        0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || th || (th = !0, Dh(Lc, function() {
            Fh();
            return null;
        }));
        f = 0 !== (d.flags & 15990);
        if (0 !== (d.subtreeFlags & 15990) || f) {
            f = U.transition;
            U.transition = null;
            var g = D;
            D = 1;
            var h = G;
            G |= 4;
            nh.current = null;
            Eg(a, d);
            Ug(a, d, e);
            Ja(a.containerInfo);
            a.current = d;
            Xg(d, a, e);
            Ic();
            G = h;
            D = g;
            U.transition = f;
        } else a.current = d;
        th && (th = !1, uh = a, vh = e);
        f = a.pendingLanes;
        0 === f && (Ef = null);
        Pc(d.stateNode, c);
        Z(a, E());
        if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
        if (Bf) throw Bf = !1, a = Cf, Cf = null, a;
        0 !== (vh & 1) && 0 !== a.tag && Fh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === xh ? wh++ : (wh = 0, xh = a) : wh = 0;
        Xc();
        return null;
    }
    function Fh() {
        if (null !== uh) {
            var a = Ec(vh), b = U.transition, c = D;
            try {
                U.transition = null;
                D = 16 > a ? 16 : a;
                if (null === uh) var d = !1;
                else {
                    a = uh;
                    uh = null;
                    vh = 0;
                    if (0 !== (G & 6)) throw Error(n(331));
                    var e = G;
                    G |= 4;
                    for(S = a.current; null !== S;){
                        var f = S, g = f.child;
                        if (0 !== (S.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(S = l; null !== S;){
                                        var m = S;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Fg(8, m, f);
                                        }
                                        var v = m.child;
                                        if (null !== v) v.return = m, S = v;
                                        else for(; null !== S;){
                                            m = S;
                                            var r = m.sibling, z = m.return;
                                            Lg(m);
                                            if (m === l) {
                                                S = null;
                                                break;
                                            }
                                            if (null !== r) {
                                                r.return = z;
                                                S = r;
                                                break;
                                            }
                                            S = z;
                                        }
                                    }
                                }
                                var q = f.alternate;
                                if (null !== q) {
                                    var N = q.child;
                                    if (null !== N) {
                                        q.child = null;
                                        do {
                                            var da = N.sibling;
                                            N.sibling = null;
                                            N = da;
                                        }while (null !== N);
                                    }
                                }
                                S = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, S = g;
                        else b: for(; null !== S;){
                            f = S;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Fg(9, f, f.return);
                            }
                            var t = f.sibling;
                            if (null !== t) {
                                t.return = f.return;
                                S = t;
                                break b;
                            }
                            S = f.return;
                        }
                    }
                    var w = a.current;
                    for(S = w; null !== S;){
                        g = S;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, S = u;
                        else b: for(g = w; null !== S;){
                            h = S;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gg(9, h);
                                }
                            } catch (wa) {
                                T(h, h.return, wa);
                            }
                            if (h === g) {
                                S = null;
                                break b;
                            }
                            var V = h.sibling;
                            if (null !== V) {
                                V.return = h.return;
                                S = V;
                                break b;
                            }
                            S = h.return;
                        }
                    }
                    G = e;
                    Xc();
                    if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
                        Oc.onPostCommitFiberRoot(Nc, a);
                    } catch (wa) {}
                    d = !0;
                }
                return d;
            } finally{
                D = c, U.transition = b;
            }
        }
        return !1;
    }
    function Uh(a, b, c) {
        b = xf(c, b);
        b = Af(a, b, 1);
        rd(a, b);
        b = H();
        a = Ah(a, 1);
        null !== a && (Bc(a, 1, b), Z(a, b));
    }
    function T(a, b, c) {
        if (3 === a.tag) Uh(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                Uh(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ef || !Ef.has(d))) {
                    a = xf(c, a);
                    a = Df(b, a, 1);
                    rd(b, a);
                    a = H();
                    b = Ah(b, 1);
                    null !== b && (Bc(b, 1, a), Z(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Gf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = H();
        a.pingedLanes |= a.suspendedLanes & c;
        F === a && (X & c) === c && (4 === Q || 3 === Q && (X & 130023424) === X && 500 > E() - Vg ? Ih(a, 0) : qh |= c);
        Z(a, b);
    }
    function Vh(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
        var c = H();
        a = Ah(a, b);
        null !== a && (Bc(a, b, c), Z(a, c));
    }
    function qg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        Vh(a, c);
    }
    function Tg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        Vh(a, c);
    }
    var Sh;
    Sh = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || B.current) kd = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return kd = !1, wg(a, b, c);
                kd = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else kd = !1, I && 0 !== (b.flags & 1048576) && Qd(b, Jd, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                var e = jc(b, A.current);
                jd(b, c);
                e = Ke(null, b, d, a, e, c);
                var f = Pe();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, C(d) ? (f = !0, nc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, od(b), e.updater = Bd, b.stateNode = e, e._reactInternals = b, Fd(b, d, a, c), b = hg(null, b, d, !0, f, c)) : (b.tag = 0, I && f && Rd(b), R(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = Wh(d);
                    a = ad(d, a);
                    switch(e){
                        case 0:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 1:
                            b = gg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = $f(null, b, d, ad(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), cg(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), gg(a, b, d, e, c);
            case 3:
                a: {
                    ig(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    pd(a, b);
                    ud(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (p && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Error(n(423));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Error(n(424));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else for(p && (Ud = Nb(b.stateNode.containerInfo), Td = b, I = !0, Wd = null, Vd = !1), c = pe(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        de();
                        if (d === e) {
                            b = Zf(a, b, c);
                            break a;
                        }
                        R(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return xe(b), null === a && ae(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Oa(d, e) ? g = null : null !== f && Oa(d, f) && (b.flags |= 32), fg(a, b), R(a, b, g, c), b.child;
            case 6:
                return null === a && ae(b), null;
            case 13:
                return mg(a, b, c);
            case 4:
                return ve(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = oe(b, null, d, c) : R(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), Yf(a, b, d, e, c);
            case 7:
                return R(a, b, b.pendingProps, c), b.child;
            case 8:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    gd(b, d, g);
                    if (null !== f) {
                        if (Rc(f.value, g)) {
                            if (f.children === e.children && !B.current) {
                                b = Zf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = qd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        id(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                id(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    R(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, jd(b, c), e = ld(e), d = d(e), b.flags |= 1, R(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = ad(d, b.pendingProps), e = ad(d.type, e), $f(a, b, d, e, c);
            case 15:
                return bg(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, C(d) ? (a = !0, nc(b)) : a = !1, jd(b, c), Dd(b, d, e), Fd(b, d, e, c), hg(null, b, d, !0, a, c);
            case 19:
                return vg(a, b, c);
            case 22:
                return dg(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Dh(a, b) {
        return Fc(a, b);
    }
    function Xh(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new Xh(a, b, c, d);
    }
    function ag(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function Wh(a) {
        if ("function" === typeof a) return ag(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === na) return 11;
            if (a === qa) return 14;
        }
        return 2;
    }
    function je(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function le(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) ag(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ia:
                return ne(c.children, e, f, b);
            case ja:
                g = 8;
                e |= 8;
                break;
            case ka:
                return a = Yd(12, c, b, e | 2), a.elementType = ka, a.lanes = f, a;
            case oa:
                return a = Yd(13, c, b, e), a.elementType = oa, a.lanes = f, a;
            case pa:
                return a = Yd(19, c, b, e), a.elementType = pa, a.lanes = f, a;
            case sa:
                return ng(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case la:
                        g = 10;
                        break a;
                    case ma:
                        g = 9;
                        break a;
                    case na:
                        g = 11;
                        break a;
                    case qa:
                        g = 14;
                        break a;
                    case ra:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ne(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ng(a, b, c, d) {
        a = Yd(22, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        a.stateNode = {};
        return a;
    }
    function ke(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function me(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function Yh(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Sa;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ac(0);
        this.expirationTimes = Ac(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ac(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        p && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a, b, c, d, e, f, g, h, k) {
        a = new Yh(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = Yd(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null
        };
        od(f);
        return a;
    }
    function $h(a) {
        if (!a) return hc;
        a = a._reactInternals;
        a: {
            if (ya(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (C(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (C(c)) return mc(a, c, b);
        }
        return b;
    }
    function ai(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Ba(b);
        return null === a ? null : a.stateNode;
    }
    function bi(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function ci(a, b) {
        bi(a, b);
        (a = a.alternate) && bi(a, b);
    }
    function di(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
    }
    function ei() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = H();
            Ad(a, 134217728, b);
            ci(a, 134217728);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = H(), c = zd(a);
            Ad(a, c, b);
            ci(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = vc(b.pendingLanes);
                    0 !== c && (Dc(b, c | 1), Z(b, E()), 0 === (G & 6) && (sh(), Xc()));
                }
                break;
            case 13:
                var d = H();
                Oh(function() {
                    return Ad(a, 1, d);
                });
                ci(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = G;
        G |= 1;
        try {
            return a(b);
        } finally{
            G = c, 0 === G && (sh(), Tc && Xc());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ah,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return Zh(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: bh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = Zh(c, d, !0, a, e, f, g, h, k);
        a.context = $h(null);
        c = a.current;
        d = H();
        e = zd(c);
        f = qd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        rd(c, f);
        a.current.lanes = e;
        Bc(a, e, d);
        Z(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ha,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: ch,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: dh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: eh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = D, c = U.transition;
        try {
            return U.transition = null, D = 16, a();
        } finally{
            D = b, U.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = D, g = U.transition;
        try {
            return U.transition = null, D = 1, a(b, c, d, e);
        } finally{
            D = f, U.transition = g, 0 === G && sh();
        }
    };
    exports.findAllNodes = kh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = kh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, v = k.y, r = v + k.height;
                if (d >= l && f >= v && e <= m && g <= r) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || r < f || v > g)) {
                    v > f && (k.height += v - f, k.y = f);
                    r < g && (k.height = g - v);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== v || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ai;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Aa(a);
        a = null !== a ? Da(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ai(a);
    };
    exports.flushControlled = function(a) {
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            U.transition = null, D = 1, a();
        } finally{
            D = d, U.transition = c, G = b, 0 === G && (sh(), Xc());
        }
    };
    exports.flushPassiveEffects = Fh;
    exports.flushSync = Oh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        b = jh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return D;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            gh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (hh(f, h) && (d.push(ih(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ih(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Fa(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ea.ReactCurrentDispatcher,
            findHostInstanceByFiber: di,
            findFiberByHostInstance: a.findFiberByHostInstance || ei,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.0.0-fc46dba67-20220329"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Nc = b.inject(a), Oc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = kh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = D;
        try {
            return D = a, b();
        } finally{
            D = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = H(), g = zd(e);
        c = $h(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = qd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        rd(e, b);
        a = Ad(e, g, f);
        null !== a && sd(a, e, g);
        return g;
    };
    return exports;
};

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("2LLMu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Vector3", () => $204508e5b4b18960$export$64b5c384219d3699);
$parcel$export(module.exports, "VectorOps", () => $204508e5b4b18960$export$e2f642242c040d8f);
$parcel$export(module.exports, "Quaternion", () => $204508e5b4b18960$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "RotationOps", () => $204508e5b4b18960$export$824960640e91b57);
$parcel$export(module.exports, "SdpMatrix3", () => $204508e5b4b18960$export$a634d4178dd6cfce);
$parcel$export(module.exports, "SdpMatrix3Ops", () => $204508e5b4b18960$export$afeef1d10fc8a4f3);
$parcel$export(module.exports, "RigidBodyType", () => $204508e5b4b18960$export$9df1fa60cce90854);
$parcel$export(module.exports, "JointType", () => $204508e5b4b18960$export$d8c34c2371473e33);
$parcel$export(module.exports, "MotorModel", () => $204508e5b4b18960$export$9fe5861f16a3846f);
$parcel$export(module.exports, "CoefficientCombineRule", () => $204508e5b4b18960$export$5d7f3962eb4528af);
$parcel$export(module.exports, "FeatureType", () => $204508e5b4b18960$export$c40deacab7e2491c);
$parcel$export(module.exports, "ShapeType", () => $204508e5b4b18960$export$fc850f719b5599d5);
$parcel$export(module.exports, "ActiveCollisionTypes", () => $204508e5b4b18960$export$822f84f0c1c58b2a);
$parcel$export(module.exports, "MassPropsMode", () => $204508e5b4b18960$export$9d99ce4bda7104cf);
$parcel$export(module.exports, "QueryFilterFlags", () => $204508e5b4b18960$export$39a39008025d4cb);
$parcel$export(module.exports, "ActiveEvents", () => $204508e5b4b18960$export$f28998d26d157fd3);
$parcel$export(module.exports, "ActiveHooks", () => $204508e5b4b18960$export$194d8ad9e2dc63e8);
$parcel$export(module.exports, "SolverFlags", () => $204508e5b4b18960$export$d50a7c063745a562);
$parcel$export(module.exports, "RigidBody", () => $204508e5b4b18960$export$41c0a739a32ac4d);
$parcel$export(module.exports, "RigidBodyDesc", () => $204508e5b4b18960$export$105dcb996a5d3c42);
$parcel$export(module.exports, "RigidBodySet", () => $204508e5b4b18960$export$bd569bf5451ee055);
$parcel$export(module.exports, "IntegrationParameters", () => $204508e5b4b18960$export$c22d4691787a8578);
$parcel$export(module.exports, "ImpulseJoint", () => $204508e5b4b18960$export$13616a6dfa0c261e);
$parcel$export(module.exports, "RevoluteImpulseJoint", () => $204508e5b4b18960$export$f21c6aedecbeb53d);
$parcel$export(module.exports, "PrismaticImpulseJoint", () => $204508e5b4b18960$export$ca91224fa01cc4c5);
$parcel$export(module.exports, "FixedImpulseJoint", () => $204508e5b4b18960$export$13a2c1429de97fd0);
$parcel$export(module.exports, "SphericalImpulseJoint", () => $204508e5b4b18960$export$da358565907d92be);
$parcel$export(module.exports, "UnitImpulseJoint", () => $204508e5b4b18960$export$b6c446c752acb453);
$parcel$export(module.exports, "JointData", () => $204508e5b4b18960$export$9ad4996060073eaa);
$parcel$export(module.exports, "ImpulseJointSet", () => $204508e5b4b18960$export$7b6f816cee9f25f2);
$parcel$export(module.exports, "MultibodyJoint", () => $204508e5b4b18960$export$9f6b52d8d09f7b72);
$parcel$export(module.exports, "RevoluteMultibodyJoint", () => $204508e5b4b18960$export$e2bca3ac97ae239e);
$parcel$export(module.exports, "PrismaticMultibodyJoint", () => $204508e5b4b18960$export$1ac8e4ec1713e3da);
$parcel$export(module.exports, "FixedMultibodyJoint", () => $204508e5b4b18960$export$6984fd596a92ce33);
$parcel$export(module.exports, "SphericalMultibodyJoint", () => $204508e5b4b18960$export$b9ffb05588678855);
$parcel$export(module.exports, "UnitMultibodyJoint", () => $204508e5b4b18960$export$b677e6fe6c6cb994);
$parcel$export(module.exports, "MultibodyJointSet", () => $204508e5b4b18960$export$b6a38ee363602c2a);
$parcel$export(module.exports, "CCDSolver", () => $204508e5b4b18960$export$ffc4c782649f077);
$parcel$export(module.exports, "IslandManager", () => $204508e5b4b18960$export$129e66920a069ba5);
$parcel$export(module.exports, "BroadPhase", () => $204508e5b4b18960$export$d80423229f8b133);
$parcel$export(module.exports, "NarrowPhase", () => $204508e5b4b18960$export$f7b463e625571e2b);
$parcel$export(module.exports, "TempContactManifold", () => $204508e5b4b18960$export$7ac890e03fe91616);
$parcel$export(module.exports, "ShapeContact", () => $204508e5b4b18960$export$1d7ee127e07c91bb);
$parcel$export(module.exports, "PointProjection", () => $204508e5b4b18960$export$5e813b027a709134);
$parcel$export(module.exports, "PointColliderProjection", () => $204508e5b4b18960$export$fc779dece190555);
$parcel$export(module.exports, "Ray", () => $204508e5b4b18960$export$a186db52eed6d40e);
$parcel$export(module.exports, "RayIntersection", () => $204508e5b4b18960$export$292489680db6ed3f);
$parcel$export(module.exports, "RayColliderIntersection", () => $204508e5b4b18960$export$bc228139800bb3c);
$parcel$export(module.exports, "RayColliderToi", () => $204508e5b4b18960$export$fc9976cd477662f8);
$parcel$export(module.exports, "ShapeTOI", () => $204508e5b4b18960$export$1c5cc33417eb8bc);
$parcel$export(module.exports, "ShapeColliderTOI", () => $204508e5b4b18960$export$edd42a90ffbc1c72);
$parcel$export(module.exports, "Shape", () => $204508e5b4b18960$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "Ball", () => $204508e5b4b18960$export$a83d7c3fa53790c9);
$parcel$export(module.exports, "Cuboid", () => $204508e5b4b18960$export$c8821cc685709b7b);
$parcel$export(module.exports, "RoundCuboid", () => $204508e5b4b18960$export$c87d2c121efe06ab);
$parcel$export(module.exports, "Capsule", () => $204508e5b4b18960$export$28bdb8fc07bf3804);
$parcel$export(module.exports, "Segment", () => $204508e5b4b18960$export$d53aa5c5ab432700);
$parcel$export(module.exports, "Polyline", () => $204508e5b4b18960$export$79f3ee03e63e7073);
$parcel$export(module.exports, "Triangle", () => $204508e5b4b18960$export$5a465592bfe74b48);
$parcel$export(module.exports, "RoundTriangle", () => $204508e5b4b18960$export$5d38c33920824fab);
$parcel$export(module.exports, "HalfSpace", () => $204508e5b4b18960$export$b774d5dd1a533096);
$parcel$export(module.exports, "TriMesh", () => $204508e5b4b18960$export$16df86f06e459b09);
$parcel$export(module.exports, "Heightfield", () => $204508e5b4b18960$export$fa360b5b58f475b7);
$parcel$export(module.exports, "ConvexPolyhedron", () => $204508e5b4b18960$export$7c637a75bc263948);
$parcel$export(module.exports, "RoundConvexPolyhedron", () => $204508e5b4b18960$export$f9ecc9020d30774f);
$parcel$export(module.exports, "Cylinder", () => $204508e5b4b18960$export$665c37f020fe48f9);
$parcel$export(module.exports, "RoundCylinder", () => $204508e5b4b18960$export$6fe70449556bd1bd);
$parcel$export(module.exports, "Cone", () => $204508e5b4b18960$export$22209bc4af3d3757);
$parcel$export(module.exports, "RoundCone", () => $204508e5b4b18960$export$fec6094316a593bd);
$parcel$export(module.exports, "Collider", () => $204508e5b4b18960$export$b7c6eef0ebb06133);
$parcel$export(module.exports, "ColliderDesc", () => $204508e5b4b18960$export$7d4cec221ee36947);
$parcel$export(module.exports, "ColliderSet", () => $204508e5b4b18960$export$8ec69bf37b303313);
$parcel$export(module.exports, "PhysicsPipeline", () => $204508e5b4b18960$export$f3c42ca1c254a387);
$parcel$export(module.exports, "QueryPipeline", () => $204508e5b4b18960$export$636a60a98ff98f0b);
$parcel$export(module.exports, "SerializationPipeline", () => $204508e5b4b18960$export$b54bf36dd1f18c08);
$parcel$export(module.exports, "World", () => $204508e5b4b18960$export$812cd9544993280d);
$parcel$export(module.exports, "DebugRenderBuffers", () => $204508e5b4b18960$export$354e114f10103d2d);
$parcel$export(module.exports, "DebugRenderPipeline", () => $204508e5b4b18960$export$acdffcc934f6bc95);
$parcel$export(module.exports, "CharacterCollision", () => $204508e5b4b18960$export$d8a6c60ecc79c6a6);
$parcel$export(module.exports, "KinematicCharacterController", () => $204508e5b4b18960$export$ed5de7d26b924ce3);
$parcel$export(module.exports, "TempContactForceEvent", () => $204508e5b4b18960$export$cba99c196a0dcc61);
$parcel$export(module.exports, "EventQueue", () => $204508e5b4b18960$export$2fc6338444a158e6);
$parcel$export(module.exports, "init", () => $204508e5b4b18960$export$2cd8252107eb640b);
$parcel$export(module.exports, "version", () => $204508e5b4b18960$export$83d89fbfd8236492);
$parcel$export(module.exports, "default", () => $204508e5b4b18960$export$2e2bcd8739ae039);
let $204508e5b4b18960$var$A;
const $204508e5b4b18960$var$I = new Array(32).fill(void 0);
function $204508e5b4b18960$var$g(A) {
    return $204508e5b4b18960$var$I[A];
}
$204508e5b4b18960$var$I.push(void 0, null, !0, !1);
let $204508e5b4b18960$var$C = $204508e5b4b18960$var$I.length;
function $204508e5b4b18960$var$B(A) {
    const B = $204508e5b4b18960$var$g(A);
    return function(A) {
        A < 36 || ($204508e5b4b18960$var$I[A] = $204508e5b4b18960$var$C, $204508e5b4b18960$var$C = A);
    }(A), B;
}
function $204508e5b4b18960$var$Q(A) {
    $204508e5b4b18960$var$C === $204508e5b4b18960$var$I.length && $204508e5b4b18960$var$I.push($204508e5b4b18960$var$I.length + 1);
    const g = $204508e5b4b18960$var$C;
    return $204508e5b4b18960$var$C = $204508e5b4b18960$var$I[g], $204508e5b4b18960$var$I[g] = A, g;
}
function $204508e5b4b18960$var$E(A) {
    return null == A;
}
let $204508e5b4b18960$var$i = new Float64Array;
function $204508e5b4b18960$var$D() {
    return 0 === $204508e5b4b18960$var$i.byteLength && ($204508e5b4b18960$var$i = new Float64Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$i;
}
let $204508e5b4b18960$var$o = new Int32Array;
function $204508e5b4b18960$var$G() {
    return 0 === $204508e5b4b18960$var$o.byteLength && ($204508e5b4b18960$var$o = new Int32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$o;
}
const $204508e5b4b18960$var$w = new TextDecoder("utf-8", {
    ignoreBOM: !0,
    fatal: !0
});
$204508e5b4b18960$var$w.decode();
let $204508e5b4b18960$var$k = new Uint8Array;
function $204508e5b4b18960$var$S(I, g) {
    return $204508e5b4b18960$var$w.decode((0 === $204508e5b4b18960$var$k.byteLength && ($204508e5b4b18960$var$k = new Uint8Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$k).subarray(I, I + g));
}
function $204508e5b4b18960$var$a(A, I) {
    if (!(A instanceof I)) throw new Error(`expected instance of ${I.name}`);
    return A.ptr;
}
let $204508e5b4b18960$var$M = new Float32Array;
function $204508e5b4b18960$var$K() {
    return 0 === $204508e5b4b18960$var$M.byteLength && ($204508e5b4b18960$var$M = new Float32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$M;
}
let $204508e5b4b18960$var$y = 32;
function $204508e5b4b18960$var$J(A) {
    if (1 == $204508e5b4b18960$var$y) throw new Error("out of js stack");
    return $204508e5b4b18960$var$I[--$204508e5b4b18960$var$y] = A, $204508e5b4b18960$var$y;
}
function $204508e5b4b18960$var$U(A, I) {
    return $204508e5b4b18960$var$K().subarray(A / 4, A / 4 + I);
}
let $204508e5b4b18960$var$h = new Uint32Array;
function $204508e5b4b18960$var$N() {
    return 0 === $204508e5b4b18960$var$h.byteLength && ($204508e5b4b18960$var$h = new Uint32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$h;
}
let $204508e5b4b18960$var$F = 0;
function $204508e5b4b18960$var$q(A, I) {
    const g = I(4 * A.length);
    return $204508e5b4b18960$var$K().set(A, g / 4), $204508e5b4b18960$var$F = A.length, g;
}
function $204508e5b4b18960$var$R(A, I) {
    const g = I(4 * A.length);
    return $204508e5b4b18960$var$N().set(A, g / 4), $204508e5b4b18960$var$F = A.length, g;
}
function $204508e5b4b18960$var$s(I, g) {
    try {
        return I.apply(this, g);
    } catch (I) {
        $204508e5b4b18960$var$A.__wbindgen_exn_store($204508e5b4b18960$var$Q(I));
    }
}
Object.freeze({
    Revolute: 0,
    0: "Revolute",
    Fixed: 1,
    1: "Fixed",
    Prismatic: 2,
    2: "Prismatic",
    Spherical: 3,
    3: "Spherical",
    Generic: 4,
    4: "Generic"
}), Object.freeze({
    AccelerationBased: 0,
    0: "AccelerationBased",
    ForceBased: 1,
    1: "ForceBased"
});
const $204508e5b4b18960$var$c = Object.freeze({
    X: 0,
    0: "X",
    Y: 1,
    1: "Y",
    Z: 2,
    2: "Z",
    AngX: 3,
    3: "AngX",
    AngY: 4,
    4: "AngY",
    AngZ: 5,
    5: "AngZ"
});
Object.freeze({
    Dynamic: 0,
    0: "Dynamic",
    Fixed: 1,
    1: "Fixed",
    KinematicPositionBased: 2,
    2: "KinematicPositionBased",
    KinematicVelocityBased: 3,
    3: "KinematicVelocityBased"
}), Object.freeze({
    Vertex: 0,
    0: "Vertex",
    Edge: 1,
    1: "Edge",
    Face: 2,
    2: "Face",
    Unknown: 3,
    3: "Unknown"
}), Object.freeze({
    Ball: 0,
    0: "Ball",
    Cuboid: 1,
    1: "Cuboid",
    Capsule: 2,
    2: "Capsule",
    Segment: 3,
    3: "Segment",
    Polyline: 4,
    4: "Polyline",
    Triangle: 5,
    5: "Triangle",
    TriMesh: 6,
    6: "TriMesh",
    HeightField: 7,
    7: "HeightField",
    Compound: 8,
    8: "Compound",
    ConvexPolyhedron: 9,
    9: "ConvexPolyhedron",
    Cylinder: 10,
    10: "Cylinder",
    Cone: 11,
    11: "Cone",
    RoundCuboid: 12,
    12: "RoundCuboid",
    RoundTriangle: 13,
    13: "RoundTriangle",
    RoundCylinder: 14,
    14: "RoundCylinder",
    RoundCone: 15,
    15: "RoundCone",
    RoundConvexPolyhedron: 16,
    16: "RoundConvexPolyhedron",
    HalfSpace: 17,
    17: "HalfSpace"
});
class $204508e5b4b18960$var$Y {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$Y.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawbroadphase_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawbroadphase_new();
        return $204508e5b4b18960$var$Y.__wrap(I);
    }
}
class $204508e5b4b18960$var$L {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$L.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawccdsolver_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawccdsolver_new();
        return $204508e5b4b18960$var$L.__wrap(I);
    }
}
class $204508e5b4b18960$var$H {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$H.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcharactercollision_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawcharactercollision_new();
        return $204508e5b4b18960$var$H.__wrap(I);
    }
    handle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.ptr);
    }
    translationApplied() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationApplied(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    translationRemaining() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationRemaining(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    worldWitness1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    worldWitness2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    worldNormal1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    worldNormal2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
}
class $204508e5b4b18960$var$l {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$l.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcolliderset_free(I);
    }
    coTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coTranslation(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    coRotation(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coRotation(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    coSetTranslation(I, g, C, B) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetTranslation(this.ptr, I, g, C, B);
    }
    coSetTranslationWrtParent(I, g, C, B) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetTranslationWrtParent(this.ptr, I, g, C, B);
    }
    coSetRotation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRotation(this.ptr, I, g, C, B, Q);
    }
    coSetRotationWrtParent(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRotationWrtParent(this.ptr, I, g, C, B, Q);
    }
    coIsSensor(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIsSensor(this.ptr, I);
    }
    coShapeType(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coShapeType(this.ptr, I) >>> 0;
    }
    coHalfspaceNormal(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHalfspaceNormal(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    coHalfExtents(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHalfExtents(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    coSetHalfExtents(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawcolliderset_coSetHalfExtents(this.ptr, I, g.ptr);
    }
    coRadius(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coRadius(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetRadius(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRadius(this.ptr, I, g);
    }
    coHalfHeight(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHalfHeight(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetHalfHeight(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetHalfHeight(this.ptr, I, g);
    }
    coRoundRadius(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coRoundRadius(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetRoundRadius(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRoundRadius(this.ptr, I, g);
    }
    coVertices(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coVertices(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = $204508e5b4b18960$var$U(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coIndices(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coIndices(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = (function(A, I) {
                return $204508e5b4b18960$var$N().subarray(A / 4, A / 4 + I);
            })(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldHeights(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldHeights(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = $204508e5b4b18960$var$U(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldScale(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldScale(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    coHeightfieldNRows(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldNRows(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldNCols(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldNCols(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coParent(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coParent(B, this.ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$D()[B / 8 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetEnabled(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetEnabled(this.ptr, I, g);
    }
    coIsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIsEnabled(this.ptr, I);
    }
    coFriction(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coFriction(this.ptr, I);
    }
    coRestitution(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coRestitution(this.ptr, I);
    }
    coDensity(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coDensity(this.ptr, I);
    }
    coMass(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coMass(this.ptr, I);
    }
    coVolume(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coVolume(this.ptr, I);
    }
    coCollisionGroups(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coCollisionGroups(this.ptr, I) >>> 0;
    }
    coSolverGroups(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coSolverGroups(this.ptr, I) >>> 0;
    }
    coActiveHooks(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveHooks(this.ptr, I) >>> 0;
    }
    coActiveCollisionTypes(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveCollisionTypes(this.ptr, I);
    }
    coActiveEvents(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveEvents(this.ptr, I) >>> 0;
    }
    coContactForceEventThreshold(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coContactForceEventThreshold(this.ptr, I);
    }
    coContainsPoint(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coContainsPoint(this.ptr, I, g.ptr);
    }
    coCastShape(I, g, C, B, Q, E, i, D) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(E, $204508e5b4b18960$var$QA);
        const o = $204508e5b4b18960$var$A.rawcolliderset_coCastShape(this.ptr, I, g.ptr, C.ptr, B.ptr, Q.ptr, E.ptr, i, D);
        return 0 === o ? void 0 : $204508e5b4b18960$var$BA.__wrap(o);
    }
    coCastCollider(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
        const i = $204508e5b4b18960$var$A.rawcolliderset_coCastCollider(this.ptr, I, g.ptr, C, B.ptr, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$gA.__wrap(i);
    }
    coIntersectsShape(I, g, C, B) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$_);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIntersectsShape(this.ptr, I, g.ptr, C.ptr, B.ptr);
    }
    coContactShape(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$_);
        const E = $204508e5b4b18960$var$A.rawcolliderset_coContactShape(this.ptr, I, g.ptr, C.ptr, B.ptr, Q);
        return 0 === E ? void 0 : $204508e5b4b18960$var$CA.__wrap(E);
    }
    coContactCollider(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawcolliderset_coContactCollider(this.ptr, I, g, C);
        return 0 === B ? void 0 : $204508e5b4b18960$var$CA.__wrap(B);
    }
    coProjectPoint(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA);
        const B = $204508e5b4b18960$var$A.rawcolliderset_coProjectPoint(this.ptr, I, g.ptr, C);
        return $204508e5b4b18960$var$X.__wrap(B);
    }
    coIntersectsRay(I, g, C, B) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIntersectsRay(this.ptr, I, g.ptr, C.ptr, B);
    }
    coCastRay(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        return $204508e5b4b18960$var$A.rawcolliderset_coCastRay(this.ptr, I, g.ptr, C.ptr, B, Q);
    }
    coCastRayAndGetNormal(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const E = $204508e5b4b18960$var$A.rawcolliderset_coCastRayAndGetNormal(this.ptr, I, g.ptr, C.ptr, B, Q);
        return 0 === E ? void 0 : $204508e5b4b18960$var$u.__wrap(E);
    }
    coSetSensor(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetSensor(this.ptr, I, g);
    }
    coSetRestitution(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRestitution(this.ptr, I, g);
    }
    coSetFriction(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetFriction(this.ptr, I, g);
    }
    coFrictionCombineRule(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coFrictionCombineRule(this.ptr, I) >>> 0;
    }
    coSetFrictionCombineRule(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetFrictionCombineRule(this.ptr, I, g);
    }
    coRestitutionCombineRule(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coRestitutionCombineRule(this.ptr, I) >>> 0;
    }
    coSetRestitutionCombineRule(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRestitutionCombineRule(this.ptr, I, g);
    }
    coSetCollisionGroups(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetCollisionGroups(this.ptr, I, g);
    }
    coSetSolverGroups(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetSolverGroups(this.ptr, I, g);
    }
    coSetActiveHooks(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveHooks(this.ptr, I, g);
    }
    coSetActiveEvents(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveEvents(this.ptr, I, g);
    }
    coSetActiveCollisionTypes(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveCollisionTypes(this.ptr, I, g);
    }
    coSetShape(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$A.rawcolliderset_coSetShape(this.ptr, I, g.ptr);
    }
    coSetContactForceEventThreshold(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetContactForceEventThreshold(this.ptr, I, g);
    }
    coSetDensity(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetDensity(this.ptr, I, g);
    }
    coSetMass(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetMass(this.ptr, I, g);
    }
    coSetMassProperties(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$A.rawcolliderset_coSetMassProperties(this.ptr, I, g, C.ptr, B.ptr, Q.ptr);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawcolliderset_new();
        return $204508e5b4b18960$var$l.__wrap(I);
    }
    len() {
        return $204508e5b4b18960$var$A.rawcolliderset_len(this.ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_contains(this.ptr, I);
    }
    createCollider(I, g, C, B, Q, E, i, o, w, k, S, M, K, y, J, U, h, N, F, q, R, s, c, Y) {
        try {
            const l = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(o, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(w, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(Y, $204508e5b4b18960$var$v), $204508e5b4b18960$var$A.rawcolliderset_createCollider(l, this.ptr, I, g.ptr, C.ptr, B.ptr, Q, E, i.ptr, o.ptr, w.ptr, k, S, M, K, y, J, U, h, N, F, q, R, s, c, Y.ptr);
            var L = $204508e5b4b18960$var$G()[l / 4 + 0], H = $204508e5b4b18960$var$D()[l / 8 + 1];
            return 0 === L ? void 0 : H;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    remove(I, g, C, B) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$b), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$v), $204508e5b4b18960$var$A.rawcolliderset_remove(this.ptr, I, g.ptr, C.ptr, B);
    }
    isHandleValid(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_contains(this.ptr, I);
    }
    forEachColliderHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawcolliderset_forEachColliderHandle(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$t {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$t.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactforceevent_free(I);
    }
    collider1() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.ptr);
    }
    collider2() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_collider2(this.ptr);
    }
    total_force() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_total_force(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    total_force_magnitude() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_total_force_magnitude(this.ptr);
    }
    max_force_direction() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_max_force_direction(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    max_force_magnitude() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_max_force_magnitude(this.ptr);
    }
}
class $204508e5b4b18960$var$p {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$p.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactmanifold_free(I);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_normal(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    local_n1() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_local_n1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    local_n2() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_local_n2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    subshape1() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_subshape1(this.ptr) >>> 0;
    }
    subshape2() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_subshape2(this.ptr) >>> 0;
    }
    num_contacts() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_num_contacts(this.ptr) >>> 0;
    }
    contact_local_p1(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_contact_local_p1(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    contact_local_p2(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_contact_local_p2(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    contact_dist(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_dist(this.ptr, I);
    }
    contact_fid1(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_fid1(this.ptr, I) >>> 0;
    }
    contact_fid2(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_fid2(this.ptr, I) >>> 0;
    }
    contact_impulse(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_impulse(this.ptr, I);
    }
    contact_tangent_impulse_x(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_tangent_impulse_x(this.ptr, I);
    }
    contact_tangent_impulse_y(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_tangent_impulse_y(this.ptr, I);
    }
    num_solver_contacts() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_num_solver_contacts(this.ptr) >>> 0;
    }
    solver_contact_point(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_point(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$QA.__wrap(g);
    }
    solver_contact_dist(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_dist(this.ptr, I);
    }
    solver_contact_friction(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_friction(this.ptr, I);
    }
    solver_contact_restitution(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_restitution(this.ptr, I);
    }
    solver_contact_tangent_velocity(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_tangent_velocity(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
}
class $204508e5b4b18960$var$e {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$e.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactpair_free(I);
    }
    collider1() {
        return $204508e5b4b18960$var$A.rawcontactpair_collider1(this.ptr);
    }
    collider2() {
        return $204508e5b4b18960$var$A.rawcontactpair_collider2(this.ptr);
    }
    numContactManifolds() {
        return $204508e5b4b18960$var$A.rawcontactpair_numContactManifolds(this.ptr) >>> 0;
    }
    contactManifold(I) {
        const g = $204508e5b4b18960$var$A.rawcontactpair_contactManifold(this.ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$p.__wrap(g);
    }
}
class $204508e5b4b18960$var$r {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$r.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawdebugrenderpipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawdebugrenderpipeline_new();
        return $204508e5b4b18960$var$r.__wrap(I);
    }
    vertices() {
        return $204508e5b4b18960$var$B($204508e5b4b18960$var$A.rawdebugrenderpipeline_vertices(this.ptr));
    }
    colors() {
        return $204508e5b4b18960$var$B($204508e5b4b18960$var$A.rawdebugrenderpipeline_colors(this.ptr));
    }
    render(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$n), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$j), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$x), $204508e5b4b18960$var$A.rawdebugrenderpipeline_render(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q.ptr);
    }
}
class $204508e5b4b18960$var$d {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$d.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawdeserializedworld_free(I);
    }
    takeGravity() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeGravity(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$QA.__wrap(I);
    }
    takeIntegrationParameters() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeIntegrationParameters(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$Z.__wrap(I);
    }
    takeIslandManager() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeIslandManager(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$b.__wrap(I);
    }
    takeBroadPhase() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeBroadPhase(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$Y.__wrap(I);
    }
    takeNarrowPhase() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeNarrowPhase(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$x.__wrap(I);
    }
    takeBodies() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeBodies(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$v.__wrap(I);
    }
    takeColliders() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeColliders(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$l.__wrap(I);
    }
    takeImpulseJoints() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeImpulseJoints(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$n.__wrap(I);
    }
    takeMultibodyJoints() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeMultibodyJoints(this.ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$j.__wrap(I);
    }
}
class $204508e5b4b18960$var$T {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$T.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_raweventqueue_free(I);
    }
    constructor(I){
        const g = $204508e5b4b18960$var$A.raweventqueue_new(I);
        return $204508e5b4b18960$var$T.__wrap(g);
    }
    drainCollisionEvents(g) {
        try {
            $204508e5b4b18960$var$A.raweventqueue_drainCollisionEvents(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    drainContactForceEvents(g) {
        try {
            $204508e5b4b18960$var$A.raweventqueue_drainContactForceEvents(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    clear() {
        $204508e5b4b18960$var$A.raweventqueue_clear(this.ptr);
    }
}
class $204508e5b4b18960$var$O {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$O.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawgenericjoint_free(I);
    }
    static spherical(I, g) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA);
        const C = $204508e5b4b18960$var$A.rawgenericjoint_spherical(I.ptr, g.ptr);
        return $204508e5b4b18960$var$O.__wrap(C);
    }
    static prismatic(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const i = $204508e5b4b18960$var$A.rawgenericjoint_prismatic(I.ptr, g.ptr, C.ptr, B, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$O.__wrap(i);
    }
    static fixed(I, g, C, B) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$_);
        const Q = $204508e5b4b18960$var$A.rawgenericjoint_fixed(I.ptr, g.ptr, C.ptr, B.ptr);
        return $204508e5b4b18960$var$O.__wrap(Q);
    }
    static revolute(I, g, C) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const B = $204508e5b4b18960$var$A.rawgenericjoint_revolute(I.ptr, g.ptr, C.ptr);
        return 0 === B ? void 0 : $204508e5b4b18960$var$O.__wrap(B);
    }
}
class $204508e5b4b18960$var$n {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$n.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawimpulsejointset_free(I);
    }
    jointType(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointType(this.ptr, I) >>> 0;
    }
    jointBodyHandle1(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointBodyHandle1(this.ptr, I);
    }
    jointBodyHandle2(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointBodyHandle2(this.ptr, I);
    }
    jointFrameX1(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointFrameX1(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    jointFrameX2(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointFrameX2(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    jointAnchor1(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointAnchor1(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    jointAnchor2(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointAnchor2(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    jointSetAnchor1(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawimpulsejointset_jointSetAnchor1(this.ptr, I, g.ptr);
    }
    jointSetAnchor2(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawimpulsejointset_jointSetAnchor2(this.ptr, I, g.ptr);
    }
    jointContactsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_jointContactsEnabled(this.ptr, I);
    }
    jointSetContactsEnabled(I, g) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointSetContactsEnabled(this.ptr, I, g);
    }
    jointLimitsEnabled(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsEnabled(this.ptr, I, g);
    }
    jointLimitsMin(I, g) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsMin(this.ptr, I, g);
    }
    jointLimitsMax(I, g) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsMax(this.ptr, I, g);
    }
    jointSetLimits(I, g, C, B) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointSetLimits(this.ptr, I, g, C, B);
    }
    jointConfigureMotorModel(I, g, C) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorModel(this.ptr, I, g, C);
    }
    jointConfigureMotorVelocity(I, g, C, B) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorVelocity(this.ptr, I, g, C, B);
    }
    jointConfigureMotorPosition(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorPosition(this.ptr, I, g, C, B, Q);
    }
    jointConfigureMotor(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotor(this.ptr, I, g, C, B, Q, E);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawimpulsejointset_new();
        return $204508e5b4b18960$var$n.__wrap(I);
    }
    createJoint(I, g, C, B) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$O);
        return $204508e5b4b18960$var$A.rawimpulsejointset_createJoint(this.ptr, I.ptr, g, C, B);
    }
    remove(I, g) {
        $204508e5b4b18960$var$A.rawimpulsejointset_remove(this.ptr, I, g);
    }
    len() {
        return $204508e5b4b18960$var$A.rawimpulsejointset_len(this.ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_contains(this.ptr, I);
    }
    forEachJointHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawimpulsejointset_forEachJointHandle(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    forEachJointAttachedToRigidBody(g, C) {
        try {
            $204508e5b4b18960$var$A.rawimpulsejointset_forEachJointAttachedToRigidBody(this.ptr, g, $204508e5b4b18960$var$J(C));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$Z {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$Z.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawintegrationparameters_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawintegrationparameters_new();
        return $204508e5b4b18960$var$Z.__wrap(I);
    }
    get dt() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.ptr);
    }
    get erp() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    get allowedLinearError() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_allowedLinearError(this.ptr);
    }
    get predictionDistance() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_predictionDistance(this.ptr);
    }
    get maxVelocityIterations() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_maxVelocityIterations(this.ptr) >>> 0;
    }
    get maxVelocityFrictionIterations() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_maxVelocityFrictionIterations(this.ptr) >>> 0;
    }
    get maxStabilizationIterations() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_maxStabilizationIterations(this.ptr) >>> 0;
    }
    get minIslandSize() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_minIslandSize(this.ptr) >>> 0;
    }
    get maxCcdSubsteps() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_maxCcdSubsteps(this.ptr) >>> 0;
    }
    set dt(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_dt(this.ptr, I);
    }
    set erp(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_erp(this.ptr, I);
    }
    set allowedLinearError(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_allowedLinearError(this.ptr, I);
    }
    set predictionDistance(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_predictionDistance(this.ptr, I);
    }
    set maxVelocityIterations(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_maxVelocityIterations(this.ptr, I);
    }
    set maxVelocityFrictionIterations(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_maxVelocityFrictionIterations(this.ptr, I);
    }
    set maxStabilizationIterations(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_maxStabilizationIterations(this.ptr, I);
    }
    set minIslandSize(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_minIslandSize(this.ptr, I);
    }
    set maxCcdSubsteps(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_maxCcdSubsteps(this.ptr, I);
    }
}
class $204508e5b4b18960$var$b {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$b.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawislandmanager_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawislandmanager_new();
        return $204508e5b4b18960$var$b.__wrap(I);
    }
    forEachActiveRigidBodyHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawislandmanager_forEachActiveRigidBodyHandle(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$W {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$W.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawkinematiccharactercontroller_free(I);
    }
    constructor(I){
        const g = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_new(I);
        return $204508e5b4b18960$var$W.__wrap(g);
    }
    up() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_up(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    setUp(I) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setUp(this.ptr, I.ptr);
    }
    offset() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_offset(this.ptr);
    }
    setOffset(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setOffset(this.ptr, I);
    }
    slideEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_slideEnabled(this.ptr);
    }
    setSlideEnabled(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setSlideEnabled(this.ptr, I);
    }
    autostepMaxHeight() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepMaxHeight(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    autostepMinWidth() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepMinWidth(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    autostepIncludesDynamicBodies() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepIncludesDynamicBodies(this.ptr);
        return 16777215 === I ? void 0 : 0 !== I;
    }
    autostepEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepEnabled(this.ptr);
    }
    enableAutostep(I, g, C) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_enableAutostep(this.ptr, I, g, C);
    }
    disableAutostep() {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_disableAutostep(this.ptr);
    }
    maxSlopeClimbAngle() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.ptr);
    }
    setMaxSlopeClimbAngle(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setMaxSlopeClimbAngle(this.ptr, I);
    }
    minSlopeSlideAngle() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_minSlopeSlideAngle(this.ptr);
    }
    setMinSlopeSlideAngle(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setMinSlopeSlideAngle(this.ptr, I);
    }
    snapToGroundDistance() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_snapToGroundDistance(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    enableSnapToGround(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_enableSnapToGround(this.ptr, I);
    }
    disableSnapToGround() {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_disableSnapToGround(this.ptr);
    }
    snapToGroundEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_snapToGroundEnabled(this.ptr);
    }
    computeColliderMovement(g, C, B, Q, i, D, o, G, w, k, S) {
        try {
            $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$V), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computeColliderMovement(this.ptr, g, C.ptr, B.ptr, Q.ptr, i, D.ptr, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(S));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    computedMovement() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedMovement(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    computedGrounded() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedGrounded(this.ptr);
    }
    numComputedCollisions() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_numComputedCollisions(this.ptr) >>> 0;
    }
    computedCollision(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$H);
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedCollision(this.ptr, I, g.ptr);
    }
}
class $204508e5b4b18960$var$j {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$j.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawmultibodyjointset_free(I);
    }
    jointType(I) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointType(this.ptr, I) >>> 0;
    }
    jointFrameX1(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointFrameX1(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    jointFrameX2(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointFrameX2(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    jointAnchor1(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointAnchor1(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    jointAnchor2(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointAnchor2(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    jointContactsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_jointContactsEnabled(this.ptr, I);
    }
    jointSetContactsEnabled(I, g) {
        $204508e5b4b18960$var$A.rawmultibodyjointset_jointSetContactsEnabled(this.ptr, I, g);
    }
    jointLimitsEnabled(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsEnabled(this.ptr, I, g);
    }
    jointLimitsMin(I, g) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsMin(this.ptr, I, g);
    }
    jointLimitsMax(I, g) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsMax(this.ptr, I, g);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawmultibodyjointset_new();
        return $204508e5b4b18960$var$j.__wrap(I);
    }
    createJoint(I, g, C, B) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$O);
        return $204508e5b4b18960$var$A.rawmultibodyjointset_createJoint(this.ptr, I.ptr, g, C, B);
    }
    remove(I, g) {
        $204508e5b4b18960$var$A.rawmultibodyjointset_remove(this.ptr, I, g);
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_contains(this.ptr, I);
    }
    forEachJointHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawmultibodyjointset_forEachJointHandle(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    forEachJointAttachedToRigidBody(g, C) {
        try {
            $204508e5b4b18960$var$A.rawmultibodyjointset_forEachJointAttachedToRigidBody(this.ptr, g, $204508e5b4b18960$var$J(C));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$x {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$x.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawnarrowphase_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawnarrowphase_new();
        return $204508e5b4b18960$var$x.__wrap(I);
    }
    contacts_with(I, g) {
        $204508e5b4b18960$var$A.rawnarrowphase_contacts_with(this.ptr, I, $204508e5b4b18960$var$Q(g));
    }
    contact_pair(I, g) {
        const C = $204508e5b4b18960$var$A.rawnarrowphase_contact_pair(this.ptr, I, g);
        return 0 === C ? void 0 : $204508e5b4b18960$var$e.__wrap(C);
    }
    intersections_with(I, g) {
        $204508e5b4b18960$var$A.rawnarrowphase_intersections_with(this.ptr, I, $204508e5b4b18960$var$Q(g));
    }
    intersection_pair(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawnarrowphase_intersection_pair(this.ptr, I, g);
    }
}
class $204508e5b4b18960$var$f {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$f.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawphysicspipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawphysicspipeline_new();
        return $204508e5b4b18960$var$f.__wrap(I);
    }
    step(I, g, C, B, Q, E, i, D, o, G) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$Z), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$b), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$Y), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$x), $204508e5b4b18960$var$a(E, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$n), $204508e5b4b18960$var$a(o, $204508e5b4b18960$var$j), $204508e5b4b18960$var$a(G, $204508e5b4b18960$var$L), $204508e5b4b18960$var$A.rawphysicspipeline_step(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, E.ptr, i.ptr, D.ptr, o.ptr, G.ptr);
    }
    stepWithEvents(I, g, C, B, E, i, D, o, G, w, k, S, M, K) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$Z), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$b), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$Y), $204508e5b4b18960$var$a(E, $204508e5b4b18960$var$x), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(o, $204508e5b4b18960$var$n), $204508e5b4b18960$var$a(G, $204508e5b4b18960$var$j), $204508e5b4b18960$var$a(w, $204508e5b4b18960$var$L), $204508e5b4b18960$var$a(k, $204508e5b4b18960$var$T), $204508e5b4b18960$var$A.rawphysicspipeline_stepWithEvents(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, E.ptr, i.ptr, D.ptr, o.ptr, G.ptr, w.ptr, k.ptr, $204508e5b4b18960$var$Q(S), $204508e5b4b18960$var$Q(M), $204508e5b4b18960$var$Q(K));
    }
}
class $204508e5b4b18960$var$m {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$m.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawpointcolliderprojection_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_colliderHandle(this.ptr);
    }
    point() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedMovement(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    isInside() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedGrounded(this.ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_featureType(this.ptr) >>> 0;
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawpointcolliderprojection_featureId(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$X {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$X.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawpointprojection_free(I);
    }
    point() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedMovement(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    isInside() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedGrounded(this.ptr);
    }
}
class $204508e5b4b18960$var$V {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$V.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawquerypipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawquerypipeline_new();
        return $204508e5b4b18960$var$V.__wrap(I);
    }
    update(I, g) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$l), $204508e5b4b18960$var$A.rawquerypipeline_update(this.ptr, I.ptr, g.ptr);
    }
    castRay(g, C, B, Q, i, D, o, G, w, k, S) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$QA);
            const M = $204508e5b4b18960$var$A.rawquerypipeline_castRay(this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i, D, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(S));
            return 0 === M ? void 0 : $204508e5b4b18960$var$z.__wrap(M);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    castRayAndGetNormal(g, C, B, Q, i, D, o, G, w, k, S) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$QA);
            const M = $204508e5b4b18960$var$A.rawquerypipeline_castRayAndGetNormal(this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i, D, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(S));
            return 0 === M ? void 0 : $204508e5b4b18960$var$P.__wrap(M);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    intersectionsWithRay(g, C, B, Q, i, D, o, G, w, k, S, M) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithRay(this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i, D, $204508e5b4b18960$var$J(o), G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(M));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    intersectionWithShape(g, C, B, Q, i, o, w, k, S, M) {
        try {
            const h = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionWithShape(h, this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i.ptr, o, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(M));
            var K = $204508e5b4b18960$var$G()[h / 4 + 0], U = $204508e5b4b18960$var$D()[h / 8 + 1];
            return 0 === K ? void 0 : U;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16), $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    projectPoint(g, C, B, Q, i, D, o, G, w) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
            const k = $204508e5b4b18960$var$A.rawquerypipeline_projectPoint(this.ptr, g.ptr, C.ptr, B.ptr, Q, i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, $204508e5b4b18960$var$J(w));
            return 0 === k ? void 0 : $204508e5b4b18960$var$m.__wrap(k);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    projectPointAndGetFeature(g, C, B, Q, i, D, o, G) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
            const w = $204508e5b4b18960$var$A.rawquerypipeline_projectPointAndGetFeature(this.ptr, g.ptr, C.ptr, B.ptr, Q, !$204508e5b4b18960$var$E(i), $204508e5b4b18960$var$E(i) ? 0 : i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, $204508e5b4b18960$var$J(G));
            return 0 === w ? void 0 : $204508e5b4b18960$var$m.__wrap(w);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    intersectionsWithPoint(g, C, B, Q, i, D, o, G, w) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithPoint(this.ptr, g.ptr, C.ptr, B.ptr, $204508e5b4b18960$var$J(Q), i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, $204508e5b4b18960$var$J(w));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    castShape(g, C, B, Q, i, D, o, G, w, k, S, M, K) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$IA);
            const U = $204508e5b4b18960$var$A.rawquerypipeline_castShape(this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i.ptr, D.ptr, o, G, w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, !$204508e5b4b18960$var$E(M), $204508e5b4b18960$var$E(M) ? 0 : M, $204508e5b4b18960$var$J(K));
            return 0 === U ? void 0 : $204508e5b4b18960$var$gA.__wrap(U);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    intersectionsWithShape(g, C, B, Q, i, D, o, G, w, k, S) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithShape(this.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, i.ptr, $204508e5b4b18960$var$J(D), o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(S));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    collidersWithAabbIntersectingAabb(g, C, B) {
        try {
            $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawquerypipeline_collidersWithAabbIntersectingAabb(this.ptr, g.ptr, C.ptr, $204508e5b4b18960$var$J(B));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$P {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$P.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawraycolliderintersection_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.ptr);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawraycolliderintersection_normal(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawraycolliderintersection_toi(this.ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawraycolliderintersection_featureType(this.ptr) >>> 0;
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawraycolliderintersection_featureId(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$z {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$z.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawraycollidertoi_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.ptr);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
}
class $204508e5b4b18960$var$u {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$u.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrayintersection_free(I);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawrayintersection_featureType(this.ptr) >>> 0;
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawrayintersection_featureId(C, this.ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$v {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$v.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrigidbodyset_free(I);
    }
    rbTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbTranslation(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbRotation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbRotation(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    rbSleep(I) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSleep(this.ptr, I);
    }
    rbIsSleeping(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsSleeping(this.ptr, I);
    }
    rbIsMoving(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsMoving(this.ptr, I);
    }
    rbNextTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbNextTranslation(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbNextRotation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbNextRotation(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    rbSetTranslation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetTranslation(this.ptr, I, g, C, B, Q);
    }
    rbSetRotation(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetRotation(this.ptr, I, g, C, B, Q, E);
    }
    rbSetLinvel(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetLinvel(this.ptr, I, g.ptr, C);
    }
    rbSetAngvel(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAngvel(this.ptr, I, g.ptr, C);
    }
    rbSetNextKinematicTranslation(I, g, C, B) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetNextKinematicTranslation(this.ptr, I, g, C, B);
    }
    rbSetNextKinematicRotation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetNextKinematicRotation(this.ptr, I, g, C, B, Q);
    }
    rbRecomputeMassPropertiesFromColliders(I, g) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$l), $204508e5b4b18960$var$A.rawrigidbodyset_rbRecomputeMassPropertiesFromColliders(this.ptr, I, g.ptr);
    }
    rbSetAdditionalMass(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAdditionalMass(this.ptr, I, g, C);
    }
    rbSetAdditionalMassProperties(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAdditionalMassProperties(this.ptr, I, g, C.ptr, B.ptr, Q.ptr, E);
    }
    rbLinvel(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbLinvel(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbAngvel(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbAngvel(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbLockTranslations(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbLockTranslations(this.ptr, I, g, C);
    }
    rbSetEnabledTranslations(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabledTranslations(this.ptr, I, g, C, B, Q);
    }
    rbLockRotations(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbLockRotations(this.ptr, I, g, C);
    }
    rbSetEnabledRotations(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabledRotations(this.ptr, I, g, C, B, Q);
    }
    rbDominanceGroup(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbDominanceGroup(this.ptr, I);
    }
    rbSetDominanceGroup(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetDominanceGroup(this.ptr, I, g);
    }
    rbEnableCcd(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbEnableCcd(this.ptr, I, g);
    }
    rbMass(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbMass(this.ptr, I);
    }
    rbInvMass(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbInvMass(this.ptr, I);
    }
    rbEffectiveInvMass(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveInvMass(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbLocalCom(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbLocalCom(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbWorldCom(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbWorldCom(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbInvPrincipalInertiaSqrt(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbInvPrincipalInertiaSqrt(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbPrincipalInertiaLocalFrame(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbPrincipalInertiaLocalFrame(this.ptr, I);
        return $204508e5b4b18960$var$_.__wrap(g);
    }
    rbPrincipalInertia(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbPrincipalInertia(this.ptr, I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    rbEffectiveWorldInvInertiaSqrt(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveWorldInvInertiaSqrt(this.ptr, I);
        return $204508e5b4b18960$var$$.__wrap(g);
    }
    rbEffectiveAngularInertia(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveAngularInertia(this.ptr, I);
        return $204508e5b4b18960$var$$.__wrap(g);
    }
    rbWakeUp(I) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbWakeUp(this.ptr, I);
    }
    rbIsCcdEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsCcdEnabled(this.ptr, I);
    }
    rbNumColliders(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbNumColliders(this.ptr, I) >>> 0;
    }
    rbCollider(I, g) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbCollider(this.ptr, I, g);
    }
    rbBodyType(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbBodyType(this.ptr, I) >>> 0;
    }
    rbSetBodyType(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetBodyType(this.ptr, I, g, C);
    }
    rbIsFixed(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsFixed(this.ptr, I);
    }
    rbIsKinematic(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsKinematic(this.ptr, I);
    }
    rbIsDynamic(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsDynamic(this.ptr, I);
    }
    rbLinearDamping(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbLinearDamping(this.ptr, I);
    }
    rbAngularDamping(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbAngularDamping(this.ptr, I);
    }
    rbSetLinearDamping(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetLinearDamping(this.ptr, I, g);
    }
    rbSetAngularDamping(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAngularDamping(this.ptr, I, g);
    }
    rbSetEnabled(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabled(this.ptr, I, g);
    }
    rbIsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsEnabled(this.ptr, I);
    }
    rbGravityScale(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbGravityScale(this.ptr, I);
    }
    rbSetGravityScale(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetGravityScale(this.ptr, I, g, C);
    }
    rbResetForces(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbResetForces(this.ptr, I, g);
    }
    rbResetTorques(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbResetTorques(this.ptr, I, g);
    }
    rbAddForce(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddForce(this.ptr, I, g.ptr, C);
    }
    rbApplyImpulse(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyImpulse(this.ptr, I, g.ptr, C);
    }
    rbAddTorque(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddTorque(this.ptr, I, g.ptr, C);
    }
    rbApplyTorqueImpulse(I, g, C) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyTorqueImpulse(this.ptr, I, g.ptr, C);
    }
    rbAddForceAtPoint(I, g, C, B) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddForceAtPoint(this.ptr, I, g.ptr, C.ptr, B);
    }
    rbApplyImpulseAtPoint(I, g, C, B) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyImpulseAtPoint(this.ptr, I, g.ptr, C.ptr, B);
    }
    rbUserData(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbUserData(this.ptr, I) >>> 0;
    }
    rbSetUserData(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetUserData(this.ptr, I, g);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawrigidbodyset_new();
        return $204508e5b4b18960$var$v.__wrap(I);
    }
    createRigidBody(I, g, C, B, Q, E, i, D, o, G, w, k, S, M, K, y, J, U, h, N, F, q, R, s) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(o, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(G, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(w, $204508e5b4b18960$var$_);
        return $204508e5b4b18960$var$A.rawrigidbodyset_createRigidBody(this.ptr, I, g.ptr, C.ptr, B, Q, E, i.ptr, D.ptr, o.ptr, G.ptr, w.ptr, k, S, M, K, y, J, U, h, N, F, q, R, s);
    }
    remove(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$b), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$n), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$j), $204508e5b4b18960$var$A.rawrigidbodyset_remove(this.ptr, I, g.ptr, C.ptr, B.ptr, Q.ptr);
    }
    len() {
        return $204508e5b4b18960$var$A.rawrigidbodyset_len(this.ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_contains(this.ptr, I);
    }
    forEachRigidBodyHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawrigidbodyset_forEachRigidBodyHandle(this.ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$y++] = void 0;
        }
    }
    propagateModifiedBodyPositionsToColliders(I) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$l), $204508e5b4b18960$var$A.rawrigidbodyset_propagateModifiedBodyPositionsToColliders(this.ptr, I.ptr);
    }
}
class $204508e5b4b18960$var$_ {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$_.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrotation_free(I);
    }
    constructor(I, g, C, B){
        const Q = $204508e5b4b18960$var$A.rawrotation_new(I, g, C, B);
        return $204508e5b4b18960$var$_.__wrap(Q);
    }
    static identity() {
        const I = $204508e5b4b18960$var$A.rawrotation_identity();
        return $204508e5b4b18960$var$_.__wrap(I);
    }
    get x() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.ptr);
    }
    get y() {
        return $204508e5b4b18960$var$A.rawrotation_y(this.ptr);
    }
    get z() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    get w() {
        return $204508e5b4b18960$var$A.rawrotation_w(this.ptr);
    }
}
class $204508e5b4b18960$var$$ {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$$.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawsdpmatrix3_free(I);
    }
    elements() {
        return $204508e5b4b18960$var$B($204508e5b4b18960$var$A.rawsdpmatrix3_elements(this.ptr));
    }
}
class $204508e5b4b18960$var$AA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$AA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawserializationpipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawserializationpipeline_new();
        return $204508e5b4b18960$var$AA.__wrap(I);
    }
    serializeAll(I, g, C, Q, E, i, D, o, G) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$Z), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$b), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$Y), $204508e5b4b18960$var$a(E, $204508e5b4b18960$var$x), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$v), $204508e5b4b18960$var$a(D, $204508e5b4b18960$var$l), $204508e5b4b18960$var$a(o, $204508e5b4b18960$var$n), $204508e5b4b18960$var$a(G, $204508e5b4b18960$var$j);
        return $204508e5b4b18960$var$B($204508e5b4b18960$var$A.rawserializationpipeline_serializeAll(this.ptr, I.ptr, g.ptr, C.ptr, Q.ptr, E.ptr, i.ptr, D.ptr, o.ptr, G.ptr));
    }
    deserializeAll(I) {
        const g = $204508e5b4b18960$var$A.rawserializationpipeline_deserializeAll(this.ptr, $204508e5b4b18960$var$Q(I));
        return 0 === g ? void 0 : $204508e5b4b18960$var$d.__wrap(g);
    }
}
class $204508e5b4b18960$var$IA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$IA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshape_free(I);
    }
    static cuboid(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_cuboid(I, g, C);
        return $204508e5b4b18960$var$IA.__wrap(B);
    }
    static roundCuboid(I, g, C, B) {
        const Q = $204508e5b4b18960$var$A.rawshape_roundCuboid(I, g, C, B);
        return $204508e5b4b18960$var$IA.__wrap(Q);
    }
    static ball(I) {
        const g = $204508e5b4b18960$var$A.rawshape_ball(I);
        return $204508e5b4b18960$var$IA.__wrap(g);
    }
    static halfspace(I) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA);
        const g = $204508e5b4b18960$var$A.rawshape_halfspace(I.ptr);
        return $204508e5b4b18960$var$IA.__wrap(g);
    }
    static capsule(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_capsule(I, g);
        return $204508e5b4b18960$var$IA.__wrap(C);
    }
    static cylinder(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_cylinder(I, g);
        return $204508e5b4b18960$var$IA.__wrap(C);
    }
    static roundCylinder(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_roundCylinder(I, g, C);
        return $204508e5b4b18960$var$IA.__wrap(B);
    }
    static cone(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_cone(I, g);
        return $204508e5b4b18960$var$IA.__wrap(C);
    }
    static roundCone(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_roundCone(I, g, C);
        return $204508e5b4b18960$var$IA.__wrap(B);
    }
    static polyline(I, g) {
        const C = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$R(g, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F, i = $204508e5b4b18960$var$A.rawshape_polyline(C, B, Q, E);
        return $204508e5b4b18960$var$IA.__wrap(i);
    }
    static trimesh(I, g) {
        const C = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$R(g, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F, i = $204508e5b4b18960$var$A.rawshape_trimesh(C, B, Q, E);
        return $204508e5b4b18960$var$IA.__wrap(i);
    }
    static heightfield(I, g, C, B) {
        const Q = $204508e5b4b18960$var$q(C, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F;
        $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
        const i = $204508e5b4b18960$var$A.rawshape_heightfield(I, g, Q, E, B.ptr);
        return $204508e5b4b18960$var$IA.__wrap(i);
    }
    static segment(I, g) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA);
        const C = $204508e5b4b18960$var$A.rawshape_segment(I.ptr, g.ptr);
        return $204508e5b4b18960$var$IA.__wrap(C);
    }
    static triangle(I, g, C) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const B = $204508e5b4b18960$var$A.rawshape_triangle(I.ptr, g.ptr, C.ptr);
        return $204508e5b4b18960$var$IA.__wrap(B);
    }
    static roundTriangle(I, g, C, B) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const Q = $204508e5b4b18960$var$A.rawshape_roundTriangle(I.ptr, g.ptr, C.ptr, B);
        return $204508e5b4b18960$var$IA.__wrap(Q);
    }
    static convexHull(I) {
        const g = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), C = $204508e5b4b18960$var$F, B = $204508e5b4b18960$var$A.rawshape_convexHull(g, C);
        return 0 === B ? void 0 : $204508e5b4b18960$var$IA.__wrap(B);
    }
    static roundConvexHull(I, g) {
        const C = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$A.rawshape_roundConvexHull(C, B, g);
        return 0 === Q ? void 0 : $204508e5b4b18960$var$IA.__wrap(Q);
    }
    static convexMesh(I, g) {
        const C = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$R(g, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F, i = $204508e5b4b18960$var$A.rawshape_convexMesh(C, B, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$IA.__wrap(i);
    }
    static roundConvexMesh(I, g, C) {
        const B = $204508e5b4b18960$var$q(I, $204508e5b4b18960$var$A.__wbindgen_malloc), Q = $204508e5b4b18960$var$F, E = $204508e5b4b18960$var$R(g, $204508e5b4b18960$var$A.__wbindgen_malloc), i = $204508e5b4b18960$var$F, D = $204508e5b4b18960$var$A.rawshape_roundConvexMesh(B, Q, E, i, C);
        return 0 === D ? void 0 : $204508e5b4b18960$var$IA.__wrap(D);
    }
    castShape(I, g, C, B, Q, E, i, D, o) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(E, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(i, $204508e5b4b18960$var$QA);
        const G = $204508e5b4b18960$var$A.rawshape_castShape(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, E.ptr, i.ptr, D, o);
        return 0 === G ? void 0 : $204508e5b4b18960$var$BA.__wrap(G);
    }
    intersectsShape(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_);
        return 0 !== $204508e5b4b18960$var$A.rawshape_intersectsShape(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q.ptr);
    }
    contactShape(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(Q, $204508e5b4b18960$var$_);
        const i = $204508e5b4b18960$var$A.rawshape_contactShape(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q.ptr, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$CA.__wrap(i);
    }
    containsPoint(I, g, C) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        return 0 !== $204508e5b4b18960$var$A.rawshape_containsPoint(this.ptr, I.ptr, g.ptr, C.ptr);
    }
    projectPoint(I, g, C, B) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA);
        const Q = $204508e5b4b18960$var$A.rawshape_projectPoint(this.ptr, I.ptr, g.ptr, C.ptr, B);
        return $204508e5b4b18960$var$X.__wrap(Q);
    }
    intersectsRay(I, g, C, B, Q) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
        return 0 !== $204508e5b4b18960$var$A.rawshape_intersectsRay(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q);
    }
    castRay(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
        return $204508e5b4b18960$var$A.rawshape_castRay(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q, E);
    }
    castRayAndGetNormal(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$a(I, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(g, $204508e5b4b18960$var$_), $204508e5b4b18960$var$a(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$a(B, $204508e5b4b18960$var$QA);
        const i = $204508e5b4b18960$var$A.rawshape_castRayAndGetNormal(this.ptr, I.ptr, g.ptr, C.ptr, B.ptr, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$u.__wrap(i);
    }
}
class $204508e5b4b18960$var$gA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$gA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshapecollidertoi_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.ptr);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    witness1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    witness2() {
        const I = $204508e5b4b18960$var$A.rawshapecollidertoi_witness2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawshapecollidertoi_normal2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
}
class $204508e5b4b18960$var$CA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$CA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshapecontact_free(I);
    }
    distance() {
        return $204508e5b4b18960$var$A.rawshapecontact_distance(this.ptr);
    }
    point1() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedMovement(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    point2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawshapecollidertoi_witness2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
}
class $204508e5b4b18960$var$BA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$BA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshapetoi_free(I);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.ptr);
    }
    witness1() {
        const I = $204508e5b4b18960$var$A.rawshapetoi_witness1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    witness2() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_total_force(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawshapetoi_normal1(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawshapetoi_normal2(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
}
class $204508e5b4b18960$var$QA {
    static __wrap(A) {
        const I = Object.create($204508e5b4b18960$var$QA.prototype);
        return I.ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.ptr;
        return this.ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawvector_free(I);
    }
    static zero() {
        const I = $204508e5b4b18960$var$A.rawvector_zero();
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    constructor(I, g, C){
        const B = $204508e5b4b18960$var$A.rawvector_new(I, g, C);
        return $204508e5b4b18960$var$QA.__wrap(B);
    }
    get x() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.ptr);
    }
    set x(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_dt(this.ptr, I);
    }
    get y() {
        return $204508e5b4b18960$var$A.rawrotation_y(this.ptr);
    }
    set y(I) {
        $204508e5b4b18960$var$A.rawvector_set_y(this.ptr, I);
    }
    get z() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.ptr);
    }
    set z(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_erp(this.ptr, I);
    }
    xyz() {
        const I = $204508e5b4b18960$var$A.rawvector_xyz(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    yxz() {
        const I = $204508e5b4b18960$var$A.rawvector_yxz(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    zxy() {
        const I = $204508e5b4b18960$var$A.rawvector_zxy(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    xzy() {
        const I = $204508e5b4b18960$var$A.rawvector_xzy(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    yzx() {
        const I = $204508e5b4b18960$var$A.rawvector_yzx(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
    zyx() {
        const I = $204508e5b4b18960$var$A.rawvector_zyx(this.ptr);
        return $204508e5b4b18960$var$QA.__wrap(I);
    }
}
async function $204508e5b4b18960$var$EA(I) {
    void 0 === I && (I = new URL("rapier_wasm3d_bg.wasm", "<deleted>"));
    const C = function() {
        const I = {
            wbg: {}
        };
        return I.wbg.__wbindgen_object_drop_ref = function(A) {
            $204508e5b4b18960$var$B(A);
        }, I.wbg.__wbindgen_number_new = function(A) {
            return $204508e5b4b18960$var$Q(A);
        }, I.wbg.__wbindgen_number_get = function(A, I) {
            const C = $204508e5b4b18960$var$g(I), B = "number" == typeof C ? C : void 0;
            $204508e5b4b18960$var$D()[A / 8 + 1] = $204508e5b4b18960$var$E(B) ? 0 : B, $204508e5b4b18960$var$G()[A / 4 + 0] = !$204508e5b4b18960$var$E(B);
        }, I.wbg.__wbindgen_boolean_get = function(A) {
            const I = $204508e5b4b18960$var$g(A);
            return "boolean" == typeof I ? I ? 1 : 0 : 2;
        }, I.wbg.__wbindgen_is_function = function(A) {
            return "function" == typeof $204508e5b4b18960$var$g(A);
        }, I.wbg.__wbg_rawraycolliderintersection_new = function(A) {
            return $204508e5b4b18960$var$Q($204508e5b4b18960$var$P.__wrap(A));
        }, I.wbg.__wbg_rawcontactforceevent_new = function(A) {
            return $204508e5b4b18960$var$Q($204508e5b4b18960$var$t.__wrap(A));
        }, I.wbg.__wbg_call_168da88779e35f61 = function() {
            return $204508e5b4b18960$var$s(function(A, I, C) {
                return $204508e5b4b18960$var$Q($204508e5b4b18960$var$g(A).call($204508e5b4b18960$var$g(I), $204508e5b4b18960$var$g(C)));
            }, arguments);
        }, I.wbg.__wbg_call_3999bee59e9f7719 = function() {
            return $204508e5b4b18960$var$s(function(A, I, C, B) {
                return $204508e5b4b18960$var$Q($204508e5b4b18960$var$g(A).call($204508e5b4b18960$var$g(I), $204508e5b4b18960$var$g(C), $204508e5b4b18960$var$g(B)));
            }, arguments);
        }, I.wbg.__wbg_call_e1f72c051cdab859 = function() {
            return $204508e5b4b18960$var$s(function(A, I, C, B, E) {
                return $204508e5b4b18960$var$Q($204508e5b4b18960$var$g(A).call($204508e5b4b18960$var$g(I), $204508e5b4b18960$var$g(C), $204508e5b4b18960$var$g(B), $204508e5b4b18960$var$g(E)));
            }, arguments);
        }, I.wbg.__wbg_bind_10dfe70e95d2a480 = function(A, I, C, B) {
            return $204508e5b4b18960$var$Q($204508e5b4b18960$var$g(A).bind($204508e5b4b18960$var$g(I), $204508e5b4b18960$var$g(C), $204508e5b4b18960$var$g(B)));
        }, I.wbg.__wbg_buffer_3f3d764d4747d564 = function(A) {
            return $204508e5b4b18960$var$Q($204508e5b4b18960$var$g(A).buffer);
        }, I.wbg.__wbg_newwithbyteoffsetandlength_d9aa266703cb98be = function(A, I, C) {
            return $204508e5b4b18960$var$Q(new Uint8Array($204508e5b4b18960$var$g(A), I >>> 0, C >>> 0));
        }, I.wbg.__wbg_new_8c3f0052272a457a = function(A) {
            return $204508e5b4b18960$var$Q(new Uint8Array($204508e5b4b18960$var$g(A)));
        }, I.wbg.__wbg_set_83db9690f9353e79 = function(A, I, C) {
            $204508e5b4b18960$var$g(A).set($204508e5b4b18960$var$g(I), C >>> 0);
        }, I.wbg.__wbg_length_9e1ae1900cb0fbd5 = function(A) {
            return $204508e5b4b18960$var$g(A).length;
        }, I.wbg.__wbg_newwithbyteoffsetandlength_be22e5fcf4f69ab4 = function(A, I, C) {
            return $204508e5b4b18960$var$Q(new Float32Array($204508e5b4b18960$var$g(A), I >>> 0, C >>> 0));
        }, I.wbg.__wbg_set_0e0314cf6675c1b9 = function(A, I, C) {
            $204508e5b4b18960$var$g(A).set($204508e5b4b18960$var$g(I), C >>> 0);
        }, I.wbg.__wbg_length_9a2deed95d22668d = function(A) {
            return $204508e5b4b18960$var$g(A).length;
        }, I.wbg.__wbg_newwithlength_a7168e4a1e8f5e12 = function(A) {
            return $204508e5b4b18960$var$Q(new Float32Array(A >>> 0));
        }, I.wbg.__wbindgen_throw = function(A, I) {
            throw new Error($204508e5b4b18960$var$S(A, I));
        }, I.wbg.__wbindgen_memory = function() {
            return $204508e5b4b18960$var$Q($204508e5b4b18960$var$A.memory);
        }, I;
    }();
    ("string" == typeof I || "function" == typeof Request && I instanceof Request || "function" == typeof URL && I instanceof URL) && (I = fetch(I));
    const { instance: w, module: a } = await async function(A, I) {
        if ("function" == typeof Response && A instanceof Response) {
            if ("function" == typeof WebAssembly.instantiateStreaming) try {
                return await WebAssembly.instantiateStreaming(A, I);
            } catch (I) {
                if ("application/wasm" == A.headers.get("Content-Type")) throw I;
                console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", I);
            }
            const g = await A.arrayBuffer();
            return await WebAssembly.instantiate(g, I);
        }
        {
            const g = await WebAssembly.instantiate(A, I);
            return g instanceof WebAssembly.Instance ? {
                instance: g,
                module: A
            } : g;
        }
    }(await I, C);
    return function(I, g) {
        return $204508e5b4b18960$var$A = I.exports, $204508e5b4b18960$var$EA.__wbindgen_wasm_module = g, $204508e5b4b18960$var$M = new Float32Array, $204508e5b4b18960$var$i = new Float64Array, $204508e5b4b18960$var$o = new Int32Array, $204508e5b4b18960$var$h = new Uint32Array, $204508e5b4b18960$var$k = new Uint8Array, $204508e5b4b18960$var$A;
    }(w, a);
}
class $204508e5b4b18960$export$64b5c384219d3699 {
    constructor(A, I, g){
        this.x = A, this.y = I, this.z = g;
    }
}
class $204508e5b4b18960$export$e2f642242c040d8f {
    static new(A, I, g) {
        return new $204508e5b4b18960$export$64b5c384219d3699(A, I, g);
    }
    static intoRaw(A) {
        return new $204508e5b4b18960$var$QA(A.x, A.y, A.z);
    }
    static zeros() {
        return $204508e5b4b18960$export$e2f642242c040d8f.new(0, 0, 0);
    }
    static fromRaw(A) {
        if (!A) return null;
        let I = $204508e5b4b18960$export$e2f642242c040d8f.new(A.x, A.y, A.z);
        return A.free(), I;
    }
    static copy(A, I) {
        A.x = I.x, A.y = I.y, A.z = I.z;
    }
}
class $204508e5b4b18960$export$23d6a54f0bbc85a3 {
    constructor(A, I, g, C){
        this.x = A, this.y = I, this.z = g, this.w = C;
    }
}
class $204508e5b4b18960$export$824960640e91b57 {
    static identity() {
        return new $204508e5b4b18960$export$23d6a54f0bbc85a3(0, 0, 0, 1);
    }
    static fromRaw(A) {
        if (!A) return null;
        let I = new $204508e5b4b18960$export$23d6a54f0bbc85a3(A.x, A.y, A.z, A.w);
        return A.free(), I;
    }
    static intoRaw(A) {
        return new $204508e5b4b18960$var$_(A.x, A.y, A.z, A.w);
    }
    static copy(A, I) {
        A.x = I.x, A.y = I.y, A.z = I.z, A.w = I.w;
    }
}
class $204508e5b4b18960$export$a634d4178dd6cfce {
    constructor(A){
        this.elements = A;
    }
    get m11() {
        return this.elements[0];
    }
    get m12() {
        return this.elements[1];
    }
    get m21() {
        return this.m12;
    }
    get m13() {
        return this.elements[2];
    }
    get m31() {
        return this.m13;
    }
    get m22() {
        return this.elements[3];
    }
    get m23() {
        return this.elements[4];
    }
    get m32() {
        return this.m23;
    }
    get m33() {
        return this.elements[5];
    }
}
class $204508e5b4b18960$export$afeef1d10fc8a4f3 {
    static fromRaw(A) {
        const I = new $204508e5b4b18960$export$a634d4178dd6cfce(A.elements());
        return A.free(), I;
    }
}
var $204508e5b4b18960$export$9df1fa60cce90854, $204508e5b4b18960$export$d8c34c2371473e33, $204508e5b4b18960$export$9fe5861f16a3846f, $204508e5b4b18960$export$5d7f3962eb4528af, $204508e5b4b18960$export$c40deacab7e2491c, $204508e5b4b18960$export$fc850f719b5599d5, $204508e5b4b18960$export$822f84f0c1c58b2a, $204508e5b4b18960$export$9d99ce4bda7104cf, $204508e5b4b18960$export$39a39008025d4cb, $204508e5b4b18960$export$f28998d26d157fd3, $204508e5b4b18960$export$194d8ad9e2dc63e8, $204508e5b4b18960$export$d50a7c063745a562;
!function(A) {
    A[A.Dynamic = 0] = "Dynamic", A[A.Fixed = 1] = "Fixed", A[A.KinematicPositionBased = 2] = "KinematicPositionBased", A[A.KinematicVelocityBased = 3] = "KinematicVelocityBased";
}($204508e5b4b18960$export$9df1fa60cce90854 || ($204508e5b4b18960$export$9df1fa60cce90854 = {}));
class $204508e5b4b18960$export$41c0a739a32ac4d {
    constructor(A, I, g){
        this.rawSet = A, this.colliderSet = I, this.handle = g;
    }
    finalizeDeserialization(A) {
        this.colliderSet = A;
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    lockTranslations(A, I) {
        return this.rawSet.rbLockTranslations(this.handle, A, I);
    }
    lockRotations(A, I) {
        return this.rawSet.rbLockRotations(this.handle, A, I);
    }
    setEnabledTranslations(A, I, g, C) {
        return this.rawSet.rbSetEnabledTranslations(this.handle, A, I, g, C);
    }
    restrictTranslations(A, I, g, C) {
        this.setEnabledTranslations(A, I, g, C);
    }
    setEnabledRotations(A, I, g, C) {
        return this.rawSet.rbSetEnabledRotations(this.handle, A, I, g, C);
    }
    restrictRotations(A, I, g, C) {
        this.setEnabledRotations(A, I, g, C);
    }
    dominanceGroup() {
        return this.rawSet.rbDominanceGroup(this.handle);
    }
    setDominanceGroup(A) {
        this.rawSet.rbSetDominanceGroup(this.handle, A);
    }
    enableCcd(A) {
        this.rawSet.rbEnableCcd(this.handle, A);
    }
    translation() {
        let A = this.rawSet.rbTranslation(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    rotation() {
        let A = this.rawSet.rbRotation(this.handle);
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(A);
    }
    nextTranslation() {
        let A = this.rawSet.rbNextTranslation(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    nextRotation() {
        let A = this.rawSet.rbNextRotation(this.handle);
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(A);
    }
    setTranslation(A, I) {
        this.rawSet.rbSetTranslation(this.handle, A.x, A.y, A.z, I);
    }
    setLinvel(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbSetLinvel(this.handle, g, I), g.free();
    }
    gravityScale() {
        return this.rawSet.rbGravityScale(this.handle);
    }
    setGravityScale(A, I) {
        this.rawSet.rbSetGravityScale(this.handle, A, I);
    }
    setRotation(A, I) {
        this.rawSet.rbSetRotation(this.handle, A.x, A.y, A.z, A.w, I);
    }
    setAngvel(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbSetAngvel(this.handle, g, I), g.free();
    }
    setNextKinematicTranslation(A) {
        this.rawSet.rbSetNextKinematicTranslation(this.handle, A.x, A.y, A.z);
    }
    setNextKinematicRotation(A) {
        this.rawSet.rbSetNextKinematicRotation(this.handle, A.x, A.y, A.z, A.w);
    }
    linvel() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbLinvel(this.handle));
    }
    angvel() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbAngvel(this.handle));
    }
    mass() {
        return this.rawSet.rbMass(this.handle);
    }
    effectiveInvMass() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbEffectiveInvMass(this.handle));
    }
    invMass() {
        return this.rawSet.rbInvMass(this.handle);
    }
    localCom() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbLocalCom(this.handle));
    }
    worldCom() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbWorldCom(this.handle));
    }
    invPrincipalInertiaSqrt() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbInvPrincipalInertiaSqrt(this.handle));
    }
    principalInertia() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbPrincipalInertia(this.handle));
    }
    principalInertiaLocalFrame() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.rbPrincipalInertiaLocalFrame(this.handle));
    }
    effectiveWorldInvInertiaSqrt() {
        return $204508e5b4b18960$export$afeef1d10fc8a4f3.fromRaw(this.rawSet.rbEffectiveWorldInvInertiaSqrt(this.handle));
    }
    effectiveAngularInertia() {
        return $204508e5b4b18960$export$afeef1d10fc8a4f3.fromRaw(this.rawSet.rbEffectiveAngularInertia(this.handle));
    }
    sleep() {
        this.rawSet.rbSleep(this.handle);
    }
    wakeUp() {
        this.rawSet.rbWakeUp(this.handle);
    }
    isCcdEnabled() {
        return this.rawSet.rbIsCcdEnabled(this.handle);
    }
    numColliders() {
        return this.rawSet.rbNumColliders(this.handle);
    }
    collider(A) {
        return this.colliderSet.get(this.rawSet.rbCollider(this.handle, A));
    }
    setEnabled(A) {
        this.rawSet.rbSetEnabled(this.handle, A);
    }
    isEnabled() {
        return this.rawSet.rbIsEnabled(this.handle);
    }
    bodyType() {
        return this.rawSet.rbBodyType(this.handle);
    }
    setBodyType(A, I) {
        return this.rawSet.rbSetBodyType(this.handle, A, I);
    }
    isSleeping() {
        return this.rawSet.rbIsSleeping(this.handle);
    }
    isMoving() {
        return this.rawSet.rbIsMoving(this.handle);
    }
    isFixed() {
        return this.rawSet.rbIsFixed(this.handle);
    }
    isKinematic() {
        return this.rawSet.rbIsKinematic(this.handle);
    }
    isDynamic() {
        return this.rawSet.rbIsDynamic(this.handle);
    }
    linearDamping() {
        return this.rawSet.rbLinearDamping(this.handle);
    }
    angularDamping() {
        return this.rawSet.rbAngularDamping(this.handle);
    }
    setLinearDamping(A) {
        this.rawSet.rbSetLinearDamping(this.handle, A);
    }
    recomputeMassPropertiesFromColliders() {
        this.rawSet.rbRecomputeMassPropertiesFromColliders(this.handle, this.colliderSet.raw);
    }
    setAdditionalMass(A, I) {
        this.rawSet.rbSetAdditionalMass(this.handle, A, I);
    }
    setAdditionalMassProperties(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), i = $204508e5b4b18960$export$824960640e91b57.intoRaw(C);
        this.rawSet.rbSetAdditionalMassProperties(this.handle, A, Q, E, i, B), Q.free(), E.free(), i.free();
    }
    setAngularDamping(A) {
        this.rawSet.rbSetAngularDamping(this.handle, A);
    }
    resetForces(A) {
        this.rawSet.rbResetForces(this.handle, A);
    }
    resetTorques(A) {
        this.rawSet.rbResetTorques(this.handle, A);
    }
    addForce(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbAddForce(this.handle, g, I), g.free();
    }
    applyImpulse(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbApplyImpulse(this.handle, g, I), g.free();
    }
    addTorque(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbAddTorque(this.handle, g, I), g.free();
    }
    applyTorqueImpulse(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbApplyTorqueImpulse(this.handle, g, I), g.free();
    }
    addForceAtPoint(A, I, g) {
        const C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.rawSet.rbAddForceAtPoint(this.handle, C, B, g), C.free(), B.free();
    }
    applyImpulseAtPoint(A, I, g) {
        const C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.rawSet.rbApplyImpulseAtPoint(this.handle, C, B, g), C.free(), B.free();
    }
}
class $204508e5b4b18960$export$105dcb996a5d3c42 {
    constructor(A){
        this.enabled = !0, this.status = A, this.translation = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.rotation = $204508e5b4b18960$export$824960640e91b57.identity(), this.gravityScale = 1, this.linvel = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.mass = 0, this.massOnly = !1, this.centerOfMass = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.translationsEnabledX = !0, this.translationsEnabledY = !0, this.angvel = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.principalAngularInertia = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.angularInertiaLocalFrame = $204508e5b4b18960$export$824960640e91b57.identity(), this.translationsEnabledZ = !0, this.rotationsEnabledX = !0, this.rotationsEnabledY = !0, this.rotationsEnabledZ = !0, this.linearDamping = 0, this.angularDamping = 0, this.canSleep = !0, this.sleeping = !1, this.ccdEnabled = !1, this.dominanceGroup = 0;
    }
    static dynamic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Dynamic);
    }
    static kinematicPositionBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicPositionBased);
    }
    static kinematicVelocityBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicVelocityBased);
    }
    static fixed() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Fixed);
    }
    static newDynamic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Dynamic);
    }
    static newKinematicPositionBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicPositionBased);
    }
    static newKinematicVelocityBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicVelocityBased);
    }
    static newStatic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Fixed);
    }
    setDominanceGroup(A) {
        return this.dominanceGroup = A, this;
    }
    setEnabled(A) {
        return this.enabled = A, this;
    }
    setTranslation(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The translation components must be numbers.");
        return this.translation = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setRotation(A) {
        return $204508e5b4b18960$export$824960640e91b57.copy(this.rotation, A), this;
    }
    setGravityScale(A) {
        return this.gravityScale = A, this;
    }
    setAdditionalMass(A) {
        return this.mass = A, this.massOnly = !0, this;
    }
    setLinvel(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The linvel components must be numbers.");
        return this.linvel = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setAngvel(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.copy(this.angvel, A), this;
    }
    setAdditionalMassProperties(A, I, g, C) {
        return this.mass = A, $204508e5b4b18960$export$e2f642242c040d8f.copy(this.centerOfMass, I), $204508e5b4b18960$export$e2f642242c040d8f.copy(this.principalAngularInertia, g), $204508e5b4b18960$export$824960640e91b57.copy(this.angularInertiaLocalFrame, C), this.massOnly = !1, this;
    }
    enabledTranslations(A, I, g) {
        return this.translationsEnabledX = A, this.translationsEnabledY = I, this.translationsEnabledZ = g, this;
    }
    restrictTranslations(A, I, g) {
        return this.enabledTranslations(A, I, g);
    }
    lockTranslations() {
        return this.enabledTranslations(!1, !1, !1);
    }
    enabledRotations(A, I, g) {
        return this.rotationsEnabledX = A, this.rotationsEnabledY = I, this.rotationsEnabledZ = g, this;
    }
    restrictRotations(A, I, g) {
        return this.enabledRotations(A, I, g);
    }
    lockRotations() {
        return this.restrictRotations(!1, !1, !1);
    }
    setLinearDamping(A) {
        return this.linearDamping = A, this;
    }
    setAngularDamping(A) {
        return this.angularDamping = A, this;
    }
    setCanSleep(A) {
        return this.canSleep = A, this;
    }
    setSleeping(A) {
        return this.sleeping = A, this;
    }
    setCcdEnabled(A) {
        return this.ccdEnabled = A, this;
    }
    setUserData(A) {
        return this.userData = A, this;
    }
}
class $204508e5b4b18960$var$YA {
    constructor(){
        this.fconv = new Float64Array(1), this.uconv = new Uint32Array(this.fconv.buffer), this.data = new Array, this.size = 0;
    }
    set(A, I) {
        let g = this.index(A);
        for(; this.data.length <= g;)this.data.push(null);
        null == this.data[g] && (this.size += 1), this.data[g] = I;
    }
    len() {
        return this.size;
    }
    delete(A) {
        let I = this.index(A);
        I < this.data.length && (null != this.data[I] && (this.size -= 1), this.data[I] = null);
    }
    clear() {
        this.data = new Array;
    }
    get(A) {
        let I = this.index(A);
        return I < this.data.length ? this.data[I] : null;
    }
    forEach(A) {
        for (const I of this.data)null != I && A(I);
    }
    getAll() {
        return this.data.filter((A)=>null != A);
    }
    index(A) {
        return this.fconv[0] = A, this.uconv[0];
    }
}
class $204508e5b4b18960$export$bd569bf5451ee055 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$v, this.map = new $204508e5b4b18960$var$YA, A && A.forEachRigidBodyHandle((I)=>{
            this.map.set(I, new $204508e5b4b18960$export$41c0a739a32ac4d(A, null, I));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createRigidBody(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.translation), C = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.rotation), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.linvel), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.centerOfMass), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.angvel), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.principalAngularInertia), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.angularInertiaLocalFrame), o = this.raw.createRigidBody(I.enabled, g, C, I.gravityScale, I.mass, I.massOnly, Q, B, E, i, D, I.translationsEnabledX, I.translationsEnabledY, I.translationsEnabledZ, I.rotationsEnabledX, I.rotationsEnabledY, I.rotationsEnabledZ, I.linearDamping, I.angularDamping, I.status, I.canSleep, I.sleeping, I.ccdEnabled, I.dominanceGroup);
        g.free(), C.free(), B.free(), Q.free(), E.free(), i.free(), D.free();
        const G = new $204508e5b4b18960$export$41c0a739a32ac4d(this.raw, A, o);
        return G.userData = I.userData, this.map.set(o, G), G;
    }
    remove(A, I, g, C, B) {
        for(let I = 0; I < this.raw.rbNumColliders(A); I += 1)g.unmap(this.raw.rbCollider(A, I));
        C.forEachJointHandleAttachedToRigidBody(A, (A)=>C.unmap(A)), B.forEachJointHandleAttachedToRigidBody(A, (A)=>B.unmap(A)), this.raw.remove(A, I.raw, g.raw, C.raw, B.raw), this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    forEachActiveRigidBody(A, I) {
        A.forEachActiveRigidBodyHandle((A)=>{
            I(this.get(A));
        });
    }
    getAll() {
        return this.map.getAll();
    }
}
class $204508e5b4b18960$export$c22d4691787a8578 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$Z;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    get dt() {
        return this.raw.dt;
    }
    get erp() {
        return this.raw.erp;
    }
    get allowedLinearError() {
        return this.raw.allowedLinearError;
    }
    get predictionDistance() {
        return this.raw.predictionDistance;
    }
    get maxVelocityIterations() {
        return this.raw.maxVelocityIterations;
    }
    get maxVelocityFrictionIterations() {
        return this.raw.maxVelocityFrictionIterations;
    }
    get maxStabilizationIterations() {
        return this.raw.maxStabilizationIterations;
    }
    get minIslandSize() {
        return this.raw.minIslandSize;
    }
    get maxCcdSubsteps() {
        return this.raw.maxCcdSubsteps;
    }
    set dt(A) {
        this.raw.dt = A;
    }
    set erp(A) {
        this.raw.erp = A;
    }
    set allowedLinearError(A) {
        this.raw.allowedLinearError = A;
    }
    set predictionDistance(A) {
        this.raw.predictionDistance = A;
    }
    set maxVelocityIterations(A) {
        this.raw.maxVelocityIterations = A;
    }
    set maxVelocityFrictionIterations(A) {
        this.raw.maxVelocityFrictionIterations = A;
    }
    set maxStabilizationIterations(A) {
        this.raw.maxStabilizationIterations = A;
    }
    set minIslandSize(A) {
        this.raw.minIslandSize = A;
    }
    set maxCcdSubsteps(A) {
        this.raw.maxCcdSubsteps = A;
    }
}
!function(A) {
    A[A.Revolute = 0] = "Revolute", A[A.Fixed = 1] = "Fixed", A[A.Prismatic = 2] = "Prismatic", A[A.Spherical = 3] = "Spherical";
}($204508e5b4b18960$export$d8c34c2371473e33 || ($204508e5b4b18960$export$d8c34c2371473e33 = {})), function(A) {
    A[A.AccelerationBased = 0] = "AccelerationBased", A[A.ForceBased = 1] = "ForceBased";
}($204508e5b4b18960$export$9fe5861f16a3846f || ($204508e5b4b18960$export$9fe5861f16a3846f = {}));
class $204508e5b4b18960$export$13616a6dfa0c261e {
    constructor(A, I, g){
        this.rawSet = A, this.bodySet = I, this.handle = g;
    }
    static newTyped(A, I, g) {
        switch(A.jointType(g)){
            case $204508e5b4b18960$export$d8c34c2371473e33.Revolute:
                return new $204508e5b4b18960$export$f21c6aedecbeb53d(A, I, g);
            case $204508e5b4b18960$export$d8c34c2371473e33.Prismatic:
                return new $204508e5b4b18960$export$ca91224fa01cc4c5(A, I, g);
            case $204508e5b4b18960$export$d8c34c2371473e33.Fixed:
                return new $204508e5b4b18960$export$13a2c1429de97fd0(A, I, g);
            case $204508e5b4b18960$export$d8c34c2371473e33.Spherical:
                return new $204508e5b4b18960$export$da358565907d92be(A, I, g);
            default:
                return new $204508e5b4b18960$export$13616a6dfa0c261e(A, I, g);
        }
    }
    finalizeDeserialization(A) {
        this.bodySet = A;
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    body1() {
        return this.bodySet.get(this.rawSet.jointBodyHandle1(this.handle));
    }
    body2() {
        return this.bodySet.get(this.rawSet.jointBodyHandle2(this.handle));
    }
    type() {
        return this.rawSet.jointType(this.handle);
    }
    frameX1() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.jointFrameX1(this.handle));
    }
    frameX2() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.jointFrameX2(this.handle));
    }
    anchor1() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.jointAnchor1(this.handle));
    }
    anchor2() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.jointAnchor2(this.handle));
    }
    setAnchor1(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.jointSetAnchor1(this.handle, I), I.free();
    }
    setAnchor2(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.jointSetAnchor2(this.handle, I), I.free();
    }
    setContactsEnabled(A) {
        this.rawSet.jointSetContactsEnabled(this.handle, A);
    }
    contactsEnabled() {
        return this.rawSet.jointContactsEnabled(this.handle);
    }
}
class $204508e5b4b18960$export$b6c446c752acb453 extends $204508e5b4b18960$export$13616a6dfa0c261e {
    limitsEnabled() {
        return this.rawSet.jointLimitsEnabled(this.handle, this.rawAxis());
    }
    limitsMin() {
        return this.rawSet.jointLimitsMin(this.handle, this.rawAxis());
    }
    limitsMax() {
        return this.rawSet.jointLimitsMax(this.handle, this.rawAxis());
    }
    setLimits(A, I) {
        this.rawSet.jointSetLimits(this.handle, this.rawAxis(), A, I);
    }
    configureMotorModel(A) {
        this.rawSet.jointConfigureMotorModel(this.handle, this.rawAxis(), A);
    }
    configureMotorVelocity(A, I) {
        this.rawSet.jointConfigureMotorVelocity(this.handle, this.rawAxis(), A, I);
    }
    configureMotorPosition(A, I, g) {
        this.rawSet.jointConfigureMotorPosition(this.handle, this.rawAxis(), A, I, g);
    }
    configureMotor(A, I, g, C) {
        this.rawSet.jointConfigureMotor(this.handle, this.rawAxis(), A, I, g, C);
    }
}
class $204508e5b4b18960$export$13a2c1429de97fd0 extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$ca91224fa01cc4c5 extends $204508e5b4b18960$export$b6c446c752acb453 {
    rawAxis() {
        return $204508e5b4b18960$var$c.X;
    }
}
class $204508e5b4b18960$export$f21c6aedecbeb53d extends $204508e5b4b18960$export$b6c446c752acb453 {
    rawAxis() {
        return $204508e5b4b18960$var$c.AngX;
    }
}
class $204508e5b4b18960$export$da358565907d92be extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$9ad4996060073eaa {
    constructor(){}
    static fixed(A, I, g, C) {
        let B = new $204508e5b4b18960$export$9ad4996060073eaa;
        return B.anchor1 = A, B.anchor2 = g, B.frame1 = I, B.frame2 = C, B.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Fixed, B;
    }
    static spherical(A, I) {
        let g = new $204508e5b4b18960$export$9ad4996060073eaa;
        return g.anchor1 = A, g.anchor2 = I, g.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Spherical, g;
    }
    static prismatic(A, I, g) {
        let C = new $204508e5b4b18960$export$9ad4996060073eaa;
        return C.anchor1 = A, C.anchor2 = I, C.axis = g, C.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Prismatic, C;
    }
    static revolute(A, I, g) {
        let C = new $204508e5b4b18960$export$9ad4996060073eaa;
        return C.anchor1 = A, C.anchor2 = I, C.axis = g, C.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Revolute, C;
    }
    intoRaw() {
        let A, I, g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.anchor1), C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.anchor2), B = !1, Q = 0, E = 0;
        switch(this.jointType){
            case $204508e5b4b18960$export$d8c34c2371473e33.Fixed:
                let i = $204508e5b4b18960$export$824960640e91b57.intoRaw(this.frame1), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(this.frame2);
                I = $204508e5b4b18960$var$O.fixed(g, i, C, D), i.free(), D.free();
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Prismatic:
                A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.axis), this.limitsEnabled && (B = !0, Q = this.limits[0], E = this.limits[1]), I = $204508e5b4b18960$var$O.prismatic(g, C, A, B, Q, E), A.free();
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Spherical:
                I = $204508e5b4b18960$var$O.spherical(g, C);
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Revolute:
                A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.axis), I = $204508e5b4b18960$var$O.revolute(g, C, A), A.free();
        }
        return g.free(), C.free(), I;
    }
}
class $204508e5b4b18960$export$7b6f816cee9f25f2 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$n, this.map = new $204508e5b4b18960$var$YA, A && A.forEachJointHandle((I)=>{
            this.map.set(I, $204508e5b4b18960$export$13616a6dfa0c261e.newTyped(A, null, I));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createJoint(A, I, g, C, B) {
        const Q = I.intoRaw(), E = this.raw.createJoint(Q, g, C, B);
        Q.free();
        let i = $204508e5b4b18960$export$13616a6dfa0c261e.newTyped(this.raw, A, E);
        return this.map.set(E, i), i;
    }
    remove(A, I) {
        this.raw.remove(A, I), this.unmap(A);
    }
    forEachJointHandleAttachedToRigidBody(A, I) {
        this.raw.forEachJointAttachedToRigidBody(A, I);
    }
    unmap(A) {
        this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    getAll() {
        return this.map.getAll();
    }
}
class $204508e5b4b18960$export$9f6b52d8d09f7b72 {
    constructor(A, I){
        this.rawSet = A, this.handle = I;
    }
    static newTyped(A, I) {
        switch(A.jointType(I)){
            case $204508e5b4b18960$export$d8c34c2371473e33.Revolute:
                return new $204508e5b4b18960$export$e2bca3ac97ae239e(A, I);
            case $204508e5b4b18960$export$d8c34c2371473e33.Prismatic:
                return new $204508e5b4b18960$export$1ac8e4ec1713e3da(A, I);
            case $204508e5b4b18960$export$d8c34c2371473e33.Fixed:
                return new $204508e5b4b18960$export$6984fd596a92ce33(A, I);
            case $204508e5b4b18960$export$d8c34c2371473e33.Spherical:
                return new $204508e5b4b18960$export$b9ffb05588678855(A, I);
            default:
                return new $204508e5b4b18960$export$9f6b52d8d09f7b72(A, I);
        }
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    setContactsEnabled(A) {
        this.rawSet.jointSetContactsEnabled(this.handle, A);
    }
    contactsEnabled() {
        return this.rawSet.jointContactsEnabled(this.handle);
    }
}
class $204508e5b4b18960$export$b677e6fe6c6cb994 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$6984fd596a92ce33 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$1ac8e4ec1713e3da extends $204508e5b4b18960$export$b677e6fe6c6cb994 {
    rawAxis() {
        return $204508e5b4b18960$var$c.X;
    }
}
class $204508e5b4b18960$export$e2bca3ac97ae239e extends $204508e5b4b18960$export$b677e6fe6c6cb994 {
    rawAxis() {
        return $204508e5b4b18960$var$c.AngX;
    }
}
class $204508e5b4b18960$export$b9ffb05588678855 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$b6a38ee363602c2a {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$j, this.map = new $204508e5b4b18960$var$YA, A && A.forEachJointHandle((A)=>{
            this.map.set(A, $204508e5b4b18960$export$9f6b52d8d09f7b72.newTyped(this.raw, A));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    createJoint(A, I, g, C) {
        const B = A.intoRaw(), Q = this.raw.createJoint(B, I, g, C);
        B.free();
        let E = $204508e5b4b18960$export$9f6b52d8d09f7b72.newTyped(this.raw, Q);
        return this.map.set(Q, E), E;
    }
    remove(A, I) {
        this.raw.remove(A, I), this.map.delete(A);
    }
    unmap(A) {
        this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    forEachJointHandleAttachedToRigidBody(A, I) {
        this.raw.forEachJointAttachedToRigidBody(A, I);
    }
    getAll() {
        return this.map.getAll();
    }
}
!function(A) {
    A[A.Average = 0] = "Average", A[A.Min = 1] = "Min", A[A.Multiply = 2] = "Multiply", A[A.Max = 3] = "Max";
}($204508e5b4b18960$export$5d7f3962eb4528af || ($204508e5b4b18960$export$5d7f3962eb4528af = {}));
class $204508e5b4b18960$export$ffc4c782649f077 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$L;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
}
class $204508e5b4b18960$export$129e66920a069ba5 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$b;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    forEachActiveRigidBodyHandle(A) {
        this.raw.forEachActiveRigidBodyHandle(A);
    }
}
class $204508e5b4b18960$export$d80423229f8b133 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$Y;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
}
class $204508e5b4b18960$export$f7b463e625571e2b {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$x, this.tempManifold = new $204508e5b4b18960$export$7ac890e03fe91616(null);
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    contactsWith(A, I) {
        this.raw.contacts_with(A, I);
    }
    intersectionsWith(A, I) {
        this.raw.intersections_with(A, I);
    }
    contactPair(A, I, g) {
        const C = this.raw.contact_pair(A, I);
        if (C) {
            const I = C.collider1() != A;
            let B;
            for(B = 0; B < C.numContactManifolds(); ++B)this.tempManifold.raw = C.contactManifold(B), this.tempManifold.raw && g(this.tempManifold, I), this.tempManifold.free();
            C.free();
        }
    }
    intersectionPair(A, I) {
        return this.raw.intersection_pair(A, I);
    }
}
class $204508e5b4b18960$export$7ac890e03fe91616 {
    constructor(A){
        this.raw = A;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    normal() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.normal());
    }
    localNormal1() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.local_n1());
    }
    localNormal2() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.local_n2());
    }
    subshape1() {
        return this.raw.subshape1();
    }
    subshape2() {
        return this.raw.subshape2();
    }
    numContacts() {
        return this.raw.num_contacts();
    }
    localContactPoint1(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.contact_local_p1(A));
    }
    localContactPoint2(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.contact_local_p2(A));
    }
    contactDist(A) {
        return this.raw.contact_dist(A);
    }
    contactFid1(A) {
        return this.raw.contact_fid1(A);
    }
    contactFid2(A) {
        return this.raw.contact_fid2(A);
    }
    contactImpulse(A) {
        return this.raw.contact_impulse(A);
    }
    contactTangentImpulseX(A) {
        return this.raw.contact_tangent_impulse_x(A);
    }
    contactTangentImpulseY(A) {
        return this.raw.contact_tangent_impulse_y(A);
    }
    numSolverContacts() {
        return this.raw.num_solver_contacts();
    }
    solverContactPoint(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.solver_contact_point(A));
    }
    solverContactDist(A) {
        return this.raw.solver_contact_dist(A);
    }
    solverContactFriction(A) {
        return this.raw.solver_contact_friction(A);
    }
    solverContactRestitution(A) {
        return this.raw.solver_contact_restitution(A);
    }
    solverContactTangentVelocity(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.solver_contact_tangent_velocity(A));
    }
}
class $204508e5b4b18960$export$1d7ee127e07c91bb {
    constructor(A, I, g, C, B){
        this.distance = A, this.point1 = I, this.point2 = g, this.normal1 = C, this.normal2 = B;
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$1d7ee127e07c91bb(A.distance(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal2()));
        return A.free(), I;
    }
}
!function(A) {
    A[A.Vertex = 0] = "Vertex", A[A.Edge = 1] = "Edge", A[A.Face = 2] = "Face", A[A.Unknown = 3] = "Unknown";
}($204508e5b4b18960$export$c40deacab7e2491c || ($204508e5b4b18960$export$c40deacab7e2491c = {}));
class $204508e5b4b18960$export$5e813b027a709134 {
    constructor(A, I){
        this.point = A, this.isInside = I;
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$5e813b027a709134($204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point()), A.isInside());
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$fc779dece190555 {
    constructor(A, I, g, C, B){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.collider = A, this.point = I, this.isInside = g, void 0 !== B && (this.featureId = B), void 0 !== C && (this.featureType = C);
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$fc779dece190555(A.get(I.colliderHandle()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.point()), I.isInside(), I.featureType(), I.featureId());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$a186db52eed6d40e {
    constructor(A, I){
        this.origin = A, this.dir = I;
    }
    pointAt(A) {
        return {
            x: this.origin.x + this.dir.x * A,
            y: this.origin.y + this.dir.y * A,
            z: this.origin.z + this.dir.z * A
        };
    }
}
class $204508e5b4b18960$export$292489680db6ed3f {
    constructor(A, I, g, C){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.toi = A, this.normal = I, void 0 !== C && (this.featureId = C), void 0 !== g && (this.featureType = g);
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$292489680db6ed3f(A.toi(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal()), A.featureType(), A.featureId());
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$bc228139800bb3c {
    constructor(A, I, g, C, B){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.collider = A, this.toi = I, this.normal = g, void 0 !== B && (this.featureId = B), void 0 !== C && (this.featureType = C);
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$bc228139800bb3c(A.get(I.colliderHandle()), I.toi(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal()), I.featureType(), I.featureId());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$fc9976cd477662f8 {
    constructor(A, I){
        this.collider = A, this.toi = I;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$fc9976cd477662f8(A.get(I.colliderHandle()), I.toi());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$1c5cc33417eb8bc {
    constructor(A, I, g, C, B){
        this.toi = A, this.witness1 = I, this.witness2 = g, this.normal1 = C, this.normal2 = B;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$1c5cc33417eb8bc(I.toi(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal2()));
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$edd42a90ffbc1c72 extends $204508e5b4b18960$export$1c5cc33417eb8bc {
    constructor(A, I, g, C, B, Q){
        super(I, g, C, B, Q), this.collider = A;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$edd42a90ffbc1c72(A.get(I.colliderHandle()), I.toi(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal2()));
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$6428a7f2611ef1fa {
    static fromRaw(A, I) {
        const g = A.coShapeType(I);
        let C, B, Q, E, i, D, o;
        switch(g){
            case $204508e5b4b18960$export$fc850f719b5599d5.Ball:
                return new $204508e5b4b18960$export$a83d7c3fa53790c9(A.coRadius(I));
            case $204508e5b4b18960$export$fc850f719b5599d5.Cuboid:
                return C = A.coHalfExtents(I), new $204508e5b4b18960$export$c8821cc685709b7b(C.x, C.y, C.z);
            case $204508e5b4b18960$export$fc850f719b5599d5.RoundCuboid:
                return C = A.coHalfExtents(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$c87d2c121efe06ab(C.x, C.y, C.z, B);
            case $204508e5b4b18960$export$fc850f719b5599d5.Capsule:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$28bdb8fc07bf3804(i, D);
            case $204508e5b4b18960$export$fc850f719b5599d5.Segment:
                return Q = A.coVertices(I), new $204508e5b4b18960$export$d53aa5c5ab432700($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]));
            case $204508e5b4b18960$export$fc850f719b5599d5.Polyline:
                return Q = A.coVertices(I), E = A.coIndices(I), new $204508e5b4b18960$export$79f3ee03e63e7073(Q, E);
            case $204508e5b4b18960$export$fc850f719b5599d5.Triangle:
                return Q = A.coVertices(I), new $204508e5b4b18960$export$5a465592bfe74b48($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[6], Q[7], Q[8]));
            case $204508e5b4b18960$export$fc850f719b5599d5.RoundTriangle:
                return Q = A.coVertices(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$5d38c33920824fab($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[6], Q[7], Q[8]), B);
            case $204508e5b4b18960$export$fc850f719b5599d5.HalfSpace:
                return o = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.coHalfspaceNormal(I)), new $204508e5b4b18960$export$b774d5dd1a533096(o);
            case $204508e5b4b18960$export$fc850f719b5599d5.TriMesh:
                return Q = A.coVertices(I), E = A.coIndices(I), new $204508e5b4b18960$export$16df86f06e459b09(Q, E);
            case $204508e5b4b18960$export$fc850f719b5599d5.HeightField:
                const G = A.coHeightfieldScale(I), w = A.coHeightfieldHeights(I), k = A.coHeightfieldNRows(I), S = A.coHeightfieldNCols(I);
                return new $204508e5b4b18960$export$fa360b5b58f475b7(k, S, w, G);
            case $204508e5b4b18960$export$fc850f719b5599d5.ConvexPolyhedron:
                return Q = A.coVertices(I), E = A.coIndices(I), new $204508e5b4b18960$export$7c637a75bc263948(Q, E);
            case $204508e5b4b18960$export$fc850f719b5599d5.RoundConvexPolyhedron:
                return Q = A.coVertices(I), E = A.coIndices(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$f9ecc9020d30774f(Q, E, B);
            case $204508e5b4b18960$export$fc850f719b5599d5.Cylinder:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$665c37f020fe48f9(i, D);
            case $204508e5b4b18960$export$fc850f719b5599d5.RoundCylinder:
                return i = A.coHalfHeight(I), D = A.coRadius(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$6fe70449556bd1bd(i, D, B);
            case $204508e5b4b18960$export$fc850f719b5599d5.Cone:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$22209bc4af3d3757(i, D);
            case $204508e5b4b18960$export$fc850f719b5599d5.RoundCone:
                return i = A.coHalfHeight(I), D = A.coRadius(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$fec6094316a593bd(i, D, B);
            default:
                throw new Error("unknown shape type: " + g);
        }
    }
    castShape(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), G = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), k = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), S = $204508e5b4b18960$export$824960640e91b57.intoRaw(Q), a = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(E), M = this.intoRaw(), K = C.intoRaw(), y = $204508e5b4b18960$export$1c5cc33417eb8bc.fromRaw(null, M.castShape(o, G, w, K, k, S, a, i, D));
        return o.free(), G.free(), w.free(), k.free(), S.free(), a.free(), M.free(), K.free(), y;
    }
    intersectsShape(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(C), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(B), o = this.intoRaw(), G = g.intoRaw(), w = o.intersectsShape(Q, E, G, i, D);
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G.free(), w;
    }
    contactShape(A, I, g, C, B, Q) {
        let E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), i = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(C), o = $204508e5b4b18960$export$824960640e91b57.intoRaw(B), G = this.intoRaw(), w = g.intoRaw(), k = $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(G.contactShape(E, i, w, D, o, Q));
        return E.free(), i.free(), D.free(), o.free(), G.free(), w.free(), k;
    }
    containsPoint(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), E = this.intoRaw(), i = E.containsPoint(C, B, Q);
        return C.free(), B.free(), Q.free(), E.free(), i;
    }
    projectPoint(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), i = this.intoRaw(), D = $204508e5b4b18960$export$5e813b027a709134.fromRaw(i.projectPoint(B, Q, E, C));
        return B.free(), Q.free(), E.free(), i.free(), D;
    }
    intersectsRay(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), D = this.intoRaw(), o = D.intersectsRay(B, Q, E, i, C);
        return B.free(), Q.free(), E.free(), i.free(), D.free(), o;
    }
    castRay(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), o = this.intoRaw(), G = o.castRay(Q, E, i, D, C, B);
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G;
    }
    castRayAndGetNormal(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), o = this.intoRaw(), G = $204508e5b4b18960$export$292489680db6ed3f.fromRaw(o.castRayAndGetNormal(Q, E, i, D, C, B));
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G;
    }
}
!function(A) {
    A[A.Ball = 0] = "Ball", A[A.Cuboid = 1] = "Cuboid", A[A.Capsule = 2] = "Capsule", A[A.Segment = 3] = "Segment", A[A.Polyline = 4] = "Polyline", A[A.Triangle = 5] = "Triangle", A[A.TriMesh = 6] = "TriMesh", A[A.HeightField = 7] = "HeightField", A[A.ConvexPolyhedron = 9] = "ConvexPolyhedron", A[A.Cylinder = 10] = "Cylinder", A[A.Cone = 11] = "Cone", A[A.RoundCuboid = 12] = "RoundCuboid", A[A.RoundTriangle = 13] = "RoundTriangle", A[A.RoundCylinder = 14] = "RoundCylinder", A[A.RoundCone = 15] = "RoundCone", A[A.RoundConvexPolyhedron = 16] = "RoundConvexPolyhedron", A[A.HalfSpace = 17] = "HalfSpace";
}($204508e5b4b18960$export$fc850f719b5599d5 || ($204508e5b4b18960$export$fc850f719b5599d5 = {}));
class $204508e5b4b18960$export$a83d7c3fa53790c9 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Ball, this.radius = A;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.ball(this.radius);
    }
}
class $204508e5b4b18960$export$b774d5dd1a533096 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.HalfSpace, this.normal = A;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.normal), I = $204508e5b4b18960$var$IA.halfspace(A);
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$c8821cc685709b7b extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cuboid, this.halfExtents = $204508e5b4b18960$export$e2f642242c040d8f.new(A, I, g);
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.cuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z);
    }
}
class $204508e5b4b18960$export$c87d2c121efe06ab extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCuboid, this.halfExtents = $204508e5b4b18960$export$e2f642242c040d8f.new(A, I, g), this.borderRadius = C;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.roundCuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z, this.borderRadius);
    }
}
class $204508e5b4b18960$export$28bdb8fc07bf3804 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Capsule, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.capsule(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$d53aa5c5ab432700 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Segment, this.a = A, this.b = I;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$var$IA.segment(A, I);
        return A.free(), I.free(), g;
    }
}
class $204508e5b4b18960$export$5a465592bfe74b48 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Triangle, this.a = A, this.b = I, this.c = g;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.c), C = $204508e5b4b18960$var$IA.triangle(A, I, g);
        return A.free(), I.free(), g.free(), C;
    }
}
class $204508e5b4b18960$export$5d38c33920824fab extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundTriangle, this.a = A, this.b = I, this.c = g, this.borderRadius = C;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.c), C = $204508e5b4b18960$var$IA.roundTriangle(A, I, g, this.borderRadius);
        return A.free(), I.free(), g.free(), C;
    }
}
class $204508e5b4b18960$export$79f3ee03e63e7073 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Polyline, this.vertices = A, this.indices = null != I ? I : new Uint32Array(0);
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.polyline(this.vertices, this.indices);
    }
}
class $204508e5b4b18960$export$16df86f06e459b09 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.TriMesh, this.vertices = A, this.indices = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.trimesh(this.vertices, this.indices);
    }
}
class $204508e5b4b18960$export$7c637a75bc263948 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.ConvexPolyhedron, this.vertices = A, this.indices = I;
    }
    intoRaw() {
        return this.indices ? $204508e5b4b18960$var$IA.convexMesh(this.vertices, this.indices) : $204508e5b4b18960$var$IA.convexHull(this.vertices);
    }
}
class $204508e5b4b18960$export$f9ecc9020d30774f extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundConvexPolyhedron, this.vertices = A, this.indices = I, this.borderRadius = g;
    }
    intoRaw() {
        return this.indices ? $204508e5b4b18960$var$IA.roundConvexMesh(this.vertices, this.indices, this.borderRadius) : $204508e5b4b18960$var$IA.roundConvexHull(this.vertices, this.borderRadius);
    }
}
class $204508e5b4b18960$export$fa360b5b58f475b7 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.HeightField, this.nrows = A, this.ncols = I, this.heights = g, this.scale = C;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.scale), I = $204508e5b4b18960$var$IA.heightfield(this.nrows, this.ncols, this.heights, A);
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$665c37f020fe48f9 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cylinder, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.cylinder(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$6fe70449556bd1bd extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCylinder, this.borderRadius = g, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.roundCylinder(this.halfHeight, this.radius, this.borderRadius);
    }
}
class $204508e5b4b18960$export$22209bc4af3d3757 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cone, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.cone(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$fec6094316a593bd extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCone, this.halfHeight = A, this.radius = I, this.borderRadius = g;
    }
    intoRaw() {
        return $204508e5b4b18960$var$IA.roundCone(this.halfHeight, this.radius, this.borderRadius);
    }
}
!function(A) {
    A[A.DYNAMIC_DYNAMIC = 1] = "DYNAMIC_DYNAMIC", A[A.DYNAMIC_KINEMATIC = 12] = "DYNAMIC_KINEMATIC", A[A.DYNAMIC_FIXED = 2] = "DYNAMIC_FIXED", A[A.KINEMATIC_KINEMATIC = 52224] = "KINEMATIC_KINEMATIC", A[A.KINEMATIC_FIXED = 8704] = "KINEMATIC_FIXED", A[A.FIXED_FIXED = 32] = "FIXED_FIXED", A[A.DEFAULT = 15] = "DEFAULT", A[A.ALL = 60943] = "ALL";
}($204508e5b4b18960$export$822f84f0c1c58b2a || ($204508e5b4b18960$export$822f84f0c1c58b2a = {}));
class $204508e5b4b18960$export$b7c6eef0ebb06133 {
    constructor(A, I, g, C){
        this.colliderSet = A, this.handle = I, this._parent = g, this._shape = C;
    }
    finalizeDeserialization(A) {
        null != this.handle && (this._parent = A.get(this.colliderSet.raw.coParent(this.handle)));
    }
    ensureShapeIsCached() {
        this._shape || (this._shape = $204508e5b4b18960$export$6428a7f2611ef1fa.fromRaw(this.colliderSet.raw, this.handle));
    }
    get shape() {
        return this.ensureShapeIsCached(), this._shape;
    }
    isValid() {
        return this.colliderSet.raw.contains(this.handle);
    }
    translation() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.colliderSet.raw.coTranslation(this.handle));
    }
    rotation() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.colliderSet.raw.coRotation(this.handle));
    }
    isSensor() {
        return this.colliderSet.raw.coIsSensor(this.handle);
    }
    setSensor(A) {
        this.colliderSet.raw.coSetSensor(this.handle, A);
    }
    setShape(A) {
        let I = A.intoRaw();
        this.colliderSet.raw.coSetShape(this.handle, I), I.free(), this._shape = A;
    }
    setEnabled(A) {
        this.colliderSet.raw.coSetEnabled(this.handle, A);
    }
    isEnabled() {
        return this.colliderSet.raw.coIsEnabled(this.handle);
    }
    setRestitution(A) {
        this.colliderSet.raw.coSetRestitution(this.handle, A);
    }
    setFriction(A) {
        this.colliderSet.raw.coSetFriction(this.handle, A);
    }
    frictionCombineRule() {
        return this.colliderSet.raw.coFrictionCombineRule(this.handle);
    }
    setFrictionCombineRule(A) {
        this.colliderSet.raw.coSetFrictionCombineRule(this.handle, A);
    }
    restitutionCombineRule() {
        return this.colliderSet.raw.coRestitutionCombineRule(this.handle);
    }
    setRestitutionCombineRule(A) {
        this.colliderSet.raw.coSetRestitutionCombineRule(this.handle, A);
    }
    setCollisionGroups(A) {
        this.colliderSet.raw.coSetCollisionGroups(this.handle, A);
    }
    setSolverGroups(A) {
        this.colliderSet.raw.coSetSolverGroups(this.handle, A);
    }
    activeHooks() {
        return this.colliderSet.raw.coActiveHooks(this.handle);
    }
    setActiveHooks(A) {
        this.colliderSet.raw.coSetActiveHooks(this.handle, A);
    }
    activeEvents() {
        return this.colliderSet.raw.coActiveEvents(this.handle);
    }
    setActiveEvents(A) {
        this.colliderSet.raw.coSetActiveEvents(this.handle, A);
    }
    activeCollisionTypes() {
        return this.colliderSet.raw.coActiveCollisionTypes(this.handle);
    }
    setContactForceEventThreshold(A) {
        return this.colliderSet.raw.coSetContactForceEventThreshold(this.handle, A);
    }
    contactForceEventThreshold() {
        return this.colliderSet.raw.coContactForceEventThreshold(this.handle);
    }
    setActiveCollisionTypes(A) {
        this.colliderSet.raw.coSetActiveCollisionTypes(this.handle, A);
    }
    setDensity(A) {
        this.colliderSet.raw.coSetDensity(this.handle, A);
    }
    setMass(A) {
        this.colliderSet.raw.coSetMass(this.handle, A);
    }
    setMassProperties(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(C);
        this.colliderSet.raw.coSetMassProperties(this.handle, A, B, Q, E), B.free(), Q.free(), E.free();
    }
    setTranslation(A) {
        this.colliderSet.raw.coSetTranslation(this.handle, A.x, A.y, A.z);
    }
    setTranslationWrtParent(A) {
        this.colliderSet.raw.coSetTranslationWrtParent(this.handle, A.x, A.y, A.z);
    }
    setRotation(A) {
        this.colliderSet.raw.coSetRotation(this.handle, A.x, A.y, A.z, A.w);
    }
    setRotationWrtParent(A) {
        this.colliderSet.raw.coSetRotationWrtParent(this.handle, A.x, A.y, A.z, A.w);
    }
    shapeType() {
        return this.colliderSet.raw.coShapeType(this.handle);
    }
    halfExtents() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.colliderSet.raw.coHalfExtents(this.handle));
    }
    setHalfExtents(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.colliderSet.raw.coSetHalfExtents(this.handle, I);
    }
    radius() {
        return this.colliderSet.raw.coRadius(this.handle);
    }
    setRadius(A) {
        this.colliderSet.raw.coSetRadius(this.handle, A);
    }
    roundRadius() {
        return this.colliderSet.raw.coRoundRadius(this.handle);
    }
    setRoundRadius(A) {
        this.colliderSet.raw.coSetRoundRadius(this.handle, A);
    }
    halfHeight() {
        return this.colliderSet.raw.coHalfHeight(this.handle);
    }
    setHalfHeight(A) {
        this.colliderSet.raw.coSetHalfHeight(this.handle, A);
    }
    vertices() {
        return this.colliderSet.raw.coVertices(this.handle);
    }
    indices() {
        return this.colliderSet.raw.coIndices(this.handle);
    }
    heightfieldHeights() {
        return this.colliderSet.raw.coHeightfieldHeights(this.handle);
    }
    heightfieldScale() {
        let A = this.colliderSet.raw.coHeightfieldScale(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    heightfieldNRows() {
        return this.colliderSet.raw.coHeightfieldNRows(this.handle);
    }
    heightfieldNCols() {
        return this.colliderSet.raw.coHeightfieldNCols(this.handle);
    }
    parent() {
        return this._parent;
    }
    friction() {
        return this.colliderSet.raw.coFriction(this.handle);
    }
    restitution() {
        return this.colliderSet.raw.coRestitution(this.handle);
    }
    density() {
        return this.colliderSet.raw.coDensity(this.handle);
    }
    mass() {
        return this.colliderSet.raw.coMass(this.handle);
    }
    volume() {
        return this.colliderSet.raw.coVolume(this.handle);
    }
    collisionGroups() {
        return this.colliderSet.raw.coCollisionGroups(this.handle);
    }
    solverGroups() {
        return this.colliderSet.raw.coSolverGroups(this.handle);
    }
    containsPoint(A) {
        let I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), g = this.colliderSet.raw.coContainsPoint(this.handle, I);
        return I.free(), g;
    }
    projectPoint(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), C = $204508e5b4b18960$export$5e813b027a709134.fromRaw(this.colliderSet.raw.coProjectPoint(this.handle, g, I));
        return g.free(), C;
    }
    intersectsRay(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), B = this.colliderSet.raw.coIntersectsRay(this.handle, g, C, I);
        return g.free(), C.free(), B;
    }
    castShape(A, I, g, C, B, Q, E) {
        let i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), o = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), w = I.intoRaw(), k = $204508e5b4b18960$export$1c5cc33417eb8bc.fromRaw(this.colliderSet, this.colliderSet.raw.coCastShape(this.handle, i, w, D, o, G, Q, E));
        return i.free(), D.free(), o.free(), G.free(), w.free(), k;
    }
    castCollider(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), i = $204508e5b4b18960$export$edd42a90ffbc1c72.fromRaw(this.colliderSet, this.colliderSet.raw.coCastCollider(this.handle, Q, I.handle, E, C, B));
        return Q.free(), E.free(), i;
    }
    intersectsShape(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), B = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), Q = A.intoRaw(), E = this.colliderSet.raw.coIntersectsShape(this.handle, Q, C, B);
        return C.free(), B.free(), Q.free(), E;
    }
    contactShape(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), E = A.intoRaw(), i = $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(this.colliderSet.raw.coContactShape(this.handle, E, B, Q, C));
        return B.free(), Q.free(), E.free(), i;
    }
    contactCollider(A, I) {
        return $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(this.colliderSet.raw.coContactCollider(this.handle, A.handle, I));
    }
    castRay(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), Q = this.colliderSet.raw.coCastRay(this.handle, C, B, I, g);
        return C.free(), B.free(), Q;
    }
    castRayAndGetNormal(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), Q = $204508e5b4b18960$export$292489680db6ed3f.fromRaw(this.colliderSet.raw.coCastRayAndGetNormal(this.handle, C, B, I, g));
        return C.free(), B.free(), Q;
    }
}
!function(A) {
    A[A.Density = 0] = "Density", A[A.Mass = 1] = "Mass", A[A.MassProps = 2] = "MassProps";
}($204508e5b4b18960$export$9d99ce4bda7104cf || ($204508e5b4b18960$export$9d99ce4bda7104cf = {}));
class $204508e5b4b18960$export$7d4cec221ee36947 {
    constructor(A){
        this.enabled = !0, this.shape = A, this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Density, this.density = 1, this.friction = .5, this.restitution = 0, this.rotation = $204508e5b4b18960$export$824960640e91b57.identity(), this.translation = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.isSensor = !1, this.collisionGroups = 4294967295, this.solverGroups = 4294967295, this.frictionCombineRule = $204508e5b4b18960$export$5d7f3962eb4528af.Average, this.restitutionCombineRule = $204508e5b4b18960$export$5d7f3962eb4528af.Average, this.activeCollisionTypes = $204508e5b4b18960$export$822f84f0c1c58b2a.DEFAULT, this.activeEvents = 0, this.activeHooks = 0, this.mass = 0, this.centerOfMass = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.contactForceEventThreshold = 0, this.principalAngularInertia = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.angularInertiaLocalFrame = $204508e5b4b18960$export$824960640e91b57.identity();
    }
    static ball(A) {
        const I = new $204508e5b4b18960$export$a83d7c3fa53790c9(A);
        return new $204508e5b4b18960$export$7d4cec221ee36947(I);
    }
    static capsule(A, I) {
        const g = new $204508e5b4b18960$export$28bdb8fc07bf3804(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static segment(A, I) {
        const g = new $204508e5b4b18960$export$d53aa5c5ab432700(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static triangle(A, I, g) {
        const C = new $204508e5b4b18960$export$5a465592bfe74b48(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static roundTriangle(A, I, g, C) {
        const B = new $204508e5b4b18960$export$5d38c33920824fab(A, I, g, C);
        return new $204508e5b4b18960$export$7d4cec221ee36947(B);
    }
    static polyline(A, I) {
        const g = new $204508e5b4b18960$export$79f3ee03e63e7073(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static trimesh(A, I) {
        const g = new $204508e5b4b18960$export$16df86f06e459b09(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static cuboid(A, I, g) {
        const C = new $204508e5b4b18960$export$c8821cc685709b7b(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static roundCuboid(A, I, g, C) {
        const B = new $204508e5b4b18960$export$c87d2c121efe06ab(A, I, g, C);
        return new $204508e5b4b18960$export$7d4cec221ee36947(B);
    }
    static heightfield(A, I, g, C) {
        const B = new $204508e5b4b18960$export$fa360b5b58f475b7(A, I, g, C);
        return new $204508e5b4b18960$export$7d4cec221ee36947(B);
    }
    static cylinder(A, I) {
        const g = new $204508e5b4b18960$export$665c37f020fe48f9(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundCylinder(A, I, g) {
        const C = new $204508e5b4b18960$export$6fe70449556bd1bd(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static cone(A, I) {
        const g = new $204508e5b4b18960$export$22209bc4af3d3757(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundCone(A, I, g) {
        const C = new $204508e5b4b18960$export$fec6094316a593bd(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static convexHull(A) {
        const I = new $204508e5b4b18960$export$7c637a75bc263948(A, null);
        return new $204508e5b4b18960$export$7d4cec221ee36947(I);
    }
    static convexMesh(A, I) {
        const g = new $204508e5b4b18960$export$7c637a75bc263948(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundConvexHull(A, I) {
        const g = new $204508e5b4b18960$export$f9ecc9020d30774f(A, null, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundConvexMesh(A, I, g) {
        const C = new $204508e5b4b18960$export$f9ecc9020d30774f(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    setTranslation(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The translation components must be numbers.");
        return this.translation = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setRotation(A) {
        return $204508e5b4b18960$export$824960640e91b57.copy(this.rotation, A), this;
    }
    setSensor(A) {
        return this.isSensor = A, this;
    }
    setEnabled(A) {
        return this.enabled = A, this;
    }
    setDensity(A) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Density, this.density = A, this;
    }
    setMass(A) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Mass, this.mass = A, this;
    }
    setMassProperties(A, I, g, C) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.MassProps, this.mass = A, $204508e5b4b18960$export$e2f642242c040d8f.copy(this.centerOfMass, I), $204508e5b4b18960$export$e2f642242c040d8f.copy(this.principalAngularInertia, g), $204508e5b4b18960$export$824960640e91b57.copy(this.angularInertiaLocalFrame, C), this;
    }
    setRestitution(A) {
        return this.restitution = A, this;
    }
    setFriction(A) {
        return this.friction = A, this;
    }
    setFrictionCombineRule(A) {
        return this.frictionCombineRule = A, this;
    }
    setRestitutionCombineRule(A) {
        return this.restitutionCombineRule = A, this;
    }
    setCollisionGroups(A) {
        return this.collisionGroups = A, this;
    }
    setSolverGroups(A) {
        return this.solverGroups = A, this;
    }
    setActiveHooks(A) {
        return this.activeHooks = A, this;
    }
    setActiveEvents(A) {
        return this.activeEvents = A, this;
    }
    setActiveCollisionTypes(A) {
        return this.activeCollisionTypes = A, this;
    }
    setContactForceEventThreshold(A) {
        return this.contactForceEventThreshold = A, this;
    }
}
class $204508e5b4b18960$export$8ec69bf37b303313 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$l, this.map = new $204508e5b4b18960$var$YA, A && A.forEachColliderHandle((A)=>{
            this.map.set(A, new $204508e5b4b18960$export$b7c6eef0ebb06133(this, A, null));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    castClosure(A) {
        return (I)=>A ? A(this.get(I)) : void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createCollider(A, I, g) {
        let C = null != g && null != g;
        if (C && isNaN(g)) throw Error("Cannot create a collider with a parent rigid-body handle that is not a number.");
        let B = I.shape.intoRaw(), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.translation), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.rotation), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.centerOfMass), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.principalAngularInertia), o = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.angularInertiaLocalFrame), G = this.raw.createCollider(I.enabled, B, Q, E, I.massPropsMode, I.mass, i, D, o, I.density, I.friction, I.restitution, I.frictionCombineRule, I.restitutionCombineRule, I.isSensor, I.collisionGroups, I.solverGroups, I.activeCollisionTypes, I.activeHooks, I.activeEvents, I.contactForceEventThreshold, C, C ? g : 0, A.raw);
        B.free(), Q.free(), E.free(), i.free(), D.free(), o.free();
        let w = C ? A.get(g) : null, k = new $204508e5b4b18960$export$b7c6eef0ebb06133(this, G, w, I.shape);
        return this.map.set(G, k), k;
    }
    remove(A, I, g, C) {
        this.raw.remove(A, I.raw, g.raw, C), this.unmap(A);
    }
    unmap(A) {
        this.map.delete(A);
    }
    get(A) {
        return this.map.get(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    getAll() {
        return this.map.getAll();
    }
}
class $204508e5b4b18960$export$f3c42ca1c254a387 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$f;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    step(A, I, g, C, B, Q, E, i, D, o, G, w) {
        let k = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        G ? this.raw.stepWithEvents(k, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw, o.raw, G.raw, w, w ? w.filterContactPair : null, w ? w.filterIntersectionPair : null) : this.raw.step(k, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw, o.raw), k.free();
    }
}
!function(A) {
    A[A.EXCLUDE_FIXED = 1] = "EXCLUDE_FIXED", A[A.EXCLUDE_KINEMATIC = 2] = "EXCLUDE_KINEMATIC", A[A.EXCLUDE_DYNAMIC = 4] = "EXCLUDE_DYNAMIC", A[A.EXCLUDE_SENSORS = 8] = "EXCLUDE_SENSORS", A[A.EXCLUDE_SOLIDS = 16] = "EXCLUDE_SOLIDS", A[A.ONLY_DYNAMIC = 3] = "ONLY_DYNAMIC", A[A.ONLY_KINEMATIC = 5] = "ONLY_KINEMATIC", A[A.ONLY_FIXED = 6] = "ONLY_FIXED";
}($204508e5b4b18960$export$39a39008025d4cb || ($204508e5b4b18960$export$39a39008025d4cb = {}));
class $204508e5b4b18960$export$636a60a98ff98f0b {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$V;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    update(A, I) {
        this.raw.update(A.raw, I.raw);
    }
    castRay(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir), k = $204508e5b4b18960$export$fc9976cd477662f8.fromRaw(I, this.raw.castRay(A.raw, I.raw, G, w, C, B, Q, E, i, D, o));
        return G.free(), w.free(), k;
    }
    castRayAndGetNormal(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir), k = $204508e5b4b18960$export$bc228139800bb3c.fromRaw(I, this.raw.castRayAndGetNormal(A.raw, I.raw, G, w, C, B, Q, E, i, D, o));
        return G.free(), w.free(), k;
    }
    intersectionsWithRay(A, I, g, C, B, Q, E, i, D, o, G) {
        let w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), k = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir);
        this.raw.intersectionsWithRay(A.raw, I.raw, w, k, C, B, (A)=>Q($204508e5b4b18960$export$bc228139800bb3c.fromRaw(I, A)), E, i, D, o, G), w.free(), k.free();
    }
    intersectionWithShape(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), w = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), k = B.intoRaw(), S = this.raw.intersectionWithShape(A.raw, I.raw, G, w, k, Q, E, i, D, o);
        return G.free(), w.free(), k.free(), S;
    }
    projectPoint(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), G = $204508e5b4b18960$export$fc779dece190555.fromRaw(I, this.raw.projectPoint(A.raw, I.raw, o, C, B, Q, E, i, D));
        return o.free(), G;
    }
    projectPointAndGetFeature(A, I, g, C, B, Q, E, i) {
        let D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), o = $204508e5b4b18960$export$fc779dece190555.fromRaw(I, this.raw.projectPointAndGetFeature(A.raw, I.raw, D, C, B, Q, E, i));
        return D.free(), o;
    }
    intersectionsWithPoint(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g);
        this.raw.intersectionsWithPoint(A.raw, I.raw, o, C, B, Q, E, i, D), o.free();
    }
    castShape(A, I, g, C, B, Q, E, i, D, o, G, w, k) {
        let S = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), a = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), M = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), K = Q.intoRaw(), y = $204508e5b4b18960$export$edd42a90ffbc1c72.fromRaw(I, this.raw.castShape(A.raw, I.raw, S, a, M, K, E, i, D, o, G, w, k));
        return S.free(), a.free(), M.free(), K.free(), y;
    }
    intersectionsWithShape(A, I, g, C, B, Q, E, i, D, o, G) {
        let w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), k = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), S = B.intoRaw();
        this.raw.intersectionsWithShape(A.raw, I.raw, w, k, S, Q, E, i, D, o, G), w.free(), k.free(), S.free();
    }
    collidersWithAabbIntersectingAabb(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.collidersWithAabbIntersectingAabb(C, B, g), C.free(), B.free();
    }
}
class $204508e5b4b18960$export$b54bf36dd1f18c08 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$AA;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    serializeAll(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        const G = this.raw.serializeAll(o, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw);
        return o.free(), G;
    }
    deserializeAll(A) {
        return $204508e5b4b18960$export$812cd9544993280d.fromRaw(this.raw.deserializeAll(A));
    }
}
class $204508e5b4b18960$export$354e114f10103d2d {
    constructor(A, I){
        this.vertices = A, this.colors = I;
    }
}
class $204508e5b4b18960$export$acdffcc934f6bc95 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$r;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.vertices = void 0, this.colors = void 0;
    }
    render(A, I, g, C, B) {
        this.raw.render(A.raw, I.raw, g.raw, C.raw, B.raw), this.vertices = this.raw.vertices(), this.colors = this.raw.colors();
    }
}
class $204508e5b4b18960$export$d8a6c60ecc79c6a6 {
}
class $204508e5b4b18960$export$ed5de7d26b924ce3 {
    constructor(A, I, g, C, B){
        this.params = I, this.bodies = g, this.colliders = C, this.queries = B, this.raw = new $204508e5b4b18960$var$W(A), this.rawCharacterCollision = new $204508e5b4b18960$var$H, this._applyImpulsesToDynamicBodies = !1, this._characterMass = null;
    }
    free() {
        this.raw && (this.raw.free(), this.rawCharacterCollision.free()), this.raw = void 0, this.rawCharacterCollision = void 0;
    }
    up() {
        return this.raw.up();
    }
    setUp(A) {
        let I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        return this.raw.setUp(I);
    }
    applyImpulsesToDynamicBodies() {
        return this._applyImpulsesToDynamicBodies;
    }
    setApplyImpulsesToDynamicBodies(A) {
        this._applyImpulsesToDynamicBodies = A;
    }
    characterMass() {
        return this._characterMass;
    }
    setCharacterMass(A) {
        this._characterMass = A;
    }
    offset() {
        return this.raw.offset();
    }
    setOffset(A) {
        this.raw.setOffset(A);
    }
    slideEnabled() {
        return this.raw.slideEnabled();
    }
    setSlideEnabled(A) {
        this.raw.setSlideEnabled(A);
    }
    autostepMaxHeight() {
        return this.raw.autostepMaxHeight();
    }
    autostepMinWidth() {
        return this.raw.autostepMinWidth();
    }
    autostepIncludesDynamicBodies() {
        return this.raw.autostepIncludesDynamicBodies();
    }
    autostepEnabled() {
        return this.raw.autostepEnabled();
    }
    enableAutostep(A, I, g) {
        this.raw.enableAutostep(A, I, g);
    }
    disableAutostep() {
        return this.raw.disableAutostep();
    }
    maxSlopeClimbAngle() {
        return this.raw.maxSlopeClimbAngle();
    }
    setMaxSlopeClimbAngle(A) {
        this.raw.setMaxSlopeClimbAngle(A);
    }
    minSlopeSlideAngle() {
        return this.raw.minSlopeSlideAngle();
    }
    setMinSlopeSlideAngle(A) {
        this.raw.setMinSlopeSlideAngle(A);
    }
    snapToGroundDistance() {
        return this.raw.snapToGroundDistance();
    }
    enableSnapToGround(A) {
        this.raw.enableSnapToGround(A);
    }
    disableSnapToGround() {
        this.raw.disableSnapToGround();
    }
    snapToGroundEnabled() {
        return this.raw.snapToGroundEnabled();
    }
    computeColliderMovement(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.computeColliderMovement(this.params.dt, this.bodies.raw, this.colliders.raw, this.queries.raw, A.handle, Q, this._applyImpulsesToDynamicBodies, this._characterMass, g, C, this.colliders.castClosure(B)), Q.free();
    }
    computedMovement() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.computedMovement());
    }
    computedGrounded() {
        return this.raw.computedGrounded();
    }
    numComputedCollisions() {
        return this.raw.numComputedCollisions();
    }
    computedCollision(A, I) {
        if (this.raw.computedCollision(A, this.rawCharacterCollision)) {
            let A = this.rawCharacterCollision;
            return (I = null != I ? I : new $204508e5b4b18960$export$d8a6c60ecc79c6a6).translationApplied = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.translationApplied()), I.translationRemaining = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.translationRemaining()), I.toi = A.toi(), I.witness1 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldWitness1()), I.witness2 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldWitness2()), I.normal1 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldNormal1()), I.normal2 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldNormal2()), I.collider = this.colliders.get(A.handle()), I;
        }
        return null;
    }
}
class $204508e5b4b18960$export$812cd9544993280d {
    constructor(A, I, g, C, B, Q, E, i, D, o, G, w, k, S){
        this.gravity = A, this.integrationParameters = new $204508e5b4b18960$export$c22d4691787a8578(I), this.islands = new $204508e5b4b18960$export$129e66920a069ba5(g), this.broadPhase = new $204508e5b4b18960$export$d80423229f8b133(C), this.narrowPhase = new $204508e5b4b18960$export$f7b463e625571e2b(B), this.bodies = new $204508e5b4b18960$export$bd569bf5451ee055(Q), this.colliders = new $204508e5b4b18960$export$8ec69bf37b303313(E), this.impulseJoints = new $204508e5b4b18960$export$7b6f816cee9f25f2(i), this.multibodyJoints = new $204508e5b4b18960$export$b6a38ee363602c2a(D), this.ccdSolver = new $204508e5b4b18960$export$ffc4c782649f077(o), this.queryPipeline = new $204508e5b4b18960$export$636a60a98ff98f0b(G), this.physicsPipeline = new $204508e5b4b18960$export$f3c42ca1c254a387(w), this.serializationPipeline = new $204508e5b4b18960$export$b54bf36dd1f18c08(k), this.debugRenderPipeline = new $204508e5b4b18960$export$acdffcc934f6bc95(S), this.characterControllers = new Set, this.impulseJoints.finalizeDeserialization(this.bodies), this.bodies.finalizeDeserialization(this.colliders), this.colliders.finalizeDeserialization(this.bodies);
    }
    free() {
        this.integrationParameters.free(), this.islands.free(), this.broadPhase.free(), this.narrowPhase.free(), this.bodies.free(), this.colliders.free(), this.impulseJoints.free(), this.multibodyJoints.free(), this.ccdSolver.free(), this.queryPipeline.free(), this.physicsPipeline.free(), this.serializationPipeline.free(), this.debugRenderPipeline.free(), this.characterControllers.forEach((A)=>A.free()), this.integrationParameters = void 0, this.islands = void 0, this.broadPhase = void 0, this.narrowPhase = void 0, this.bodies = void 0, this.colliders = void 0, this.ccdSolver = void 0, this.impulseJoints = void 0, this.multibodyJoints = void 0, this.queryPipeline = void 0, this.physicsPipeline = void 0, this.serializationPipeline = void 0, this.debugRenderPipeline = void 0, this.characterControllers = void 0;
    }
    static fromRaw(A) {
        return A ? new $204508e5b4b18960$export$812cd9544993280d($204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.takeGravity()), A.takeIntegrationParameters(), A.takeIslandManager(), A.takeBroadPhase(), A.takeNarrowPhase(), A.takeBodies(), A.takeColliders(), A.takeImpulseJoints(), A.takeMultibodyJoints()) : null;
    }
    takeSnapshot() {
        return this.serializationPipeline.serializeAll(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints);
    }
    static restoreSnapshot(A) {
        return (new $204508e5b4b18960$export$b54bf36dd1f18c08).deserializeAll(A);
    }
    debugRender() {
        return this.debugRenderPipeline.render(this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.narrowPhase), new $204508e5b4b18960$export$354e114f10103d2d(this.debugRenderPipeline.vertices, this.debugRenderPipeline.colors);
    }
    step(A, I) {
        this.physicsPipeline.step(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.ccdSolver, A, I), this.queryPipeline.update(this.bodies, this.colliders);
    }
    propagateModifiedBodyPositionsToColliders() {
        this.bodies.raw.propagateModifiedBodyPositionsToColliders(this.colliders.raw);
    }
    updateSceneQueries() {
        this.propagateModifiedBodyPositionsToColliders(), this.queryPipeline.update(this.bodies, this.colliders);
    }
    get timestep() {
        return this.integrationParameters.dt;
    }
    set timestep(A) {
        this.integrationParameters.dt = A;
    }
    get maxVelocityIterations() {
        return this.integrationParameters.maxVelocityIterations;
    }
    set maxVelocityIterations(A) {
        this.integrationParameters.maxVelocityIterations = A;
    }
    get maxVelocityFrictionIterations() {
        return this.integrationParameters.maxVelocityFrictionIterations;
    }
    set maxVelocityFrictionIterations(A) {
        this.integrationParameters.maxVelocityFrictionIterations = A;
    }
    get maxStabilizationIterations() {
        return this.integrationParameters.maxStabilizationIterations;
    }
    set maxStabilizationIterations(A) {
        this.integrationParameters.maxStabilizationIterations = A;
    }
    createRigidBody(A) {
        return this.bodies.createRigidBody(this.colliders, A);
    }
    createCharacterController(A) {
        let I = new $204508e5b4b18960$export$ed5de7d26b924ce3(A, this.integrationParameters, this.bodies, this.colliders, this.queryPipeline);
        return this.characterControllers.add(I), I;
    }
    removeCharacterController(A) {
        this.characterControllers.delete(A), A.free();
    }
    createCollider(A, I) {
        let g = I ? I.handle : void 0;
        return this.colliders.createCollider(this.bodies, A, g);
    }
    createImpulseJoint(A, I, g, C) {
        return this.impulseJoints.createJoint(this.bodies, A, I.handle, g.handle, C);
    }
    createMultibodyJoint(A, I, g, C) {
        return this.multibodyJoints.createJoint(A, I.handle, g.handle, C);
    }
    getRigidBody(A) {
        return this.bodies.get(A);
    }
    getCollider(A) {
        return this.colliders.get(A);
    }
    getImpulseJoint(A) {
        return this.impulseJoints.get(A);
    }
    getMultibodyJoint(A) {
        return this.multibodyJoints.get(A);
    }
    removeRigidBody(A) {
        this.bodies && this.bodies.remove(A.handle, this.islands, this.colliders, this.impulseJoints, this.multibodyJoints);
    }
    removeCollider(A, I) {
        this.colliders && this.colliders.remove(A.handle, this.islands, this.bodies, I);
    }
    removeImpulseJoint(A, I) {
        this.impulseJoints && this.impulseJoints.remove(A.handle, I);
    }
    removeMultibodyJoint(A, I) {
        this.impulseJoints && this.multibodyJoints.remove(A.handle, I);
    }
    forEachCollider(A) {
        this.colliders.forEach(A);
    }
    forEachRigidBody(A) {
        this.bodies.forEach(A);
    }
    forEachActiveRigidBody(A) {
        this.bodies.forEachActiveRigidBody(this.islands, A);
    }
    castRay(A, I, g, C, B, Q, E, i) {
        return this.queryPipeline.castRay(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
    }
    castRayAndGetNormal(A, I, g, C, B, Q, E, i) {
        return this.queryPipeline.castRayAndGetNormal(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
    }
    intersectionsWithRay(A, I, g, C, B, Q, E, i, D) {
        this.queryPipeline.intersectionsWithRay(this.bodies, this.colliders, A, I, g, C, B, Q, E ? E.handle : null, i ? i.handle : null, this.colliders.castClosure(D));
    }
    intersectionWithShape(A, I, g, C, B, Q, E, i) {
        let D = this.queryPipeline.intersectionWithShape(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
        return null != D ? this.colliders.get(D) : null;
    }
    projectPoint(A, I, g, C, B, Q, E) {
        return this.queryPipeline.projectPoint(this.bodies, this.colliders, A, I, g, C, B ? B.handle : null, Q ? Q.handle : null, this.colliders.castClosure(E));
    }
    projectPointAndGetFeature(A, I, g, C, B, Q) {
        return this.queryPipeline.projectPointAndGetFeature(this.bodies, this.colliders, A, I, g, C ? C.handle : null, B ? B.handle : null, this.colliders.castClosure(Q));
    }
    intersectionsWithPoint(A, I, g, C, B, Q, E) {
        this.queryPipeline.intersectionsWithPoint(this.bodies, this.colliders, A, this.colliders.castClosure(I), g, C, B ? B.handle : null, Q ? Q.handle : null, this.colliders.castClosure(E));
    }
    castShape(A, I, g, C, B, Q, E, i, D, o, G) {
        return this.queryPipeline.castShape(this.bodies, this.colliders, A, I, g, C, B, Q, E, i, D ? D.handle : null, o ? o.handle : null, this.colliders.castClosure(G));
    }
    intersectionsWithShape(A, I, g, C, B, Q, E, i, D) {
        this.queryPipeline.intersectionsWithShape(this.bodies, this.colliders, A, I, g, this.colliders.castClosure(C), B, Q, E ? E.handle : null, i ? i.handle : null, this.colliders.castClosure(D));
    }
    collidersWithAabbIntersectingAabb(A, I, g) {
        this.queryPipeline.collidersWithAabbIntersectingAabb(A, I, this.colliders.castClosure(g));
    }
    contactsWith(A, I) {
        this.narrowPhase.contactsWith(A.handle, this.colliders.castClosure(I));
    }
    intersectionsWith(A, I) {
        this.narrowPhase.intersectionsWith(A.handle, this.colliders.castClosure(I));
    }
    contactPair(A, I, g) {
        this.narrowPhase.contactPair(A.handle, I.handle, g);
    }
    intersectionPair(A, I) {
        return this.narrowPhase.intersectionPair(A.handle, I.handle);
    }
}
!function(A) {
    A[A.COLLISION_EVENTS = 1] = "COLLISION_EVENTS", A[A.CONTACT_FORCE_EVENTS = 2] = "CONTACT_FORCE_EVENTS";
}($204508e5b4b18960$export$f28998d26d157fd3 || ($204508e5b4b18960$export$f28998d26d157fd3 = {}));
class $204508e5b4b18960$export$cba99c196a0dcc61 {
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    collider1() {
        return this.raw.collider1();
    }
    collider2() {
        return this.raw.collider2();
    }
    totalForce() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.total_force());
    }
    totalForceMagnitude() {
        return this.raw.total_force_magnitude();
    }
    maxForceDirection() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.max_force_direction());
    }
    maxForceMagnitude() {
        return this.raw.max_force_magnitude();
    }
}
class $204508e5b4b18960$export$2fc6338444a158e6 {
    constructor(A, I){
        this.raw = I || new $204508e5b4b18960$var$T(A);
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    drainCollisionEvents(A) {
        this.raw.drainCollisionEvents(A);
    }
    drainContactForceEvents(A) {
        let I = new $204508e5b4b18960$export$cba99c196a0dcc61;
        this.raw.drainContactForceEvents((g)=>{
            I.raw = g, A(I), I.free();
        });
    }
    clear() {
        this.raw.clear();
    }
}
function $204508e5b4b18960$var$TI(A, I, g, C) {
    return new (g || (g = Promise))(function(B, Q) {
        function E(A) {
            try {
                D(C.next(A));
            } catch (A) {
                Q(A);
            }
        }
        function i(A) {
            try {
                D(C.throw(A));
            } catch (A) {
                Q(A);
            }
        }
        function D(A) {
            var I;
            A.done ? B(A.value) : (I = A.value, I instanceof g ? I : new g(function(A) {
                A(I);
            })).then(E, i);
        }
        D((C = C.apply(A, I || [])).next());
    });
}
!function(A) {
    A[A.FILTER_CONTACT_PAIRS = 1] = "FILTER_CONTACT_PAIRS", A[A.FILTER_INTERSECTION_PAIRS = 2] = "FILTER_INTERSECTION_PAIRS";
}($204508e5b4b18960$export$194d8ad9e2dc63e8 || ($204508e5b4b18960$export$194d8ad9e2dc63e8 = {})), function(A) {
    A[A.EMPTY = 0] = "EMPTY", A[A.COMPUTE_IMPULSE = 1] = "COMPUTE_IMPULSE";
}($204508e5b4b18960$export$d50a7c063745a562 || ($204508e5b4b18960$export$d50a7c063745a562 = {}));
for(var $204508e5b4b18960$var$OI = {
    byteLength: function(A) {
        var I = $204508e5b4b18960$var$fI(A), g = I[0], C = I[1];
        return 3 * (g + C) / 4 - C;
    },
    toByteArray: function(A) {
        var I, g, C = $204508e5b4b18960$var$fI(A), B = C[0], Q = C[1], E = new $204508e5b4b18960$var$bI(function(A, I, g) {
            return 3 * (I + g) / 4 - g;
        }(0, B, Q)), i = 0, D = Q > 0 ? B - 4 : B;
        for(g = 0; g < D; g += 4)I = $204508e5b4b18960$var$ZI[A.charCodeAt(g)] << 18 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 1)] << 12 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 2)] << 6 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 3)], E[i++] = I >> 16 & 255, E[i++] = I >> 8 & 255, E[i++] = 255 & I;
        2 === Q && (I = $204508e5b4b18960$var$ZI[A.charCodeAt(g)] << 2 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 1)] >> 4, E[i++] = 255 & I);
        1 === Q && (I = $204508e5b4b18960$var$ZI[A.charCodeAt(g)] << 10 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 1)] << 4 | $204508e5b4b18960$var$ZI[A.charCodeAt(g + 2)] >> 2, E[i++] = I >> 8 & 255, E[i++] = 255 & I);
        return E;
    },
    fromByteArray: function(A) {
        for(var I, g = A.length, C = g % 3, B = [], Q = 16383, E = 0, i = g - C; E < i; E += Q)B.push($204508e5b4b18960$var$mI(A, E, E + Q > i ? i : E + Q));
        1 === C ? (I = A[g - 1], B.push($204508e5b4b18960$var$nI[I >> 2] + $204508e5b4b18960$var$nI[I << 4 & 63] + "==")) : 2 === C && (I = (A[g - 2] << 8) + A[g - 1], B.push($204508e5b4b18960$var$nI[I >> 10] + $204508e5b4b18960$var$nI[I >> 4 & 63] + $204508e5b4b18960$var$nI[I << 2 & 63] + "="));
        return B.join("");
    }
}, $204508e5b4b18960$var$nI = [], $204508e5b4b18960$var$ZI = [], $204508e5b4b18960$var$bI = "undefined" != typeof Uint8Array ? Uint8Array : Array, $204508e5b4b18960$var$WI = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $204508e5b4b18960$var$jI = 0, $204508e5b4b18960$var$xI = $204508e5b4b18960$var$WI.length; $204508e5b4b18960$var$jI < $204508e5b4b18960$var$xI; ++$204508e5b4b18960$var$jI)$204508e5b4b18960$var$nI[$204508e5b4b18960$var$jI] = $204508e5b4b18960$var$WI[$204508e5b4b18960$var$jI], $204508e5b4b18960$var$ZI[$204508e5b4b18960$var$WI.charCodeAt($204508e5b4b18960$var$jI)] = $204508e5b4b18960$var$jI;
function $204508e5b4b18960$var$fI(A) {
    var I = A.length;
    if (I % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var g = A.indexOf("=");
    return -1 === g && (g = I), [
        g,
        g === I ? 0 : 4 - g % 4
    ];
}
function $204508e5b4b18960$var$mI(A, I, g) {
    for(var C, B, Q = [], E = I; E < g; E += 3)C = (A[E] << 16 & 16711680) + (A[E + 1] << 8 & 65280) + (255 & A[E + 2]), Q.push($204508e5b4b18960$var$nI[(B = C) >> 18 & 63] + $204508e5b4b18960$var$nI[B >> 12 & 63] + $204508e5b4b18960$var$nI[B >> 6 & 63] + $204508e5b4b18960$var$nI[63 & B]);
    return Q.join("");
}
function $204508e5b4b18960$export$2cd8252107eb640b() {
    return $204508e5b4b18960$var$TI(this, void 0, void 0, function*() {
        yield $204508e5b4b18960$var$EA($204508e5b4b18960$var$OI.toByteArray("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").buffer);
    });
}
function $204508e5b4b18960$export$83d89fbfd8236492() {
    return function() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.version(C);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return $204508e5b4b18960$var$S(I, g);
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16), $204508e5b4b18960$var$A.__wbindgen_free(I, g);
        }
    }();
}
$204508e5b4b18960$var$ZI["-".charCodeAt(0)] = 62, $204508e5b4b18960$var$ZI["_".charCodeAt(0)] = 63;
var $204508e5b4b18960$export$2e2bcd8739ae039 = Object.freeze({
    __proto__: null,
    version: $204508e5b4b18960$export$83d89fbfd8236492,
    Vector3: $204508e5b4b18960$export$64b5c384219d3699,
    VectorOps: $204508e5b4b18960$export$e2f642242c040d8f,
    Quaternion: $204508e5b4b18960$export$23d6a54f0bbc85a3,
    RotationOps: $204508e5b4b18960$export$824960640e91b57,
    SdpMatrix3: $204508e5b4b18960$export$a634d4178dd6cfce,
    SdpMatrix3Ops: $204508e5b4b18960$export$afeef1d10fc8a4f3,
    get RigidBodyType () {
        return $204508e5b4b18960$export$9df1fa60cce90854;
    },
    RigidBody: $204508e5b4b18960$export$41c0a739a32ac4d,
    RigidBodyDesc: $204508e5b4b18960$export$105dcb996a5d3c42,
    RigidBodySet: $204508e5b4b18960$export$bd569bf5451ee055,
    IntegrationParameters: $204508e5b4b18960$export$c22d4691787a8578,
    get JointType () {
        return $204508e5b4b18960$export$d8c34c2371473e33;
    },
    get MotorModel () {
        return $204508e5b4b18960$export$9fe5861f16a3846f;
    },
    ImpulseJoint: $204508e5b4b18960$export$13616a6dfa0c261e,
    UnitImpulseJoint: $204508e5b4b18960$export$b6c446c752acb453,
    FixedImpulseJoint: $204508e5b4b18960$export$13a2c1429de97fd0,
    PrismaticImpulseJoint: $204508e5b4b18960$export$ca91224fa01cc4c5,
    RevoluteImpulseJoint: $204508e5b4b18960$export$f21c6aedecbeb53d,
    SphericalImpulseJoint: $204508e5b4b18960$export$da358565907d92be,
    JointData: $204508e5b4b18960$export$9ad4996060073eaa,
    ImpulseJointSet: $204508e5b4b18960$export$7b6f816cee9f25f2,
    MultibodyJoint: $204508e5b4b18960$export$9f6b52d8d09f7b72,
    UnitMultibodyJoint: $204508e5b4b18960$export$b677e6fe6c6cb994,
    FixedMultibodyJoint: $204508e5b4b18960$export$6984fd596a92ce33,
    PrismaticMultibodyJoint: $204508e5b4b18960$export$1ac8e4ec1713e3da,
    RevoluteMultibodyJoint: $204508e5b4b18960$export$e2bca3ac97ae239e,
    SphericalMultibodyJoint: $204508e5b4b18960$export$b9ffb05588678855,
    MultibodyJointSet: $204508e5b4b18960$export$b6a38ee363602c2a,
    get CoefficientCombineRule () {
        return $204508e5b4b18960$export$5d7f3962eb4528af;
    },
    CCDSolver: $204508e5b4b18960$export$ffc4c782649f077,
    IslandManager: $204508e5b4b18960$export$129e66920a069ba5,
    BroadPhase: $204508e5b4b18960$export$d80423229f8b133,
    NarrowPhase: $204508e5b4b18960$export$f7b463e625571e2b,
    TempContactManifold: $204508e5b4b18960$export$7ac890e03fe91616,
    Shape: $204508e5b4b18960$export$6428a7f2611ef1fa,
    get ShapeType () {
        return $204508e5b4b18960$export$fc850f719b5599d5;
    },
    Ball: $204508e5b4b18960$export$a83d7c3fa53790c9,
    HalfSpace: $204508e5b4b18960$export$b774d5dd1a533096,
    Cuboid: $204508e5b4b18960$export$c8821cc685709b7b,
    RoundCuboid: $204508e5b4b18960$export$c87d2c121efe06ab,
    Capsule: $204508e5b4b18960$export$28bdb8fc07bf3804,
    Segment: $204508e5b4b18960$export$d53aa5c5ab432700,
    Triangle: $204508e5b4b18960$export$5a465592bfe74b48,
    RoundTriangle: $204508e5b4b18960$export$5d38c33920824fab,
    Polyline: $204508e5b4b18960$export$79f3ee03e63e7073,
    TriMesh: $204508e5b4b18960$export$16df86f06e459b09,
    ConvexPolyhedron: $204508e5b4b18960$export$7c637a75bc263948,
    RoundConvexPolyhedron: $204508e5b4b18960$export$f9ecc9020d30774f,
    Heightfield: $204508e5b4b18960$export$fa360b5b58f475b7,
    Cylinder: $204508e5b4b18960$export$665c37f020fe48f9,
    RoundCylinder: $204508e5b4b18960$export$6fe70449556bd1bd,
    Cone: $204508e5b4b18960$export$22209bc4af3d3757,
    RoundCone: $204508e5b4b18960$export$fec6094316a593bd,
    get ActiveCollisionTypes () {
        return $204508e5b4b18960$export$822f84f0c1c58b2a;
    },
    Collider: $204508e5b4b18960$export$b7c6eef0ebb06133,
    get MassPropsMode () {
        return $204508e5b4b18960$export$9d99ce4bda7104cf;
    },
    ColliderDesc: $204508e5b4b18960$export$7d4cec221ee36947,
    ColliderSet: $204508e5b4b18960$export$8ec69bf37b303313,
    get FeatureType () {
        return $204508e5b4b18960$export$c40deacab7e2491c;
    },
    Ray: $204508e5b4b18960$export$a186db52eed6d40e,
    RayIntersection: $204508e5b4b18960$export$292489680db6ed3f,
    RayColliderIntersection: $204508e5b4b18960$export$bc228139800bb3c,
    RayColliderToi: $204508e5b4b18960$export$fc9976cd477662f8,
    PointProjection: $204508e5b4b18960$export$5e813b027a709134,
    PointColliderProjection: $204508e5b4b18960$export$fc779dece190555,
    ShapeTOI: $204508e5b4b18960$export$1c5cc33417eb8bc,
    ShapeColliderTOI: $204508e5b4b18960$export$edd42a90ffbc1c72,
    ShapeContact: $204508e5b4b18960$export$1d7ee127e07c91bb,
    World: $204508e5b4b18960$export$812cd9544993280d,
    PhysicsPipeline: $204508e5b4b18960$export$f3c42ca1c254a387,
    SerializationPipeline: $204508e5b4b18960$export$b54bf36dd1f18c08,
    get ActiveEvents () {
        return $204508e5b4b18960$export$f28998d26d157fd3;
    },
    TempContactForceEvent: $204508e5b4b18960$export$cba99c196a0dcc61,
    EventQueue: $204508e5b4b18960$export$2fc6338444a158e6,
    get ActiveHooks () {
        return $204508e5b4b18960$export$194d8ad9e2dc63e8;
    },
    get SolverFlags () {
        return $204508e5b4b18960$export$d50a7c063745a562;
    },
    DebugRenderBuffers: $204508e5b4b18960$export$354e114f10103d2d,
    DebugRenderPipeline: $204508e5b4b18960$export$acdffcc934f6bc95,
    get QueryFilterFlags () {
        return $204508e5b4b18960$export$39a39008025d4cb;
    },
    QueryPipeline: $204508e5b4b18960$export$636a60a98ff98f0b,
    init: $204508e5b4b18960$export$2cd8252107eb640b,
    CharacterCollision: $204508e5b4b18960$export$d8a6c60ecc79c6a6,
    KinematicCharacterController: $204508e5b4b18960$export$ed5de7d26b924ce3
});

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $f731f978dad0a1fd$exports = {};
var $88d8b625acfa2d94$exports = {};

$88d8b625acfa2d94$exports = new URL((parcelRequire("27Lyk")).resolve("2lYs1"), import.meta.url).toString();


var $3ea68dba33412ea2$exports = {};

$3ea68dba33412ea2$exports = new URL((parcelRequire("27Lyk")).resolve("hGfTQ"), import.meta.url).toString();


var $aa28a38f21e9dc60$exports = {};

$aa28a38f21e9dc60$exports = new URL((parcelRequire("27Lyk")).resolve("d7sSv"), import.meta.url).toString();


var $db842fa04047598a$exports = {};

$db842fa04047598a$exports = new URL((parcelRequire("27Lyk")).resolve("bvZRV"), import.meta.url).toString();


var $a24f842775087891$exports = {};

$a24f842775087891$exports = new URL((parcelRequire("27Lyk")).resolve("lIcrF"), import.meta.url).toString();


var $0a76ce1d09666c24$exports = {};

$0a76ce1d09666c24$exports = new URL((parcelRequire("27Lyk")).resolve("95Fy5"), import.meta.url).toString();


var $ef23a5b171e17679$exports = {};

$ef23a5b171e17679$exports = new URL((parcelRequire("27Lyk")).resolve("4n3Wf"), import.meta.url).toString();


$f731f978dad0a1fd$exports = {
    "BeeTown": $88d8b625acfa2d94$exports,
    "Forest 1-2": $3ea68dba33412ea2$exports,
    "Level1-1WITHPOND": $aa28a38f21e9dc60$exports,
    "map": $db842fa04047598a$exports,
    "map2": $a24f842775087891$exports,
    "map3": $0a76ce1d09666c24$exports,
    "world2": {
        "map2": $ef23a5b171e17679$exports
    }
};


parcelRequire("acw62");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $298fb931ed4fbf8b$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, p + 1, p = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $f8dbcd8598db1f0b$var$f = ("undefined" != typeof $cfae44f0dfdf62c0$exports && void 0 !== $cfae44f0dfdf62c0$exports.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.0.5", $f8dbcd8598db1f0b$var$y = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, false)), $f8dbcd8598db1f0b$var$g = {}, $f8dbcd8598db1f0b$var$S = /invalid hook call/i, $f8dbcd8598db1f0b$var$w = new Set, $f8dbcd8598db1f0b$var$b = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$E = Object.freeze([]), $f8dbcd8598db1f0b$var$N = Object.freeze({});
function $f8dbcd8598db1f0b$var$P(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$I = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$A(e) {
    return e.replace($f8dbcd8598db1f0b$var$C, "-").replace($f8dbcd8598db1f0b$var$I, "");
}
var $f8dbcd8598db1f0b$var$O = /(a)(d)/gi, $f8dbcd8598db1f0b$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$D(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$D(t % 52) + n).replace($f8dbcd8598db1f0b$var$O, "$1-$2");
}
var $f8dbcd8598db1f0b$var$T, $f8dbcd8598db1f0b$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$j = function(e) {
    return $f8dbcd8598db1f0b$var$k(5381, e);
};
function $f8dbcd8598db1f0b$var$x(e) {
    return $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$j(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$M(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$F = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$$ = $f8dbcd8598db1f0b$var$F ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$z = $f8dbcd8598db1f0b$var$F ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$Y = (($f8dbcd8598db1f0b$var$T = {})[$f8dbcd8598db1f0b$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$T[$f8dbcd8598db1f0b$var$$] = $f8dbcd8598db1f0b$var$G, $f8dbcd8598db1f0b$var$T);
function $f8dbcd8598db1f0b$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$$ ? $f8dbcd8598db1f0b$var$G : "$$typeof" in e ? $f8dbcd8598db1f0b$var$Y[e.$$typeof] : $f8dbcd8598db1f0b$var$B;
}
var $f8dbcd8598db1f0b$var$q = Object.defineProperty, $f8dbcd8598db1f0b$var$H = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$U = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$J = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$X = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$Z = Object.prototype;
function $f8dbcd8598db1f0b$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$Z) {
            var o = $f8dbcd8598db1f0b$var$X(t);
            o && o !== $f8dbcd8598db1f0b$var$Z && $f8dbcd8598db1f0b$var$K(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$H(t);
        $f8dbcd8598db1f0b$var$U && (r = r.concat($f8dbcd8598db1f0b$var$U(t)));
        for(var s = $f8dbcd8598db1f0b$var$W(e), i = $f8dbcd8598db1f0b$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$J(t, c);
                try {
                    $f8dbcd8598db1f0b$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$Q(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$re(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$oe(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$re(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$ie = {};
function $f8dbcd8598db1f0b$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$ue = new Map, $f8dbcd8598db1f0b$var$pe = new Map, $f8dbcd8598db1f0b$var$de = 1, $f8dbcd8598db1f0b$var$he = function(e) {
    if ($f8dbcd8598db1f0b$var$ue.has(e)) return $f8dbcd8598db1f0b$var$ue.get(e);
    for(; $f8dbcd8598db1f0b$var$pe.has($f8dbcd8598db1f0b$var$de);)$f8dbcd8598db1f0b$var$de++;
    var t = $f8dbcd8598db1f0b$var$de++;
    return $f8dbcd8598db1f0b$var$ue.set(e, t), $f8dbcd8598db1f0b$var$pe.set(t, e), t;
}, $f8dbcd8598db1f0b$var$fe = function(e, t) {
    $f8dbcd8598db1f0b$var$ue.set(e, t), $f8dbcd8598db1f0b$var$pe.set(t, e);
}, $f8dbcd8598db1f0b$var$me = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat("data-styled-version", '="').concat("6.0.5", '"]'), $f8dbcd8598db1f0b$var$ye = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$fe(u, l), $f8dbcd8598db1f0b$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $f8dbcd8598db1f0b$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, "active"), o.setAttribute("data-styled-version", "6.0.5");
    var i = $f8dbcd8598db1f0b$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$be = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ee = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Pe = $f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$var$_e = {
    isServer: !$f8dbcd8598db1f0b$var$y,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$v
}, $f8dbcd8598db1f0b$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$y && $f8dbcd8598db1f0b$var$Pe && ($f8dbcd8598db1f0b$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($f8dbcd8598db1f0b$var$f) && ($f8dbcd8598db1f0b$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $f8dbcd8598db1f0b$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$Ne(n) : t ? new $f8dbcd8598db1f0b$var$be(n) : new $f8dbcd8598db1f0b$var$Ee(n);
        }(this.options), new $f8dbcd8598db1f0b$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$Ie = /&/g, $f8dbcd8598db1f0b$var$Ae = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Oe(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$De(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$N : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$N : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), u.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$Ae, ""), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Oe(l, i.namespace));
        var p = [];
        return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, $298fb931ed4fbf8b$export$5a7767152ae0305f(u.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$ce(15), $f8dbcd8598db1f0b$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Re = new $f8dbcd8598db1f0b$var$Ce, $f8dbcd8598db1f0b$var$Te = $f8dbcd8598db1f0b$var$De(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Re,
    stylis: $f8dbcd8598db1f0b$var$Te
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Ve() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Ve().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$xe.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$Fe = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$se(this, function() {
            throw $f8dbcd8598db1f0b$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$Te), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$Be(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$Q(i) ? r.push("".concat($f8dbcd8598db1f0b$var$ze(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$oe(i) ? r.push.apply(r, (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Ge(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$Be(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$Q(e)) {
        if (!$f8dbcd8598db1f0b$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$Fe ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$oe(e) ? $f8dbcd8598db1f0b$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($f8dbcd8598db1f0b$var$E, e.map(function(e) {
        return $f8dbcd8598db1f0b$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$Q(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$We = $f8dbcd8598db1f0b$var$j("6.0.5"), $f8dbcd8598db1f0b$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Ye(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$k($f8dbcd8598db1f0b$var$We, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$te(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$k(a, p), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$ce(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$ce(14);
            if ($f8dbcd8598db1f0b$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$ce(8);
            return n ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ze = {}, $f8dbcd8598db1f0b$var$Ke = new Set;
function $f8dbcd8598db1f0b$var$Qe(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$M(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$A(e);
        $f8dbcd8598db1f0b$var$Ze[n] = ($f8dbcd8598db1f0b$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$x("6.0.5" + n + $f8dbcd8598db1f0b$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$M(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $f8dbcd8598db1f0b$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), m = $f8dbcd8598db1f0b$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$te(s[c], a[c]) : "style" === c ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$te(s.className, n.className)), s;
            }(i, r, $f8dbcd8598db1f0b$var$P(r, f, c) || $f8dbcd8598db1f0b$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $f8dbcd8598db1f0b$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$f8dbcd8598db1f0b$var$M(g) && !$f8dbcd8598db1f0b$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $acw62.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $f8dbcd8598db1f0b$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$Q(t) || $f8dbcd8598db1f0b$var$oe(t)) {
        var r = t;
        return $f8dbcd8598db1f0b$var$tt($f8dbcd8598db1f0b$var$Ge($f8dbcd8598db1f0b$var$et($f8dbcd8598db1f0b$var$E, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $f8dbcd8598db1f0b$var$Ge(s) : $f8dbcd8598db1f0b$var$tt($f8dbcd8598db1f0b$var$Ge($f8dbcd8598db1f0b$var$et(s, n)));
}
function $f8dbcd8598db1f0b$var$ot(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$N), !o) throw $f8dbcd8598db1f0b$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$ot(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$ot(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$rt = function(e) {
    return $f8dbcd8598db1f0b$var$ot($f8dbcd8598db1f0b$var$Qe, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$rt;
$f8dbcd8598db1f0b$var$_.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$rt(e);
});
var $f8dbcd8598db1f0b$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Ye(e), $f8dbcd8598db1f0b$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$x(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$it(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$g, o, s);
        else {
            var i = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$x(r);
    return new $f8dbcd8598db1f0b$var$Fe(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $f8dbcd8598db1f0b$var$K(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $f8dbcd8598db1f0b$var$Se(), o = $f8dbcd8598db1f0b$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.0.5", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
            var r = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n["data-styled-version"] = "6.0.5", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $f8dbcd8598db1f0b$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$ce(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Ce,
    mainSheet: $f8dbcd8598db1f0b$var$Re
};
var $f8dbcd8598db1f0b$var$dt = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");




var $acw62 = parcelRequire("acw62");
// @ts-ignore
var $7c9bfd0eccee11f6$exports = {};







$7c9bfd0eccee11f6$exports = {
    "BeeTown": $88d8b625acfa2d94$exports,
    "Forest 1-2": $3ea68dba33412ea2$exports,
    "Level1-1WITHPOND": $aa28a38f21e9dc60$exports,
    "map": $db842fa04047598a$exports,
    "map2": $a24f842775087891$exports,
    "map3": $0a76ce1d09666c24$exports,
    "world2": {
        "map2": $ef23a5b171e17679$exports
    }
};


var $17158869b2ff324f$export$c6f7686a82f0b939 = function ConfigurableInstance(config) {
    if (config === void 0) config = {};
    Object.assign(this, config);
};
function $17158869b2ff324f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $17158869b2ff324f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $17158869b2ff324f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $17158869b2ff324f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $17158869b2ff324f$var$_extends() {
    $17158869b2ff324f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17158869b2ff324f$var$_extends.apply(this, arguments);
}
function $17158869b2ff324f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $17158869b2ff324f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $17158869b2ff324f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $17158869b2ff324f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $17158869b2ff324f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $17158869b2ff324f$var$_arrayLikeToArray(o, minLen);
}
function $17158869b2ff324f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $17158869b2ff324f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $17158869b2ff324f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
/**
 * An object used to invalidate a path.
 * */ var $17158869b2ff324f$var$INVALID = {};
/**
 * Easily manage a data structure that can be dynamically built
 * from paths with out throwing errors for accessing undefined
 * portions of the structure.
 * */ var $17158869b2ff324f$export$3fd05f34aa54480b = /*#__PURE__*/ function(_ConfigurableInstance) {
    $17158869b2ff324f$var$_inheritsLoose(HashMatrix, _ConfigurableInstance);
    function HashMatrix(config) {
        var _this;
        if (config === void 0) config = {};
        _this = _ConfigurableInstance.call(this, config) || this;
        _this._changeHandlerMap = {};
        _this._errorHandlerMap = {};
        if (typeof _this.pathDelimiter !== "string") _this.pathDelimiter = HashMatrix.DEFAULT_PATH_DELIMITER;
        _this._setDefaultName();
        return _this;
    }
    HashMatrix.keyIsNumeric = function keyIsNumeric(key) {
        var numeric = false;
        try {
            numeric = Number.isInteger(parseInt("" + key, 10));
        } catch (error) {}
        return numeric;
    };
    var _proto = HashMatrix.prototype;
    _proto._setDefaultName = function _setDefaultName() {
        if (!this.hasOwnProperty("name")) {
            if (typeof this.constructor.DEFAULT_NAME === "string") this.name = this.constructor.DEFAULT_NAME;
            else this.name = HashMatrix.DEFAULT_NAME;
        }
    };
    _proto.getChangeHandlerList = function getChangeHandlerList(path) {
        var pathString = this.getPathString(path);
        return this._changeHandlerMap[pathString] || [];
    };
    _proto.setChangeHandlerList = function setChangeHandlerList(path, handlerList) {
        if (handlerList === void 0) handlerList = [];
        var pathString = this.getPathString(path);
        this._changeHandlerMap[pathString] = handlerList;
    };
    _proto.addChangeHandler = function addChangeHandler(path, handler) {
        var _this2 = this;
        if (path === void 0) path = "";
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.addChangeHandler(this.getPathArray(path, this.targetPath), handler);
        if (!!handler) {
            var handlerList = this.getChangeHandlerList(path);
            if (handlerList.indexOf(handler) === -1) {
                handlerList.push(handler);
                this.setChangeHandlerList(path, handlerList);
                return function() {
                    return _this2.removeChangeHandler(path, handler);
                };
            }
        }
    };
    _proto.removeChangeHandler = function removeChangeHandler(path, handler) {
        if (path === void 0) path = "";
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.removeChangeHandler(this.getPathArray(path, this.targetPath), handler);
        var handlerList = this.getChangeHandlerList(path);
        if (handlerList.indexOf(handler) !== -1) {
            var newHandlerList = [];
            handlerList.forEach(function(h) {
                if (h !== handler) newHandlerList.push(h);
            });
            this.setChangeHandlerList(path, newHandlerList);
        }
    };
    _proto.onChange = function onChange(path, causePath) {
        var _this3 = this;
        var handlerList = this.getChangeHandlerList(path);
        handlerList.forEach(function(h) {
            return h(path, causePath, _this3);
        });
    };
    _proto.getErrorHandlerList = function getErrorHandlerList(path) {
        var pathString = this.getPathString(path);
        return this._errorHandlerMap[pathString] || [];
    };
    _proto.setErrorHandlerList = function setErrorHandlerList(path, handlerList) {
        if (handlerList === void 0) handlerList = [];
        var pathString = this.getPathString(path);
        this._errorHandlerMap[pathString] = handlerList;
    };
    _proto.addErrorHandler = function addErrorHandler(path, handler) {
        var _this4 = this;
        if (path === void 0) path = "";
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.addErrorHandler(this.getPathArray(path, this.targetPath), handler);
        if (!!handler) {
            var handlerList = this.getErrorHandlerList(path);
            if (handlerList.indexOf(handler) === -1) {
                handlerList.push(handler);
                this.setErrorHandlerList(path, handlerList);
                return function() {
                    return _this4.removeErrorHandler(path, handler);
                };
            }
        }
    };
    _proto.removeErrorHandler = function removeErrorHandler(path, handler) {
        if (path === void 0) path = "";
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.removeErrorHandler(this.getPathArray(path, this.targetPath), handler);
        var handlerList = this.getErrorHandlerList(path);
        if (handlerList.indexOf(handler) !== -1) {
            var newHandlerList = [];
            handlerList.forEach(function(h) {
                if (h !== handler) newHandlerList.push(h);
            });
            this.setErrorHandlerList(path, newHandlerList);
        }
    };
    _proto.onError = function onError(error, path, causePath) {
        var _this5 = this;
        var handlerList = this.getErrorHandlerList(path);
        handlerList.forEach(function(h) {
            return h(error, path, causePath, _this5);
        });
    };
    _proto.getBasePathArray = function getBasePathArray(path) {
        if (path === void 0) path = "";
        return path instanceof Array ? [].concat(path) : path === "" ? [] : ("" + path).split(this.pathDelimiter);
    };
    _proto.getPathArray = function getPathArray(path, prefixPath) {
        if (path === void 0) path = "";
        if (prefixPath === void 0) prefixPath = "";
        var prefixPathArray = this.getBasePathArray(prefixPath);
        var pathArray = this.getBasePathArray(path);
        return [].concat(prefixPathArray, pathArray);
    };
    _proto.getPathString = function getPathString(path, prefixPath) {
        return this.getPathArray(path, prefixPath).join(this.pathDelimiter);
    };
    _proto.dispatchChanges = function dispatchChanges(path) {
        var pathArray = this.getPathArray(path);
        var pathString = this.getPathString(pathArray); // Notify lifecycle listeners of changes all the way up the path.
        if (pathArray.length) {
            var currentPath = [].concat(pathArray); // TRICKY: Start with the deepest path and move up to the most shallow.
            while(currentPath.length){
                this.onChange(this.getPathString(currentPath), pathString);
                currentPath.pop();
            }
        }
        this.onChange("", pathString);
    };
    _proto.dispatchErrors = function dispatchErrors(error, path) {
        var pathArray = this.getPathArray(path);
        var pathString = this.getPathString(pathArray); // Notify lifecycle listeners of errors all the way up the path.
        if (pathArray.length) {
            var currentPath = [].concat(pathArray); // TRICKY: Start with the deepest path and move up to the most shallow.
            while(currentPath.length){
                this.onError(error, this.getPathString(currentPath), pathString);
                currentPath.pop();
            }
        }
        this.onError(error, "", pathString);
    };
    _proto._setErrorInternal = function _setErrorInternal(path, error) {
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.setError(this.getPathArray(path, this.targetPath), error);
        this.dispatchErrors(error, path);
    };
    _proto.setError = function setError(path, error) {
        return this._setErrorInternal(path, error);
    };
    _proto._getPathInternal = function _getPathInternal(path) {
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.getPath(this.getPathArray(path, this.targetPath));
        var pathArray = this.getPathArray(path);
        if (pathArray.length) {
            var value, currentValue = this.hashMatrix, finished = true;
            for(var _iterator = $17158869b2ff324f$var$_createForOfIteratorHelperLoose(pathArray), _step; !(_step = _iterator()).done;){
                var part = _step.value;
                // Don't fail, just return `undefined`.
                try {
                    var _currentValue;
                    currentValue = (_currentValue = currentValue) === null || _currentValue === void 0 ? void 0 : _currentValue[part];
                } catch (error) {
                    finished = false;
                    break;
                }
            } // TRICKY: Don't select the current value if the full path wasn't processed.
            if (finished) value = currentValue;
            return value;
        } else return this.hashMatrix;
    };
    _proto.getPath = function getPath(path) {
        return this._getPathInternal(path);
    };
    _proto._setPathInternal = function _setPathInternal(path, value) {
        if (this.hashMatrix instanceof HashMatrix) return this.hashMatrix.setPath(this.getPathArray(path, this.targetPath), value);
        var targetValue = value === $17158869b2ff324f$var$INVALID ? undefined : value;
        var pathArray = this.getPathArray(path); // TRICKY: DO NOT set if the value is exactly equal.
        if (targetValue !== this._getPathInternal(path)) {
            var newHashMatrix = $17158869b2ff324f$var$_extends({}, this.hashMatrix);
            if (pathArray.length) {
                var lastIndex = pathArray.length - 1;
                var lastPart = pathArray[lastIndex];
                var currentValue = newHashMatrix;
                for(var i = 0; i < lastIndex; i++){
                    var part = pathArray[i];
                    var nextPart = pathArray[i + 1]; // TRICKY: Build out the tree is it's not there.
                    if (typeof currentValue[part] === "undefined") currentValue[part] = HashMatrix.keyIsNumeric(nextPart) ? [] : {};
                    else if (currentValue[part] instanceof Array) currentValue[part] = [].concat(currentValue[part]);
                    else if (currentValue[part] instanceof Object) currentValue[part] = $17158869b2ff324f$var$_extends({}, currentValue[part]);
                    currentValue = currentValue[part];
                }
                currentValue[lastPart] = targetValue;
                this.hashMatrix = newHashMatrix;
            } else this.hashMatrix = targetValue;
            this.dispatchChanges(pathArray);
        } else if (value === $17158869b2ff324f$var$INVALID) this.dispatchChanges(pathArray);
    };
    _proto.setPath = function setPath(path, value) {
        return this._setPathInternal(path, value);
    };
    _proto.invalidatePath = function invalidatePath(path) {
        this.setPath(path, $17158869b2ff324f$var$INVALID);
    };
    _proto.getValue = function getValue() {
        return this.getPath([]);
    };
    _proto.setValue = function setValue(value) {
        return this.setPath([], value);
    };
    _proto.invalidate = function invalidate() {
        var _this6 = this;
        if (!this.preventInvalidation) {
            if (typeof this.debounceInvalidationMS === "number") {
                clearTimeout(this._invalidationDebounceTimeout);
                this._invalidationDebounceTimeout = setTimeout(function() {
                    return _this6.setValue($17158869b2ff324f$var$INVALID);
                }, this.debounceInvalidationMS);
            } else this.setValue($17158869b2ff324f$var$INVALID);
        }
    };
    return HashMatrix;
}($17158869b2ff324f$export$c6f7686a82f0b939);
$17158869b2ff324f$export$3fd05f34aa54480b.DEFAULT_NAME = "HashMatrix";
$17158869b2ff324f$export$3fd05f34aa54480b.DEFAULT_PATH_DELIMITER = ".";
$17158869b2ff324f$export$3fd05f34aa54480b.ERRORS = {
    INVALID_PATH_DELIMITER: "INVALID_PATH_DELIMITER"
};
// A type of promise-like that resolves synchronously and supports only one observer
var $17158869b2ff324f$var$_iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = /*#__PURE__*/ Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values
var $17158869b2ff324f$var$_asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = /*#__PURE__*/ Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing
function $17158869b2ff324f$var$_catch(body, recover) {
    try {
        var result = body();
    } catch (e) {
        return recover(e);
    }
    if (result && result.then) return result.then(void 0, recover);
    return result;
} // Asynchronously await a promise and pass the result to a finally continuation
var $17158869b2ff324f$var$getMergedDependencies = function getMergedDependencies(depStructure, merge) {
    if (depStructure === void 0) depStructure = {};
    if (merge === false) return depStructure;
    var _depStructure = depStructure, dependencies = _depStructure.dependencies, getters = _depStructure.getters, setters = _depStructure.setters, invalidators = _depStructure.invalidators, listeners = _depStructure.listeners;
    return $17158869b2ff324f$var$_extends({}, dependencies, getters, setters, invalidators, listeners);
};
/**
 * A container used to resolve a `DependencyDeclaration`.
 * @see DependencyDeclaration
 * */ var $17158869b2ff324f$export$e5ba30b7633db20b = /*#__PURE__*/ function(_HashMatrix) {
    $17158869b2ff324f$var$_inheritsLoose(LifePod, _HashMatrix);
    /**
   * @param {DependencyDeclaration} dependencyDeclaration The `DependencyDeclaration` to be resolved.
   * */ function LifePod(_temp) {
        var _this;
        var _ref = _temp === void 0 ? {} : _temp, _ref$dependencies = _ref.dependencies, dependencies = _ref$dependencies === void 0 ? [] : _ref$dependencies, cleanDependencyDeclaration = $17158869b2ff324f$var$_objectWithoutPropertiesLoose(_ref, [
            "dependencies"
        ]);
        _this = _HashMatrix.call(this, cleanDependencyDeclaration) || this;
        _this.handleDependencyChange = function() {
            _this.invalidate();
        };
        _this.addDependencyChangeHandler = function(dependency) {
            if (dependency instanceof $17158869b2ff324f$export$3fd05f34aa54480b) dependency.addChangeHandler("", _this.handleDependencyChange);
        };
        _this.removeDependencyChangeHandler = function(dependency) {
            if (dependency instanceof $17158869b2ff324f$export$3fd05f34aa54480b) dependency.removeChangeHandler("", _this.handleDependencyChange);
        };
        _this.addDependencyMapChangeHandlers = function(dependencyMap) {
            if (dependencyMap === void 0) dependencyMap = {};
            Object.keys(dependencyMap).forEach(function(k) {
                return _this.addDependencyChangeHandler(dependencyMap[k]);
            });
        };
        _this.removeDependencyMapChangeHandlers = function(dependencyMap) {
            if (dependencyMap === void 0) dependencyMap = {};
            Object.keys(dependencyMap).forEach(function(k) {
                return _this.removeDependencyChangeHandler(dependencyMap[k]);
            });
        };
        _this.handleDependencyError = function(error, path, causePath, target) {
            var dependencyError = new Error("A dependency failed to resolve.");
            if (typeof error === "object") dependencyError.source = {
                error: error,
                path: path,
                causePath: causePath,
                target: target
            };
            _this.setError([], dependencyError);
        };
        _this.addDependencyErrorHandler = function(dependency) {
            if (dependency instanceof $17158869b2ff324f$export$3fd05f34aa54480b) dependency.addErrorHandler("", _this.handleDependencyError);
        };
        _this.removeDependencyErrorHandler = function(dependency) {
            if (dependency instanceof $17158869b2ff324f$export$3fd05f34aa54480b) dependency.removeErrorHandler("", _this.handleDependencyError);
        };
        _this.addDependencyMapErrorHandlers = function(dependencyMap) {
            if (dependencyMap === void 0) dependencyMap = {};
            Object.keys(dependencyMap).forEach(function(k) {
                return _this.addDependencyErrorHandler(dependencyMap[k]);
            });
        };
        _this.removeDependencyMapErrorHandlers = function(dependencyMap) {
            if (dependencyMap === void 0) dependencyMap = {};
            Object.keys(dependencyMap).forEach(function(k) {
                return _this.removeDependencyErrorHandler(dependencyMap[k]);
            });
        };
        _this.resolving = false;
        _this.dependencies = dependencies;
        return _this;
    }
    /**
   * @returns {Object.<HashMatrix>} A map of named dependencies.
   * */ var _proto = LifePod.prototype;
    _proto.resolveDependency = function resolveDependency(dependency) {
        if (dependency instanceof $17158869b2ff324f$export$3fd05f34aa54480b) return dependency.getValue();
    };
    _proto.resolveDependencyMap = function resolveDependencyMap(dependencyMap) {
        if (dependencyMap === void 0) dependencyMap = {};
        var dependencyValueMap = {};
        var resolvedDependencyDeclaration = {
            dependencies: dependencyValueMap,
            getters: this.getters,
            setters: this.setters,
            invalidators: this.invalidators,
            listeners: this.listeners
        };
        for(var k in dependencyMap){
            var dep = dependencyMap[k];
            var depValue = this.resolveDependency(dep);
            if (this.strict && typeof depValue === "undefined") return;
            else dependencyValueMap[k] = depValue;
        }
        return resolvedDependencyDeclaration;
    };
    _proto.handleFactoryPromise = function handleFactoryPromise(factoryPromise) {
        try {
            var _this3 = this;
            var _temp5 = function() {
                if (!!factoryPromise) {
                    var _temp6 = function _temp6() {
                        _this3.resolving = false;
                        _HashMatrix.prototype.setPath.call(_this3, [], _value);
                    };
                    var _value = undefined;
                    var _temp7 = $17158869b2ff324f$var$_catch(function() {
                        return Promise.resolve(factoryPromise).then(function(_factoryPromise) {
                            _value = _factoryPromise;
                        });
                    }, function(error) {
                        _this3.setError([], error);
                    });
                    return _temp7 && _temp7.then ? _temp7.then(_temp6) : _temp6(_temp7);
                }
            }();
            return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function() {}) : void 0);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.resolve = function resolve() {
        var resolvedValue;
        if (!this.resolving) {
            this.resolving = true;
            if (this.factory instanceof Function) {
                var resolvedDependencyDeclaration = this.resolveDependencyMap(this.dependencies);
                if (typeof resolvedDependencyDeclaration !== "undefined") {
                    try {
                        resolvedValue = this.factory($17158869b2ff324f$var$getMergedDependencies(resolvedDependencyDeclaration, this.mergeDeps));
                    } catch (error) {
                        this.setError([], error);
                    }
                    if (resolvedValue instanceof Promise) this.handleFactoryPromise(resolvedValue);
                    else this.resolving = false;
                } else {
                    // No resolved dependencies.
                    resolvedValue = undefined;
                    this.resolving = false;
                }
            } else {
                resolvedValue = _HashMatrix.prototype.getPath.call(this, []);
                this.resolving = false;
            }
        }
        return resolvedValue;
    } /**
   * @override
   * */ ;
    _proto.getPath = function getPath(path) {
        var directValue = _HashMatrix.prototype.getPath.call(this, []);
        var value;
        if (typeof directValue === "undefined" || this.noCache) {
            var resolvedDirectValue = this.resolve();
            if (this.resolving) value = undefined;
            else {
                _HashMatrix.prototype.setPath.call(this, [], resolvedDirectValue);
                value = _HashMatrix.prototype.getPath.call(this, path);
            }
        } else value = _HashMatrix.prototype.getPath.call(this, path);
        return value;
    } /**
   * The same as `getPath` but asynchronous and will wait for a value.
   * */ ;
    _proto.getPathAsync = function getPathAsync(path, timeoutMS) {
        try {
            var _this5 = this;
            var pathString = _this5.getPathString(path);
            return Promise.resolve(new Promise(function(res, rej) {
                var timeoutIdentifier = undefined;
                var handlers = {
                    remove: function remove() {
                        clearTimeout(timeoutIdentifier);
                        _this5.removeChangeHandler(pathString, handlers.onChange);
                        _this5.removeErrorHandler(pathString, handlers.onError);
                    },
                    onChange: function onChange() {
                        try {
                            var _value2 = _this5.getPath(path);
                            if (typeof _value2 !== "undefined") {
                                handlers.remove();
                                res(_value2);
                            }
                        } catch (error) {
                            var _ref2 = error || {}, _ref2$message = _ref2.message, message = _ref2$message === void 0 ? "" : _ref2$message;
                            handlers.onError({
                                message: message,
                                subject: _this5,
                                data: path,
                                error: error
                            });
                        }
                    },
                    onError: function onError(e) {
                        handlers.remove();
                        rej(e);
                    }
                };
                _this5.addChangeHandler(pathString, handlers.onChange);
                _this5.addErrorHandler(pathString, handlers.onError);
                if (typeof timeoutMS === "number") timeoutIdentifier = setTimeout(function() {
                    return handlers.onError(new Error(LifePod.ERROR_MESSAGES.RESOLUTION_TIMEOUT));
                }, timeoutMS);
                handlers.onChange();
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    } /**
   * The same as `getValue` but asynchronous and will wait for a value.
   * */ ;
    _proto.getValueAsync = function getValueAsync(timeoutMS) {
        try {
            var _this7 = this;
            return Promise.resolve(_this7.getPathAsync([], timeoutMS));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    $17158869b2ff324f$var$_createClass(LifePod, [
        {
            key: "dependencies",
            get: function get() {
                return this._dependencies;
            },
            set: function set(value) {
                if (!!this._dependencies) {
                    this.removeDependencyMapChangeHandlers(this._dependencies);
                    this.removeDependencyMapErrorHandlers(this._dependencies);
                }
                this._dependencies = value;
                if (!!this._dependencies) {
                    this.addDependencyMapChangeHandlers(this._dependencies);
                    this.addDependencyMapErrorHandlers(this._dependencies);
                }
            }
        }
    ]);
    return LifePod;
}($17158869b2ff324f$export$3fd05f34aa54480b);
$17158869b2ff324f$export$e5ba30b7633db20b.DEFAULT_NAME = "LifePod";
$17158869b2ff324f$export$e5ba30b7633db20b.ERROR_MESSAGES = {
    RESOLUTION_TIMEOUT: "RESOLUTION_TIMEOUT"
};
var $17158869b2ff324f$var$_STANDARD_DEPENDENCIE;
var $17158869b2ff324f$var$STANDARD_DEPENDENCY_NAMES = {
    GLOBAL: "GLOBAL"
};
var $17158869b2ff324f$var$STANDARD_DEPENDENCIES = ($17158869b2ff324f$var$_STANDARD_DEPENDENCIE = {}, $17158869b2ff324f$var$_STANDARD_DEPENDENCIE[$17158869b2ff324f$var$STANDARD_DEPENDENCY_NAMES.GLOBAL] = {
    factory: function factory() {
        return window || $parcel$global;
    }
}, $17158869b2ff324f$var$_STANDARD_DEPENDENCIE);
/**
 * Manage the lifecycle of application dependencies.
 * Use dependencies as application entry-points and keep track of live changes.
 * */ var $17158869b2ff324f$export$75f12c4a91056955 = /*#__PURE__*/ function(_HashMatrix) {
    $17158869b2ff324f$var$_inheritsLoose(Incarnate, _HashMatrix);
    /**
   * @param {SubMapDeclaration} subMapDeclaration The `SubMapDeclaration` to be managed.
   * */ function Incarnate(subMapDeclaration) {
        var _this;
        if (subMapDeclaration === void 0) subMapDeclaration = {};
        _this = _HashMatrix.call(this, subMapDeclaration) || this;
        _this._parsedSubMap = {};
        /**
     * Get a dependency by path.
     * @param {Array|string} path The path to the dependency.
     * @returns {Incarnate|LifePod|HashMatrix} The dependency.
     * */ _this.getDependency = function(path) {
            var _this$subMap;
            if (path === void 0) path = "";
            var pathArray = _this.getPathArray(path);
            var pathString = _this.getPathString(pathArray);
            if (!pathArray.length) return $17158869b2ff324f$var$_assertThisInitialized(_this);
            var name = pathArray.shift() || "";
            var stringName = "" + name;
            var subPath = [].concat(pathArray);
            if (!_this._parsedSubMap.hasOwnProperty(stringName) && ((_this$subMap = _this.subMap) === null || _this$subMap === void 0 ? void 0 : _this$subMap.hasOwnProperty(stringName))) _this._parsedSubMap[stringName] = _this.convertDeclaration(name, _this.subMap[stringName]);
            var dep = _this._parsedSubMap[stringName];
            if (dep instanceof Incarnate) return dep.getDependency(subPath);
            else if (!!dep) {
                if (subPath.length) {
                    if (dep instanceof $17158869b2ff324f$export$e5ba30b7633db20b) return new $17158869b2ff324f$export$e5ba30b7633db20b({
                        name: pathString,
                        targetPath: subPath,
                        hashMatrix: dep,
                        strict: _this.strict
                    });
                    else return new $17158869b2ff324f$export$3fd05f34aa54480b({
                        name: pathString,
                        targetPath: subPath,
                        hashMatrix: dep
                    });
                } else return dep;
            } else return new $17158869b2ff324f$export$3fd05f34aa54480b({
                name: pathString,
                targetPath: [
                    name
                ].concat(subPath),
                hashMatrix: $17158869b2ff324f$var$_assertThisInitialized(_this)
            });
        };
        _this.createGetter = function(path) {
            return function(subPath) {
                if (subPath === void 0) subPath = [];
                // TRICKY: Get the `dep` "just in time" to avoid recursion.
                var dep = _this.getDependency(path);
                return dep.getPath(subPath);
            };
        };
        _this.createSetter = function(path) {
            return function(value, subPath) {
                if (subPath === void 0) subPath = [];
                // TRICKY: Get the `dep` "just in time" to avoid recursion.
                var dep = _this.getDependency(path);
                return dep.setPath(subPath, value);
            };
        };
        _this.createInvalidator = function(path) {
            return function(subPath) {
                if (subPath === void 0) subPath = [];
                // TRICKY: Get the `dep` "just in time" to avoid recursion.
                var dep = _this.getDependency(path);
                return dep.invalidatePath(subPath);
            };
        };
        _this.createListener = function(path) {
            return function(handler, subPath) {
                if (subPath === void 0) subPath = [];
                // TRICKY: Get the `dep` "just in time" to avoid recursion.
                var dep = _this.getDependency(path);
                return dep.addChangeHandler(subPath, handler);
            };
        };
        if (!(_this.hashMatrix instanceof Object)) _this.hashMatrix = {};
        _this.subMap = $17158869b2ff324f$var$_extends({}, $17158869b2ff324f$var$STANDARD_DEPENDENCIES, _this.subMap);
        return _this;
    }
    var _proto = Incarnate.prototype;
    _proto.createLifePod = function createLifePod(name, dependencyDeclaration) {
        if (dependencyDeclaration === void 0) dependencyDeclaration = {};
        var _dependencyDeclaratio = dependencyDeclaration, _dependencyDeclaratio2 = _dependencyDeclaratio.dependencies, dependencies = _dependencyDeclaratio2 === void 0 ? {} : _dependencyDeclaratio2, _dependencyDeclaratio3 = _dependencyDeclaratio.getters, getters = _dependencyDeclaratio3 === void 0 ? {} : _dependencyDeclaratio3, _dependencyDeclaratio4 = _dependencyDeclaratio.setters, setters = _dependencyDeclaratio4 === void 0 ? {} : _dependencyDeclaratio4, _dependencyDeclaratio5 = _dependencyDeclaratio.invalidators, invalidators = _dependencyDeclaratio5 === void 0 ? {} : _dependencyDeclaratio5, _dependencyDeclaratio6 = _dependencyDeclaratio.listeners, listeners = _dependencyDeclaratio6 === void 0 ? {} : _dependencyDeclaratio6, _dependencyDeclaratio7 = _dependencyDeclaratio.strict, strict = _dependencyDeclaratio7 === void 0 ? this.strict : _dependencyDeclaratio7, _dependencyDeclaratio8 = _dependencyDeclaratio.pathDelimiter, pathDelimiter = _dependencyDeclaratio8 === void 0 ? this.pathDelimiter : _dependencyDeclaratio8, otherConfig = $17158869b2ff324f$var$_objectWithoutPropertiesLoose(_dependencyDeclaratio, [
            "dependencies",
            "getters",
            "setters",
            "invalidators",
            "listeners",
            "strict",
            "pathDelimiter"
        ]);
        var newDependencyDeclaration = $17158869b2ff324f$var$_extends({}, otherConfig, {
            name: this.getPathString(name, this.name),
            targetPath: name,
            hashMatrix: this,
            dependencies: this.getDependenciesFromMap(dependencies),
            getters: this.createFromMap(getters, this.createGetter),
            setters: this.createFromMap(setters, this.createSetter),
            invalidators: this.createFromMap(invalidators, this.createInvalidator),
            listeners: this.createFromMap(listeners, this.createListener),
            strict: strict,
            pathDelimiter: pathDelimiter
        });
        return new $17158869b2ff324f$export$e5ba30b7633db20b(newDependencyDeclaration);
    };
    _proto.createIncarnate = function createIncarnate(name, subMapDeclaration) {
        var _this2 = this;
        if (subMapDeclaration === void 0) subMapDeclaration = {};
        var _subMapDeclaration = subMapDeclaration, _subMapDeclaration$su = _subMapDeclaration.subMap, subMap = _subMapDeclaration$su === void 0 ? {} : _subMapDeclaration$su, _subMapDeclaration$sh = _subMapDeclaration.shared, shared = _subMapDeclaration$sh === void 0 ? {} : _subMapDeclaration$sh, _subMapDeclaration$st = _subMapDeclaration.strict, strict = _subMapDeclaration$st === void 0 ? this.strict : _subMapDeclaration$st, _subMapDeclaration$pa = _subMapDeclaration.pathDelimiter, pathDelimiter = _subMapDeclaration$pa === void 0 ? this.pathDelimiter : _subMapDeclaration$pa, otherConfig = $17158869b2ff324f$var$_objectWithoutPropertiesLoose(_subMapDeclaration, [
            "subMap",
            "shared",
            "strict",
            "pathDelimiter"
        ]);
        var parsedSharedMap = Object.keys(shared).reduce(function(acc, k) {
            var p = shared[k];
            acc[k] = _this2.getDependency(p);
            return acc;
        }, {});
        var subMapWithShared = $17158869b2ff324f$var$_extends({}, subMap, parsedSharedMap);
        var newSubMapDeclaration = $17158869b2ff324f$var$_extends({}, otherConfig, {
            name: this.getPathString(name, this.name),
            targetPath: name,
            hashMatrix: this,
            subMap: subMapWithShared,
            strict: strict,
            pathDelimiter: pathDelimiter
        });
        for(var k in subMap){
            var depDec = subMap[k];
            if (depDec === true && !shared.hasOwnProperty(k)) throw {
                message: Incarnate.ERRORS.UNSATISFIED_SHARED_DEPENDENCY,
                data: k,
                subject: subMapDeclaration,
                context: this
            };
        }
        return new Incarnate(newSubMapDeclaration);
    };
    _proto.convertDeclaration = function convertDeclaration(name, declaration) {
        if (declaration === void 0) declaration = {};
        if (declaration instanceof $17158869b2ff324f$export$3fd05f34aa54480b) return declaration;
        var _declaration = declaration, subMap = _declaration.subMap;
        if (subMap instanceof Object) return this.createIncarnate(name, declaration);
        else return this.createLifePod(name, declaration);
    };
    _proto.getDependenciesFromMap = function getDependenciesFromMap(dependencyMap) {
        var _this3 = this;
        if (dependencyMap === void 0) dependencyMap = {};
        return Object.keys(dependencyMap).reduce(function(acc, k) {
            var depPath = dependencyMap[k];
            acc[k] = _this3.getDependency(depPath);
            return acc;
        }, {});
    };
    _proto.createFromMap = function createFromMap(map, creator) {
        if (map === void 0) map = {};
        return Object.keys(map).reduce(function(acc, k) {
            var pathOrFunction = map[k];
            if (pathOrFunction instanceof Function) acc[k] = pathOrFunction;
            else acc[k] = creator(pathOrFunction);
            return acc;
        }, {});
    } /**
   * The same as `getPath` but triggers `LifePod` dependency resolution.
   * */ ;
    _proto.getResolvedPath = function getResolvedPath(path) {
        var dep = this.getDependency(path);
        if (dep instanceof $17158869b2ff324f$export$e5ba30b7633db20b) return dep.getValue();
        else return this.getPath(path);
    } /**
   * The same as `getPath` but triggers `LifePod` dependency resolution and waits for a value.
   * */ ;
    _proto.getResolvedPathAsync = function getResolvedPathAsync(path, timeoutMS) {
        try {
            var _this5 = this;
            var dep = _this5.getDependency(path);
            if (dep instanceof $17158869b2ff324f$export$e5ba30b7633db20b) return Promise.resolve(dep.getValueAsync(timeoutMS));
            else return Promise.resolve(_this5.getPath(path));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return Incarnate;
}($17158869b2ff324f$export$3fd05f34aa54480b);
$17158869b2ff324f$export$75f12c4a91056955.DEFAULT_NAME = "Incarnate";
/**
 * The names of the dependencies supplied with a standard instance of `Incarnate`.
 * @type {Object.<string>}
 * */ $17158869b2ff324f$export$75f12c4a91056955.STANDARD_DEPENDENCY_NAMES = $17158869b2ff324f$var$STANDARD_DEPENDENCY_NAMES;
$17158869b2ff324f$export$75f12c4a91056955.ERRORS = {
    UNSATISFIED_SHARED_DEPENDENCY: "UNSATISFIED_SHARED_DEPENDENCY"
};
var $17158869b2ff324f$export$2e2bcd8739ae039 = $17158869b2ff324f$export$75f12c4a91056955;


const $dd039c9abdc1873f$var$LEVELS_HASHMATRIX = new (0, $17158869b2ff324f$export$3fd05f34aa54480b)({
    hashMatrix: $7c9bfd0eccee11f6$exports,
    pathDelimiter: "/"
});
const $dd039c9abdc1873f$export$e592e67346359589 = (url)=>{
    // IMPORTANT: Remove windows backslashes.
    return url.replace(/\\/g, "/").replace(/^\.\//g, "");
};
const $dd039c9abdc1873f$export$1e1e6a04cb26d573 = (baseUrl, url)=>{
    baseUrl = $dd039c9abdc1873f$export$e592e67346359589(baseUrl);
    url = $dd039c9abdc1873f$export$e592e67346359589(url);
    return url.replace(baseUrl, "").replace(/^\//g, "");
};
const $dd039c9abdc1873f$export$c5d2402d2daf99c7 = (url, baseUrl)=>{
    const normalizedUrl = baseUrl ? $dd039c9abdc1873f$export$1e1e6a04cb26d573(baseUrl, url) : $dd039c9abdc1873f$export$e592e67346359589(url);
    const pathWithoutExtension = normalizedUrl.replace(/\.glb$/, "");
    return $dd039c9abdc1873f$var$LEVELS_HASHMATRIX.getPath(pathWithoutExtension);
};
const $dd039c9abdc1873f$export$7a002bf1396da61 = (_mesh, userData, commandContext)=>{
    const { levelContext: { setLevelUrl: setLevelUrl } } = commandContext;
    const { LoadLevel: loadLevel = [] } = userData;
    if (loadLevel && loadLevel.length > 0) {
        const [{ path: levelUrl = "" } = {}] = loadLevel;
        setLevelUrl(levelUrl);
    }
};


const $eb94f9a7e3c6143e$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $acw62.createContext)({
    levelUrl: "",
    setLevelUrl: ()=>{}
});
const $eb94f9a7e3c6143e$export$4840719527ba78ad = ()=>(0, $acw62.useContext)($eb94f9a7e3c6143e$export$650d12d3c2ddb8fc);
const { Consumer: $eb94f9a7e3c6143e$export$1cd1027e08033b75, Provider: $eb94f9a7e3c6143e$export$78491a609ee38270 } = $eb94f9a7e3c6143e$export$650d12d3c2ddb8fc;
const $eb94f9a7e3c6143e$export$fcf2368bd3dde5ab = ({ baseFolderUrl: baseFolderUrl = "", initialLevelUrl: initialLevelUrl = "", children: children })=>{
    const [levelUrl, setLevelUrlInternal] = (0, $acw62.useState)(initialLevelUrl);
    const setLevelUrl = (0, $acw62.useCallback)((levelUrl)=>setLevelUrlInternal((0, $dd039c9abdc1873f$export$c5d2402d2daf99c7)(levelUrl, baseFolderUrl)), [
        setLevelUrlInternal
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            levelUrl: levelUrl,
            setLevelUrl: setLevelUrl
        }), [
        levelUrl,
        setLevelUrl
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb94f9a7e3c6143e$export$78491a609ee38270, {
        value: value,
        children: children
    });
};





var $acw62 = parcelRequire("acw62");


var $d5b33d7c30034067$exports = {};

$parcel$export($d5b33d7c30034067$exports, "REVISION", () => $d5b33d7c30034067$export$3545e07a80636437);
$parcel$export($d5b33d7c30034067$exports, "MOUSE", () => $d5b33d7c30034067$export$7177b3e430c2d7ca);
$parcel$export($d5b33d7c30034067$exports, "TOUCH", () => $d5b33d7c30034067$export$d46bd3ead7cc759b);
$parcel$export($d5b33d7c30034067$exports, "CullFaceNone", () => $d5b33d7c30034067$export$3237e1f2c1ea1f44);
$parcel$export($d5b33d7c30034067$exports, "CullFaceBack", () => $d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
$parcel$export($d5b33d7c30034067$exports, "CullFaceFront", () => $d5b33d7c30034067$export$b8058bcc7037d3f3);
$parcel$export($d5b33d7c30034067$exports, "CullFaceFrontBack", () => $d5b33d7c30034067$export$f24be24dcddeac0d);
$parcel$export($d5b33d7c30034067$exports, "BasicShadowMap", () => $d5b33d7c30034067$export$346307dbae2b7447);
$parcel$export($d5b33d7c30034067$exports, "PCFShadowMap", () => $d5b33d7c30034067$export$5813f879eee7cd88);
$parcel$export($d5b33d7c30034067$exports, "PCFSoftShadowMap", () => $d5b33d7c30034067$export$a47c4b43a1be34f0);
$parcel$export($d5b33d7c30034067$exports, "VSMShadowMap", () => $d5b33d7c30034067$export$896ae1ade6c829c4);
$parcel$export($d5b33d7c30034067$exports, "FrontSide", () => $d5b33d7c30034067$export$2ede184fc2998901);
$parcel$export($d5b33d7c30034067$exports, "BackSide", () => $d5b33d7c30034067$export$d9f0486e75b5ace);
$parcel$export($d5b33d7c30034067$exports, "DoubleSide", () => $d5b33d7c30034067$export$3b296b6f144d5b03);
$parcel$export($d5b33d7c30034067$exports, "TwoPassDoubleSide", () => $d5b33d7c30034067$export$211211c00f97204d);
$parcel$export($d5b33d7c30034067$exports, "NoBlending", () => $d5b33d7c30034067$export$63b8d6b580fc65ba);
$parcel$export($d5b33d7c30034067$exports, "NormalBlending", () => $d5b33d7c30034067$export$5b29a26d96ee6af0);
$parcel$export($d5b33d7c30034067$exports, "AdditiveBlending", () => $d5b33d7c30034067$export$777d8f9551c2216b);
$parcel$export($d5b33d7c30034067$exports, "SubtractiveBlending", () => $d5b33d7c30034067$export$cdfa06f868e2e467);
$parcel$export($d5b33d7c30034067$exports, "MultiplyBlending", () => $d5b33d7c30034067$export$4138e1c684b46a20);
$parcel$export($d5b33d7c30034067$exports, "CustomBlending", () => $d5b33d7c30034067$export$eda4864c68df1fa2);
$parcel$export($d5b33d7c30034067$exports, "AddEquation", () => $d5b33d7c30034067$export$20183a0484ce21a0);
$parcel$export($d5b33d7c30034067$exports, "SubtractEquation", () => $d5b33d7c30034067$export$73e0df5177988548);
$parcel$export($d5b33d7c30034067$exports, "ReverseSubtractEquation", () => $d5b33d7c30034067$export$28e582859cbec660);
$parcel$export($d5b33d7c30034067$exports, "MinEquation", () => $d5b33d7c30034067$export$c8c1508da8d0600c);
$parcel$export($d5b33d7c30034067$exports, "MaxEquation", () => $d5b33d7c30034067$export$99948c02fb51055f);
$parcel$export($d5b33d7c30034067$exports, "ZeroFactor", () => $d5b33d7c30034067$export$2110f05edf778d3d);
$parcel$export($d5b33d7c30034067$exports, "OneFactor", () => $d5b33d7c30034067$export$8805bad65e24940e);
$parcel$export($d5b33d7c30034067$exports, "SrcColorFactor", () => $d5b33d7c30034067$export$7fbe15b28d28cf52);
$parcel$export($d5b33d7c30034067$exports, "OneMinusSrcColorFactor", () => $d5b33d7c30034067$export$947829af9f2c17f6);
$parcel$export($d5b33d7c30034067$exports, "SrcAlphaFactor", () => $d5b33d7c30034067$export$d5773124e86cf28c);
$parcel$export($d5b33d7c30034067$exports, "OneMinusSrcAlphaFactor", () => $d5b33d7c30034067$export$11d468cc7f19e971);
$parcel$export($d5b33d7c30034067$exports, "DstAlphaFactor", () => $d5b33d7c30034067$export$a78aed1ca2a87192);
$parcel$export($d5b33d7c30034067$exports, "OneMinusDstAlphaFactor", () => $d5b33d7c30034067$export$5d0fe17fd8773bac);
$parcel$export($d5b33d7c30034067$exports, "DstColorFactor", () => $d5b33d7c30034067$export$ef5f2dd8ffac5574);
$parcel$export($d5b33d7c30034067$exports, "OneMinusDstColorFactor", () => $d5b33d7c30034067$export$56b85b2686ab16);
$parcel$export($d5b33d7c30034067$exports, "SrcAlphaSaturateFactor", () => $d5b33d7c30034067$export$c05e2a1fc8609506);
$parcel$export($d5b33d7c30034067$exports, "NeverDepth", () => $d5b33d7c30034067$export$69025ce147cee220);
$parcel$export($d5b33d7c30034067$exports, "AlwaysDepth", () => $d5b33d7c30034067$export$7182eb52ea3b3f04);
$parcel$export($d5b33d7c30034067$exports, "LessDepth", () => $d5b33d7c30034067$export$eedccec66ab7ebe);
$parcel$export($d5b33d7c30034067$exports, "LessEqualDepth", () => $d5b33d7c30034067$export$296f78a0b892f81a);
$parcel$export($d5b33d7c30034067$exports, "EqualDepth", () => $d5b33d7c30034067$export$a60d398fc7b7590e);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualDepth", () => $d5b33d7c30034067$export$7d7234c1240a1fc4);
$parcel$export($d5b33d7c30034067$exports, "GreaterDepth", () => $d5b33d7c30034067$export$c5e2c52991f30937);
$parcel$export($d5b33d7c30034067$exports, "NotEqualDepth", () => $d5b33d7c30034067$export$2f843afa843d8916);
$parcel$export($d5b33d7c30034067$exports, "MultiplyOperation", () => $d5b33d7c30034067$export$e50ac29801f1774d);
$parcel$export($d5b33d7c30034067$exports, "MixOperation", () => $d5b33d7c30034067$export$9f9d94f963c85479);
$parcel$export($d5b33d7c30034067$exports, "AddOperation", () => $d5b33d7c30034067$export$e641dc52bc3494aa);
$parcel$export($d5b33d7c30034067$exports, "NoToneMapping", () => $d5b33d7c30034067$export$9fcb6b4294603b2);
$parcel$export($d5b33d7c30034067$exports, "LinearToneMapping", () => $d5b33d7c30034067$export$98f52c2a46c598ca);
$parcel$export($d5b33d7c30034067$exports, "ReinhardToneMapping", () => $d5b33d7c30034067$export$74b25e54b3bcd548);
$parcel$export($d5b33d7c30034067$exports, "CineonToneMapping", () => $d5b33d7c30034067$export$932b3dd283d4a366);
$parcel$export($d5b33d7c30034067$exports, "ACESFilmicToneMapping", () => $d5b33d7c30034067$export$a0d98fe6d7e4af64);
$parcel$export($d5b33d7c30034067$exports, "CustomToneMapping", () => $d5b33d7c30034067$export$2c7b09c1e9abfb5e);
$parcel$export($d5b33d7c30034067$exports, "UVMapping", () => $d5b33d7c30034067$export$1beec6768cbb3d2d);
$parcel$export($d5b33d7c30034067$exports, "CubeReflectionMapping", () => $d5b33d7c30034067$export$8759762a6477f2c4);
$parcel$export($d5b33d7c30034067$exports, "CubeRefractionMapping", () => $d5b33d7c30034067$export$dc59f8aed047f61d);
$parcel$export($d5b33d7c30034067$exports, "EquirectangularReflectionMapping", () => $d5b33d7c30034067$export$d64030b316d3b087);
$parcel$export($d5b33d7c30034067$exports, "EquirectangularRefractionMapping", () => $d5b33d7c30034067$export$ee99d97d46898098);
$parcel$export($d5b33d7c30034067$exports, "CubeUVReflectionMapping", () => $d5b33d7c30034067$export$dbf3e70ff37af79);
$parcel$export($d5b33d7c30034067$exports, "RepeatWrapping", () => $d5b33d7c30034067$export$533346c8e8dac0f5);
$parcel$export($d5b33d7c30034067$exports, "ClampToEdgeWrapping", () => $d5b33d7c30034067$export$9d9334239a5a5e06);
$parcel$export($d5b33d7c30034067$exports, "MirroredRepeatWrapping", () => $d5b33d7c30034067$export$c7e7c00b14f51a4f);
$parcel$export($d5b33d7c30034067$exports, "NearestFilter", () => $d5b33d7c30034067$export$727aa5ec3fe39bf0);
$parcel$export($d5b33d7c30034067$exports, "NearestMipmapNearestFilter", () => $d5b33d7c30034067$export$d129e38cf6feaa8c);
$parcel$export($d5b33d7c30034067$exports, "NearestMipMapNearestFilter", () => $d5b33d7c30034067$export$14a4936464a36496);
$parcel$export($d5b33d7c30034067$exports, "NearestMipmapLinearFilter", () => $d5b33d7c30034067$export$d2327c1afe5bfdf2);
$parcel$export($d5b33d7c30034067$exports, "NearestMipMapLinearFilter", () => $d5b33d7c30034067$export$cbc5b7f5647595d8);
$parcel$export($d5b33d7c30034067$exports, "LinearFilter", () => $d5b33d7c30034067$export$8a72f490b25c56c8);
$parcel$export($d5b33d7c30034067$exports, "LinearMipmapNearestFilter", () => $d5b33d7c30034067$export$19a719f377145a13);
$parcel$export($d5b33d7c30034067$exports, "LinearMipMapNearestFilter", () => $d5b33d7c30034067$export$dbe96bee3fe9dbf0);
$parcel$export($d5b33d7c30034067$exports, "LinearMipmapLinearFilter", () => $d5b33d7c30034067$export$5d8599b6a933fb1b);
$parcel$export($d5b33d7c30034067$exports, "LinearMipMapLinearFilter", () => $d5b33d7c30034067$export$90d80f1e3506775f);
$parcel$export($d5b33d7c30034067$exports, "UnsignedByteType", () => $d5b33d7c30034067$export$2e8ce08d3f6f5e10);
$parcel$export($d5b33d7c30034067$exports, "ByteType", () => $d5b33d7c30034067$export$545fce0311a9796a);
$parcel$export($d5b33d7c30034067$exports, "ShortType", () => $d5b33d7c30034067$export$88572337f312435f);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShortType", () => $d5b33d7c30034067$export$c63dc51868b06a9d);
$parcel$export($d5b33d7c30034067$exports, "IntType", () => $d5b33d7c30034067$export$5c612977753abe2);
$parcel$export($d5b33d7c30034067$exports, "UnsignedIntType", () => $d5b33d7c30034067$export$c3c7fc4518ebba96);
$parcel$export($d5b33d7c30034067$exports, "FloatType", () => $d5b33d7c30034067$export$f6d331659b644596);
$parcel$export($d5b33d7c30034067$exports, "HalfFloatType", () => $d5b33d7c30034067$export$2697304443f382bc);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShort4444Type", () => $d5b33d7c30034067$export$b3969b01faf587f2);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShort5551Type", () => $d5b33d7c30034067$export$18886f8ae33e90de);
$parcel$export($d5b33d7c30034067$exports, "UnsignedInt248Type", () => $d5b33d7c30034067$export$6c8ea339bfab1301);
$parcel$export($d5b33d7c30034067$exports, "AlphaFormat", () => $d5b33d7c30034067$export$988473390501ed4b);
$parcel$export($d5b33d7c30034067$exports, "RGBAFormat", () => $d5b33d7c30034067$export$3f8bb04b555a363c);
$parcel$export($d5b33d7c30034067$exports, "LuminanceFormat", () => $d5b33d7c30034067$export$cc09ccbf6d1ed449);
$parcel$export($d5b33d7c30034067$exports, "LuminanceAlphaFormat", () => $d5b33d7c30034067$export$9053a81c4a69c289);
$parcel$export($d5b33d7c30034067$exports, "DepthFormat", () => $d5b33d7c30034067$export$c1b6b5136be58045);
$parcel$export($d5b33d7c30034067$exports, "DepthStencilFormat", () => $d5b33d7c30034067$export$1e113ac2d0905829);
$parcel$export($d5b33d7c30034067$exports, "RedFormat", () => $d5b33d7c30034067$export$4e041a7967d15c4b);
$parcel$export($d5b33d7c30034067$exports, "RedIntegerFormat", () => $d5b33d7c30034067$export$aa92e870a709d190);
$parcel$export($d5b33d7c30034067$exports, "RGFormat", () => $d5b33d7c30034067$export$6cdf0b461c7ce8a0);
$parcel$export($d5b33d7c30034067$exports, "RGIntegerFormat", () => $d5b33d7c30034067$export$1ba1c45f9f77d4d7);
$parcel$export($d5b33d7c30034067$exports, "RGBAIntegerFormat", () => $d5b33d7c30034067$export$c200e7d26f592f21);
$parcel$export($d5b33d7c30034067$exports, "RGB_S3TC_DXT1_Format", () => $d5b33d7c30034067$export$21d1799c6d552fc0);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT1_Format", () => $d5b33d7c30034067$export$afa304c3e981b668);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT3_Format", () => $d5b33d7c30034067$export$d2a1a68024a3e56c);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT5_Format", () => $d5b33d7c30034067$export$9a79c424327dacf9);
$parcel$export($d5b33d7c30034067$exports, "RGB_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$19ada9bbb1af3573);
$parcel$export($d5b33d7c30034067$exports, "RGB_PVRTC_2BPPV1_Format", () => $d5b33d7c30034067$export$d0f0355bb3d948e4);
$parcel$export($d5b33d7c30034067$exports, "RGBA_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$b82296714358084c);
$parcel$export($d5b33d7c30034067$exports, "RGBA_PVRTC_2BPPV1_Format", () => $d5b33d7c30034067$export$b71692456c47b6c3);
$parcel$export($d5b33d7c30034067$exports, "RGB_ETC1_Format", () => $d5b33d7c30034067$export$6ab91af2d757aee7);
$parcel$export($d5b33d7c30034067$exports, "RGB_ETC2_Format", () => $d5b33d7c30034067$export$7800993ef8106a6a);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ETC2_EAC_Format", () => $d5b33d7c30034067$export$23ed8300a860e7d8);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_4x4_Format", () => $d5b33d7c30034067$export$dc5570b4a2b92d48);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_5x4_Format", () => $d5b33d7c30034067$export$68880cd325f8b2fb);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_5x5_Format", () => $d5b33d7c30034067$export$7d2c0be323373d95);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_6x5_Format", () => $d5b33d7c30034067$export$22b52da301fc3a3e);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_6x6_Format", () => $d5b33d7c30034067$export$c009e2cb4a66485e);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x5_Format", () => $d5b33d7c30034067$export$118fff5afa255b63);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x6_Format", () => $d5b33d7c30034067$export$120713c829ae0667);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x8_Format", () => $d5b33d7c30034067$export$c79eeabbf53313e9);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x5_Format", () => $d5b33d7c30034067$export$443cf6567cdd6424);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x6_Format", () => $d5b33d7c30034067$export$6573984fc9840780);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x8_Format", () => $d5b33d7c30034067$export$e7aee563f30091de);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x10_Format", () => $d5b33d7c30034067$export$2eb8634622ddeab7);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_12x10_Format", () => $d5b33d7c30034067$export$202b1ce7b5d25742);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_12x12_Format", () => $d5b33d7c30034067$export$18ab77abd087e467);
$parcel$export($d5b33d7c30034067$exports, "RGBA_BPTC_Format", () => $d5b33d7c30034067$export$ce40b115e188bc81);
$parcel$export($d5b33d7c30034067$exports, "RED_RGTC1_Format", () => $d5b33d7c30034067$export$b1688df4c4c21670);
$parcel$export($d5b33d7c30034067$exports, "SIGNED_RED_RGTC1_Format", () => $d5b33d7c30034067$export$fc15e5d8261eed58);
$parcel$export($d5b33d7c30034067$exports, "RED_GREEN_RGTC2_Format", () => $d5b33d7c30034067$export$d220f6ade8463a0f);
$parcel$export($d5b33d7c30034067$exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $d5b33d7c30034067$export$768646d09dc1b6ef);
$parcel$export($d5b33d7c30034067$exports, "LoopOnce", () => $d5b33d7c30034067$export$d62fdc9d1b1cccad);
$parcel$export($d5b33d7c30034067$exports, "LoopRepeat", () => $d5b33d7c30034067$export$dfaf4422ce096e29);
$parcel$export($d5b33d7c30034067$exports, "LoopPingPong", () => $d5b33d7c30034067$export$f8f6f2041b78e210);
$parcel$export($d5b33d7c30034067$exports, "InterpolateDiscrete", () => $d5b33d7c30034067$export$995b32462a65e855);
$parcel$export($d5b33d7c30034067$exports, "InterpolateLinear", () => $d5b33d7c30034067$export$30fac1aace31cf4d);
$parcel$export($d5b33d7c30034067$exports, "InterpolateSmooth", () => $d5b33d7c30034067$export$198b11ff4c72bb30);
$parcel$export($d5b33d7c30034067$exports, "ZeroCurvatureEnding", () => $d5b33d7c30034067$export$7f795934b84ab523);
$parcel$export($d5b33d7c30034067$exports, "ZeroSlopeEnding", () => $d5b33d7c30034067$export$24a4ccb5099273b5);
$parcel$export($d5b33d7c30034067$exports, "WrapAroundEnding", () => $d5b33d7c30034067$export$8e8c3ecdcd8e1fee);
$parcel$export($d5b33d7c30034067$exports, "NormalAnimationBlendMode", () => $d5b33d7c30034067$export$bcfbbdcf8de7f8cd);
$parcel$export($d5b33d7c30034067$exports, "AdditiveAnimationBlendMode", () => $d5b33d7c30034067$export$d875e029ef558d3);
$parcel$export($d5b33d7c30034067$exports, "TrianglesDrawMode", () => $d5b33d7c30034067$export$4c28c87c2dc84758);
$parcel$export($d5b33d7c30034067$exports, "TriangleStripDrawMode", () => $d5b33d7c30034067$export$b23a071aa286eb29);
$parcel$export($d5b33d7c30034067$exports, "TriangleFanDrawMode", () => $d5b33d7c30034067$export$f0d8293634f88842);
$parcel$export($d5b33d7c30034067$exports, "LinearEncoding", () => $d5b33d7c30034067$export$7207336e4151a112);
$parcel$export($d5b33d7c30034067$exports, "sRGBEncoding", () => $d5b33d7c30034067$export$f32388edbb32674);
$parcel$export($d5b33d7c30034067$exports, "BasicDepthPacking", () => $d5b33d7c30034067$export$deeb383078690b50);
$parcel$export($d5b33d7c30034067$exports, "RGBADepthPacking", () => $d5b33d7c30034067$export$8f910f4c4f73df11);
$parcel$export($d5b33d7c30034067$exports, "TangentSpaceNormalMap", () => $d5b33d7c30034067$export$2852a58ebdac27b8);
$parcel$export($d5b33d7c30034067$exports, "ObjectSpaceNormalMap", () => $d5b33d7c30034067$export$9990ad26f9db5b2c);
$parcel$export($d5b33d7c30034067$exports, "NoColorSpace", () => $d5b33d7c30034067$export$bfcb490c2dd3db51);
$parcel$export($d5b33d7c30034067$exports, "SRGBColorSpace", () => $d5b33d7c30034067$export$561f394b24edfcaa);
$parcel$export($d5b33d7c30034067$exports, "LinearSRGBColorSpace", () => $d5b33d7c30034067$export$42429b3acfb233a4);
$parcel$export($d5b33d7c30034067$exports, "DisplayP3ColorSpace", () => $d5b33d7c30034067$export$626af19ae879bdf6);
$parcel$export($d5b33d7c30034067$exports, "ZeroStencilOp", () => $d5b33d7c30034067$export$69433f11f42d5527);
$parcel$export($d5b33d7c30034067$exports, "KeepStencilOp", () => $d5b33d7c30034067$export$9f542ae4b5baca34);
$parcel$export($d5b33d7c30034067$exports, "ReplaceStencilOp", () => $d5b33d7c30034067$export$8a4f28336ef203d3);
$parcel$export($d5b33d7c30034067$exports, "IncrementStencilOp", () => $d5b33d7c30034067$export$2928c0231297c036);
$parcel$export($d5b33d7c30034067$exports, "DecrementStencilOp", () => $d5b33d7c30034067$export$c0e9611c8a15f9a8);
$parcel$export($d5b33d7c30034067$exports, "IncrementWrapStencilOp", () => $d5b33d7c30034067$export$9c2c08927385dcc4);
$parcel$export($d5b33d7c30034067$exports, "DecrementWrapStencilOp", () => $d5b33d7c30034067$export$7c74ea00fa1315e6);
$parcel$export($d5b33d7c30034067$exports, "InvertStencilOp", () => $d5b33d7c30034067$export$22e2e5726612443);
$parcel$export($d5b33d7c30034067$exports, "NeverStencilFunc", () => $d5b33d7c30034067$export$1343870698229224);
$parcel$export($d5b33d7c30034067$exports, "LessStencilFunc", () => $d5b33d7c30034067$export$8e1d8ed281997fa6);
$parcel$export($d5b33d7c30034067$exports, "EqualStencilFunc", () => $d5b33d7c30034067$export$55648a1cde8329a7);
$parcel$export($d5b33d7c30034067$exports, "LessEqualStencilFunc", () => $d5b33d7c30034067$export$2dff107857e6aca2);
$parcel$export($d5b33d7c30034067$exports, "GreaterStencilFunc", () => $d5b33d7c30034067$export$6f93765ab2f451a2);
$parcel$export($d5b33d7c30034067$exports, "NotEqualStencilFunc", () => $d5b33d7c30034067$export$6f3fb2d2440f2b76);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualStencilFunc", () => $d5b33d7c30034067$export$4119cf7b4c98fd5a);
$parcel$export($d5b33d7c30034067$exports, "AlwaysStencilFunc", () => $d5b33d7c30034067$export$14cf96713ddd97a8);
$parcel$export($d5b33d7c30034067$exports, "NeverCompare", () => $d5b33d7c30034067$export$d9e2d19a747baaab);
$parcel$export($d5b33d7c30034067$exports, "LessCompare", () => $d5b33d7c30034067$export$36bcf49c713b3eb7);
$parcel$export($d5b33d7c30034067$exports, "EqualCompare", () => $d5b33d7c30034067$export$66f28d946fc6a0d5);
$parcel$export($d5b33d7c30034067$exports, "LessEqualCompare", () => $d5b33d7c30034067$export$64eea11eb407ddf1);
$parcel$export($d5b33d7c30034067$exports, "GreaterCompare", () => $d5b33d7c30034067$export$155af022118f3a38);
$parcel$export($d5b33d7c30034067$exports, "NotEqualCompare", () => $d5b33d7c30034067$export$67ab95dde6bed156);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualCompare", () => $d5b33d7c30034067$export$1cdcb70d53d65f61);
$parcel$export($d5b33d7c30034067$exports, "AlwaysCompare", () => $d5b33d7c30034067$export$187b73a3e352c145);
$parcel$export($d5b33d7c30034067$exports, "StaticDrawUsage", () => $d5b33d7c30034067$export$763e8360f4d7f77d);
$parcel$export($d5b33d7c30034067$exports, "DynamicDrawUsage", () => $d5b33d7c30034067$export$8505d14ac8546ca);
$parcel$export($d5b33d7c30034067$exports, "StreamDrawUsage", () => $d5b33d7c30034067$export$721e63549e51d81e);
$parcel$export($d5b33d7c30034067$exports, "StaticReadUsage", () => $d5b33d7c30034067$export$415731dc4f48e299);
$parcel$export($d5b33d7c30034067$exports, "DynamicReadUsage", () => $d5b33d7c30034067$export$9e809946455f13bc);
$parcel$export($d5b33d7c30034067$exports, "StreamReadUsage", () => $d5b33d7c30034067$export$2ed9499a35b5f832);
$parcel$export($d5b33d7c30034067$exports, "StaticCopyUsage", () => $d5b33d7c30034067$export$32ab2503ea19469a);
$parcel$export($d5b33d7c30034067$exports, "DynamicCopyUsage", () => $d5b33d7c30034067$export$ab4022c2c3f86315);
$parcel$export($d5b33d7c30034067$exports, "StreamCopyUsage", () => $d5b33d7c30034067$export$ba7f1db36a76a970);
$parcel$export($d5b33d7c30034067$exports, "GLSL1", () => $d5b33d7c30034067$export$43600cc67fabd9f);
$parcel$export($d5b33d7c30034067$exports, "GLSL3", () => $d5b33d7c30034067$export$f63012db5506e7dd);
$parcel$export($d5b33d7c30034067$exports, "_SRGBAFormat", () => $d5b33d7c30034067$export$ca1dce8b5e1de74d);
$parcel$export($d5b33d7c30034067$exports, "WebGLCoordinateSystem", () => $d5b33d7c30034067$export$5a0e9190d10875d3);
$parcel$export($d5b33d7c30034067$exports, "WebGPUCoordinateSystem", () => $d5b33d7c30034067$export$cc83beedcb9be9ac);
$parcel$export($d5b33d7c30034067$exports, "EventDispatcher", () => $d5b33d7c30034067$export$ec8b666c5fe2c75a);
$parcel$export($d5b33d7c30034067$exports, "MathUtils", () => $d5b33d7c30034067$export$6a7ef315a0d1ef07);
$parcel$export($d5b33d7c30034067$exports, "Vector2", () => $d5b33d7c30034067$export$c977b3e384af9ae1);
$parcel$export($d5b33d7c30034067$exports, "Matrix3", () => $d5b33d7c30034067$export$8ff26dafa08918);
$parcel$export($d5b33d7c30034067$exports, "ColorManagement", () => $d5b33d7c30034067$export$5e6fd513f44698c);
$parcel$export($d5b33d7c30034067$exports, "ImageUtils", () => $d5b33d7c30034067$export$698882cf06df44aa);
$parcel$export($d5b33d7c30034067$exports, "Source", () => $d5b33d7c30034067$export$1d2df86270c81ecb);
$parcel$export($d5b33d7c30034067$exports, "Texture", () => $d5b33d7c30034067$export$5431306cf43de24a);
$parcel$export($d5b33d7c30034067$exports, "Vector4", () => $d5b33d7c30034067$export$fa7daccca11cdbe3);
$parcel$export($d5b33d7c30034067$exports, "WebGLRenderTarget", () => $d5b33d7c30034067$export$3c052beb2e51e23f);
$parcel$export($d5b33d7c30034067$exports, "DataArrayTexture", () => $d5b33d7c30034067$export$dfac6c8e811406a3);
$parcel$export($d5b33d7c30034067$exports, "WebGLArrayRenderTarget", () => $d5b33d7c30034067$export$c77a02c11ed180c7);
$parcel$export($d5b33d7c30034067$exports, "Data3DTexture", () => $d5b33d7c30034067$export$d7a3086320f856db);
$parcel$export($d5b33d7c30034067$exports, "WebGL3DRenderTarget", () => $d5b33d7c30034067$export$7ee06591009639df);
$parcel$export($d5b33d7c30034067$exports, "WebGLMultipleRenderTargets", () => $d5b33d7c30034067$export$bd934554fb721730);
$parcel$export($d5b33d7c30034067$exports, "Quaternion", () => $d5b33d7c30034067$export$23d6a54f0bbc85a3);
$parcel$export($d5b33d7c30034067$exports, "Vector3", () => $d5b33d7c30034067$export$64b5c384219d3699);
$parcel$export($d5b33d7c30034067$exports, "Box3", () => $d5b33d7c30034067$export$6f7d5a9418ab2aa3);
$parcel$export($d5b33d7c30034067$exports, "Sphere", () => $d5b33d7c30034067$export$805e8b72413ccaba);
$parcel$export($d5b33d7c30034067$exports, "Ray", () => $d5b33d7c30034067$export$a186db52eed6d40e);
$parcel$export($d5b33d7c30034067$exports, "Matrix4", () => $d5b33d7c30034067$export$2ae72fc923e5eb5);
$parcel$export($d5b33d7c30034067$exports, "Euler", () => $d5b33d7c30034067$export$d93cc409a0768c5f);
$parcel$export($d5b33d7c30034067$exports, "Layers", () => $d5b33d7c30034067$export$89312ce47c0ca777);
$parcel$export($d5b33d7c30034067$exports, "Object3D", () => $d5b33d7c30034067$export$e4dd07dff30cc924);
$parcel$export($d5b33d7c30034067$exports, "Triangle", () => $d5b33d7c30034067$export$5a465592bfe74b48);
$parcel$export($d5b33d7c30034067$exports, "Material", () => $d5b33d7c30034067$export$a2d8b23205c25948);
$parcel$export($d5b33d7c30034067$exports, "Color", () => $d5b33d7c30034067$export$892596cec99bc70e);
$parcel$export($d5b33d7c30034067$exports, "MeshBasicMaterial", () => $d5b33d7c30034067$export$55cbcc9b622fe1f5);
$parcel$export($d5b33d7c30034067$exports, "DataUtils", () => $d5b33d7c30034067$export$11ce8b759162cc80);
$parcel$export($d5b33d7c30034067$exports, "BufferAttribute", () => $d5b33d7c30034067$export$8dea267bd6bde117);
$parcel$export($d5b33d7c30034067$exports, "Int8BufferAttribute", () => $d5b33d7c30034067$export$f9ff2d6a20248cbf);
$parcel$export($d5b33d7c30034067$exports, "Uint8BufferAttribute", () => $d5b33d7c30034067$export$cacc90cf35d11cdd);
$parcel$export($d5b33d7c30034067$exports, "Uint8ClampedBufferAttribute", () => $d5b33d7c30034067$export$baaa85a1a812c157);
$parcel$export($d5b33d7c30034067$exports, "Int16BufferAttribute", () => $d5b33d7c30034067$export$2b755a102ccdcefe);
$parcel$export($d5b33d7c30034067$exports, "Uint16BufferAttribute", () => $d5b33d7c30034067$export$640a853f68025f2e);
$parcel$export($d5b33d7c30034067$exports, "Int32BufferAttribute", () => $d5b33d7c30034067$export$46b369aed2968a0a);
$parcel$export($d5b33d7c30034067$exports, "Uint32BufferAttribute", () => $d5b33d7c30034067$export$7eb8c9fa25cd5bd6);
$parcel$export($d5b33d7c30034067$exports, "Float16BufferAttribute", () => $d5b33d7c30034067$export$dbd3698c64958d69);
$parcel$export($d5b33d7c30034067$exports, "Float32BufferAttribute", () => $d5b33d7c30034067$export$cbe7a62641830ebd);
$parcel$export($d5b33d7c30034067$exports, "Float64BufferAttribute", () => $d5b33d7c30034067$export$9e0ade74842adbb8);
$parcel$export($d5b33d7c30034067$exports, "BufferGeometry", () => $d5b33d7c30034067$export$b7be63a67df8959);
$parcel$export($d5b33d7c30034067$exports, "Mesh", () => $d5b33d7c30034067$export$e176487c05830cc5);
$parcel$export($d5b33d7c30034067$exports, "BoxGeometry", () => $d5b33d7c30034067$export$33e43285f7406bd5);
$parcel$export($d5b33d7c30034067$exports, "UniformsUtils", () => $d5b33d7c30034067$export$d8ecdf8615bfea69);
$parcel$export($d5b33d7c30034067$exports, "ShaderMaterial", () => $d5b33d7c30034067$export$83c7d75d550a8b0d);
$parcel$export($d5b33d7c30034067$exports, "Camera", () => $d5b33d7c30034067$export$79f141de891a5fed);
$parcel$export($d5b33d7c30034067$exports, "PerspectiveCamera", () => $d5b33d7c30034067$export$74e4ae24825f68d7);
$parcel$export($d5b33d7c30034067$exports, "CubeCamera", () => $d5b33d7c30034067$export$d0cdd0bd804995de);
$parcel$export($d5b33d7c30034067$exports, "CubeTexture", () => $d5b33d7c30034067$export$ee2e5a18258a4049);
$parcel$export($d5b33d7c30034067$exports, "WebGLCubeRenderTarget", () => $d5b33d7c30034067$export$ac386671d651941e);
$parcel$export($d5b33d7c30034067$exports, "Plane", () => $d5b33d7c30034067$export$7ff5ac152ef991b0);
$parcel$export($d5b33d7c30034067$exports, "Frustum", () => $d5b33d7c30034067$export$35efe6f4c85463d2);
$parcel$export($d5b33d7c30034067$exports, "PlaneGeometry", () => $d5b33d7c30034067$export$967d831af31f69ce);
$parcel$export($d5b33d7c30034067$exports, "ShaderChunk", () => $d5b33d7c30034067$export$955f9f2e84c43c8b);
$parcel$export($d5b33d7c30034067$exports, "UniformsLib", () => $d5b33d7c30034067$export$6643083551874bf5);
$parcel$export($d5b33d7c30034067$exports, "ShaderLib", () => $d5b33d7c30034067$export$bee4a7d47f8f5014);
$parcel$export($d5b33d7c30034067$exports, "OrthographicCamera", () => $d5b33d7c30034067$export$9ebf355ee4ed261b);
$parcel$export($d5b33d7c30034067$exports, "PMREMGenerator", () => $d5b33d7c30034067$export$6add42717753e221);
$parcel$export($d5b33d7c30034067$exports, "MeshDepthMaterial", () => $d5b33d7c30034067$export$2698c22ec13825db);
$parcel$export($d5b33d7c30034067$exports, "MeshDistanceMaterial", () => $d5b33d7c30034067$export$33e187ed002f2a19);
$parcel$export($d5b33d7c30034067$exports, "WebGLUtils", () => $d5b33d7c30034067$export$ddaebcad857649a8);
$parcel$export($d5b33d7c30034067$exports, "ArrayCamera", () => $d5b33d7c30034067$export$56b937d9e5581166);
$parcel$export($d5b33d7c30034067$exports, "Group", () => $d5b33d7c30034067$export$eb2fcfdbd7ba97d4);
$parcel$export($d5b33d7c30034067$exports, "DepthTexture", () => $d5b33d7c30034067$export$fc830aa069cc8c2f);
$parcel$export($d5b33d7c30034067$exports, "WebGLRenderer", () => $d5b33d7c30034067$export$f6cc00ef28d7cf97);
$parcel$export($d5b33d7c30034067$exports, "WebGL1Renderer", () => $d5b33d7c30034067$export$a2f65229194348f9);
$parcel$export($d5b33d7c30034067$exports, "FogExp2", () => $d5b33d7c30034067$export$6f1519f023b8d0f6);
$parcel$export($d5b33d7c30034067$exports, "Fog", () => $d5b33d7c30034067$export$3c890837b09508d4);
$parcel$export($d5b33d7c30034067$exports, "Scene", () => $d5b33d7c30034067$export$38af1803e3442a7f);
$parcel$export($d5b33d7c30034067$exports, "InterleavedBuffer", () => $d5b33d7c30034067$export$3d5cd879f108f53f);
$parcel$export($d5b33d7c30034067$exports, "InterleavedBufferAttribute", () => $d5b33d7c30034067$export$920b6d07334599c7);
$parcel$export($d5b33d7c30034067$exports, "SpriteMaterial", () => $d5b33d7c30034067$export$5ec7dd1c6994bf8e);
$parcel$export($d5b33d7c30034067$exports, "Sprite", () => $d5b33d7c30034067$export$3075603db8e6204c);
$parcel$export($d5b33d7c30034067$exports, "LOD", () => $d5b33d7c30034067$export$112e7237be0c5f30);
$parcel$export($d5b33d7c30034067$exports, "SkinnedMesh", () => $d5b33d7c30034067$export$b303577035157ecf);
$parcel$export($d5b33d7c30034067$exports, "Bone", () => $d5b33d7c30034067$export$b127726e56765aa4);
$parcel$export($d5b33d7c30034067$exports, "DataTexture", () => $d5b33d7c30034067$export$b691f601014eabe1);
$parcel$export($d5b33d7c30034067$exports, "Skeleton", () => $d5b33d7c30034067$export$8f31e4c4a37b8e9c);
$parcel$export($d5b33d7c30034067$exports, "InstancedBufferAttribute", () => $d5b33d7c30034067$export$32ea87a8b54d744a);
$parcel$export($d5b33d7c30034067$exports, "InstancedMesh", () => $d5b33d7c30034067$export$f3c979c331175ad7);
$parcel$export($d5b33d7c30034067$exports, "LineBasicMaterial", () => $d5b33d7c30034067$export$fbaaa33907730a0c);
$parcel$export($d5b33d7c30034067$exports, "Line", () => $d5b33d7c30034067$export$17d680238e50603e);
$parcel$export($d5b33d7c30034067$exports, "LineSegments", () => $d5b33d7c30034067$export$ff1ed10fedfdd604);
$parcel$export($d5b33d7c30034067$exports, "LineLoop", () => $d5b33d7c30034067$export$f85a24d745e4f17d);
$parcel$export($d5b33d7c30034067$exports, "PointsMaterial", () => $d5b33d7c30034067$export$a178c45366ce5d6b);
$parcel$export($d5b33d7c30034067$exports, "Points", () => $d5b33d7c30034067$export$1c787534cb11aa3e);
$parcel$export($d5b33d7c30034067$exports, "VideoTexture", () => $d5b33d7c30034067$export$6e09d1edf8d5a25c);
$parcel$export($d5b33d7c30034067$exports, "FramebufferTexture", () => $d5b33d7c30034067$export$9270d786f73ce6fe);
$parcel$export($d5b33d7c30034067$exports, "CompressedTexture", () => $d5b33d7c30034067$export$3466bac9141a5cc4);
$parcel$export($d5b33d7c30034067$exports, "CompressedArrayTexture", () => $d5b33d7c30034067$export$5fe6b8e34b274fcb);
$parcel$export($d5b33d7c30034067$exports, "CanvasTexture", () => $d5b33d7c30034067$export$f7189e49152d1c13);
$parcel$export($d5b33d7c30034067$exports, "Curve", () => $d5b33d7c30034067$export$b0e83c3ef8d2db1);
$parcel$export($d5b33d7c30034067$exports, "EllipseCurve", () => $d5b33d7c30034067$export$3f87a931616cde04);
$parcel$export($d5b33d7c30034067$exports, "ArcCurve", () => $d5b33d7c30034067$export$b1eedc9aab6300e8);
$parcel$export($d5b33d7c30034067$exports, "CatmullRomCurve3", () => $d5b33d7c30034067$export$b9146b27c24b744c);
$parcel$export($d5b33d7c30034067$exports, "CubicBezierCurve", () => $d5b33d7c30034067$export$e36650d36468bb39);
$parcel$export($d5b33d7c30034067$exports, "CubicBezierCurve3", () => $d5b33d7c30034067$export$13d5f1c9525f246c);
$parcel$export($d5b33d7c30034067$exports, "LineCurve", () => $d5b33d7c30034067$export$ab2e07e76531a47e);
$parcel$export($d5b33d7c30034067$exports, "LineCurve3", () => $d5b33d7c30034067$export$1fdfd9d9cf487600);
$parcel$export($d5b33d7c30034067$exports, "QuadraticBezierCurve", () => $d5b33d7c30034067$export$5938c4ee491a43ad);
$parcel$export($d5b33d7c30034067$exports, "QuadraticBezierCurve3", () => $d5b33d7c30034067$export$bf3f4c7e459f90fc);
$parcel$export($d5b33d7c30034067$exports, "SplineCurve", () => $d5b33d7c30034067$export$d3bdd77da77afc1b);
$parcel$export($d5b33d7c30034067$exports, "CurvePath", () => $d5b33d7c30034067$export$4aaf9b66af1bbf2c);
$parcel$export($d5b33d7c30034067$exports, "Path", () => $d5b33d7c30034067$export$4b2950bdac9b6ee9);
$parcel$export($d5b33d7c30034067$exports, "LatheGeometry", () => $d5b33d7c30034067$export$6d839803fcd1882c);
$parcel$export($d5b33d7c30034067$exports, "CapsuleGeometry", () => $d5b33d7c30034067$export$41680e8551036033);
$parcel$export($d5b33d7c30034067$exports, "CircleGeometry", () => $d5b33d7c30034067$export$d5c0e8d607467193);
$parcel$export($d5b33d7c30034067$exports, "CylinderGeometry", () => $d5b33d7c30034067$export$68f745719dbe5198);
$parcel$export($d5b33d7c30034067$exports, "ConeGeometry", () => $d5b33d7c30034067$export$a7a48974f285c9b3);
$parcel$export($d5b33d7c30034067$exports, "PolyhedronGeometry", () => $d5b33d7c30034067$export$60e57a7d3f20ff65);
$parcel$export($d5b33d7c30034067$exports, "DodecahedronGeometry", () => $d5b33d7c30034067$export$c0babfeb8708fc9c);
$parcel$export($d5b33d7c30034067$exports, "EdgesGeometry", () => $d5b33d7c30034067$export$4730b1542707547f);
$parcel$export($d5b33d7c30034067$exports, "Shape", () => $d5b33d7c30034067$export$6428a7f2611ef1fa);
$parcel$export($d5b33d7c30034067$exports, "ShapeUtils", () => $d5b33d7c30034067$export$96bdf6d9c66d7ba8);
$parcel$export($d5b33d7c30034067$exports, "ExtrudeGeometry", () => $d5b33d7c30034067$export$598697a1efa63ca7);
$parcel$export($d5b33d7c30034067$exports, "IcosahedronGeometry", () => $d5b33d7c30034067$export$9567cc828c9535da);
$parcel$export($d5b33d7c30034067$exports, "OctahedronGeometry", () => $d5b33d7c30034067$export$1954e2b809fe361e);
$parcel$export($d5b33d7c30034067$exports, "RingGeometry", () => $d5b33d7c30034067$export$68cb731f50f614af);
$parcel$export($d5b33d7c30034067$exports, "ShapeGeometry", () => $d5b33d7c30034067$export$57a29a1c803e9065);
$parcel$export($d5b33d7c30034067$exports, "SphereGeometry", () => $d5b33d7c30034067$export$1b417fc3b307a251);
$parcel$export($d5b33d7c30034067$exports, "TetrahedronGeometry", () => $d5b33d7c30034067$export$fb3f7adc68bd6e02);
$parcel$export($d5b33d7c30034067$exports, "TorusGeometry", () => $d5b33d7c30034067$export$a2312a2a1fa56495);
$parcel$export($d5b33d7c30034067$exports, "TorusKnotGeometry", () => $d5b33d7c30034067$export$77e9bfadfb9ab8c8);
$parcel$export($d5b33d7c30034067$exports, "TubeGeometry", () => $d5b33d7c30034067$export$7897d9d48904490c);
$parcel$export($d5b33d7c30034067$exports, "WireframeGeometry", () => $d5b33d7c30034067$export$4b739da06d24892b);
$parcel$export($d5b33d7c30034067$exports, "ShadowMaterial", () => $d5b33d7c30034067$export$e8564da406055a3);
$parcel$export($d5b33d7c30034067$exports, "RawShaderMaterial", () => $d5b33d7c30034067$export$21c421a2e1df9d22);
$parcel$export($d5b33d7c30034067$exports, "MeshStandardMaterial", () => $d5b33d7c30034067$export$f2980790215acccd);
$parcel$export($d5b33d7c30034067$exports, "MeshPhysicalMaterial", () => $d5b33d7c30034067$export$28d04986c4269c9f);
$parcel$export($d5b33d7c30034067$exports, "MeshPhongMaterial", () => $d5b33d7c30034067$export$24c72f71cbaf0678);
$parcel$export($d5b33d7c30034067$exports, "MeshToonMaterial", () => $d5b33d7c30034067$export$df893cf97e765622);
$parcel$export($d5b33d7c30034067$exports, "MeshNormalMaterial", () => $d5b33d7c30034067$export$bfe8c0a091f41ae7);
$parcel$export($d5b33d7c30034067$exports, "MeshLambertMaterial", () => $d5b33d7c30034067$export$5023a9a8114806b8);
$parcel$export($d5b33d7c30034067$exports, "MeshMatcapMaterial", () => $d5b33d7c30034067$export$6f5fef6235ec12ee);
$parcel$export($d5b33d7c30034067$exports, "LineDashedMaterial", () => $d5b33d7c30034067$export$327886a3efaeaebe);
$parcel$export($d5b33d7c30034067$exports, "AnimationUtils", () => $d5b33d7c30034067$export$7ee8caa573e71ad1);
$parcel$export($d5b33d7c30034067$exports, "Interpolant", () => $d5b33d7c30034067$export$b558baee9c0f72d3);
$parcel$export($d5b33d7c30034067$exports, "CubicInterpolant", () => $d5b33d7c30034067$export$3646682e7a3959);
$parcel$export($d5b33d7c30034067$exports, "LinearInterpolant", () => $d5b33d7c30034067$export$a8e6009059f51e1a);
$parcel$export($d5b33d7c30034067$exports, "DiscreteInterpolant", () => $d5b33d7c30034067$export$fb9758ef7ef8d5cc);
$parcel$export($d5b33d7c30034067$exports, "KeyframeTrack", () => $d5b33d7c30034067$export$b0e479f45b7006d6);
$parcel$export($d5b33d7c30034067$exports, "BooleanKeyframeTrack", () => $d5b33d7c30034067$export$d3a344b98cf0b775);
$parcel$export($d5b33d7c30034067$exports, "ColorKeyframeTrack", () => $d5b33d7c30034067$export$83444c5d885347d8);
$parcel$export($d5b33d7c30034067$exports, "NumberKeyframeTrack", () => $d5b33d7c30034067$export$d45f0d1a4d9a9314);
$parcel$export($d5b33d7c30034067$exports, "QuaternionLinearInterpolant", () => $d5b33d7c30034067$export$2db1cfb7923d931e);
$parcel$export($d5b33d7c30034067$exports, "QuaternionKeyframeTrack", () => $d5b33d7c30034067$export$b8043f12b5aafbd7);
$parcel$export($d5b33d7c30034067$exports, "StringKeyframeTrack", () => $d5b33d7c30034067$export$6ce41d4f3a8df9cd);
$parcel$export($d5b33d7c30034067$exports, "VectorKeyframeTrack", () => $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
$parcel$export($d5b33d7c30034067$exports, "AnimationClip", () => $d5b33d7c30034067$export$d942c706bf23829c);
$parcel$export($d5b33d7c30034067$exports, "Cache", () => $d5b33d7c30034067$export$94affb487e701bf2);
$parcel$export($d5b33d7c30034067$exports, "LoadingManager", () => $d5b33d7c30034067$export$99cc795e99919eed);
$parcel$export($d5b33d7c30034067$exports, "DefaultLoadingManager", () => $d5b33d7c30034067$export$b033c3f9a95c6a16);
$parcel$export($d5b33d7c30034067$exports, "Loader", () => $d5b33d7c30034067$export$3b0d6d7590275603);
$parcel$export($d5b33d7c30034067$exports, "FileLoader", () => $d5b33d7c30034067$export$98435a25b5cf7b2b);
$parcel$export($d5b33d7c30034067$exports, "AnimationLoader", () => $d5b33d7c30034067$export$29711c7e14f61db);
$parcel$export($d5b33d7c30034067$exports, "CompressedTextureLoader", () => $d5b33d7c30034067$export$bd73ce947a280350);
$parcel$export($d5b33d7c30034067$exports, "ImageLoader", () => $d5b33d7c30034067$export$8905ce1c7a2464a1);
$parcel$export($d5b33d7c30034067$exports, "CubeTextureLoader", () => $d5b33d7c30034067$export$2ec114afc2cf6308);
$parcel$export($d5b33d7c30034067$exports, "DataTextureLoader", () => $d5b33d7c30034067$export$792d8a18f2c55855);
$parcel$export($d5b33d7c30034067$exports, "TextureLoader", () => $d5b33d7c30034067$export$fd1bfc71f64c538c);
$parcel$export($d5b33d7c30034067$exports, "Light", () => $d5b33d7c30034067$export$6ecadb6ed240d696);
$parcel$export($d5b33d7c30034067$exports, "HemisphereLight", () => $d5b33d7c30034067$export$8d474f55edbb9624);
$parcel$export($d5b33d7c30034067$exports, "SpotLight", () => $d5b33d7c30034067$export$81495cbb73897362);
$parcel$export($d5b33d7c30034067$exports, "PointLight", () => $d5b33d7c30034067$export$4c9c1cb3f0b6f455);
$parcel$export($d5b33d7c30034067$exports, "DirectionalLight", () => $d5b33d7c30034067$export$3fea33cc9972c868);
$parcel$export($d5b33d7c30034067$exports, "AmbientLight", () => $d5b33d7c30034067$export$af279bfef9ec2c96);
$parcel$export($d5b33d7c30034067$exports, "RectAreaLight", () => $d5b33d7c30034067$export$61db2d908bbd2429);
$parcel$export($d5b33d7c30034067$exports, "SphericalHarmonics3", () => $d5b33d7c30034067$export$ba61ce607e1f405a);
$parcel$export($d5b33d7c30034067$exports, "LightProbe", () => $d5b33d7c30034067$export$e7ef036e309b38d2);
$parcel$export($d5b33d7c30034067$exports, "MaterialLoader", () => $d5b33d7c30034067$export$3bd6d323353dcf96);
$parcel$export($d5b33d7c30034067$exports, "LoaderUtils", () => $d5b33d7c30034067$export$b5d2dc08d867e41a);
$parcel$export($d5b33d7c30034067$exports, "InstancedBufferGeometry", () => $d5b33d7c30034067$export$231f009cbe414146);
$parcel$export($d5b33d7c30034067$exports, "BufferGeometryLoader", () => $d5b33d7c30034067$export$dc275bb96327833a);
$parcel$export($d5b33d7c30034067$exports, "ObjectLoader", () => $d5b33d7c30034067$export$40110c8505c5ad19);
$parcel$export($d5b33d7c30034067$exports, "ImageBitmapLoader", () => $d5b33d7c30034067$export$52286b55c4a9b51f);
$parcel$export($d5b33d7c30034067$exports, "AudioContext", () => $d5b33d7c30034067$export$fcbc63750ec2a81f);
$parcel$export($d5b33d7c30034067$exports, "AudioLoader", () => $d5b33d7c30034067$export$d8d5fccfbf47714e);
$parcel$export($d5b33d7c30034067$exports, "HemisphereLightProbe", () => $d5b33d7c30034067$export$2f22dadc8bc42820);
$parcel$export($d5b33d7c30034067$exports, "AmbientLightProbe", () => $d5b33d7c30034067$export$afe310a21c86023d);
$parcel$export($d5b33d7c30034067$exports, "StereoCamera", () => $d5b33d7c30034067$export$bc7f73a1065bee0c);
$parcel$export($d5b33d7c30034067$exports, "Clock", () => $d5b33d7c30034067$export$9735c82c4bae3302);
$parcel$export($d5b33d7c30034067$exports, "AudioListener", () => $d5b33d7c30034067$export$8a1b810c6fde8951);
$parcel$export($d5b33d7c30034067$exports, "Audio", () => $d5b33d7c30034067$export$153755f98d9861de);
$parcel$export($d5b33d7c30034067$exports, "PositionalAudio", () => $d5b33d7c30034067$export$4b3e397ef1832507);
$parcel$export($d5b33d7c30034067$exports, "AudioAnalyser", () => $d5b33d7c30034067$export$d47da1ef3d382827);
$parcel$export($d5b33d7c30034067$exports, "PropertyMixer", () => $d5b33d7c30034067$export$dfe0af1ca1acb78a);
$parcel$export($d5b33d7c30034067$exports, "PropertyBinding", () => $d5b33d7c30034067$export$7bf70fcf9f891893);
$parcel$export($d5b33d7c30034067$exports, "AnimationObjectGroup", () => $d5b33d7c30034067$export$30619c2afd3f34db);
$parcel$export($d5b33d7c30034067$exports, "AnimationAction", () => $d5b33d7c30034067$export$6946940a69e799e);
$parcel$export($d5b33d7c30034067$exports, "AnimationMixer", () => $d5b33d7c30034067$export$fbd77e5aefaa0102);
$parcel$export($d5b33d7c30034067$exports, "Uniform", () => $d5b33d7c30034067$export$2947cebfe91c02f8);
$parcel$export($d5b33d7c30034067$exports, "UniformsGroup", () => $d5b33d7c30034067$export$c412d5ffe1f79209);
$parcel$export($d5b33d7c30034067$exports, "InstancedInterleavedBuffer", () => $d5b33d7c30034067$export$25ec0e1af1389358);
$parcel$export($d5b33d7c30034067$exports, "GLBufferAttribute", () => $d5b33d7c30034067$export$6b7339ae8dbddf73);
$parcel$export($d5b33d7c30034067$exports, "Raycaster", () => $d5b33d7c30034067$export$8b7aaceff00bd2f);
$parcel$export($d5b33d7c30034067$exports, "Spherical", () => $d5b33d7c30034067$export$d712cd887b4a00f7);
$parcel$export($d5b33d7c30034067$exports, "Cylindrical", () => $d5b33d7c30034067$export$287165bb2177f4fd);
$parcel$export($d5b33d7c30034067$exports, "Box2", () => $d5b33d7c30034067$export$60f553fa130f08b0);
$parcel$export($d5b33d7c30034067$exports, "Line3", () => $d5b33d7c30034067$export$e0ba6359f1954fd3);
$parcel$export($d5b33d7c30034067$exports, "SpotLightHelper", () => $d5b33d7c30034067$export$4b14638ffdd81e68);
$parcel$export($d5b33d7c30034067$exports, "SkeletonHelper", () => $d5b33d7c30034067$export$5277df3c9e732259);
$parcel$export($d5b33d7c30034067$exports, "PointLightHelper", () => $d5b33d7c30034067$export$9a9291685b9e4023);
$parcel$export($d5b33d7c30034067$exports, "HemisphereLightHelper", () => $d5b33d7c30034067$export$8dca15f13f4f8172);
$parcel$export($d5b33d7c30034067$exports, "GridHelper", () => $d5b33d7c30034067$export$3875d39926561055);
$parcel$export($d5b33d7c30034067$exports, "PolarGridHelper", () => $d5b33d7c30034067$export$361430a10f533cd3);
$parcel$export($d5b33d7c30034067$exports, "DirectionalLightHelper", () => $d5b33d7c30034067$export$f8e434dc14203e7d);
$parcel$export($d5b33d7c30034067$exports, "CameraHelper", () => $d5b33d7c30034067$export$ed8e93f853cd795);
$parcel$export($d5b33d7c30034067$exports, "BoxHelper", () => $d5b33d7c30034067$export$38a664cc862a6a9d);
$parcel$export($d5b33d7c30034067$exports, "Box3Helper", () => $d5b33d7c30034067$export$ce39f4bb96c9a290);
$parcel$export($d5b33d7c30034067$exports, "PlaneHelper", () => $d5b33d7c30034067$export$a34fe8156c66e5d7);
$parcel$export($d5b33d7c30034067$exports, "ArrowHelper", () => $d5b33d7c30034067$export$a3008e7bd8d2cbe7);
$parcel$export($d5b33d7c30034067$exports, "AxesHelper", () => $d5b33d7c30034067$export$6c8303f35b8578fd);
$parcel$export($d5b33d7c30034067$exports, "ShapePath", () => $d5b33d7c30034067$export$148534a3c727230b);
$parcel$export($d5b33d7c30034067$exports, "BoxBufferGeometry", () => $d5b33d7c30034067$export$ab3456a079aa7d80);
$parcel$export($d5b33d7c30034067$exports, "CapsuleBufferGeometry", () => $d5b33d7c30034067$export$f036d76f832848a);
$parcel$export($d5b33d7c30034067$exports, "CircleBufferGeometry", () => $d5b33d7c30034067$export$3f74fe60decf7462);
$parcel$export($d5b33d7c30034067$exports, "ConeBufferGeometry", () => $d5b33d7c30034067$export$59d971120dc8b6e7);
$parcel$export($d5b33d7c30034067$exports, "CylinderBufferGeometry", () => $d5b33d7c30034067$export$d4345c83207d7c68);
$parcel$export($d5b33d7c30034067$exports, "DodecahedronBufferGeometry", () => $d5b33d7c30034067$export$37cd4e52cce48c4c);
$parcel$export($d5b33d7c30034067$exports, "ExtrudeBufferGeometry", () => $d5b33d7c30034067$export$91836d01b9f75a58);
$parcel$export($d5b33d7c30034067$exports, "IcosahedronBufferGeometry", () => $d5b33d7c30034067$export$731fd4feef063ea2);
$parcel$export($d5b33d7c30034067$exports, "LatheBufferGeometry", () => $d5b33d7c30034067$export$dc3e1273c1dd9240);
$parcel$export($d5b33d7c30034067$exports, "OctahedronBufferGeometry", () => $d5b33d7c30034067$export$8e05fc91596f4752);
$parcel$export($d5b33d7c30034067$exports, "PlaneBufferGeometry", () => $d5b33d7c30034067$export$e789a11a194ca4e0);
$parcel$export($d5b33d7c30034067$exports, "PolyhedronBufferGeometry", () => $d5b33d7c30034067$export$38789b531813345c);
$parcel$export($d5b33d7c30034067$exports, "RingBufferGeometry", () => $d5b33d7c30034067$export$ee8b85b34b7d9cad);
$parcel$export($d5b33d7c30034067$exports, "ShapeBufferGeometry", () => $d5b33d7c30034067$export$233afc324766bed8);
$parcel$export($d5b33d7c30034067$exports, "SphereBufferGeometry", () => $d5b33d7c30034067$export$d5d06a966fec4192);
$parcel$export($d5b33d7c30034067$exports, "TetrahedronBufferGeometry", () => $d5b33d7c30034067$export$369e08f62a796c65);
$parcel$export($d5b33d7c30034067$exports, "TorusBufferGeometry", () => $d5b33d7c30034067$export$19d55f905fa4f2cb);
$parcel$export($d5b33d7c30034067$exports, "TorusKnotBufferGeometry", () => $d5b33d7c30034067$export$2b32466f4274fe5c);
$parcel$export($d5b33d7c30034067$exports, "TubeBufferGeometry", () => $d5b33d7c30034067$export$d97a193ce44e691b);
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = "153";
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$211211c00f97204d = 2; // r149
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$b1688df4c4c21670 = 36283;
const $d5b33d7c30034067$export$fc15e5d8261eed58 = 36284;
const $d5b33d7c30034067$export$d220f6ade8463a0f = 36285;
const $d5b33d7c30034067$export$768646d09dc1b6ef = 36286;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$f32388edbb32674 = 3001;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = "";
const $d5b33d7c30034067$export$561f394b24edfcaa = "srgb";
const $d5b33d7c30034067$export$42429b3acfb233a4 = "srgb-linear";
const $d5b33d7c30034067$export$626af19ae879bdf6 = "display-p3";
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$d9e2d19a747baaab = 512;
const $d5b33d7c30034067$export$36bcf49c713b3eb7 = 513;
const $d5b33d7c30034067$export$66f28d946fc6a0d5 = 514;
const $d5b33d7c30034067$export$64eea11eb407ddf1 = 515;
const $d5b33d7c30034067$export$155af022118f3a38 = 516;
const $d5b33d7c30034067$export$67ab95dde6bed156 = 517;
const $d5b33d7c30034067$export$1cdcb70d53d65f61 = 518;
const $d5b33d7c30034067$export$187b73a3e352c145 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = "100";
const $d5b33d7c30034067$export$f63012db5506e7dd = "300 es";
const $d5b33d7c30034067$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $d5b33d7c30034067$export$5a0e9190d10875d3 = 2000;
const $d5b33d7c30034067$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + "-" + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $d5b33d7c30034067$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $d5b33d7c30034067$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize
};
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d5b33d7c30034067$var$_m3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $d5b33d7c30034067$var$_cache = {};
function $d5b33d7c30034067$var$warnOnce(message) {
    if (message in $d5b33d7c30034067$var$_cache) return;
    $d5b33d7c30034067$var$_cache[message] = true;
    console.warn(message);
}
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $d5b33d7c30034067$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $d5b33d7c30034067$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $d5b33d7c30034067$var$TO_LINEAR = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: (color)=>color,
    [$d5b33d7c30034067$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$d5b33d7c30034067$export$626af19ae879bdf6]: $d5b33d7c30034067$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $d5b33d7c30034067$var$FROM_LINEAR = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: (color)=>color,
    [$d5b33d7c30034067$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$d5b33d7c30034067$export$626af19ae879bdf6]: $d5b33d7c30034067$var$LinearSRGBToDisplayP3
};
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $d5b33d7c30034067$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $d5b33d7c30034067$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $d5b33d7c30034067$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS("canvas");
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $d5b33d7c30034067$var$sourceId = 0;
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$sourceId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $d5b33d7c30034067$var$textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === "string") this.colorSpace = colorSpace1;
        else {
            $d5b33d7c30034067$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
            this.colorSpace = colorSpace1 === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $d5b33d7c30034067$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        return this.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $d5b33d7c30034067$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        this.colorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $d5b33d7c30034067$var$_box$3.copy(object.boundingBox);
            $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($d5b33d7c30034067$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $d5b33d7c30034067$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($d5b33d7c30034067$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$3.copy(geometry.boundingBox);
                    $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($d5b33d7c30034067$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$2.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$4.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$2);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($d5b33d7c30034067$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $d5b33d7c30034067$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($d5b33d7c30034067$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $d5b33d7c30034067$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_v2$3));
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $d5b33d7c30034067$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segCenter).addScaledVector($d5b33d7c30034067$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$9.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$9.dot($d5b33d7c30034067$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$2.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: "added"
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: "removed"
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
        if (parent) {
            $d5b33d7c30034067$var$_m1$1.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$warnedGetUV = false;
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$1.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v0$1);
        const dot01 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$1);
        return $d5b33d7c30034067$var$_v3$1.x >= 0 && $d5b33d7c30034067$var$_v3$1.y >= 0 && $d5b33d7c30034067$var$_v3$1.x + $d5b33d7c30034067$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $d5b33d7c30034067$var$_v3$1.x);
        target.addScaledVector(v2, $d5b33d7c30034067$var$_v3$1.y);
        target.addScaledVector(v3, $d5b33d7c30034067$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$1.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $d5b33d7c30034067$var$materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $d5b33d7c30034067$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        return Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.r * 255, 0, 255)) * 65536 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.g * 255, 0, 255)) * 256 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        target.r = $d5b33d7c30034067$var$_color.r;
        target.g = $d5b33d7c30034067$var$_color.g;
        target.b = $d5b33d7c30034067$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        if (colorSpace1 !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        $d5b33d7c30034067$var$_hslA.h += h;
        $d5b33d7c30034067$var$_hslA.s += s;
        $d5b33d7c30034067$var$_hslA.l += l;
        this.setHSL($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $d5b33d7c30034067$var$_color = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
const $d5b33d7c30034067$export$11ce8b759162cc80 = {
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
};
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $d5b33d7c30034067$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $d5b33d7c30034067$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        this.array[index + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$9e0ade74842adbb8 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$1 = 0;
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$_id$1++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$1.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$7.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge() {
        console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead.");
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$7.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$7.x, $d5b33d7c30034067$var$_vector$7.y, $d5b33d7c30034067$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_sphereHitAt = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_normalA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                else $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub(target), influence);
            }
            target.add($d5b33d7c30034067$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$5.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($d5b33d7c30034067$var$_sphere$5.containsPoint($d5b33d7c30034067$var$_ray$3.origin) === false) {
            if ($d5b33d7c30034067$var$_ray$3.intersectSphere($d5b33d7c30034067$var$_sphere$5, $d5b33d7c30034067$var$_sphereHitAt) === null) return;
            if ($d5b33d7c30034067$var$_ray$3.origin.distanceToSquared($d5b33d7c30034067$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $d5b33d7c30034067$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $d5b33d7c30034067$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $d5b33d7c30034067$var$_vA$1);
    object.getVertexPosition(b, $d5b33d7c30034067$var$_vB$1);
    object.getVertexPosition(c, $d5b33d7c30034067$var$_vC$1);
    const intersection = $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv1, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv1, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $d5b33d7c30034067$var$_normalA.fromBufferAttribute(normal, a);
            $d5b33d7c30034067$var$_normalB.fromBufferAttribute(normal, b);
            $d5b33d7c30034067$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_normalA, $d5b33d7c30034067$var$_normalB, $d5b33d7c30034067$var$_normalC, new $d5b33d7c30034067$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $d5b33d7c30034067$export$33e43285f7406bd5 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $d5b33d7c30034067$export$42429b3acfb233a4;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = -90; // negative fov is not an error
const $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$33e43285f7406bd5(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$4.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$4.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$967d831af31f69ce extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			 return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float R21 = R12;\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $d5b33d7c30034067$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n	diffuseColor *= texture2D( map, vMapUv );\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#ifdef USE_UV\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    encodings_fragment: $d5b33d7c30034067$var$encodings_fragment,
    encodings_pars_fragment: $d5b33d7c30034067$var$encodings_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_fragment: $d5b33d7c30034067$var$lightmap_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    output_fragment: $d5b33d7c30034067$var$output_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const xr = renderer.xr;
        const environmentBlendMode = xr.getEnvironmentBlendMode();
        switch(environmentBlendMode){
            case "opaque":
                forceClear = true;
                break;
            case "additive":
                state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
                forceClear = true;
                break;
            case "alpha-blend":
                state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
                forceClear = true;
                break;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $d5b33d7c30034067$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget);
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            colorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $d5b33d7c30034067$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $d5b33d7c30034067$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $d5b33d7c30034067$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($d5b33d7c30034067$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($d5b33d7c30034067$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $d5b33d7c30034067$var$emptyTexture, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $d5b33d7c30034067$export$42429b3acfb233a4:
            return [
                "Linear",
                "( value )"
            ];
        case $d5b33d7c30034067$export$561f394b24edfcaa:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace1);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $d5b33d7c30034067$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== "";
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    const string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $d5b33d7c30034067$var$generateExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $d5b33d7c30034067$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $d5b33d7c30034067$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $d5b33d7c30034067$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join("\n");
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $d5b33d7c30034067$export$9fcb6b4294603b2,
            useLegacyLights: renderer.useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions, capabilities) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$d5b33d7c30034067$export$2ede184fc2998901]: $d5b33d7c30034067$export$d9f0486e75b5ace,
        [$d5b33d7c30034067$export$d9f0486e75b5ace]: $d5b33d7c30034067$export$2ede184fc2998901,
        [$d5b33d7c30034067$export$3b296b6f144d5b03]: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $d5b33d7c30034067$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$d5b33d7c30034067$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$d5b33d7c30034067$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: gl.ZERO,
        [$d5b33d7c30034067$export$8805bad65e24940e]: gl.ONE,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$d5b33d7c30034067$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $d5b33d7c30034067$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $d5b33d7c30034067$var$isPowerOfTwo(image.width) && $d5b33d7c30034067$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $d5b33d7c30034067$export$727aa5ec3fe39bf0 || f === $d5b33d7c30034067$export$d129e38cf6feaa8c || f === $d5b33d7c30034067$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$d5b33d7c30034067$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$d5b33d7c30034067$export$d9e2d19a747baaab]: _gl.NEVER,
        [$d5b33d7c30034067$export$187b73a3e352c145]: _gl.ALWAYS,
        [$d5b33d7c30034067$export$36bcf49c713b3eb7]: _gl.LESS,
        [$d5b33d7c30034067$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$d5b33d7c30034067$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$d5b33d7c30034067$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$d5b33d7c30034067$export$155af022118f3a38]: _gl.GREATER,
        [$d5b33d7c30034067$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $d5b33d7c30034067$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $d5b33d7c30034067$export$d2327c1afe5bfdf2 && texture.minFilter !== $d5b33d7c30034067$export$5d8599b6a933fb1b) return;
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $d5b33d7c30034067$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $d5b33d7c30034067$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $d5b33d7c30034067$export$c63dc51868b06a9d && texture.type !== $d5b33d7c30034067$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $d5b33d7c30034067$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $d5b33d7c30034067$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $d5b33d7c30034067$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.format === $d5b33d7c30034067$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $d5b33d7c30034067$export$42429b3acfb233a4 && colorSpace1 !== $d5b33d7c30034067$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $d5b33d7c30034067$export$3f8bb04b555a363c) {
                        texture.format = $d5b33d7c30034067$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $d5b33d7c30034067$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51) {
        let extension;
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return gl.BYTE;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return gl.SHORT;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return gl.INT;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return gl.FLOAT;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return gl.ALPHA;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $d5b33d7c30034067$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return gl.RED;
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$7800993ef8106a6a) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $d5b33d7c30034067$export$b1688df4c4c21670 || p === $d5b33d7c30034067$export$fc15e5d8261eed58 || p === $d5b33d7c30034067$export$d220f6ade8463a0f || p === $d5b33d7c30034067$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $d5b33d7c30034067$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: "move"
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $d5b33d7c30034067$export$c1b6b5136be58045;
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        let userCamera = null;
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $d5b33d7c30034067$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true; // @deprecated, r153
        this.enabled = false;
        this.isPresenting = false;
        this.getCamera = function() {}; // @deprecated, r153
        this.setUserCamera = function(value) {
            userCamera = value;
        };
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCameraXR = function(camera) {
            if (session === null) return camera;
            if (userCamera) camera = userCamera;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            if (userCamera) updateUserCamera(cameraXR, parent);
            return cameraXR;
        };
        function updateUserCamera(cameraXR, parent) {
            const camera = userCamera;
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$createCanvasElement() {
    const canvas = $d5b33d7c30034067$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $d5b33d7c30034067$var$createCanvasElement(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        // physical lights
        this.useLegacyLights = true;
        // tone mapping
        this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _vector2 = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            if (_gl instanceof WebGLRenderingContext) console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.");
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions, capabilities);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $d5b33d7c30034067$export$c200e7d26f592f21 || targetFormat === $d5b33d7c30034067$export$1ba1c45f9f77d4d7 || targetFormat === $d5b33d7c30034067$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $d5b33d7c30034067$export$2e8ce08d3f6f5e10 || targetType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || targetType === $d5b33d7c30034067$export$c63dc51868b06a9d || targetType === $d5b33d7c30034067$export$6c8ea339bfab1301 || targetType === $d5b33d7c30034067$export$b3969b01faf587f2 || targetType === $d5b33d7c30034067$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    const __webglFramebuffer = properties.get(_currentRenderTarget).__webglFramebuffer;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, __webglFramebuffer, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, __webglFramebuffer, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this.useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) camera = xr.updateCameraXR(camera); // use XR camera for rendering
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            this.info.render.frame++;
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this.useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        if (object.isSkinnedMesh) // update skeleton only once in a frame
                        {
                            if (object.skeleton.frame !== info.render.frame) {
                                object.skeleton.update();
                                object.skeleton.frame = info.render.frame;
                            }
                        }
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
                samples: isWebGL2 && antialias === true ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($d5b33d7c30034067$var$floorPowerOfTwo(_vector2.x), $d5b33d7c30034067$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            const toneMapping = material.toneMapped ? _this.toneMapping : $d5b33d7c30034067$export$9fcb6b4294603b2;
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $d5b33d7c30034067$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        return this.outputColorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        this.outputColorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$42429b3acfb233a4;
    }
}
class $d5b33d7c30034067$export$a2f65229194348f9 extends $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
}
$d5b33d7c30034067$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
    get autoUpdate() {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        return this.matrixWorldAutoUpdate;
    }
    set autoUpdate(value) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        this.matrixWorldAutoUpdate = value;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute("position", new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute("uv", new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material !== undefined ? material : new $d5b33d7c30034067$export$5ec7dd1c6994bf8e();
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vertex = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $d5b33d7c30034067$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $d5b33d7c30034067$var$_vertex);
            this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $d5b33d7c30034067$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $d5b33d7c30034067$var$_vertex);
            this.boundingSphere.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($d5b33d7c30034067$var$_vector3.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $d5b33d7c30034067$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_box3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_identity = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $d5b33d7c30034067$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_box3.copy(geometry.boundingBox).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingBox.union($d5b33d7c30034067$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingSphere.union($d5b33d7c30034067$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh.material = this.material;
        if ($d5b33d7c30034067$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$2.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_start$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_start$1.distanceTo($d5b33d7c30034067$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vEnd = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interSegment = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interRay = new $d5b33d7c30034067$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute("lineDistance", new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$5fe6b8e34b274fcb extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $d5b33d7c30034067$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$6d839803fcd1882c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$41680e8551036033 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$d5c0e8d607467193 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$68f745719dbe5198 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$a7a48974f285c9b3 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$60e57a7d3f20ff65 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$c0babfeb8708fc9c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    const bridge = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $d5b33d7c30034067$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $d5b33d7c30034067$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $d5b33d7c30034067$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$598697a1efa63ca7 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$9567cc828c9535da extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$1954e2b809fe361e extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$68cb731f50f614af extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$57a29a1c803e9065 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$1b417fc3b307a251 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$fb3f7adc68bd6e02 extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$a2312a2a1fa56495 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$77e9bfadfb9ab8c8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$7897d9d48904490c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$7897d9d48904490c(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$33e43285f7406bd5,
    CapsuleGeometry: $d5b33d7c30034067$export$41680e8551036033,
    CircleGeometry: $d5b33d7c30034067$export$d5c0e8d607467193,
    ConeGeometry: $d5b33d7c30034067$export$a7a48974f285c9b3,
    CylinderGeometry: $d5b33d7c30034067$export$68f745719dbe5198,
    DodecahedronGeometry: $d5b33d7c30034067$export$c0babfeb8708fc9c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$598697a1efa63ca7,
    IcosahedronGeometry: $d5b33d7c30034067$export$9567cc828c9535da,
    LatheGeometry: $d5b33d7c30034067$export$6d839803fcd1882c,
    OctahedronGeometry: $d5b33d7c30034067$export$1954e2b809fe361e,
    PlaneGeometry: $d5b33d7c30034067$export$967d831af31f69ce,
    PolyhedronGeometry: $d5b33d7c30034067$export$60e57a7d3f20ff65,
    RingGeometry: $d5b33d7c30034067$export$68cb731f50f614af,
    ShapeGeometry: $d5b33d7c30034067$export$57a29a1c803e9065,
    SphereGeometry: $d5b33d7c30034067$export$1b417fc3b307a251,
    TetrahedronGeometry: $d5b33d7c30034067$export$fb3f7adc68bd6e02,
    TorusGeometry: $d5b33d7c30034067$export$a2312a2a1fa56495,
    TorusKnotGeometry: $d5b33d7c30034067$export$77e9bfadfb9ab8c8,
    TubeGeometry: $d5b33d7c30034067$export$7897d9d48904490c,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $d5b33d7c30034067$var$arraySlice(array, from, to) {
    if ($d5b33d7c30034067$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $d5b33d7c30034067$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
const $d5b33d7c30034067$export$7ee8caa573e71ad1 = {
    arraySlice: $d5b33d7c30034067$var$arraySlice,
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $d5b33d7c30034067$var$convertArray(track.times, Array),
                "values": $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $d5b33d7c30034067$var$arraySlice(times, from, to);
            this.values = $d5b33d7c30034067$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $d5b33d7c30034067$var$arraySlice(this.times), values = $d5b33d7c30034067$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $d5b33d7c30034067$var$arraySlice(times, 0, writeIndex);
            this.values = $d5b33d7c30034067$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $d5b33d7c30034067$var$arraySlice(this.times, 0);
        const values = $d5b33d7c30034067$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case "color":
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case "quaternion":
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case "string":
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        texture.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($d5b33d7c30034067$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
class $d5b33d7c30034067$export$fcbc63750ec2a81f {
    static getContext() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    }
    static setContext(value) {
        $d5b33d7c30034067$var$_context = value;
    }
}
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
class $d5b33d7c30034067$export$2f22dadc8bc42820 extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(skyColor);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e().set(groundColor);
        const sky = new $d5b33d7c30034067$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $d5b33d7c30034067$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $d5b33d7c30034067$export$afe310a21c86023d extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $d5b33d7c30034067$var$_reservedRe = new RegExp("[" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = "[^" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + "]";
const $d5b33d7c30034067$var$_wordCharOrDot = "[^" + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + "$");
const $d5b33d7c30034067$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($d5b33d7c30034067$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $d5b33d7c30034067$var$id++
        });
        this.name = "";
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $d5b33d7c30034067$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint("c", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint("t", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint("n1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint("n2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint("n3", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint("n4", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint("f1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint("f2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint("f3", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint("f4", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint("u1", pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint("u2", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint("u3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint("cf1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint("cf2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint("cf3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint("cf4", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint("cn1", pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint("cn2", pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint("cn3", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint("cn4", pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute("position", new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $d5b33d7c30034067$export$ab3456a079aa7d80 extends $d5b33d7c30034067$export$33e43285f7406bd5 {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        console.warn("THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.");
        super(width, height, depth, widthSegments, heightSegments, depthSegments);
    }
}
class $d5b33d7c30034067$export$f036d76f832848a extends $d5b33d7c30034067$export$41680e8551036033 {
    constructor(radius, length, capSegments, radialSegments){
        console.warn("THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.");
        super(radius, length, capSegments, radialSegments);
    }
}
class $d5b33d7c30034067$export$3f74fe60decf7462 extends $d5b33d7c30034067$export$d5c0e8d607467193 {
    constructor(radius, segments, thetaStart, thetaLength){
        console.warn("THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.");
        super(radius, segments, thetaStart, thetaLength);
    }
}
class $d5b33d7c30034067$export$59d971120dc8b6e7 extends $d5b33d7c30034067$export$a7a48974f285c9b3 {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.");
        super(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $d5b33d7c30034067$export$d4345c83207d7c68 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.");
        super(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $d5b33d7c30034067$export$37cd4e52cce48c4c extends $d5b33d7c30034067$export$c0babfeb8708fc9c {
    constructor(radius, detail){
        console.warn("THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.");
        super(radius, detail);
    }
}
class $d5b33d7c30034067$export$91836d01b9f75a58 extends $d5b33d7c30034067$export$598697a1efa63ca7 {
    constructor(shapes, options){
        console.warn("THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.");
        super(shapes, options);
    }
}
class $d5b33d7c30034067$export$731fd4feef063ea2 extends $d5b33d7c30034067$export$9567cc828c9535da {
    constructor(radius, detail){
        console.warn("THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.");
        super(radius, detail);
    }
}
class $d5b33d7c30034067$export$dc3e1273c1dd9240 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(points, segments, phiStart, phiLength){
        console.warn("THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.");
        super(points, segments, phiStart, phiLength);
    }
}
class $d5b33d7c30034067$export$8e05fc91596f4752 extends $d5b33d7c30034067$export$1954e2b809fe361e {
    constructor(radius, detail){
        console.warn("THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.");
        super(radius, detail);
    }
}
class $d5b33d7c30034067$export$e789a11a194ca4e0 extends $d5b33d7c30034067$export$967d831af31f69ce {
    constructor(width, height, widthSegments, heightSegments){
        console.warn("THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.");
        super(width, height, widthSegments, heightSegments);
    }
}
class $d5b33d7c30034067$export$38789b531813345c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(vertices, indices, radius, detail){
        console.warn("THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.");
        super(vertices, indices, radius, detail);
    }
}
class $d5b33d7c30034067$export$ee8b85b34b7d9cad extends $d5b33d7c30034067$export$68cb731f50f614af {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        console.warn("THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.");
        super(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
    }
}
class $d5b33d7c30034067$export$233afc324766bed8 extends $d5b33d7c30034067$export$57a29a1c803e9065 {
    constructor(shapes, curveSegments){
        console.warn("THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.");
        super(shapes, curveSegments);
    }
}
class $d5b33d7c30034067$export$d5d06a966fec4192 extends $d5b33d7c30034067$export$1b417fc3b307a251 {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        console.warn("THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.");
        super(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
    }
}
class $d5b33d7c30034067$export$369e08f62a796c65 extends $d5b33d7c30034067$export$fb3f7adc68bd6e02 {
    constructor(radius, detail){
        console.warn("THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.");
        super(radius, detail);
    }
}
class $d5b33d7c30034067$export$19d55f905fa4f2cb extends $d5b33d7c30034067$export$a2312a2a1fa56495 {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        console.warn("THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.");
        super(radius, tube, radialSegments, tubularSegments, arc);
    }
}
class $d5b33d7c30034067$export$2b32466f4274fe5c extends $d5b33d7c30034067$export$77e9bfadfb9ab8c8 {
    constructor(radius, tube, tubularSegments, radialSegments, p, q){
        console.warn("THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.");
        super(radius, tube, tubularSegments, radialSegments, p, q);
    }
}
class $d5b33d7c30034067$export$d97a193ce44e691b extends $d5b33d7c30034067$export$7897d9d48904490c {
    constructor(path, tubularSegments, radius, radialSegments, closed){
        console.warn("THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.");
        super(path, tubularSegments, radius, radialSegments, closed);
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}


const $76ab0928a0395fd1$var$_taskCache = /* @__PURE__ */ new WeakMap();
class $76ab0928a0395fd1$export$45c25de53be259ac extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            const taskConfig = {
                attributeIDs: this.defaultAttributeIDs,
                attributeTypes: this.defaultAttributeTypes,
                useUniqueIDs: false
            };
            this.decodeGeometry(buffer, taskConfig).then(onLoad).catch(onError);
        }, onProgress, onError);
    }
    /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */ decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs
        };
        this.decodeGeometry(buffer, taskConfig).then(callback);
    }
    decodeGeometry(buffer, taskConfig) {
        for(const attribute in taskConfig.attributeTypes){
            const type = taskConfig.attributeTypes[attribute];
            if (type.BYTES_PER_ELEMENT !== void 0) taskConfig.attributeTypes[attribute] = type.name;
        }
        const taskKey = JSON.stringify(taskConfig);
        if ($76ab0928a0395fd1$var$_taskCache.has(buffer)) {
            const cachedTask = $76ab0928a0395fd1$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            });
        }).then((message)=>this._createGeometry(message.geometry));
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        $76ab0928a0395fd1$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
        if (geometryData.index) geometry.setIndex(new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const attribute = geometryData.attributes[i];
            const name = attribute.name;
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            geometry.setAttribute(name, new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize));
        }
        return geometry;
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, void 0, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $76ab0928a0395fd1$var$DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker2 = new Worker(this.workerSourceURL);
                worker2._callbacks = {};
                worker2._taskCosts = {};
                worker2._taskLoad = 0;
                worker2.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker2.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker2._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker2._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker2);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        return this;
    }
}
function $76ab0928a0395fd1$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig);
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    const decoderBuffer = new draco.DecoderBuffer();
                    decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
                    try {
                        const geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoderBuffer);
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            geometry.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
        }
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array: array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}



const $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343 = (obj, key)=>obj[key];


const $a986598ce43127c1$export$728c051ccdf8a702 = (geometries, useGroups)=>{
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
    let offset = 0;
    geometries.forEach((geom, i)=>{
        let attributesCount = 0;
        if (isIndexed !== (geom.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        for(let name in geom.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === void 0) attributes[name] = [];
            attributes[name].push(geom.attributes[name]);
            attributesCount++;
        }
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        if (morphTargetsRelative !== geom.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(let name in geom.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === void 0) morphAttributes[name] = [];
            morphAttributes[name].push(geom.morphAttributes[name]);
        }
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geom.userData);
        if (useGroups) {
            let count;
            if (geom.index) count = geom.index.count;
            else if (geom.attributes.position !== void 0) count = geom.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    });
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        geometries.forEach((geom)=>{
            const index = geom.index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geom.attributes.position.count;
        });
        mergedGeometry.setIndex(mergedIndex);
    }
    for(let name in attributes){
        const mergedAttribute = $a986598ce43127c1$export$c4eef4c1c9d34ea9(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    for(let name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $a986598ce43127c1$export$c4eef4c1c9d34ea9(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
};
const $a986598ce43127c1$export$c4eef4c1c9d34ea9 = (attributes)=>{
    let TypedArray = void 0;
    let itemSize = void 0;
    let normalized = void 0;
    let arrayLength = 0;
    attributes.forEach((attr)=>{
        if (TypedArray === void 0) TypedArray = attr.array.constructor;
        if (TypedArray !== attr.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === void 0) itemSize = attr.itemSize;
        if (itemSize !== attr.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === void 0) normalized = attr.normalized;
        if (normalized !== attr.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attr.array.length;
    });
    if (TypedArray && itemSize) {
        const array = new TypedArray(arrayLength);
        let offset = 0;
        attributes.forEach((attr)=>{
            array.set(attr.array, offset);
            offset += attr.array.length;
        });
        return new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    }
};
const $a986598ce43127c1$export$308f9509e428a845 = (attributes)=>{
    let TypedArray = void 0;
    let arrayLength = 0;
    let stride = 0;
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === void 0) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    const interleavedBuffer = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++){
            const set = (0, $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343)(iba, setters[k]);
            const get = (0, $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343)(attribute, getters[k]);
            set(c, get(c));
        }
    }
    return res;
};
function $a986598ce43127c1$export$35bee7999e19754d(geometry) {
    let mem = 0;
    for(let name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
function $a986598ce43127c1$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    let nextIndex = 0;
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(()=>[]);
    }
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    result.setIndex(newIndices);
    return result;
}
function $a986598ce43127c1$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $d5b33d7c30034067$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842) || drawMode === (0, $d5b33d7c30034067$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== void 0) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (index) {
            if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842)) for(let i = 1; i <= numberOfTriangles; i++){
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
            }
            else {
                for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                    newIndices.push(index.getX(i));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i + 2));
                } else {
                    newIndices.push(index.getX(i + 2));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i));
                }
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
function $a986598ce43127c1$export$29e54e2e4ab904e7(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error("THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.");
        return null;
    }
    const _vA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object2, material2, attribute, morphAttribute, morphTargetsRelative2, a2, b2, c2, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a2);
        _vB.fromBufferAttribute(attribute, b2);
        _vC.fromBufferAttribute(attribute, c2);
        const morphInfluences = object2.morphTargetInfluences;
        if (// @ts-ignore
        material2.morphTargets && morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i2 = 0, il2 = morphAttribute.length; i2 < il2; i2++){
                const influence = morphInfluences[i2];
                const morph = morphAttribute[i2];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a2);
                _tempB.fromBufferAttribute(morph, b2);
                _tempC.fromBufferAttribute(morph, c2);
                if (morphTargetsRelative2) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object2.isSkinnedMesh) {
            object2.boneTransform(a2, _vA);
            object2.boneTransform(b2, _vB);
            object2.boneTransform(c2, _vC);
        }
        modifiedAttributeArray[a2 * 3 + 0] = _vA.x;
        modifiedAttributeArray[a2 * 3 + 1] = _vA.y;
        modifiedAttributeArray[a2 * 3 + 2] = _vA.z;
        modifiedAttributeArray[b2 * 3 + 0] = _vB.x;
        modifiedAttributeArray[b2 * 3 + 1] = _vB.y;
        modifiedAttributeArray[b2 * 3 + 2] = _vB.z;
        modifiedAttributeArray[c2 * 3 + 0] = _vC.x;
        modifiedAttributeArray[c2 * 3 + 1] = _vC.y;
        modifiedAttributeArray[c2 * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group, groupMaterial;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else if (positionAttribute !== void 0) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $a986598ce43127c1$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 100;
    const verts = [
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempVec2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        const normal = new (0, $d5b33d7c30034067$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}


class $d85c731da4846b4e$export$aa93f11e7884f0f4 extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") resourcePath = this.path;
        else resourcePath = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).extractUrlBase(url);
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).decodeText(new Uint8Array(data.slice(0, 4)));
            if (magic === $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF] = new $d85c731da4846b4e$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).decodeText(new Uint8Array(data)));
        } else json = data;
        if (json.asset === void 0 || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $d85c731da4846b4e$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFMaterialsUnlitExtension();
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFTextureTransformExtension();
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
function $d85c731da4846b4e$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
const $d85c731da4846b4e$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class $d85c731da4846b4e$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(16777215);
        if (lightDef.color !== void 0) color.fromArray(lightDef.color);
        const range = lightDef.range !== void 0 ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $d5b33d7c30034067$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $d5b33d7c30034067$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $d5b33d7c30034067$export$81495cbb73897362)(color);
                lightNode.distance = range;
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $d85c731da4846b4e$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== void 0) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self2 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === void 0) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self2.cache, lightIndex, light);
        });
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1, 1, 1);
        materialParams.opacity = 1;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, 3001));
        }
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== void 0) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== void 0) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== void 0) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== void 0) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== void 0) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== void 0) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== void 0) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === void 0) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== void 0) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== void 0) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== void 0) materialParams.sheenColor.fromArray(extension.sheenColorFactor);
        if (extension.sheenRoughnessFactor !== void 0) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, 3001));
        if (extension.sheenRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== void 0) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== void 0) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
        if (extension.specularTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        if (extension.specularColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, 3001));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== void 0) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== void 0) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== void 0) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
class $d85c731da4846b4e$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class $d85c731da4846b4e$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class $d85c731da4846b4e$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
                    return res2.buffer;
                });
                else return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
class $d85c731da4846b4e$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count;
            const instancedMeshes = [];
            for (const mesh of meshes){
                const m = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                const p = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
                const q = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
                const s = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $d5b33d7c30034067$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                for(const attributeName in attributes)if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                (0, $d5b33d7c30034067$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
const $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 1313821514,
    BIN: 5130562
};
class $d85c731da4846b4e$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH);
        this.header = {
            magic: (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).decodeText(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).decodeText(contentArray);
            } else if (chunkType === $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class $d85c731da4846b4e$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== void 0) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== void 0) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
class $d85c731da4846b4e$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === void 0 || transform.texCoord === texture.channel) && transform.offset === void 0 && transform.rotation === void 0 && transform.scale === void 0) return texture;
        texture = texture.clone();
        if (transform.texCoord !== void 0) texture.channel = transform.texCoord;
        if (transform.offset !== void 0) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== void 0) texture.rotation = transform.rotation;
        if (transform.scale !== void 0) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
class $d85c731da4846b4e$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
class $d85c731da4846b4e$var$GLTFCubicSplineInterpolant extends (0, $d5b33d7c30034067$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride];
            const m0 = values[offset0 + i + stride2] * td;
            const p1 = values[offset1 + i + stride];
            const m1 = values[offset1 + i] * td;
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $d85c731da4846b4e$var$_q = /* @__PURE__ */ new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
class $d85c731da4846b4e$var$GLTFCubicSplineQuaternionInterpolant extends $d85c731da4846b4e$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $d85c731da4846b4e$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
const $d85c731da4846b4e$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $d85c731da4846b4e$var$WEBGL_FILTERS = {
    9728: (0, $d5b33d7c30034067$export$727aa5ec3fe39bf0),
    9729: (0, $d5b33d7c30034067$export$8a72f490b25c56c8),
    9984: (0, $d5b33d7c30034067$export$d129e38cf6feaa8c),
    9985: (0, $d5b33d7c30034067$export$19a719f377145a13),
    9986: (0, $d5b33d7c30034067$export$d2327c1afe5bfdf2),
    9987: (0, $d5b33d7c30034067$export$5d8599b6a933fb1b)
};
const $d85c731da4846b4e$var$WEBGL_WRAPPINGS = {
    33071: (0, $d5b33d7c30034067$export$9d9334239a5a5e06),
    33648: (0, $d5b33d7c30034067$export$c7e7c00b14f51a4f),
    10497: (0, $d5b33d7c30034067$export$533346c8e8dac0f5)
};
const $d85c731da4846b4e$var$WEBGL_TYPE_SIZES = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};
const $d85c731da4846b4e$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    // uv => uv1, 4 uv channels
    // https://github.com/mrdoob/three.js/pull/25943
    // https://github.com/mrdoob/three.js/pull/25788
    ...(0, $d5b33d7c30034067$export$3545e07a80636437).replace(/\D+/g, "") >= 152 ? {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv1",
        TEXCOORD_2: "uv2",
        TEXCOORD_3: "uv3"
    } : {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv2"
    },
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $d85c731da4846b4e$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $d85c731da4846b4e$var$INTERPOLATION = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $d5b33d7c30034067$export$30fac1aace31cf4d),
    STEP: (0, $d5b33d7c30034067$export$995b32462a65e855)
};
const $d85c731da4846b4e$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
function $d85c731da4846b4e$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === void 0) cache["DefaultMaterial"] = new (0, $d5b33d7c30034067$export$f2980790215acccd)({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $d5b33d7c30034067$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $d85c731da4846b4e$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    for(const name in objectDef.extensions)if (knownExtensions[name] === void 0) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
function $d85c731da4846b4e$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== void 0) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
function $d85c731da4846b4e$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== void 0) hasMorphPosition = true;
        if (target.NORMAL !== void 0) hasMorphNormal = true;
        if (target.COLOR_0 !== void 0) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
function $d85c731da4846b4e$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== void 0) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $d85c731da4846b4e$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $d85c731da4846b4e$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $d85c731da4846b4e$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== void 0) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $d85c731da4846b4e$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $d85c731da4846b4e$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $d85c731da4846b4e$var$getNormalizedComponentScale(constructor) {
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $d85c731da4846b4e$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $d85c731da4846b4e$var$_identityMatrix = /* @__PURE__ */ new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
class $d85c731da4846b4e$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        this.cache = new $d85c731da4846b4e$var$GLTFRegistry();
        this.associations = /* @__PURE__ */ new Map();
        this.primitiveCache = {};
        this.nodeCache = {};
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        this.nodeNamesUsed = {};
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $d5b33d7c30034067$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $d5b33d7c30034067$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        this.cache.removeAll();
        this.nodeCache = {};
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, result, json);
            $d85c731da4846b4e$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
   * Marks the special nodes/meshes in json for efficient parse.
   */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== void 0) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                if (nodeDef.skin !== void 0) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== void 0) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */ _addNodeRef(cache, index) {
        if (index === void 0) return;
        if (cache.refs[index] === void 0) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        if (bufferDef.uri === void 0 && bufferIndex === 0) return Promise.resolve(this.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
            const itemSize = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== void 0) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== void 0) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            if (byteStride && byteStride !== itemBytes) {
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    ib = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            if (accessorDef.sparse !== void 0) {
                const itemSizeIndices = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $d85c731da4846b4e$var$WEBGL_FILTERS[sampler.magFilter] || (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
            texture.minFilter = $d85c731da4846b4e$var$WEBGL_FILTERS[sampler.minFilter] || (0, $d5b33d7c30034067$export$5d8599b6a933fb1b);
            texture.wrapS = $d85c731da4846b4e$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            texture.wrapT = $d85c731da4846b4e$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== void 0) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== void 0) sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === void 0) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $d5b33d7c30034067$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
            });
        }).then(function(texture) {
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $d85c731da4846b4e$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */ assignTexture(materialParams, mapName, mapDef, encoding) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== void 0 ? mapDef.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (encoding !== void 0) {
                if ("colorSpace" in texture) texture.colorSpace = encoding === 3001 ? "srgb" : "srgb-linear";
                else texture.encoding = encoding;
            }
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === void 0;
        const useVertexColors = geometry.attributes.color !== void 0;
        const useFlatShading = geometry.attributes.normal === void 0;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $d5b33d7c30034067$export$a178c45366ce5d6b)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false;
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $d5b33d7c30034067$export$fbaaa33907730a0c)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$f2980790215acccd;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1, 1, 1);
            materialParams.opacity = 1;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, 3001));
            materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
            materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
            if (metallicRoughness.metallicRoughnessTexture !== void 0) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $d5b33d7c30034067$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $d85c731da4846b4e$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $d85c731da4846b4e$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $d85c731da4846b4e$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== void 0) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== void 0) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().fromArray(materialDef.emissiveFactor);
        if (materialDef.emissiveTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, 3001));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $d85c731da4846b4e$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $d5b33d7c30034067$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $d85c731da4846b4e$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $d85c731da4846b4e$var$createPrimitiveKey(primitive);
            const cached = cache[cacheKey];
            if (cached) pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) geometryPromise = createDracoPrimitive(primitive);
                else geometryPromise = $d85c731da4846b4e$var$addPrimitiveAttributes(new (0, $d5b33d7c30034067$export$b7be63a67df8959)(), primitive, parser);
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === void 0 ? $d85c731da4846b4e$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                let mesh;
                const material = materials[i];
                if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $d5b33d7c30034067$export$b303577035157ecf)(geometry, material) : new (0, $d5b33d7c30034067$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) mesh.normalizeSkinWeights();
                    if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $a986598ce43127c1$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$b23a071aa286eb29));
                    else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $a986598ce43127c1$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$f0d8293634f88842));
                } else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $d5b33d7c30034067$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $d5b33d7c30034067$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $d5b33d7c30034067$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $d5b33d7c30034067$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $d85c731da4846b4e$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $d85c731da4846b4e$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $d5b33d7c30034067$export$74e4ae24825f68d7)((0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $d5b33d7c30034067$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $d85c731da4846b4e$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== void 0) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $d5b33d7c30034067$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */ loadAnimation(animationIndex) {
        const json = this.json;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === void 0) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === void 0) continue;
                node.updateMatrix();
                let TypedKeyframeTrack;
                switch($d85c731da4846b4e$var$PATH_PROPERTIES[target.path]){
                    case $d85c731da4846b4e$var$PATH_PROPERTIES.weights:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$d45f0d1a4d9a9314);
                        break;
                    case $d85c731da4846b4e$var$PATH_PROPERTIES.rotation:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$b8043f12b5aafbd7);
                        break;
                    case $d85c731da4846b4e$var$PATH_PROPERTIES.position:
                    case $d85c731da4846b4e$var$PATH_PROPERTIES.scale:
                    default:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
                        break;
                }
                const targetName = node.name ? node.name : node.uuid;
                const interpolation = sampler.interpolation !== void 0 ? $d85c731da4846b4e$var$INTERPOLATION[sampler.interpolation] : (0, $d5b33d7c30034067$export$30fac1aace31cf4d);
                const targetNames = [];
                if ($d85c731da4846b4e$var$PATH_PROPERTIES[target.path] === $d85c731da4846b4e$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
                    if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
                });
                else targetNames.push(targetName);
                let outputArray = outputAccessor.array;
                if (outputAccessor.normalized) {
                    const scale = $d85c731da4846b4e$var$getNormalizedComponentScale(outputArray.constructor);
                    const scaled = new Float32Array(outputArray.length);
                    for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
                    outputArray = scaled;
                }
                for(let j = 0, jl = targetNames.length; j < jl; j++){
                    const track = new TypedKeyframeTrack(targetNames[j] + "." + $d85c731da4846b4e$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
                    if (sampler.interpolation === "CUBICSPLINE") {
                        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
                            const interpolantType = this instanceof (0, $d5b33d7c30034067$export$b8043f12b5aafbd7) ? $d85c731da4846b4e$var$GLTFCubicSplineQuaternionInterpolant : $d85c731da4846b4e$var$GLTFCubicSplineInterpolant;
                            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
                        };
                        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
                    }
                    tracks.push(track);
                }
            }
            return new (0, $d5b33d7c30034067$export$d942c706bf23829c)(animationName, void 0, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === void 0) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            if (nodeDef.weights !== void 0) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $d85c731da4846b4e$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        if (this.nodeCache[nodeIndex] !== void 0) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== void 0) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            if (nodeDef.isBone === true) node = new (0, $d5b33d7c30034067$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $d5b33d7c30034067$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $d85c731da4846b4e$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== void 0) {
                const matrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== void 0) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== void 0) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== void 0) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        const scene = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $d85c731da4846b4e$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            const reduceAssociations = (node)=>{
                const reducedAssociations = /* @__PURE__ */ new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $d5b33d7c30034067$export$a2d8b23205c25948) || key instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node2)=>{
                    const mappings = parser.associations.get(node2);
                    if (mappings != null) reducedAssociations.set(node2, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
}
function $d85c731da4846b4e$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== void 0) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        if (min !== void 0 && max !== void 0) {
            box.set(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $d5b33d7c30034067$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $d85c731da4846b4e$var$getNormalizedComponentScale($d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== void 0) {
        const maxDisplacement = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        const vector = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== void 0) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                if (min !== void 0 && max !== void 0) {
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $d85c731da4846b4e$var$getNormalizedComponentScale($d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $d5b33d7c30034067$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
function $d85c731da4846b4e$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== void 0 && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
            geometry.setIndex(accessor2);
        });
        pending.push(accessor);
    }
    $d85c731da4846b4e$var$assignExtrasToUserData(geometry, primitiveDef);
    $d85c731da4846b4e$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== void 0 ? $d85c731da4846b4e$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}

let $3bf52461e9095b24$var$generated;
const $3bf52461e9095b24$export$1111800106ba519a = ()=>{
    if ($3bf52461e9095b24$var$generated) return $3bf52461e9095b24$var$generated;
    const wasm_base = "B9h9z9tFBBBF8fL9gBB9gLaaaaaFa9gEaaaB9gFaFa9gEaaaFaEMcBFFFGGGEIIILF9wFFFLEFBFKNFaFCx/IFMO/LFVK9tv9t9vq95GBt9f9f939h9z9t9f9j9h9s9s9f9jW9vq9zBBp9tv9z9o9v9wW9f9kv9j9v9kv9WvqWv94h919m9mvqBF8Z9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv94h919m9mvqBGy9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv949TvZ91v9u9jvBEn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9P9jWBIi9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9R919hWBLn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9F949wBKI9z9iqlBOc+x8ycGBM/qQFTa8jUUUUBCU/EBlHL8kUUUUBC9+RKGXAGCFJAI9LQBCaRKAE2BBC+gF9HQBALAEAIJHOAGlAGTkUUUBRNCUoBAG9uC/wgBZHKCUGAKCUG9JyRVAECFJRICBRcGXEXAcAF9PQFAVAFAclAcAVJAF9JyRMGXGXAG9FQBAMCbJHKC9wZRSAKCIrCEJCGrRQANCUGJRfCBRbAIRTEXGXAOATlAQ9PQBCBRISEMATAQJRIGXAS9FQBCBRtCBREEXGXAOAIlCi9PQBCBRISLMANCU/CBJAEJRKGXGXGXGXGXATAECKrJ2BBAtCKZrCEZfIBFGEBMAKhB83EBAKCNJhB83EBSEMAKAI2BIAI2BBHmCKrHYAYCE6HYy86BBAKCFJAICIJAYJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCGJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCEJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCIJAYAmJHY2BBAI2BFHmCKrHPAPCE6HPy86BBAKCLJAYAPJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCKJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCOJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCNJAYAmJHY2BBAI2BGHmCKrHPAPCE6HPy86BBAKCVJAYAPJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCcJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCMJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCSJAYAmJHm2BBAI2BEHICKrHYAYCE6HYy86BBAKCQJAmAYJHm2BBAICIrCEZHYAYCE6HYy86BBAKCfJAmAYJHm2BBAICGrCEZHYAYCE6HYy86BBAKCbJAmAYJHK2BBAICEZHIAICE6HIy86BBAKAIJRISGMAKAI2BNAI2BBHmCIrHYAYCb6HYy86BBAKCFJAICNJAYJHY2BBAmCbZHmAmCb6Hmy86BBAKCGJAYAmJHm2BBAI2BFHYCIrHPAPCb6HPy86BBAKCEJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCIJAmAYJHm2BBAI2BGHYCIrHPAPCb6HPy86BBAKCLJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCKJAmAYJHm2BBAI2BEHYCIrHPAPCb6HPy86BBAKCOJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCNJAmAYJHm2BBAI2BIHYCIrHPAPCb6HPy86BBAKCVJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCcJAmAYJHm2BBAI2BLHYCIrHPAPCb6HPy86BBAKCMJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCSJAmAYJHm2BBAI2BKHYCIrHPAPCb6HPy86BBAKCQJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCfJAmAYJHm2BBAI2BOHICIrHYAYCb6HYy86BBAKCbJAmAYJHK2BBAICbZHIAICb6HIy86BBAKAIJRISFMAKAI8pBB83BBAKCNJAICNJ8pBB83BBAICTJRIMAtCGJRtAECTJHEAS9JQBMMGXAIQBCBRISEMGXAM9FQBANAbJ2BBRtCBRKAfREEXAEANCU/CBJAKJ2BBHTCFrCBATCFZl9zAtJHt86BBAEAGJREAKCFJHKAM9HQBMMAfCFJRfAIRTAbCFJHbAG9HQBMMABAcAG9sJANCUGJAMAG9sTkUUUBpANANCUGJAMCaJAG9sJAGTkUUUBpMAMCBAIyAcJRcAIQBMC9+RKSFMCBC99AOAIlAGCAAGCA9Ly6yRKMALCU/EBJ8kUUUUBAKM+OmFTa8jUUUUBCoFlHL8kUUUUBC9+RKGXAFCE9uHOCtJAI9LQBCaRKAE2BBHNC/wFZC/gF9HQBANCbZHVCF9LQBALCoBJCgFCUFT+JUUUBpALC84Jha83EBALC8wJha83EBALC8oJha83EBALCAJha83EBALCiJha83EBALCTJha83EBALha83ENALha83EBAEAIJC9wJRcAECFJHNAOJRMGXAF9FQBCQCbAVCF6yRSABRECBRVCBRQCBRfCBRICBRKEXGXAMAcuQBC9+RKSEMGXGXAN2BBHOC/vF9LQBALCoBJAOCIrCa9zAKJCbZCEWJHb8oGIRTAb8oGBRtGXAOCbZHbAS9PQBALAOCa9zAIJCbZCGWJ8oGBAVAbyROAb9FRbGXGXAGCG9HQBABAt87FBABCIJAO87FBABCGJAT87FBSFMAEAtjGBAECNJAOjGBAECIJATjGBMAVAbJRVALCoBJAKCEWJHmAOjGBAmATjGIALAICGWJAOjGBALCoBJAKCFJCbZHKCEWJHTAtjGBATAOjGIAIAbJRIAKCFJRKSGMGXGXAbCb6QBAQAbJAbC989zJCFJRQSFMAM1BBHbCgFZROGXGXAbCa9MQBAMCFJRMSFMAM1BFHbCgBZCOWAOCgBZqROGXAbCa9MQBAMCGJRMSFMAM1BGHbCgBZCfWAOqROGXAbCa9MQBAMCEJRMSFMAM1BEHbCgBZCdWAOqROGXAbCa9MQBAMCIJRMSFMAM2BIC8cWAOqROAMCLJRMMAOCFrCBAOCFZl9zAQJRQMGXGXAGCG9HQBABAt87FBABCIJAQ87FBABCGJAT87FBSFMAEAtjGBAECNJAQjGBAECIJATjGBMALCoBJAKCEWJHOAQjGBAOATjGIALAICGWJAQjGBALCoBJAKCFJCbZHKCEWJHOAtjGBAOAQjGIAICFJRIAKCFJRKSFMGXAOCDF9LQBALAIAcAOCbZJ2BBHbCIrHTlCbZCGWJ8oGBAVCFJHtATyROALAIAblCbZCGWJ8oGBAtAT9FHmJHtAbCbZHTyRbAT9FRTGXGXAGCG9HQBABAV87FBABCIJAb87FBABCGJAO87FBSFMAEAVjGBAECNJAbjGBAECIJAOjGBMALAICGWJAVjGBALCoBJAKCEWJHYAOjGBAYAVjGIALAICFJHICbZCGWJAOjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAIAmJCbZHICGWJAbjGBALCoBJAKCGJCbZHKCEWJHOAVjGBAOAbjGIAKCFJRKAIATJRIAtATJRVSFMAVCBAM2BBHYyHTAOC/+F6HPJROAYCbZRtGXGXAYCIrHmQBAOCFJRbSFMAORbALAIAmlCbZCGWJ8oGBROMGXGXAtQBAbCFJRVSFMAbRVALAIAYlCbZCGWJ8oGBRbMGXGXAP9FQBAMCFJRYSFMAM1BFHYCgFZRTGXGXAYCa9MQBAMCGJRYSFMAM1BGHYCgBZCOWATCgBZqRTGXAYCa9MQBAMCEJRYSFMAM1BEHYCgBZCfWATqRTGXAYCa9MQBAMCIJRYSFMAM1BIHYCgBZCdWATqRTGXAYCa9MQBAMCLJRYSFMAMCKJRYAM2BLC8cWATqRTMATCFrCBATCFZl9zAQJHQRTMGXGXAmCb6QBAYRPSFMAY1BBHMCgFZROGXGXAMCa9MQBAYCFJRPSFMAY1BFHMCgBZCOWAOCgBZqROGXAMCa9MQBAYCGJRPSFMAY1BGHMCgBZCfWAOqROGXAMCa9MQBAYCEJRPSFMAY1BEHMCgBZCdWAOqROGXAMCa9MQBAYCIJRPSFMAYCLJRPAY2BIC8cWAOqROMAOCFrCBAOCFZl9zAQJHQROMGXGXAtCb6QBAPRMSFMAP1BBHMCgFZRbGXGXAMCa9MQBAPCFJRMSFMAP1BFHMCgBZCOWAbCgBZqRbGXAMCa9MQBAPCGJRMSFMAP1BGHMCgBZCfWAbqRbGXAMCa9MQBAPCEJRMSFMAP1BEHMCgBZCdWAbqRbGXAMCa9MQBAPCIJRMSFMAPCLJRMAP2BIC8cWAbqRbMAbCFrCBAbCFZl9zAQJHQRbMGXGXAGCG9HQBABAT87FBABCIJAb87FBABCGJAO87FBSFMAEATjGBAECNJAbjGBAECIJAOjGBMALCoBJAKCEWJHYAOjGBAYATjGIALAICGWJATjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAICFJHICbZCGWJAOjGBALCoBJAKCGJCbZCEWJHOATjGBAOAbjGIALAIAm9FAmCb6qJHICbZCGWJAbjGBAIAt9FAtCb6qJRIAKCEJRKMANCFJRNABCKJRBAECSJREAKCbZRKAICbZRIAfCEJHfAF9JQBMMCBC99AMAc6yRKMALCoFJ8kUUUUBAKM/tIFGa8jUUUUBCTlRLC9+RKGXAFCLJAI9LQBCaRKAE2BBC/+FZC/QF9HQBALhB83ENAECFJRKAEAIJC98JREGXAF9FQBGXAGCG6QBEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMALCNJAICFZCGWqHGAICGrCBAICFrCFZl9zAG8oGBJHIjGBABAIjGBABCIJRBAFCaJHFQBSGMMEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMABAICGrCBAICFrCFZl9zALCNJAICFZCGWqHI8oGBJHG87FBAIAGjGBABCGJRBAFCaJHFQBMMCBC99AKAE6yRKMAKM+lLKFaF99GaG99FaG99GXGXAGCI9HQBAF9FQFEXGXGX9DBBB8/9DBBB+/ABCGJHG1BB+yAB1BBHE+yHI+L+TABCFJHL1BBHK+yHO+L+THN9DBBBB9gHVyAN9DBB/+hANAN+U9DBBBBANAVyHcAc+MHMAECa3yAI+SHIAI+UAcAMAKCa3yAO+SHcAc+U+S+S+R+VHO+U+SHN+L9DBBB9P9d9FQBAN+oRESFMCUUUU94REMAGAE86BBGXGX9DBBB8/9DBBB+/Ac9DBBBB9gyAcAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMALAG86BBGXGX9DBBB8/9DBBB+/AI9DBBBB9gyAIAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMABAG86BBABCIJRBAFCaJHFQBSGMMAF9FQBEXGXGX9DBBB8/9DBBB+/ABCIJHG8uFB+yAB8uFBHE+yHI+L+TABCGJHL8uFBHK+yHO+L+THN9DBBBB9gHVyAN9DB/+g6ANAN+U9DBBBBANAVyHcAc+MHMAECa3yAI+SHIAI+UAcAMAKCa3yAO+SHcAc+U+S+S+R+VHO+U+SHN+L9DBBB9P9d9FQBAN+oRESFMCUUUU94REMAGAE87FBGXGX9DBBB8/9DBBB+/Ac9DBBBB9gyAcAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMALAG87FBGXGX9DBBB8/9DBBB+/AI9DBBBB9gyAIAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMABAG87FBABCNJRBAFCaJHFQBMMM/SEIEaE99EaF99GXAF9FQBCBREABRIEXGXGX9D/zI818/AICKJ8uFBHLCEq+y+VHKAI8uFB+y+UHO9DB/+g6+U9DBBB8/9DBBB+/AO9DBBBB9gy+SHN+L9DBBB9P9d9FQBAN+oRVSFMCUUUU94RVMAICIJ8uFBRcAICGJ8uFBRMABALCFJCEZAEqCFWJAV87FBGXGXAKAM+y+UHN9DB/+g6+U9DBBB8/9DBBB+/AN9DBBBB9gy+SHS+L9DBBB9P9d9FQBAS+oRMSFMCUUUU94RMMABALCGJCEZAEqCFWJAM87FBGXGXAKAc+y+UHK9DB/+g6+U9DBBB8/9DBBB+/AK9DBBBB9gy+SHS+L9DBBB9P9d9FQBAS+oRcSFMCUUUU94RcMABALCaJCEZAEqCFWJAc87FBGXGX9DBBU8/AOAO+U+TANAN+U+TAKAK+U+THO9DBBBBAO9DBBBB9gy+R9DB/+g6+U9DBBB8/+SHO+L9DBBB9P9d9FQBAO+oRcSFMCUUUU94RcMABALCEZAEqCFWJAc87FBAICNJRIAECIJREAFCaJHFQBMMM9JBGXAGCGrAF9sHF9FQBEXABAB8oGBHGCNWCN91+yAGCi91CnWCUUU/8EJ+++U84GBABCIJRBAFCaJHFQBMMM9TFEaCBCB8oGUkUUBHFABCEJC98ZJHBjGUkUUBGXGXAB8/BCTWHGuQBCaREABAGlCggEJCTrXBCa6QFMAFREMAEM/lFFFaGXGXAFABqCEZ9FQBABRESFMGXGXAGCT9PQBABRESFMABREEXAEAF8oGBjGBAECIJAFCIJ8oGBjGBAECNJAFCNJ8oGBjGBAECSJAFCSJ8oGBjGBAECTJREAFCTJRFAGC9wJHGCb9LQBMMAGCI9JQBEXAEAF8oGBjGBAFCIJRFAECIJREAGC98JHGCE9LQBMMGXAG9FQBEXAEAF2BB86BBAECFJREAFCFJRFAGCaJHGQBMMABMoFFGaGXGXABCEZ9FQBABRESFMAFCgFZC+BwsN9sRIGXGXAGCT9PQBABRESFMABREEXAEAIjGBAECSJAIjGBAECNJAIjGBAECIJAIjGBAECTJREAGC9wJHGCb9LQBMMAGCI9JQBEXAEAIjGBAECIJREAGC98JHGCE9LQBMMGXAG9FQBEXAEAF86BBAECFJREAGCaJHGQBMMABMMMFBCUNMIT9kBB";
    const wasm_simd = "B9h9z9tFBBBFiI9gBB9gLaaaaaFa9gEaaaB9gFaFaEMcBBFBFFGGGEILF9wFFFLEFBFKNFaFCx/aFMO/LFVK9tv9t9vq95GBt9f9f939h9z9t9f9j9h9s9s9f9jW9vq9zBBp9tv9z9o9v9wW9f9kv9j9v9kv9WvqWv94h919m9mvqBG8Z9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv94h919m9mvqBIy9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv949TvZ91v9u9jvBLn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9P9jWBKi9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9R919hWBOn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9F949wBNI9z9iqlBVc+N9IcIBTEM9+FLa8jUUUUBCTlRBCBRFEXCBRGCBREEXABCNJAGJAECUaAFAGrCFZHIy86BBAEAIJREAGCFJHGCN9HQBMAFCx+YUUBJAE86BBAFCEWCxkUUBJAB8pEN83EBAFCFJHFCUG9HQBMMk8lLbaE97F9+FaL978jUUUUBCU/KBlHL8kUUUUBC9+RKGXAGCFJAI9LQBCaRKAE2BBC+gF9HQBALAEAIJHOAGlAG/8cBBCUoBAG9uC/wgBZHKCUGAKCUG9JyRNAECFJRKCBRVGXEXAVAF9PQFANAFAVlAVANJAF9JyRcGXGXAG9FQBAcCbJHIC9wZHMCE9sRSAMCFWRQAICIrCEJCGrRfCBRbEXAKRTCBRtGXEXGXAOATlAf9PQBCBRKSLMALCU/CBJAtAM9sJRmATAfJRKCBREGXAMCoB9JQBAOAKlC/gB9JQBCBRIEXAmAIJREGXGXGXGXGXATAICKrJ2BBHYCEZfIBFGEBMAECBDtDMIBSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCIJAeDeBJAiCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCNJAeDeBJAiCx+YUUBJ2BBJRKSFMAEAKDBBBDMIBAKCTJRKMGXGXGXGXGXAYCGrCEZfIBFGEBMAECBDtDMITSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMITAKCIJAeDeBJAiCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMITAKCNJAeDeBJAiCx+YUUBJ2BBJRKSFMAEAKDBBBDMITAKCTJRKMGXGXGXGXGXAYCIrCEZfIBFGEBMAECBDtDMIASEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIAAKCIJAeDeBJAiCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIAAKCNJAeDeBJAiCx+YUUBJ2BBJRKSFMAEAKDBBBDMIAAKCTJRKMGXGXGXGXGXAYCKrfIBFGEBMAECBDtDMI8wSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHYCEWCxkUUBJDBEBAYCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHYCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMI8wAKCIJAeDeBJAYCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHYCEWCxkUUBJDBEBAYCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHYCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMI8wAKCNJAeDeBJAYCx+YUUBJ2BBJRKSFMAEAKDBBBDMI8wAKCTJRKMAICoBJREAICUFJAM9LQFAERIAOAKlC/fB9LQBMMGXAEAM9PQBAECErRIEXGXAOAKlCi9PQBCBRKSOMAmAEJRYGXGXGXGXGXATAECKrJ2BBAICKZrCEZfIBFGEBMAYCBDtDMIBSEMAYAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCIJAeDeBJAiCx+YUUBJ2BBJRKSGMAYAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPAPDQBFGENVcMILKOSQfbHeD8dBh+BsxoxoUwN0AeD8dFhxoUwkwk+gUa0sHnhTkAnsHnhNkAnsHn7CgFZHiCEWCxkUUBJDBEBAiCx+YUUBJDBBBHeAeDQBBBBBBBBBBBBBBBBAnhAk7CgFZHiCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCNJAeDeBJAiCx+YUUBJ2BBJRKSFMAYAKDBBBDMIBAKCTJRKMAICGJRIAECTJHEAM9JQBMMGXAK9FQBAKRTAtCFJHtCI6QGSFMMCBRKSEMGXAM9FQBALCUGJAbJREALAbJDBGBReCBRYEXAEALCU/CBJAYJHIDBIBHdCFD9tAdCFDbHPD9OD9hD9RHdAIAMJDBIBH8ZCFD9tA8ZAPD9OD9hD9RH8ZDQBTFtGmEYIPLdKeOnHpAIAQJDBIBHyCFD9tAyAPD9OD9hD9RHyAIASJDBIBH8cCFD9tA8cAPD9OD9hD9RH8cDQBTFtGmEYIPLdKeOnH8dDQBFTtGEmYILPdKOenHPAPDQBFGEBFGEBFGEBFGEAeD9uHeDyBjGBAEAGJHIAeAPAPDQILKOILKOILKOILKOD9uHeDyBjGBAIAGJHIAeAPAPDQNVcMNVcMNVcMNVcMD9uHeDyBjGBAIAGJHIAeAPAPDQSQfbSQfbSQfbSQfbD9uHeDyBjGBAIAGJHIAeApA8dDQNVi8ZcMpySQ8c8dfb8e8fHPAPDQBFGEBFGEBFGEBFGED9uHeDyBjGBAIAGJHIAeAPAPDQILKOILKOILKOILKOD9uHeDyBjGBAIAGJHIAeAPAPDQNVcMNVcMNVcMNVcMD9uHeDyBjGBAIAGJHIAeAPAPDQSQfbSQfbSQfbSQfbD9uHeDyBjGBAIAGJHIAeAdA8ZDQNiV8ZcpMyS8cQ8df8eb8fHdAyA8cDQNiV8ZcpMyS8cQ8df8eb8fH8ZDQBFTtGEmYILPdKOenHPAPDQBFGEBFGEBFGEBFGED9uHeDyBjGBAIAGJHIAeAPAPDQILKOILKOILKOILKOD9uHeDyBjGBAIAGJHIAeAPAPDQNVcMNVcMNVcMNVcMD9uHeDyBjGBAIAGJHIAeAPAPDQSQfbSQfbSQfbSQfbD9uHeDyBjGBAIAGJHIAeAdA8ZDQNVi8ZcMpySQ8c8dfb8e8fHPAPDQBFGEBFGEBFGEBFGED9uHeDyBjGBAIAGJHIAeAPAPDQILKOILKOILKOILKOD9uHeDyBjGBAIAGJHIAeAPAPDQNVcMNVcMNVcMNVcMD9uHeDyBjGBAIAGJHIAeAPAPDQSQfbSQfbSQfbSQfbD9uHeDyBjGBAIAGJREAYCTJHYAM9JQBMMAbCIJHbAG9JQBMMABAVAG9sJALCUGJAcAG9s/8cBBALALCUGJAcCaJAG9sJAG/8cBBMAcCBAKyAVJRVAKQBMC9+RKSFMCBC99AOAKlAGCAAGCA9Ly6yRKMALCU/KBJ8kUUUUBAKMNBT+BUUUBM+KmFTa8jUUUUBCoFlHL8kUUUUBC9+RKGXAFCE9uHOCtJAI9LQBCaRKAE2BBHNC/wFZC/gF9HQBANCbZHVCF9LQBALCoBJCgFCUF/8MBALC84Jha83EBALC8wJha83EBALC8oJha83EBALCAJha83EBALCiJha83EBALCTJha83EBALha83ENALha83EBAEAIJC9wJRcAECFJHNAOJRMGXAF9FQBCQCbAVCF6yRSABRECBRVCBRQCBRfCBRICBRKEXGXAMAcuQBC9+RKSEMGXGXAN2BBHOC/vF9LQBALCoBJAOCIrCa9zAKJCbZCEWJHb8oGIRTAb8oGBRtGXAOCbZHbAS9PQBALAOCa9zAIJCbZCGWJ8oGBAVAbyROAb9FRbGXGXAGCG9HQBABAt87FBABCIJAO87FBABCGJAT87FBSFMAEAtjGBAECNJAOjGBAECIJATjGBMAVAbJRVALCoBJAKCEWJHmAOjGBAmATjGIALAICGWJAOjGBALCoBJAKCFJCbZHKCEWJHTAtjGBATAOjGIAIAbJRIAKCFJRKSGMGXGXAbCb6QBAQAbJAbC989zJCFJRQSFMAM1BBHbCgFZROGXGXAbCa9MQBAMCFJRMSFMAM1BFHbCgBZCOWAOCgBZqROGXAbCa9MQBAMCGJRMSFMAM1BGHbCgBZCfWAOqROGXAbCa9MQBAMCEJRMSFMAM1BEHbCgBZCdWAOqROGXAbCa9MQBAMCIJRMSFMAM2BIC8cWAOqROAMCLJRMMAOCFrCBAOCFZl9zAQJRQMGXGXAGCG9HQBABAt87FBABCIJAQ87FBABCGJAT87FBSFMAEAtjGBAECNJAQjGBAECIJATjGBMALCoBJAKCEWJHOAQjGBAOATjGIALAICGWJAQjGBALCoBJAKCFJCbZHKCEWJHOAtjGBAOAQjGIAICFJRIAKCFJRKSFMGXAOCDF9LQBALAIAcAOCbZJ2BBHbCIrHTlCbZCGWJ8oGBAVCFJHtATyROALAIAblCbZCGWJ8oGBAtAT9FHmJHtAbCbZHTyRbAT9FRTGXGXAGCG9HQBABAV87FBABCIJAb87FBABCGJAO87FBSFMAEAVjGBAECNJAbjGBAECIJAOjGBMALAICGWJAVjGBALCoBJAKCEWJHYAOjGBAYAVjGIALAICFJHICbZCGWJAOjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAIAmJCbZHICGWJAbjGBALCoBJAKCGJCbZHKCEWJHOAVjGBAOAbjGIAKCFJRKAIATJRIAtATJRVSFMAVCBAM2BBHYyHTAOC/+F6HPJROAYCbZRtGXGXAYCIrHmQBAOCFJRbSFMAORbALAIAmlCbZCGWJ8oGBROMGXGXAtQBAbCFJRVSFMAbRVALAIAYlCbZCGWJ8oGBRbMGXGXAP9FQBAMCFJRYSFMAM1BFHYCgFZRTGXGXAYCa9MQBAMCGJRYSFMAM1BGHYCgBZCOWATCgBZqRTGXAYCa9MQBAMCEJRYSFMAM1BEHYCgBZCfWATqRTGXAYCa9MQBAMCIJRYSFMAM1BIHYCgBZCdWATqRTGXAYCa9MQBAMCLJRYSFMAMCKJRYAM2BLC8cWATqRTMATCFrCBATCFZl9zAQJHQRTMGXGXAmCb6QBAYRPSFMAY1BBHMCgFZROGXGXAMCa9MQBAYCFJRPSFMAY1BFHMCgBZCOWAOCgBZqROGXAMCa9MQBAYCGJRPSFMAY1BGHMCgBZCfWAOqROGXAMCa9MQBAYCEJRPSFMAY1BEHMCgBZCdWAOqROGXAMCa9MQBAYCIJRPSFMAYCLJRPAY2BIC8cWAOqROMAOCFrCBAOCFZl9zAQJHQROMGXGXAtCb6QBAPRMSFMAP1BBHMCgFZRbGXGXAMCa9MQBAPCFJRMSFMAP1BFHMCgBZCOWAbCgBZqRbGXAMCa9MQBAPCGJRMSFMAP1BGHMCgBZCfWAbqRbGXAMCa9MQBAPCEJRMSFMAP1BEHMCgBZCdWAbqRbGXAMCa9MQBAPCIJRMSFMAPCLJRMAP2BIC8cWAbqRbMAbCFrCBAbCFZl9zAQJHQRbMGXGXAGCG9HQBABAT87FBABCIJAb87FBABCGJAO87FBSFMAEATjGBAECNJAbjGBAECIJAOjGBMALCoBJAKCEWJHYAOjGBAYATjGIALAICGWJATjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAICFJHICbZCGWJAOjGBALCoBJAKCGJCbZCEWJHOATjGBAOAbjGIALAIAm9FAmCb6qJHICbZCGWJAbjGBAIAt9FAtCb6qJRIAKCEJRKMANCFJRNABCKJRBAECSJREAKCbZRKAICbZRIAfCEJHfAF9JQBMMCBC99AMAc6yRKMALCoFJ8kUUUUBAKM/tIFGa8jUUUUBCTlRLC9+RKGXAFCLJAI9LQBCaRKAE2BBC/+FZC/QF9HQBALhB83ENAECFJRKAEAIJC98JREGXAF9FQBGXAGCG6QBEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMALCNJAICFZCGWqHGAICGrCBAICFrCFZl9zAG8oGBJHIjGBABAIjGBABCIJRBAFCaJHFQBSGMMEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMABAICGrCBAICFrCFZl9zALCNJAICFZCGWqHI8oGBJHG87FBAIAGjGBABCGJRBAFCaJHFQBMMCBC99AKAE6yRKMAKM/dLEK97FaF97GXGXAGCI9HQBAF9FQFCBRGEXABABDBBBHECiD+rFCiD+sFD/6FHIAECND+rFCiD+sFD/6FAID/gFAECTD+rFCiD+sFD/6FHLD/gFD/kFD/lFHKCBDtD+2FHOAICUUUU94DtHND9OD9RD/kFHI9DBB/+hDYAIAID/mFAKAKD/mFALAOALAND9OD9RD/kFHIAID/mFD/kFD/kFD/jFD/nFHLD/mF9DBBX9LDYHOD/kFCgFDtD9OAECUUU94DtD9OD9QAIALD/mFAOD/kFCND+rFCU/+EDtD9OD9QAKALD/mFAOD/kFCTD+rFCUU/8ODtD9OD9QDMBBABCTJRBAGCIJHGAF9JQBSGMMAF9FQBCBRGEXABCTJHVAVDBBBHECBDtHOCUU98D8cFCUU98D8cEHND9OABDBBBHKAEDQILKOSQfbPden8c8d8e8fCggFDtD9OD/6FAKAEDQBFGENVcMTtmYi8ZpyHECTD+sFD/6FHID/gFAECTD+rFCTD+sFD/6FHLD/gFD/kFD/lFHE9DB/+g6DYALAEAOD+2FHOALCUUUU94DtHcD9OD9RD/kFHLALD/mFAEAED/mFAIAOAIAcD9OD9RD/kFHEAED/mFD/kFD/kFD/jFD/nFHID/mF9DBBX9LDYHOD/kFCTD+rFALAID/mFAOD/kFCggEDtD9OD9QHLAEAID/mFAOD/kFCaDbCBDnGCBDnECBDnKCBDnOCBDncCBDnMCBDnfCBDnbD9OHEDQNVi8ZcMpySQ8c8dfb8e8fD9QDMBBABAKAND9OALAEDQBFTtGEmYILPdKOenD9QDMBBABCAJRBAGCIJHGAF9JQBMMM/hEIGaF97FaL978jUUUUBCTlREGXAF9FQBCBRIEXAEABDBBBHLABCTJHKDBBBHODQILKOSQfbPden8c8d8e8fHNCTD+sFHVCID+rFDMIBAB9DBBU8/DY9D/zI818/DYAVCEDtD9QD/6FD/nFHVALAODQBFGENVcMTtmYi8ZpyHLCTD+rFCTD+sFD/6FD/mFHOAOD/mFAVALCTD+sFD/6FD/mFHcAcD/mFAVANCTD+rFCTD+sFD/6FD/mFHNAND/mFD/kFD/kFD/lFCBDtD+4FD/jF9DB/+g6DYHVD/mF9DBBX9LDYHLD/kFCggEDtHMD9OAcAVD/mFALD/kFCTD+rFD9QHcANAVD/mFALD/kFCTD+rFAOAVD/mFALD/kFAMD9OD9QHVDQBFTtGEmYILPdKOenHLD8dBAEDBIBDyB+t+J83EBABCNJALD8dFAEDBIBDyF+t+J83EBAKAcAVDQNVi8ZcMpySQ8c8dfb8e8fHVD8dBAEDBIBDyG+t+J83EBABCiJAVD8dFAEDBIBDyE+t+J83EBABCAJRBAICIJHIAF9JQBMMM9jFF97GXAGCGrAF9sHG9FQBCBRFEXABABDBBBHECND+rFCND+sFD/6FAECiD+sFCnD+rFCUUU/8EDtD+uFD/mFDMBBABCTJRBAFCIJHFAG9JQBMMM9TFEaCBCB8oGUkUUBHFABCEJC98ZJHBjGUkUUBGXGXAB8/BCTWHGuQBCaREABAGlCggEJCTrXBCa6QFMAFREMAEMMMFBCUNMIT9tBB";
    const detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    const wasmpack = new Uint8Array([
        32,
        0,
        65,
        253,
        3,
        1,
        2,
        34,
        4,
        106,
        6,
        5,
        11,
        8,
        7,
        20,
        13,
        33,
        12,
        16,
        128,
        9,
        116,
        64,
        19,
        113,
        127,
        15,
        10,
        21,
        22,
        14,
        255,
        66,
        24,
        54,
        136,
        107,
        18,
        23,
        192,
        26,
        114,
        118,
        132,
        17,
        77,
        101,
        130,
        144,
        27,
        87,
        131,
        44,
        45,
        74,
        156,
        154,
        70,
        167
    ]);
    if (typeof WebAssembly !== "object") return {
        supported: false
    };
    let wasm = wasm_base;
    if (WebAssembly.validate(detector)) wasm = wasm_simd;
    let instance;
    const promise = WebAssembly.instantiate(unpack(wasm), {}).then((result)=>{
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        const result = new Uint8Array(data.length);
        for(let i = 0; i < data.length; ++i){
            const ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
        }
        let write = 0;
        for(let i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        const sbrk = instance.exports.sbrk;
        const count4 = count + 3 & -4;
        const tp = sbrk(count4 * size);
        const sp = sbrk(source.length);
        const heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        const res = fun(tp, count, size, sp, source.length);
        if (res === 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res !== 0) throw new Error(`Malformed buffer data: ${res}`);
    }
    const filters = {
        // legacy index-based enums for glTF
        0: "",
        1: "meshopt_decodeFilterOct",
        2: "meshopt_decodeFilterQuat",
        3: "meshopt_decodeFilterExp",
        // string-based enums for glTF
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    const decoders = {
        // legacy index-based enums for glTF
        0: "meshopt_decodeVertexBuffer",
        1: "meshopt_decodeIndexBuffer",
        2: "meshopt_decodeIndexSequence",
        // string-based enums for glTF
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    $3bf52461e9095b24$var$generated = {
        ready: promise,
        supported: true,
        decodeVertexBuffer (target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer (target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        }
    };
    return $3bf52461e9095b24$var$generated;
};




var $acw62 = parcelRequire("acw62");
var $c393f2421b1ab54b$exports = {};
"use strict";

$c393f2421b1ab54b$exports = (parcelRequire("02ePV"));


var $af9e91ea6e32034a$exports = {};
"use strict";
Object.defineProperty($af9e91ea6e32034a$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
function $af9e91ea6e32034a$var$createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $af9e91ea6e32034a$var$isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $af9e91ea6e32034a$var$useIsomorphicLayoutEffect = $af9e91ea6e32034a$var$isSSR ? $acw62.useEffect : $acw62.useLayoutEffect;
function $af9e91ea6e32034a$var$create(createState) {
    var api = typeof createState === "function" ? $af9e91ea6e32034a$var$createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $acw62.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $acw62.useRef(state);
        var selectorRef = $acw62.useRef(selector);
        var equalityFnRef = $acw62.useRef(equalityFn);
        var erroredRef = $acw62.useRef(false);
        var currentSliceRef = $acw62.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $acw62.useRef(state);
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        $acw62.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$af9e91ea6e32034a$exports["default"] = $af9e91ea6e32034a$var$create;


var $5785509ae5140e70$exports = {};
"use strict";

$5785509ae5140e70$exports = (parcelRequire("8RuUj"));



var $fO90s = parcelRequire("fO90s");
const $f681624d9766226e$var$isPromise = (promise)=>typeof promise === "object" && typeof promise.then === "function";
const $f681624d9766226e$var$globalCache = [];
function $f681624d9766226e$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function $f681624d9766226e$var$query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of $f681624d9766226e$var$globalCache)// Find a match
    if ($f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, "error")) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, "response")) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        remove: ()=>{
            const index = $f681624d9766226e$var$globalCache.indexOf(entry);
            if (index !== -1) $f681624d9766226e$var$globalCache.splice(index, 1);
        },
        promise: ($f681624d9766226e$var$isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $f681624d9766226e$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $f681624d9766226e$export$a1428c8f7ba796e8 = (fn, keys, config)=>$f681624d9766226e$var$query(fn, keys, false, config);
const $f681624d9766226e$export$513ccb98c53b8039 = (fn, keys, config)=>void $f681624d9766226e$var$query(fn, keys, true, config);
const $f681624d9766226e$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $f681624d9766226e$var$globalCache.find((entry)=>$f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $f681624d9766226e$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $f681624d9766226e$var$globalCache.splice(0, $f681624d9766226e$var$globalCache.length);
    else {
        const entry = $f681624d9766226e$var$globalCache.find((entry)=>$f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};


var $4157c7a4095bdc2b$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
const $4157c7a4095bdc2b$var$catalogue = {};
const $4157c7a4095bdc2b$export$f1e1789686576879 = (objects)=>void Object.assign($4157c7a4095bdc2b$var$catalogue, objects);
function $4157c7a4095bdc2b$var$createRenderer(_roots, _getEventPriority) {
    function createInstance(type, { args: args = [], attach: attach, ...props }, root) {
        let name = `${type[0].toUpperCase()}${type.slice(1)}`;
        let instance;
        if (type === "primitive") {
            if (props.object === undefined) throw new Error("R3F: Primitives without 'object' are invalid!");
            const object = props.object;
            instance = $4157c7a4095bdc2b$var$prepare(object, {
                type: type,
                root: root,
                attach: attach,
                primitive: true
            });
        } else {
            const target = $4157c7a4095bdc2b$var$catalogue[name];
            if (!target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            // Throw if an object or literal was passed for args
            if (!Array.isArray(args)) throw new Error("R3F: The args prop must be an array!");
            // Instanciate new object, link it to the root
            // Append memoized props with args so it's not forgotten
            instance = $4157c7a4095bdc2b$var$prepare(new target(...args), {
                type: type,
                root: root,
                attach: attach,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: args
                }
            });
        }
        // Auto-attach geometries and materials
        if (instance.__r3f.attach === undefined) {
            if (instance instanceof $d5b33d7c30034067$export$b7be63a67df8959) instance.__r3f.attach = "geometry";
            else if (instance instanceof $d5b33d7c30034067$export$a2d8b23205c25948) instance.__r3f.attach = "material";
        }
        // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
        // view yet. If the callback relies on references for instance, they won't be ready yet, this is
        // why it passes "true" here
        // There is no reason to apply props to injects
        if (name !== "inject") $4157c7a4095bdc2b$var$applyProps$1(instance, props);
        return instance;
    }
    function appendChild(parentInstance, child) {
        let added = false;
        if (child) {
            var _child$__r3f, _parentInstance$__r3f;
            // The attach attribute implies that the object attaches itself on the parent
            if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) $4157c7a4095bdc2b$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                // add in the usual parent-child way
                parentInstance.add(child);
                added = true;
            }
            // This is for anything that used attach, and for non-Object3Ds that don't get attached to props;
            // that is, anything that's a child in React but not a child in the scenegraph.
            if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null || _parentInstance$__r3f.objects.push(child);
            if (!child.__r3f) $4157c7a4095bdc2b$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $4157c7a4095bdc2b$var$updateInstance(child);
            $4157c7a4095bdc2b$var$invalidateInstance(child);
        }
    }
    function insertBefore(parentInstance, child, beforeChild) {
        let added = false;
        if (child) {
            var _child$__r3f2, _parentInstance$__r3f2;
            if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) $4157c7a4095bdc2b$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                child.parent = parentInstance;
                child.dispatchEvent({
                    type: "added"
                });
                const restSiblings = parentInstance.children.filter((sibling)=>sibling !== child);
                const index = restSiblings.indexOf(beforeChild);
                parentInstance.children = [
                    ...restSiblings.slice(0, index),
                    child,
                    ...restSiblings.slice(index)
                ];
                added = true;
            }
            if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null || _parentInstance$__r3f2.objects.push(child);
            if (!child.__r3f) $4157c7a4095bdc2b$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $4157c7a4095bdc2b$var$updateInstance(child);
            $4157c7a4095bdc2b$var$invalidateInstance(child);
        }
    }
    function removeRecursive(array, parent, dispose = false) {
        if (array) [
            ...array
        ].forEach((child)=>removeChild(parent, child, dispose));
    }
    function removeChild(parentInstance, child, dispose) {
        if (child) {
            var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
            // Clear the parent reference
            if (child.__r3f) child.__r3f.parent = null;
            // Remove child from the parents objects
            if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x)=>x !== child);
            // Remove attachment
            if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) $4157c7a4095bdc2b$var$detach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                var _child$__r3f4;
                parentInstance.remove(child);
                // Remove interactivity
                if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) $4157c7a4095bdc2b$var$removeInteractivity(child.__r3f.root, child);
            }
            // Allow objects to bail out of recursive dispose altogether by passing dispose={null}
            // Never dispose of primitives because their state may be kept outside of React!
            // In order for an object to be able to dispose it has to have
            //   - a dispose method,
            //   - it cannot be a <primitive object={...} />
            //   - it cannot be a THREE.Scene, because three has broken it's own api
            //
            // Since disposal is recursive, we can check the optional dispose arg, which will be undefined
            // when the reconciler calls it, but then carry our own check recursively
            const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
            const shouldDispose = dispose === undefined ? child.dispose !== null && !isPrimitive : dispose;
            // Remove nested child objects. Primitives should not have objects and children that are
            // attached to them declaratively ...
            if (!isPrimitive) {
                var _child$__r3f6;
                removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
                removeRecursive(child.children, child, shouldDispose);
            }
            // Remove references
            delete child.__r3f;
            // Dispose item whenever the reconciler feels like it
            if (shouldDispose && child.dispose && child.type !== "Scene") (0, $fO90s.unstable_scheduleCallback)((0, $fO90s.unstable_IdlePriority), ()=>{
                try {
                    child.dispose();
                } catch (e) {
                /* ... */ }
            });
            $4157c7a4095bdc2b$var$invalidateInstance(parentInstance);
        }
    }
    function switchInstance(instance, type, newProps, fiber) {
        var _instance$__r3f;
        const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
        if (!parent) return;
        const newInstance = createInstance(type, newProps, instance.__r3f.root);
        // https://github.com/pmndrs/react-three-fiber/issues/1348
        // When args change the instance has to be re-constructed, which then
        // forces r3f to re-parent the children and non-scene objects
        if (instance.children) {
            for (const child of instance.children)if (child.__r3f) appendChild(newInstance, child);
            instance.children = instance.children.filter((child)=>!child.__r3f);
        }
        instance.__r3f.objects.forEach((child)=>appendChild(newInstance, child));
        instance.__r3f.objects = [];
        if (!instance.__r3f.autoRemovedBeforeAppend) removeChild(parent, instance);
        if (newInstance.parent) newInstance.__r3f.autoRemovedBeforeAppend = true;
        appendChild(parent, newInstance);
        // Re-bind event handlers
        if (newInstance.raycast && newInstance.__r3f.eventCount) {
            const rootState = newInstance.__r3f.root.getState();
            rootState.internal.interaction.push(newInstance);
        }
        [
            fiber,
            fiber.alternate
        ].forEach((fiber)=>{
            if (fiber !== null) {
                fiber.stateNode = newInstance;
                if (fiber.ref) {
                    if (typeof fiber.ref === "function") fiber.ref(newInstance);
                    else fiber.ref.current = newInstance;
                }
            }
        });
    }
    // Don't handle text instances, warn on undefined behavior
    const handleTextInstance = ()=>console.warn("Text is not allowed in the R3F tree! This could be stray whitespace or characters.");
    const reconciler = (0, (/*@__PURE__*/$parcel$interopDefault($5785509ae5140e70$exports)))({
        createInstance: createInstance,
        removeChild: removeChild,
        appendChild: appendChild,
        appendInitialChild: appendChild,
        insertBefore: insertBefore,
        supportsMutation: true,
        isPrimaryRenderer: false,
        supportsPersistence: false,
        supportsHydration: false,
        noTimeout: -1,
        appendChildToContainer: (container, child)=>{
            if (!child) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            // Link current root to the default scene
            scene.__r3f.root = container;
            appendChild(scene, child);
        },
        removeChildFromContainer: (container, child)=>{
            if (!child) return;
            removeChild(container.getState().scene, child);
        },
        insertInContainerBefore: (container, child, beforeChild)=>{
            if (!child || !beforeChild) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            insertBefore(scene, child, beforeChild);
        },
        getRootHostContext: ()=>null,
        getChildHostContext: (parentHostContext)=>parentHostContext,
        finalizeInitialChildren (instance) {
            var _instance$__r3f2;
            const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
            // https://github.com/facebook/react/issues/20271
            // Returning true will trigger commitMount
            return Boolean(localState.handlers);
        },
        prepareUpdate (instance, _type, oldProps, newProps) {
            var _instance$__r3f3;
            const localState = (_instance$__r3f3 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f3 : {};
            // Create diff-sets
            if (localState.primitive && newProps.object && newProps.object !== instance) return [
                true
            ];
            else {
                // This is a data object, let's extract critical information about it
                const { args: argsNew = [], children: cN, ...restNew } = newProps;
                const { args: argsOld = [], children: cO, ...restOld } = oldProps;
                // Throw if an object or literal was passed for args
                if (!Array.isArray(argsNew)) throw new Error("R3F: the args prop must be an array!");
                // If it has new props or arguments, then it needs to be re-instantiated
                if (argsNew.some((value, index)=>value !== argsOld[index])) return [
                    true
                ];
                // Create a diff-set, flag if there are any changes
                const diff = $4157c7a4095bdc2b$var$diffProps(instance, restNew, restOld, true);
                if (diff.changes.length) return [
                    false,
                    diff
                ];
                // Otherwise do not touch the instance
                return null;
            }
        },
        commitUpdate (instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
            // Reconstruct when args or <primitive object={...} have changes
            if (reconstruct) switchInstance(instance, type, newProps, fiber);
            else $4157c7a4095bdc2b$var$applyProps$1(instance, diff);
        },
        commitMount (instance, _type, _props, _int) {
            var _instance$__r3f4;
            // https://github.com/facebook/react/issues/20271
            // This will make sure events are only added once to the central container
            const localState = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
            if (instance.raycast && localState.handlers && localState.eventCount) instance.__r3f.root.getState().internal.interaction.push(instance);
        },
        getPublicInstance: (instance)=>instance,
        prepareForCommit: ()=>null,
        preparePortalMount: (container)=>$4157c7a4095bdc2b$var$prepare(container.getState().scene),
        resetAfterCommit: ()=>{},
        shouldSetTextContent: ()=>false,
        clearContainer: ()=>false,
        hideInstance (instance) {
            var _instance$__r3f5;
            // Detach while the instance is hidden
            const { attach: type, parent: parent } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
            if (type && parent) $4157c7a4095bdc2b$var$detach(parent, instance, type);
            if (instance.isObject3D) instance.visible = false;
            $4157c7a4095bdc2b$var$invalidateInstance(instance);
        },
        unhideInstance (instance, props) {
            var _instance$__r3f6;
            // Re-attach when the instance is unhidden
            const { attach: type, parent: parent } = (_instance$__r3f6 = instance.__r3f) != null ? _instance$__r3f6 : {};
            if (type && parent) $4157c7a4095bdc2b$var$attach(parent, instance, type);
            if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
            $4157c7a4095bdc2b$var$invalidateInstance(instance);
        },
        createTextInstance: handleTextInstance,
        hideTextInstance: handleTextInstance,
        unhideTextInstance: handleTextInstance,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
        // @ts-ignore
        getCurrentEventPriority: ()=>_getEventPriority ? _getEventPriority() : (0, $c393f2421b1ab54b$exports.DefaultEventPriority),
        beforeActiveInstanceBlur: ()=>{},
        afterActiveInstanceBlur: ()=>{},
        detachDeletedInstance: ()=>{},
        now: typeof performance !== "undefined" && $4157c7a4095bdc2b$var$is.fun(performance.now) ? performance.now : $4157c7a4095bdc2b$var$is.fun(Date.now) ? Date.now : ()=>0,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
        scheduleTimeout: $4157c7a4095bdc2b$var$is.fun(setTimeout) ? setTimeout : undefined,
        cancelTimeout: $4157c7a4095bdc2b$var$is.fun(clearTimeout) ? clearTimeout : undefined
    });
    return {
        reconciler: reconciler,
        applyProps: $4157c7a4095bdc2b$var$applyProps$1
    };
}
var $4157c7a4095bdc2b$var$_window$document, $4157c7a4095bdc2b$var$_window$navigator;
/**
 * Returns `true` with correct TS type inference if an object has a configurable color space (since r152).
 */ const $4157c7a4095bdc2b$var$hasColorSpace = (object)=>"colorSpace" in object || "outputColorSpace" in object;
/**
 * The current THREE.ColorManagement instance, if present.
 */ const $4157c7a4095bdc2b$var$getColorManagement = ()=>{
    var _ColorManagement;
    return (_ColorManagement = $4157c7a4095bdc2b$var$catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const $4157c7a4095bdc2b$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $4157c7a4095bdc2b$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty("current");
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $4157c7a4095bdc2b$export$407448d2b89b1813 = typeof window !== "undefined" && (($4157c7a4095bdc2b$var$_window$document = window.document) != null && $4157c7a4095bdc2b$var$_window$document.createElement || (($4157c7a4095bdc2b$var$_window$navigator = window.navigator) == null ? void 0 : $4157c7a4095bdc2b$var$_window$navigator.product) === "ReactNative") ? $acw62.useLayoutEffect : $acw62.useEffect;
function $4157c7a4095bdc2b$export$3b14a55fb2447963(fn) {
    const ref = $acw62.useRef(fn);
    $4157c7a4095bdc2b$export$407448d2b89b1813(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
function $4157c7a4095bdc2b$export$ef35774e6d314e91({ set: set }) {
    $4157c7a4095bdc2b$export$407448d2b89b1813(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
class $4157c7a4095bdc2b$export$a9c23c6ac3fc3eca extends $acw62.Component {
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
    }
    componentDidCatch(err) {
        this.props.set(err);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$4157c7a4095bdc2b$export$a9c23c6ac3fc3eca.getDerivedStateFromError = ()=>({
        error: true
    });
const $4157c7a4095bdc2b$var$DEFAULT = "__default";
const $4157c7a4095bdc2b$var$DEFAULTS = new Map();
const $4157c7a4095bdc2b$var$isDiffSet = (def)=>def && !!def.memoized && !!def.changes;
function $4157c7a4095bdc2b$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== "undefined" ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ const $4157c7a4095bdc2b$export$2408f22a0fab9ae5 = (obj)=>{
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
// A collection of compare functions
const $4157c7a4095bdc2b$var$is = {
    obj: (a)=>a === Object(a) && !$4157c7a4095bdc2b$var$is.arr(a) && typeof a !== "function",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    boo: (a)=>typeof a === "boolean",
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = "shallow", objects: objects = "reference", strict: strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($4157c7a4095bdc2b$var$is.str(a) || $4157c7a4095bdc2b$var$is.num(a)) return a === b;
        const isObj = $4157c7a4095bdc2b$var$is.obj(a);
        if (isObj && objects === "reference") return a === b;
        const isArr = $4157c7a4095bdc2b$var$is.arr(a);
        if (isArr && arrays === "reference") return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === "shallow" && objects === "shallow") {
            for(i in strict ? b : a)if (!$4157c7a4095bdc2b$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: "reference"
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($4157c7a4095bdc2b$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
// Collects nodes and materials from a THREE.Object3D
function $4157c7a4095bdc2b$var$buildGraph(object) {
    const data = {
        nodes: {},
        materials: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
    return data;
}
// Disposes an object and all its properties
function $4157c7a4095bdc2b$export$342063e11d6c3cad(obj) {
    if (obj.dispose && obj.type !== "Scene") obj.dispose();
    for(const p in obj){
        p.dispose == null || p.dispose();
        delete obj[p];
    }
}
// Each object in the scene carries a small LocalState descriptor
function $4157c7a4095bdc2b$var$prepare(object, state) {
    const instance = object;
    instance.__r3f = {
        type: "",
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...state
    };
    return object;
}
function $4157c7a4095bdc2b$var$resolve(instance, key) {
    let target = instance;
    if (key.includes("-")) {
        const entries = key.split("-");
        const last = entries.pop();
        target = entries.reduce((acc, key)=>acc[key], instance);
        return {
            target: target,
            key: last
        };
    } else return {
        target: target,
        key: key
    };
}
// Checks if a dash-cased string ends with an integer
const $4157c7a4095bdc2b$var$INDEX_REGEX = /-\d+$/;
function $4157c7a4095bdc2b$var$attach(parent, child, type) {
    if ($4157c7a4095bdc2b$var$is.str(type)) {
        // If attaching into an array (foo-0), create one
        if ($4157c7a4095bdc2b$var$INDEX_REGEX.test(type)) {
            const root = type.replace($4157c7a4095bdc2b$var$INDEX_REGEX, "");
            const { target: target, key: key } = $4157c7a4095bdc2b$var$resolve(parent, root);
            if (!Array.isArray(target[key])) target[key] = [];
        }
        const { target: target, key: key } = $4157c7a4095bdc2b$var$resolve(parent, type);
        child.__r3f.previousAttach = target[key];
        target[key] = child;
    } else child.__r3f.previousAttach = type(parent, child);
}
function $4157c7a4095bdc2b$var$detach(parent, child, type) {
    var _child$__r3f, _child$__r3f2;
    if ($4157c7a4095bdc2b$var$is.str(type)) {
        const { target: target, key: key } = $4157c7a4095bdc2b$var$resolve(parent, type);
        const previous = child.__r3f.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete target[key];
        else target[key] = previous;
    } else (_child$__r3f = child.__r3f) == null || _child$__r3f.previousAttach == null || _child$__r3f.previousAttach(parent, child);
    (_child$__r3f2 = child.__r3f) == null || delete _child$__r3f2.previousAttach;
}
// This function prepares a set of changes to be applied to the instance
function $4157c7a4095bdc2b$var$diffProps(instance, { children: cN, key: kN, ref: rN, ...props }, { children: cP, key: kP, ref: rP, ...previous } = {}, remove = false) {
    var _instance$__r3f;
    const localState = (_instance$__r3f = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f : {};
    const entries = Object.entries(props);
    const changes = [];
    // Catch removed props, prepend them so they can be reset or removed
    if (remove) {
        const previousKeys = Object.keys(previous);
        for(let i = 0; i < previousKeys.length; i++)if (!props.hasOwnProperty(previousKeys[i])) entries.unshift([
            previousKeys[i],
            $4157c7a4095bdc2b$var$DEFAULT + "remove"
        ]);
    }
    entries.forEach(([key, value])=>{
        var _instance$__r3f2;
        // Bail out on primitive object
        if ((_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.primitive && key === "object") return;
        // When props match bail out
        if ($4157c7a4095bdc2b$var$is.equ(value, previous[key])) return;
        // Collect handlers and bail out
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([
            key,
            value,
            true,
            []
        ]);
        // Split dashed props
        let entries = [];
        if (key.includes("-")) entries = key.split("-");
        changes.push([
            key,
            value,
            false,
            entries
        ]);
        // Reset pierced props
        for(const prop in props){
            const value = props[prop];
            if (prop.startsWith(`${key}-`)) changes.push([
                prop,
                value,
                false,
                prop.split("-")
            ]);
        }
    });
    const memoized = {
        ...props
    };
    if (localState.memoizedProps && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
    if (localState.memoizedProps && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
    return {
        memoized: memoized,
        changes: changes
    };
}
// This function applies a set of changes to the instance
function $4157c7a4095bdc2b$var$applyProps$1(instance, data) {
    var _instance$__r3f3, _root$getState, _instance$__r3f4;
    // Filter equals, events and reserved props
    const localState = (_instance$__r3f3 = instance.__r3f) != null ? _instance$__r3f3 : {};
    const root = localState.root;
    const rootState = (_root$getState = root == null ? void 0 : root.getState == null ? void 0 : root.getState()) != null ? _root$getState : {};
    const { memoized: memoized, changes: changes } = $4157c7a4095bdc2b$var$isDiffSet(data) ? data : $4157c7a4095bdc2b$var$diffProps(instance, data);
    const prevHandlers = localState.eventCount;
    // Prepare memoized props
    if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
    for(let i = 0; i < changes.length; i++){
        let [key, value, isEvent, keys] = changes[i];
        // Alias (output)encoding => (output)colorSpace (since r152)
        // https://github.com/pmndrs/react-three-fiber/pull/2829
        if ($4157c7a4095bdc2b$var$hasColorSpace(instance)) {
            const sRGBEncoding = 3001;
            const SRGBColorSpace = "srgb";
            const LinearSRGBColorSpace = "srgb-linear";
            if (key === "encoding") {
                key = "colorSpace";
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            } else if (key === "outputEncoding") {
                key = "outputColorSpace";
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            }
        }
        let currentInstance = instance;
        let targetProp = currentInstance[key];
        // Revolve dashed props
        if (keys.length) {
            targetProp = keys.reduce((acc, key)=>acc[key], instance);
            // If the target is atomic, it forces us to switch the root
            if (!(targetProp && targetProp.set)) {
                const [name, ...reverseEntries] = keys.reverse();
                currentInstance = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                key = name;
            }
        }
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (value === $4157c7a4095bdc2b$var$DEFAULT + "remove") {
            if (currentInstance.constructor) {
                // create a blank slate of the instance and copy the particular parameter.
                let ctor = $4157c7a4095bdc2b$var$DEFAULTS.get(currentInstance.constructor);
                if (!ctor) {
                    // @ts-ignore
                    ctor = new currentInstance.constructor();
                    $4157c7a4095bdc2b$var$DEFAULTS.set(currentInstance.constructor, ctor);
                }
                value = ctor[key];
            } else // instance does not have constructor, just set it to 0
            value = 0;
        }
        // Deal with pointer events ...
        if (isEvent) {
            if (value) localState.handlers[key] = value;
            else delete localState.handlers[key];
            localState.eventCount = Object.keys(localState.handlers).length;
        } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof $d5b33d7c30034067$export$89312ce47c0ca777)) {
            // If value is an array
            if (Array.isArray(value)) {
                if (targetProp.fromArray) targetProp.fromArray(value);
                else targetProp.set(...value);
            } else if (targetProp.copy && value && value.constructor && targetProp.constructor === value.constructor) targetProp.copy(value);
            else if (value !== undefined) {
                const isColor = targetProp instanceof $d5b33d7c30034067$export$892596cec99bc70e;
                // Allow setting array scalars
                if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
                else if (targetProp instanceof $d5b33d7c30034067$export$89312ce47c0ca777 && value instanceof $d5b33d7c30034067$export$89312ce47c0ca777) targetProp.mask = value.mask;
                else targetProp.set(value);
                // For versions of three which don't support THREE.ColorManagement,
                // Auto-convert sRGB colors
                // https://github.com/pmndrs/react-three-fiber/issues/344
                if (!$4157c7a4095bdc2b$var$getColorManagement() && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
            }
        // Else, just overwrite the value
        } else {
            currentInstance[key] = value;
            // Auto-convert sRGB textures, for now ...
            // https://github.com/pmndrs/react-three-fiber/issues/344
            if (currentInstance[key] instanceof $d5b33d7c30034067$export$5431306cf43de24a && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            currentInstance[key].format === $d5b33d7c30034067$export$3f8bb04b555a363c && currentInstance[key].type === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) {
                const texture = currentInstance[key];
                if ($4157c7a4095bdc2b$var$hasColorSpace(texture) && $4157c7a4095bdc2b$var$hasColorSpace(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
                else texture.encoding = rootState.gl.outputEncoding;
            }
        }
        $4157c7a4095bdc2b$var$invalidateInstance(instance);
    }
    if (localState.parent && rootState.internal && instance.raycast && prevHandlers !== localState.eventCount) {
        // Pre-emptively remove the instance from the interaction manager
        const index = rootState.internal.interaction.indexOf(instance);
        if (index > -1) rootState.internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (localState.eventCount) rootState.internal.interaction.push(instance);
    }
    // Call the update lifecycle when it is being updated, but only when it is part of the scene.
    // Skip updates to the `onUpdate` prop itself
    const isCircular = changes.length === 1 && changes[0][0] === "onUpdate";
    if (!isCircular && changes.length && (_instance$__r3f4 = instance.__r3f) != null && _instance$__r3f4.parent) $4157c7a4095bdc2b$var$updateInstance(instance);
    return instance;
}
function $4157c7a4095bdc2b$var$invalidateInstance(instance) {
    var _instance$__r3f5, _instance$__r3f5$root;
    const state = (_instance$__r3f5 = instance.__r3f) == null ? void 0 : (_instance$__r3f5$root = _instance$__r3f5.root) == null ? void 0 : _instance$__r3f5$root.getState == null ? void 0 : _instance$__r3f5$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $4157c7a4095bdc2b$var$updateInstance(instance) {
    instance.onUpdate == null || instance.onUpdate(instance);
}
function $4157c7a4095bdc2b$var$updateCamera(camera, size) {
    // https://github.com/pmndrs/react-three-fiber/issues/92
    // Do not mess with the camera if it belongs to the user
    if (!camera.manual) {
        if ($4157c7a4095bdc2b$var$isOrthographicCamera(camera)) {
            camera.left = size.width / -2;
            camera.right = size.width / 2;
            camera.top = size.height / 2;
            camera.bottom = size.height / -2;
        } else camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // https://github.com/pmndrs/react-three-fiber/issues/178
        // Update matrix world since the renderer is a frame late
        camera.updateMatrixWorld();
    }
}
function $4157c7a4095bdc2b$var$makeId(event) {
    return (event.eventObject || event.object).uuid + "/" + event.index + event.instanceId;
}
// https://github.com/facebook/react/tree/main/packages/react-reconciler#getcurrenteventpriority
// Gives React a clue as to how import the current interaction is
function $4157c7a4095bdc2b$var$getEventPriority() {
    var _globalScope$event;
    // Get a handle to the current global scope in window and worker contexts if able
    // https://github.com/pmndrs/react-three-fiber/pull/2493
    const globalScope = typeof self !== "undefined" && self || typeof window !== "undefined" && window;
    if (!globalScope) return 0, $c393f2421b1ab54b$exports.DefaultEventPriority;
    const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
    switch(name){
        case "click":
        case "contextmenu":
        case "dblclick":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
            return 0, $c393f2421b1ab54b$exports.DiscreteEventPriority;
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerenter":
        case "pointerleave":
        case "wheel":
            return 0, $c393f2421b1ab54b$exports.ContinuousEventPriority;
        default:
            return 0, $c393f2421b1ab54b$exports.DefaultEventPriority;
    }
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $4157c7a4095bdc2b$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $4157c7a4095bdc2b$var$removeInteractivity(store, object) {
    const { internal: internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $4157c7a4095bdc2b$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $4157c7a4095bdc2b$export$db3b6bfb95261072(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                "Move",
                "Over",
                "Enter",
                "Out",
                "Leave"
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers["onPointer" + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $4157c7a4095bdc2b$export$2408f22a0fab9ae5(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $4157c7a4095bdc2b$export$2408f22a0fab9ae5(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $4157c7a4095bdc2b$export$2408f22a0fab9ae5(a.object);
            const bState = $4157c7a4095bdc2b$export$2408f22a0fab9ae5(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $4157c7a4095bdc2b$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ("pointerId" in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($4157c7a4095bdc2b$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        const rootState = store.getState();
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                const state = $4157c7a4095bdc2b$export$2408f22a0fab9ae5(hit.object) || rootState;
                const { raycaster: raycaster, pointer: pointer, camera: camera, internal: internal } = state;
                const unprojectedPoint = new $d5b33d7c30034067$export$64b5c384219d3699(pointer.x, pointer.y, 0).unproject(camera);
                const hasPointerCapture = (id)=>{
                    var _internal$capturedMap, _internal$capturedMap2;
                    return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                };
                const setPointerCapture = (id)=>{
                    const captureData = {
                        intersection: hit,
                        target: event.target
                    };
                    if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                    // event capturedMap.
                    internal.capturedMap.get(id).set(hit.eventObject, captureData);
                    else // if the pointerId was not previously captured, we create a map
                    // containing the hitObject, and the hit. hitObject is used for
                    // faster access.
                    internal.capturedMap.set(id, new Map([
                        [
                            hit.eventObject,
                            captureData
                        ]
                    ]));
                    event.target.setPointerCapture(id);
                };
                const releasePointerCapture = (id)=>{
                    const captures = internal.capturedMap.get(id);
                    if (captures) $4157c7a4095bdc2b$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                };
                // Add native event props
                let extractEventProps = {};
                // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                for(let prop in event){
                    let property = event[prop];
                    // Only copy over atomics, leave functions alone as these should be
                    // called as event.nativeEvent.fn()
                    if (typeof property !== "function") extractEventProps[prop] = property;
                }
                let raycastEvent = {
                    ...hit,
                    ...extractEventProps,
                    pointer: pointer,
                    intersections: intersections,
                    stopped: localState.stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: raycaster.ray,
                    camera: camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        // https://github.com/pmndrs/react-three-fiber/issues/596
                        // Events are not allowed to stop propagation if the pointer has been captured
                        const capturesForPointer = "pointerId" in event && internal.capturedMap.get(event.pointerId);
                        // We only authorize stopPropagation...
                        if (// ...if this pointer hasn't been captured
                        !capturesForPointer || // ... or if the hit object is capturing the pointer
                        capturesForPointer.has(hit.eventObject)) {
                            raycastEvent.stopped = localState.stopped = true;
                            // Propagation is stopped, remove all other hover records
                            // An event handler is only allowed to flush other handlers if it is hovered itself
                            if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                // Objects cannot flush out higher up objects that have already caught the event
                                const higher = intersections.slice(0, intersections.indexOf(hit));
                                cancelPointer([
                                    ...higher,
                                    hit
                                ]);
                            }
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    currentTarget: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    nativeEvent: event
                };
                // Call subscribers
                callback(raycastEvent);
                // Event bubbling may be interrupted by stopPropagation
                if (localState.stopped === true) break;
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            const handlers = instance == null ? void 0 : instance.handlers;
            internal.hovered.delete($4157c7a4095bdc2b$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case "onPointerLeave":
            case "onPointerCancel":
                return ()=>cancelPointer([]);
            case "onLostPointerCapture":
                return (event)=>{
                    const { internal: internal } = store.getState();
                    if ("pointerId" in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed, internal: internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === "onPointerMove";
            const isClickEvent = name === "onClick" || name === "onContextMenu" || name === "onDoubleClick";
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === "onPointerDown") {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                const handlers = instance == null ? void 0 : instance.handlers;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $4157c7a4095bdc2b$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
// Keys that shouldn't be copied between R3F stores
const $4157c7a4095bdc2b$var$privateKeys = [
    "set",
    "get",
    "setSize",
    "setFrameloop",
    "setDpr",
    "events",
    "invalidate",
    "advance",
    "size",
    "viewport"
];
const $4157c7a4095bdc2b$var$isRenderer = (def)=>!!(def != null && def.render);
const $4157c7a4095bdc2b$export$2d1720544b23b823 = /*#__PURE__*/ $acw62.createContext(null);
const $4157c7a4095bdc2b$var$createStore = (invalidate, advance)=>{
    const rootState = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>{
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const defaultTarget = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tempTarget = new $d5b33d7c30034067$export$64b5c384219d3699();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width, height: height, top: top, left: left } = size;
            const aspect = width / height;
            if (target instanceof $d5b33d7c30034067$export$64b5c384219d3699) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($4157c7a4095bdc2b$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            xr: null,
            scene: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $d5b33d7c30034067$export$9735c82c4bae3302(),
            pointer: pointer,
            mouse: pointer,
            frameloop: "always",
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: false
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, updateStyle, top, left)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top || 0,
                    left: left || 0,
                    updateStyle: updateStyle
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $4157c7a4095bdc2b$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = "always")=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== "never") {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                active: false,
                priority: 0,
                frames: 0,
                lastEvent: /*#__PURE__*/ $acw62.createRef(),
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootState.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootState.subscribe(()=>{
        const { camera: camera, size: size, viewport: viewport, gl: gl, set: set } = rootState.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size !== oldSize || viewport.dpr !== oldDpr) {
            var _size$updateStyle;
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $4157c7a4095bdc2b$var$updateCamera(camera, size);
            gl.setPixelRatio(viewport.dpr);
            const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== "undefined" && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootState.subscribe((state)=>invalidate(state));
    // Return root state
    return rootState;
};
function $4157c7a4095bdc2b$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
let $4157c7a4095bdc2b$var$i;
let $4157c7a4095bdc2b$var$globalEffects = new Set();
let $4157c7a4095bdc2b$var$globalAfterEffects = new Set();
let $4157c7a4095bdc2b$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $4157c7a4095bdc2b$export$7ccc53e8f1e7dfc5 = (callback)=>$4157c7a4095bdc2b$var$createSubs(callback, $4157c7a4095bdc2b$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $4157c7a4095bdc2b$export$ae1af26003f05816 = (callback)=>$4157c7a4095bdc2b$var$createSubs(callback, $4157c7a4095bdc2b$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $4157c7a4095bdc2b$export$ffb5f4729a158638 = (callback)=>$4157c7a4095bdc2b$var$createSubs(callback, $4157c7a4095bdc2b$var$globalTailEffects);
function $4157c7a4095bdc2b$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback } of effects.values())callback(timestamp);
}
function $4157c7a4095bdc2b$export$9e5f44173e64f162(type, timestamp) {
    switch(type){
        case "before":
            return $4157c7a4095bdc2b$var$run($4157c7a4095bdc2b$var$globalEffects, timestamp);
        case "after":
            return $4157c7a4095bdc2b$var$run($4157c7a4095bdc2b$var$globalAfterEffects, timestamp);
        case "tail":
            return $4157c7a4095bdc2b$var$run($4157c7a4095bdc2b$var$globalTailEffects, timestamp);
    }
}
let $4157c7a4095bdc2b$var$subscribers;
let $4157c7a4095bdc2b$var$subscription;
function $4157c7a4095bdc2b$var$render$1(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === "never" && typeof timestamp === "number") {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $4157c7a4095bdc2b$var$subscribers = state.internal.subscribers;
    for($4157c7a4095bdc2b$var$i = 0; $4157c7a4095bdc2b$var$i < $4157c7a4095bdc2b$var$subscribers.length; $4157c7a4095bdc2b$var$i++){
        $4157c7a4095bdc2b$var$subscription = $4157c7a4095bdc2b$var$subscribers[$4157c7a4095bdc2b$var$i];
        $4157c7a4095bdc2b$var$subscription.ref.current($4157c7a4095bdc2b$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === "always" ? 1 : state.internal.frames;
}
function $4157c7a4095bdc2b$var$createLoop(roots) {
    let running = false;
    let repeat;
    let frame;
    let state;
    function loop(timestamp) {
        frame = requestAnimationFrame(loop);
        running = true;
        repeat = 0;
        // Run effects
        $4157c7a4095bdc2b$export$9e5f44173e64f162("before", timestamp);
        // Render all roots
        for (const root of roots.values()){
            var _state$gl$xr;
            state = root.store.getState();
            // If the frameloop is invalidated, do not run another frame
            if (state.internal.active && (state.frameloop === "always" || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += $4157c7a4095bdc2b$var$render$1(timestamp, state);
        }
        // Run after-effects
        $4157c7a4095bdc2b$export$9e5f44173e64f162("after", timestamp);
        // Stop the loop if nothing invalidates it
        if (repeat === 0) {
            // Tail call effects, they are called when rendering stops
            $4157c7a4095bdc2b$export$9e5f44173e64f162("tail", timestamp);
            // Flag end of operation
            running = false;
            return cancelAnimationFrame(frame);
        }
    }
    function invalidate(state, frames = 1) {
        var _state$gl$xr2;
        if (!state) return roots.forEach((root)=>invalidate(root.store.getState()), frames);
        if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === "never") return;
        // Increase frames, do not go higher than 60
        state.internal.frames = Math.min(60, state.internal.frames + frames);
        // If the render-loop isn't active, start it
        if (!running) {
            running = true;
            requestAnimationFrame(loop);
        }
    }
    function advance(timestamp, runGlobalEffects = true, state, frame) {
        if (runGlobalEffects) $4157c7a4095bdc2b$export$9e5f44173e64f162("before", timestamp);
        if (!state) for (const root of roots.values())$4157c7a4095bdc2b$var$render$1(timestamp, root.store.getState());
        else $4157c7a4095bdc2b$var$render$1(timestamp, state, frame);
        if (runGlobalEffects) $4157c7a4095bdc2b$export$9e5f44173e64f162("after", timestamp);
    }
    return {
        loop: loop,
        invalidate: /**
     * Invalidates the view, requesting a frame to be rendered. Will globally invalidate unless passed a root's state.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#invalidate
     */ invalidate,
        advance: /**
     * Advances the frameloop and runs render effects, useful for when manually rendering via `frameloop="never"`.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#advance
     */ advance
    };
}
/**
 * Exposes an object's {@link LocalState}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $4157c7a4095bdc2b$export$d141bba7fdc215a3(ref) {
    const instance = $acw62.useRef(null);
    $4157c7a4095bdc2b$export$407448d2b89b1813(()=>void (instance.current = ref.current.__r3f), [
        ref
    ]);
    return instance;
}
function $4157c7a4095bdc2b$export$4a5767248b18ef41() {
    const store = $acw62.useContext($4157c7a4095bdc2b$export$2d1720544b23b823);
    if (!store) throw new Error("R3F: Hooks can only be used within the Canvas component!");
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $4157c7a4095bdc2b$export$df995fae86a55f06(selector = (state)=>state, equalityFn) {
    return $4157c7a4095bdc2b$export$4a5767248b18ef41()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $4157c7a4095bdc2b$export$ebd11618f299a286(callback, renderPriority = 0) {
    const store = $4157c7a4095bdc2b$export$4a5767248b18ef41();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $4157c7a4095bdc2b$export$3b14a55fb2447963(callback);
    // Subscribe on mount, unsubscribe on unmount
    $4157c7a4095bdc2b$export$407448d2b89b1813(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $4157c7a4095bdc2b$export$e7094788287c5e9b(object) {
    return $acw62.useMemo(()=>$4157c7a4095bdc2b$var$buildGraph(object), [
        object
    ]);
}
function $4157c7a4095bdc2b$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        // Construct new loader and run extensions
        const loader = new Proto();
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (data.scene) Object.assign(data, $4157c7a4095bdc2b$var$buildGraph(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error.message}`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $4157c7a4095bdc2b$export$96f57966bedc81b4(Proto, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $f681624d9766226e$export$a1428c8f7ba796e8)($4157c7a4095bdc2b$var$loadingFn(extensions, onProgress), [
        Proto,
        ...keys
    ], {
        equal: $4157c7a4095bdc2b$var$is.equ
    });
    // Return the object/s
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $4157c7a4095bdc2b$export$96f57966bedc81b4.preload = function(Proto, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $f681624d9766226e$export$513ccb98c53b8039)($4157c7a4095bdc2b$var$loadingFn(extensions), [
        Proto,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $4157c7a4095bdc2b$export$96f57966bedc81b4.clear = function(Proto, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $f681624d9766226e$export$42ffd38884aecdac)([
        Proto,
        ...keys
    ]);
};
const $4157c7a4095bdc2b$export$efccba1c4a2ef57b = new Map();
const { invalidate: $4157c7a4095bdc2b$export$882b5998b3b9117c, advance: $4157c7a4095bdc2b$export$953cecd6e717a553 } = $4157c7a4095bdc2b$var$createLoop($4157c7a4095bdc2b$export$efccba1c4a2ef57b);
const { reconciler: $4157c7a4095bdc2b$export$dda1d9f60106f0e9, applyProps: $4157c7a4095bdc2b$export$35e795649ee09318 } = $4157c7a4095bdc2b$var$createRenderer($4157c7a4095bdc2b$export$efccba1c4a2ef57b, $4157c7a4095bdc2b$var$getEventPriority);
const $4157c7a4095bdc2b$var$shallowLoose = {
    objects: "shallow",
    strict: false
};
const $4157c7a4095bdc2b$var$createRendererInstance = (gl, canvas)=>{
    const customRenderer = typeof gl === "function" ? gl(canvas) : gl;
    if ($4157c7a4095bdc2b$var$isRenderer(customRenderer)) return customRenderer;
    else return new $d5b33d7c30034067$export$f6cc00ef28d7cf97({
        powerPreference: "high-performance",
        canvas: canvas,
        antialias: true,
        alpha: true,
        ...gl
    });
};
function $4157c7a4095bdc2b$var$computeInitialSize(canvas, defaultSize) {
    if (defaultSize) return defaultSize;
    if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width, height: height, top: top, left: left } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left
        };
    } else if (typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $4157c7a4095bdc2b$export$8b22cf2602fb60ce(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $4157c7a4095bdc2b$export$efccba1c4a2ef57b.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn("R3F.createRoot should only be called once!");
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === "function" ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $4157c7a4095bdc2b$var$createStore($4157c7a4095bdc2b$export$882b5998b3b9117c, $4157c7a4095bdc2b$export$953cecd6e717a553);
    // Create renderer
    const fiber = prevFiber || $4157c7a4095bdc2b$export$dda1d9f60106f0e9.createContainer(store, (0, $c393f2421b1ab54b$exports.ConcurrentRoot), null, false, null, "", logRecoverableError, null);
    // Map it
    if (!prevRoot) $4157c7a4095bdc2b$export$efccba1c4a2ef57b.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let configured = false;
    let lastCamera;
    return {
        configure (props = {}) {
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events: events, onCreated: onCreatedCallback, shadows: shadows = false, linear: linear = false, flat: flat = false, legacy: legacy = false, orthographic: orthographic = false, frameloop: frameloop = "always", dpr: dpr = [
                1,
                2
            ], performance: performance1, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed: onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) state.set({
                gl: gl = $4157c7a4095bdc2b$var$createRendererInstance(glConfig, canvas)
            });
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $d5b33d7c30034067$export$8b7aaceff00bd2f()
            });
            // Set raycaster options
            const { params: params, ...options } = raycastOptions || {};
            if (!$4157c7a4095bdc2b$var$is.equ(options, raycaster, $4157c7a4095bdc2b$var$shallowLoose)) $4157c7a4095bdc2b$export$35e795649ee09318(raycaster, {
                ...options
            });
            if (!$4157c7a4095bdc2b$var$is.equ(params, raycaster.params, $4157c7a4095bdc2b$var$shallowLoose)) $4157c7a4095bdc2b$export$35e795649ee09318(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$4157c7a4095bdc2b$var$is.equ(lastCamera, cameraOptions, $4157c7a4095bdc2b$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions instanceof $d5b33d7c30034067$export$79f141de891a5fed;
                const camera = isCamera ? cameraOptions : orthographic ? new $d5b33d7c30034067$export$9ebf355ee4ed261b(0, 0, 0, 0, 0.1, 1000) : new $d5b33d7c30034067$export$74e4ae24825f68d7(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) $4157c7a4095bdc2b$export$35e795649ee09318(camera, cameraOptions);
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions instanceof $d5b33d7c30034067$export$38af1803e3442a7f) scene = sceneOptions;
                else {
                    scene = new $d5b33d7c30034067$export$38af1803e3442a7f();
                    if (sceneOptions) $4157c7a4095bdc2b$export$35e795649ee09318(scene, sceneOptions);
                }
                state.set({
                    scene: $4157c7a4095bdc2b$var$prepare(scene)
                });
            }
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === "never") return;
                    $4157c7a4095bdc2b$export$953cecd6e717a553(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $4157c7a4095bdc2b$export$882b5998b3b9117c(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener("sessionstart", handleSessionChange);
                        gl.xr.addEventListener("sessionend", handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener("sessionstart", handleSessionChange);
                        gl.xr.removeEventListener("sessionend", handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === "function") xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($4157c7a4095bdc2b$var$is.boo(shadows)) gl.shadowMap.type = $d5b33d7c30034067$export$a47c4b43a1be34f0;
                else if ($4157c7a4095bdc2b$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $d5b33d7c30034067$export$346307dbae2b7447,
                        percentage: $d5b33d7c30034067$export$5813f879eee7cd88,
                        soft: $d5b33d7c30034067$export$a47c4b43a1be34f0,
                        variance: $d5b33d7c30034067$export$896ae1ade6c829c4
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $d5b33d7c30034067$export$a47c4b43a1be34f0;
                } else if ($4157c7a4095bdc2b$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            // Safely set color management if available.
            // Avoid accessing THREE.ColorManagement to play nice with older versions
            const ColorManagement = $4157c7a4095bdc2b$var$getColorManagement();
            if (ColorManagement) {
                if ("enabled" in ColorManagement) ColorManagement.enabled = !legacy;
                else if ("legacyMode" in ColorManagement) ColorManagement.legacyMode = legacy;
            }
            // Set color space and tonemapping preferences
            const LinearEncoding = 3000;
            const sRGBEncoding = 3001;
            $4157c7a4095bdc2b$export$35e795649ee09318(gl, {
                outputEncoding: linear ? LinearEncoding : sRGBEncoding,
                toneMapping: flat ? $d5b33d7c30034067$export$9fcb6b4294603b2 : $d5b33d7c30034067$export$a0d98fe6d7e4af64
            });
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$4157c7a4095bdc2b$var$is.fun(glConfig) && !$4157c7a4095bdc2b$var$isRenderer(glConfig) && !$4157c7a4095bdc2b$var$is.equ(glConfig, gl, $4157c7a4095bdc2b$var$shallowLoose)) $4157c7a4095bdc2b$export$35e795649ee09318(gl, glConfig);
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $4157c7a4095bdc2b$var$computeInitialSize(canvas, propsSize);
            if (!$4157c7a4095bdc2b$var$is.equ(size, state.size, $4157c7a4095bdc2b$var$shallowLoose)) state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $4157c7a4095bdc2b$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance1 && !$4157c7a4095bdc2b$var$is.equ(performance1, state.performance, $4157c7a4095bdc2b$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance1
                    }
                }));
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured) this.configure();
            $4157c7a4095bdc2b$export$dda1d9f60106f0e9.updateContainer(/*#__PURE__*/ $acw62.createElement($4157c7a4095bdc2b$var$Provider, {
                store: store,
                children: children,
                onCreated: onCreated,
                rootElement: canvas
            }), fiber, null, ()=>undefined);
            return store;
        },
        unmount () {
            $4157c7a4095bdc2b$export$4368d992c4eafac0(canvas);
        }
    };
}
function $4157c7a4095bdc2b$export$43caf9889c228507(children, canvas, config) {
    console.warn("R3F.render is no longer supported in React 18. Use createRoot instead!");
    const root = $4157c7a4095bdc2b$export$8b22cf2602fb60ce(canvas);
    root.configure(config);
    return root.render(children);
}
function $4157c7a4095bdc2b$var$Provider({ store: store, children: children, onCreated: onCreated, rootElement: rootElement }) {
    $4157c7a4095bdc2b$export$407448d2b89b1813(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notifiy that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $acw62.createElement($4157c7a4095bdc2b$export$2d1720544b23b823.Provider, {
        value: store
    }, children);
}
function $4157c7a4095bdc2b$export$4368d992c4eafac0(canvas, callback) {
    const root = $4157c7a4095bdc2b$export$efccba1c4a2ef57b.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $4157c7a4095bdc2b$export$dda1d9f60106f0e9.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $4157c7a4095bdc2b$export$342063e11d6c3cad(state);
                    $4157c7a4095bdc2b$export$efccba1c4a2ef57b.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $4157c7a4095bdc2b$export$39b482c5e57630a8(children, container, state) {
    return /*#__PURE__*/ $acw62.createElement($4157c7a4095bdc2b$var$Portal, {
        key: container.uuid,
        children: children,
        container: container,
        state: state
    });
}
function $4157c7a4095bdc2b$var$Portal({ state: state = {}, children: children, container: container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events, size: size, ...rest } = state;
    const previousRoot = $4157c7a4095bdc2b$export$4a5767248b18ef41();
    const [raycaster] = $acw62.useState(()=>new $d5b33d7c30034067$export$8b7aaceff00bd2f());
    const [pointer] = $acw62.useState(()=>new $d5b33d7c30034067$export$c977b3e384af9ae1());
    const inject = $acw62.useCallback((rootState, injectState)=>{
        const intersect = {
            ...rootState
        }; // all prev state props
        // Only the fields of "rootState" that do not differ from injectState
        // Some props should be off-limits
        // Otherwise filter out the props that are different and let the inject layer take precedence
        Object.keys(rootState).forEach((key)=>{
            if (// Some props should be off-limits
            $4157c7a4095bdc2b$var$privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            rootState[key] !== injectState[key] && injectState[key]) delete intersect[key];
        });
        let viewport = undefined;
        if (injectState && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $d5b33d7c30034067$export$64b5c384219d3699(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $4157c7a4095bdc2b$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...intersect,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState == null ? void 0 : injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            ...rest
        };
    }, [
        state
    ]);
    const [usePortalStore] = $acw62.useState(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const previousState = previousRoot.getState();
        const store = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>({
                ...previousState,
                scene: container,
                raycaster: raycaster,
                pointer: pointer,
                mouse: pointer,
                previousRoot: previousRoot,
                events: {
                    ...previousState.events,
                    ...events
                },
                size: {
                    ...previousState.size,
                    ...size
                },
                ...rest,
                set: // Set and get refer to this root-state
                set,
                get: get,
                // Layers are allowed to override events
                setEvents: (events)=>set((state)=>({
                            ...state,
                            events: {
                                ...state.events,
                                ...events
                            }
                        }))
            }));
        return store;
    });
    $acw62.useEffect(()=>{
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const unsub = previousRoot.subscribe((prev)=>usePortalStore.setState((state)=>inject(prev, state)));
        return ()=>{
            unsub();
            usePortalStore.destroy();
        };
    }, []);
    $acw62.useEffect(()=>{
        usePortalStore.setState((injectState)=>inject(previousRoot.getState(), injectState));
    }, [
        inject
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, $4157c7a4095bdc2b$export$dda1d9f60106f0e9.createPortal(/*#__PURE__*/ $acw62.createElement($4157c7a4095bdc2b$export$2d1720544b23b823.Provider, {
        value: usePortalStore
    }, children), usePortalStore, null));
}
$4157c7a4095bdc2b$export$dda1d9f60106f0e9.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: "@react-three/fiber",
    version: $acw62.version
});
const $4157c7a4095bdc2b$export$90a7f3efeed30595 = $acw62.unstable_act;


// @ts-ignore
let $b13bb2a707c13142$var$dracoLoader = null;
function $b13bb2a707c13142$var$extensions(useDraco, useMeshopt, extendLoader) {
    return (loader)=>{
        if (extendLoader) extendLoader(loader);
        if (useDraco) {
            if (!$b13bb2a707c13142$var$dracoLoader) $b13bb2a707c13142$var$dracoLoader = new (0, $76ab0928a0395fd1$export$45c25de53be259ac)();
            $b13bb2a707c13142$var$dracoLoader.setDecoderPath(typeof useDraco === "string" ? useDraco : "https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
            loader.setDRACOLoader($b13bb2a707c13142$var$dracoLoader);
        }
        if (useMeshopt) loader.setMeshoptDecoder(typeof (0, $3bf52461e9095b24$export$1111800106ba519a) === "function" ? (0, $3bf52461e9095b24$export$1111800106ba519a)() : (0, $3bf52461e9095b24$export$1111800106ba519a));
    };
}
function $b13bb2a707c13142$export$cf1b4e938a4da41b(path, useDraco = true, useMeshOpt = true, extendLoader) {
    const gltf = (0, $4157c7a4095bdc2b$export$96f57966bedc81b4)((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), path, $b13bb2a707c13142$var$extensions(useDraco, useMeshOpt, extendLoader));
    return gltf;
}
$b13bb2a707c13142$export$cf1b4e938a4da41b.preload = (path, useDraco = true, useMeshOpt = true, extendLoader)=>(0, $4157c7a4095bdc2b$export$96f57966bedc81b4).preload((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), path, $b13bb2a707c13142$var$extensions(useDraco, useMeshOpt, extendLoader));
$b13bb2a707c13142$export$cf1b4e938a4da41b.clear = (input)=>(0, $4157c7a4095bdc2b$export$96f57966bedc81b4).clear((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), input);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $2LLMu = parcelRequire("2LLMu");


var $acw62 = parcelRequire("acw62");

var $54da56340462fe8a$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$54da56340462fe8a$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


const $30d3093f6e55667e$var$globalCache = [];
function $30d3093f6e55667e$var$handleAsset(fn, cache, args, lifespan = 0, preload = false) {
    for (const entry of cache)// Find a match
    if ((0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(args, entry.args)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return; // If an error occurred, throw
        if (entry.error) throw entry.error; // If a response was successful, return
        if (entry.response) return entry.response; // If the promise is still unresolved, throw
        throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        args: args,
        promise: fn(...args) // Response can't be undefined or else the loop above wouldn't be able to return it
        // This is for promises that do not return results (delays for instance)
        .then((response)=>entry.response = response != null ? response : true).catch((e)=>entry.error = e != null ? e : "unknown error").then(()=>{
            if (lifespan > 0) setTimeout(()=>{
                const index = cache.indexOf(entry);
                if (index !== -1) cache.splice(index, 1);
            }, lifespan);
        })
    };
    cache.push(entry);
    if (!preload) throw entry.promise;
}
function $30d3093f6e55667e$var$clear(cache, ...args) {
    if (args === undefined || args.length === 0) cache.splice(0, cache.length);
    else {
        const entry = cache.find((entry)=>(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(args, entry.args));
        if (entry) {
            const index = cache.indexOf(entry);
            if (index !== -1) cache.splice(index, 1);
        }
    }
}
function $30d3093f6e55667e$export$7ec372301ad780b3(fn, lifespan = 0) {
    const cache = [];
    return {
        /**
     * @throws Suspense Promise if asset is not yet ready
     * @throws Error if the promise rejected for some reason
     */ read: (...args)=>$30d3093f6e55667e$var$handleAsset(fn, cache, args, lifespan),
        preload: (...args)=>void $30d3093f6e55667e$var$handleAsset(fn, cache, args, lifespan, true),
        clear: (...args)=>$30d3093f6e55667e$var$clear(cache, ...args),
        peek: (...args)=>{
            var _cache$find;
            return (_cache$find = cache.find((entry)=>(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(args, entry.args))) == null ? void 0 : _cache$find.response;
        }
    };
}
function $30d3093f6e55667e$export$ee140a498869eaae(fn, ...args) {
    return $30d3093f6e55667e$var$handleAsset(fn, $30d3093f6e55667e$var$globalCache, args, $30d3093f6e55667e$export$ee140a498869eaae.lifespan);
}
$30d3093f6e55667e$export$ee140a498869eaae.lifespan = 0;
$30d3093f6e55667e$export$ee140a498869eaae.clear = (...args)=>$30d3093f6e55667e$var$clear($30d3093f6e55667e$var$globalCache, ...args);
$30d3093f6e55667e$export$ee140a498869eaae.preload = (fn, ...args)=>void $30d3093f6e55667e$var$handleAsset(fn, $30d3093f6e55667e$var$globalCache, args, $30d3093f6e55667e$export$ee140a498869eaae.lifespan, true);
$30d3093f6e55667e$export$ee140a498869eaae.peek = (...args)=>{
    var _globalCache$find;
    return (_globalCache$find = $30d3093f6e55667e$var$globalCache.find((entry)=>(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(args, entry.args))) == null ? void 0 : _globalCache$find.response;
};



const $58b973547927d544$export$e3a4ac9ee65ec343 = (obj, key)=>obj[key];


const $7567b49210ee5748$export$728c051ccdf8a702 = (geometries, useGroups)=>{
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
    let offset = 0;
    geometries.forEach((geom, i)=>{
        let attributesCount = 0;
        if (isIndexed !== (geom.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        for(let name in geom.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === void 0) attributes[name] = [];
            attributes[name].push(geom.attributes[name]);
            attributesCount++;
        }
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        if (morphTargetsRelative !== geom.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(let name in geom.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === void 0) morphAttributes[name] = [];
            morphAttributes[name].push(geom.morphAttributes[name]);
        }
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geom.userData);
        if (useGroups) {
            let count;
            if (geom.index) count = geom.index.count;
            else if (geom.attributes.position !== void 0) count = geom.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    });
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        geometries.forEach((geom)=>{
            const index = geom.index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geom.attributes.position.count;
        });
        mergedGeometry.setIndex(mergedIndex);
    }
    for(let name in attributes){
        const mergedAttribute = $7567b49210ee5748$export$c4eef4c1c9d34ea9(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    for(let name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $7567b49210ee5748$export$c4eef4c1c9d34ea9(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
};
const $7567b49210ee5748$export$c4eef4c1c9d34ea9 = (attributes)=>{
    let TypedArray = void 0;
    let itemSize = void 0;
    let normalized = void 0;
    let arrayLength = 0;
    attributes.forEach((attr)=>{
        if (TypedArray === void 0) TypedArray = attr.array.constructor;
        if (TypedArray !== attr.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === void 0) itemSize = attr.itemSize;
        if (itemSize !== attr.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === void 0) normalized = attr.normalized;
        if (normalized !== attr.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attr.array.length;
    });
    if (TypedArray && itemSize) {
        const array = new TypedArray(arrayLength);
        let offset = 0;
        attributes.forEach((attr)=>{
            array.set(attr.array, offset);
            offset += attr.array.length;
        });
        return new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    }
};
const $7567b49210ee5748$export$308f9509e428a845 = (attributes)=>{
    let TypedArray = void 0;
    let arrayLength = 0;
    let stride = 0;
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === void 0) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    const interleavedBuffer = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++){
            const set = (0, $58b973547927d544$export$e3a4ac9ee65ec343)(iba, setters[k]);
            const get = (0, $58b973547927d544$export$e3a4ac9ee65ec343)(attribute, getters[k]);
            set(c, get(c));
        }
    }
    return res;
};
function $7567b49210ee5748$export$35bee7999e19754d(geometry) {
    let mem = 0;
    for(let name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
function $7567b49210ee5748$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    let nextIndex = 0;
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(()=>[]);
    }
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    result.setIndex(newIndices);
    return result;
}
function $7567b49210ee5748$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $d5b33d7c30034067$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842) || drawMode === (0, $d5b33d7c30034067$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== void 0) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (index) {
            if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842)) for(let i = 1; i <= numberOfTriangles; i++){
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
            }
            else {
                for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                    newIndices.push(index.getX(i));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i + 2));
                } else {
                    newIndices.push(index.getX(i + 2));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i));
                }
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
function $7567b49210ee5748$export$29e54e2e4ab904e7(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error("THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.");
        return null;
    }
    const _vA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object2, material2, attribute, morphAttribute, morphTargetsRelative2, a2, b2, c2, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a2);
        _vB.fromBufferAttribute(attribute, b2);
        _vC.fromBufferAttribute(attribute, c2);
        const morphInfluences = object2.morphTargetInfluences;
        if (// @ts-ignore
        material2.morphTargets && morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i2 = 0, il2 = morphAttribute.length; i2 < il2; i2++){
                const influence = morphInfluences[i2];
                const morph = morphAttribute[i2];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a2);
                _tempB.fromBufferAttribute(morph, b2);
                _tempC.fromBufferAttribute(morph, c2);
                if (morphTargetsRelative2) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object2.isSkinnedMesh) {
            object2.boneTransform(a2, _vA);
            object2.boneTransform(b2, _vB);
            object2.boneTransform(c2, _vC);
        }
        modifiedAttributeArray[a2 * 3 + 0] = _vA.x;
        modifiedAttributeArray[a2 * 3 + 1] = _vA.y;
        modifiedAttributeArray[a2 * 3 + 2] = _vA.z;
        modifiedAttributeArray[b2 * 3 + 0] = _vB.x;
        modifiedAttributeArray[b2 * 3 + 1] = _vB.y;
        modifiedAttributeArray[b2 * 3 + 2] = _vB.z;
        modifiedAttributeArray[c2 * 3 + 0] = _vC.x;
        modifiedAttributeArray[c2 * 3 + 1] = _vC.y;
        modifiedAttributeArray[c2 * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group, groupMaterial;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else if (positionAttribute !== void 0) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $7567b49210ee5748$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 100;
    const verts = [
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempVec2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.toNonIndexed();
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        const normal = new (0, $d5b33d7c30034067$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}


function $4708f0499e113eb5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4708f0499e113eb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4708f0499e113eb5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4708f0499e113eb5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4708f0499e113eb5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4708f0499e113eb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $4708f0499e113eb5$var$_quaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)();
const $4708f0499e113eb5$var$_vector3 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
new (0, $d5b33d7c30034067$export$e4dd07dff30cc924)();
const $4708f0499e113eb5$var$_matrix4 = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
const $4708f0499e113eb5$var$_position = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $4708f0499e113eb5$var$_rotation = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
const $4708f0499e113eb5$var$_scale = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $4708f0499e113eb5$var$vectorArrayToVector3 = (arr)=>{
    const [x, y, z] = arr;
    return new (0, $d5b33d7c30034067$export$64b5c384219d3699)(x, y, z);
};
const $4708f0499e113eb5$var$tupleToObject = (tuple, keys)=>{
    return keys.reduce((obj, key, i)=>{
        obj[key] = tuple[i];
        return obj;
    }, {});
};
const $4708f0499e113eb5$var$rapierQuaternionToQuaternion = ({ x: x, y: y, z: z, w: w })=>$4708f0499e113eb5$var$_quaternion.set(x, y, z, w);
const $4708f0499e113eb5$var$rigidBodyTypeMap = {
    fixed: 1,
    dynamic: 0,
    kinematicPosition: 2,
    kinematicVelocity: 3
};
const $4708f0499e113eb5$var$rigidBodyTypeFromString = (type)=>$4708f0499e113eb5$var$rigidBodyTypeMap[type];
const $4708f0499e113eb5$var$scaleVertices = (vertices, scale)=>{
    const scaledVerts = Array.from(vertices);
    for(let i = 0; i < vertices.length / 3; i++){
        scaledVerts[i * 3] *= scale.x;
        scaledVerts[i * 3 + 1] *= scale.y;
        scaledVerts[i * 3 + 2] *= scale.z;
    }
    return scaledVerts;
};
const $4708f0499e113eb5$var$vectorToTuple = (v)=>{
    if (!v) return [
        0
    ];
    if (v instanceof (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)) return [
        v.x,
        v.y,
        v.z,
        v.w
    ];
    if (v instanceof (0, $d5b33d7c30034067$export$64b5c384219d3699) || v instanceof (0, $d5b33d7c30034067$export$d93cc409a0768c5f)) return [
        v.x,
        v.y,
        v.z
    ];
    if (Array.isArray(v)) return v;
    return [
        v
    ];
};
function $4708f0499e113eb5$var$useConst(initialValue) {
    const ref = (0, $acw62.useRef)();
    if (ref.current === undefined) ref.current = {
        value: typeof initialValue === "function" ? initialValue() : initialValue
    };
    return ref.current.value;
}
const $4708f0499e113eb5$var$useRaf = (callback)=>{
    const cb = (0, $acw62.useRef)(callback);
    const raf = (0, $acw62.useRef)(0);
    const lastFrame = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        cb.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        const loop = ()=>{
            const now = performance.now();
            const delta = now - lastFrame.current;
            raf.current = requestAnimationFrame(loop);
            cb.current(delta / 1000);
            lastFrame.current = now;
        };
        raf.current = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(raf.current);
    }, []);
};
const $4708f0499e113eb5$var$UseFrameStepper = ({ onStep: onStep, updatePriority: updatePriority })=>{
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)((_, dt)=>{
        onStep(dt);
    }, updatePriority);
    return null;
};
const $4708f0499e113eb5$var$RafStepper = ({ onStep: onStep })=>{
    $4708f0499e113eb5$var$useRaf((dt)=>{
        onStep(dt);
    });
    return null;
};
const $4708f0499e113eb5$var$FrameStepper = ({ onStep: onStep, type: type, updatePriority: updatePriority })=>{
    return type === "independent" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$RafStepper, {
        onStep: onStep
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$UseFrameStepper, {
        onStep: onStep,
        updatePriority: updatePriority
    });
};
var $4708f0499e113eb5$var$FrameStepper$1 = /*#__PURE__*/ (0, $acw62.memo)($4708f0499e113eb5$var$FrameStepper);
function $4708f0499e113eb5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4708f0499e113eb5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4708f0499e113eb5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $4708f0499e113eb5$var$_excluded$2 = [
    "mass",
    "linearDamping",
    "angularDamping",
    "type",
    "onCollisionEnter",
    "onCollisionExit",
    "onIntersectionEnter",
    "onIntersectionExit",
    "onContactForce",
    "children",
    "canSleep",
    "ccd",
    "gravityScale"
];
const $4708f0499e113eb5$var$scaleColliderArgs = (shape, args, scale)=>{
    const newArgs = args.slice(); // Heightfield uses a vector
    if (shape === "heightfield") {
        const s = newArgs[3];
        s.x *= scale.x;
        s.x *= scale.y;
        s.x *= scale.z;
        return newArgs;
    } // Trimesh and convex scale the vertices
    if (shape === "trimesh" || shape === "convexHull") {
        newArgs[0] = $4708f0499e113eb5$var$scaleVertices(newArgs[0], scale);
        return newArgs;
    } // Prepfill with some extra
    const scaleArray = [
        scale.x,
        scale.y,
        scale.z,
        scale.x,
        scale.x
    ];
    return newArgs.map((arg, index)=>scaleArray[index] * arg);
};
const $4708f0499e113eb5$var$createColliderFromOptions = (options, world, scale, getRigidBody)=>{
    const scaledArgs = $4708f0499e113eb5$var$scaleColliderArgs(options.shape, options.args, scale); // @ts-ignore
    const desc = (0, $2LLMu.ColliderDesc)[options.shape](...scaledArgs);
    return world.createCollider(desc, getRigidBody === null || getRigidBody === void 0 ? void 0 : getRigidBody());
};
const $4708f0499e113eb5$var$immutableColliderOptions = [
    "shape",
    "args"
];
const $4708f0499e113eb5$var$massPropertiesConflictError = "Please pick ONLY ONE of the `density`, `mass` and `massProperties` options.";
const $4708f0499e113eb5$var$setColliderMassOptions = (collider, options)=>{
    if (options.density !== undefined) {
        if (options.mass !== undefined || options.massProperties !== undefined) throw new Error($4708f0499e113eb5$var$massPropertiesConflictError);
        collider.setDensity(options.density);
        return;
    }
    if (options.mass !== undefined) {
        if (options.massProperties !== undefined) throw new Error($4708f0499e113eb5$var$massPropertiesConflictError);
        collider.setMass(options.mass);
        return;
    }
    if (options.massProperties !== undefined) collider.setMassProperties(options.massProperties.mass, options.massProperties.centerOfMass, options.massProperties.principalAngularInertia, options.massProperties.angularInertiaLocalFrame);
};
const $4708f0499e113eb5$var$mutableColliderOptions = {
    sensor: (collider, value)=>{
        collider.setSensor(value);
    },
    collisionGroups: (collider, value)=>{
        collider.setCollisionGroups(value);
    },
    solverGroups: (collider, value)=>{
        collider.setSolverGroups(value);
    },
    friction: (collider, value)=>{
        collider.setFriction(value);
    },
    frictionCombineRule: (collider, value)=>{
        collider.setFrictionCombineRule(value);
    },
    restitution: (collider, value)=>{
        collider.setRestitution(value);
    },
    restitutionCombineRule: (collider, value)=>{
        collider.setRestitutionCombineRule(value);
    },
    // To make sure the options all mutable options are listed
    quaternion: ()=>{},
    position: ()=>{},
    rotation: ()=>{},
    scale: ()=>{}
};
const $4708f0499e113eb5$var$mutableColliderOptionKeys = Object.keys($4708f0499e113eb5$var$mutableColliderOptions);
const $4708f0499e113eb5$var$setColliderOptions = (collider, options, states)=>{
    const state = states.get(collider.handle);
    if (state) {
        var _state$worldParent;
        // Update collider position based on the object's position
        const parentWorldScale = state.object.parent.getWorldScale($4708f0499e113eb5$var$_vector3);
        const parentInvertedWorldMatrix = (_state$worldParent = state.worldParent) === null || _state$worldParent === void 0 ? void 0 : _state$worldParent.matrixWorld.clone().invert();
        state.object.updateWorldMatrix(true, false);
        $4708f0499e113eb5$var$_matrix4.copy(state.object.matrixWorld);
        if (parentInvertedWorldMatrix) $4708f0499e113eb5$var$_matrix4.premultiply(parentInvertedWorldMatrix);
        $4708f0499e113eb5$var$_matrix4.decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
        if (collider.parent()) {
            collider.setTranslationWrtParent({
                x: $4708f0499e113eb5$var$_position.x * parentWorldScale.x,
                y: $4708f0499e113eb5$var$_position.y * parentWorldScale.y,
                z: $4708f0499e113eb5$var$_position.z * parentWorldScale.z
            });
            collider.setRotationWrtParent($4708f0499e113eb5$var$_rotation);
        } else {
            collider.setTranslation({
                x: $4708f0499e113eb5$var$_position.x * parentWorldScale.x,
                y: $4708f0499e113eb5$var$_position.y * parentWorldScale.y,
                z: $4708f0499e113eb5$var$_position.z * parentWorldScale.z
            });
            collider.setRotation($4708f0499e113eb5$var$_rotation);
        }
        $4708f0499e113eb5$var$mutableColliderOptionKeys.forEach((key)=>{
            if (key in options) {
                const option = options[key];
                $4708f0499e113eb5$var$mutableColliderOptions[key](collider, option, options);
            }
        }); // handle mass separately, because the assignments
        // are exclusive.
        $4708f0499e113eb5$var$setColliderMassOptions(collider, options);
    }
};
const $4708f0499e113eb5$var$useUpdateColliderOptions = (getCollider, props, states)=>{
    // TODO: Improve this, split each prop into its own effect
    const mutablePropsAsFlatArray = (0, $acw62.useMemo)(()=>$4708f0499e113eb5$var$mutableColliderOptionKeys.flatMap((key)=>{
            return $4708f0499e113eb5$var$vectorToTuple(props[key]);
        }), [
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        const collider = getCollider();
        $4708f0499e113eb5$var$setColliderOptions(collider, props, states);
    }, [
        ...mutablePropsAsFlatArray,
        getCollider
    ]);
};
const $4708f0499e113eb5$var$isChildOfMeshCollider = (child)=>{
    let flag = false;
    child.traverseAncestors((a)=>{
        if (a.userData.r3RapierType === "MeshCollider") flag = true;
    });
    return flag;
};
const $4708f0499e113eb5$var$createColliderState = (collider, object, rigidBodyObject)=>{
    return {
        collider: collider,
        worldParent: rigidBodyObject || undefined,
        object: object
    };
};
const $4708f0499e113eb5$var$autoColliderMap = {
    cuboid: "cuboid",
    ball: "ball",
    hull: "convexHull",
    trimesh: "trimesh"
};
const $4708f0499e113eb5$var$createColliderPropsFromChildren = ({ object: object, ignoreMeshColliders: _ignoreMeshColliders = true, options: options })=>{
    const childColliderProps = [];
    object.updateWorldMatrix(true, false);
    const invertedParentMatrixWorld = object.matrixWorld.clone().invert();
    const colliderFromChild = (child)=>{
        if ("isMesh" in child) {
            if (_ignoreMeshColliders && $4708f0499e113eb5$var$isChildOfMeshCollider(child)) return;
            const worldScale = child.getWorldScale($4708f0499e113eb5$var$_scale);
            const shape = $4708f0499e113eb5$var$autoColliderMap[options.colliders || "cuboid"];
            child.updateWorldMatrix(true, false);
            $4708f0499e113eb5$var$_matrix4.copy(child.matrixWorld).premultiply(invertedParentMatrixWorld).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            const rotationEuler = new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)().setFromQuaternion($4708f0499e113eb5$var$_rotation, "XYZ");
            const { geometry: geometry } = child;
            const { args: args, offset: offset } = $4708f0499e113eb5$var$getColliderArgsFromGeometry(geometry, options.colliders || "cuboid");
            const colliderProps = $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider(options)), {}, {
                args: args,
                shape: shape,
                rotation: [
                    rotationEuler.x,
                    rotationEuler.y,
                    rotationEuler.z
                ],
                position: [
                    $4708f0499e113eb5$var$_position.x + offset.x * worldScale.x,
                    $4708f0499e113eb5$var$_position.y + offset.y * worldScale.y,
                    $4708f0499e113eb5$var$_position.z + offset.z * worldScale.z
                ],
                scale: [
                    worldScale.x,
                    worldScale.y,
                    worldScale.z
                ]
            });
            childColliderProps.push(colliderProps);
        }
    };
    if (options.includeInvisible) object.traverse(colliderFromChild);
    else object.traverseVisible(colliderFromChild);
    return childColliderProps;
};
const $4708f0499e113eb5$var$getColliderArgsFromGeometry = (geometry, colliders)=>{
    switch(colliders){
        case "cuboid":
            {
                geometry.computeBoundingBox();
                const { boundingBox: boundingBox } = geometry;
                const size = boundingBox.getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
                return {
                    args: [
                        size.x / 2,
                        size.y / 2,
                        size.z / 2
                    ],
                    offset: boundingBox.getCenter(new (0, $d5b33d7c30034067$export$64b5c384219d3699)())
                };
            }
        case "ball":
            {
                geometry.computeBoundingSphere();
                const { boundingSphere: boundingSphere } = geometry;
                const radius = boundingSphere.radius;
                return {
                    args: [
                        radius
                    ],
                    offset: boundingSphere.center
                };
            }
        case "trimesh":
            {
                var _clonedGeometry$index;
                const clonedGeometry = geometry.index ? geometry.clone() : (0, $7567b49210ee5748$export$e36bb98c4c944f9)(geometry);
                return {
                    args: [
                        clonedGeometry.attributes.position.array,
                        (_clonedGeometry$index = clonedGeometry.index) === null || _clonedGeometry$index === void 0 ? void 0 : _clonedGeometry$index.array
                    ],
                    offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
                };
            }
        case "hull":
            {
                const g = geometry.clone();
                return {
                    args: [
                        g.attributes.position.array
                    ],
                    offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
                };
            }
    }
    return {
        args: [],
        offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    };
};
const $4708f0499e113eb5$var$getActiveCollisionEventsFromProps = (props)=>{
    return {
        collision: !!(props !== null && props !== void 0 && props.onCollisionEnter || props !== null && props !== void 0 && props.onCollisionExit || props !== null && props !== void 0 && props.onIntersectionEnter || props !== null && props !== void 0 && props.onIntersectionExit),
        contactForce: !!(props !== null && props !== void 0 && props.onContactForce)
    };
};
const $4708f0499e113eb5$var$useColliderEvents = (getCollider, props, events, /**
 * The RigidBody can pass down active events to the collider without attaching the event listners
 */ activeEvents = {})=>{
    const { onCollisionEnter: onCollisionEnter, onCollisionExit: onCollisionExit, onIntersectionEnter: onIntersectionEnter, onIntersectionExit: onIntersectionExit, onContactForce: onContactForce } = props;
    (0, $acw62.useEffect)(()=>{
        const collider = getCollider();
        if (collider) {
            const { collision: collisionEventsActive, contactForce: contactForceEventsActive } = $4708f0499e113eb5$var$getActiveCollisionEventsFromProps(props);
            const hasCollisionEvent = collisionEventsActive || activeEvents.collision;
            const hasContactForceEvent = contactForceEventsActive || activeEvents.contactForce;
            if (hasCollisionEvent && hasContactForceEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).COLLISION_EVENTS | (0, $2LLMu.ActiveEvents).CONTACT_FORCE_EVENTS);
            else if (hasCollisionEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).COLLISION_EVENTS);
            else if (hasContactForceEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).CONTACT_FORCE_EVENTS);
            events.set(collider.handle, {
                onCollisionEnter: onCollisionEnter,
                onCollisionExit: onCollisionExit,
                onIntersectionEnter: onIntersectionEnter,
                onIntersectionExit: onIntersectionExit,
                onContactForce: onContactForce
            });
        }
        return ()=>{
            if (collider) events.delete(collider.handle);
        };
    }, [
        onCollisionEnter,
        onCollisionExit,
        onIntersectionEnter,
        onIntersectionExit,
        onContactForce,
        activeEvents
    ]);
};
const $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider = (props = {})=>{
    const rest = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded$2);
    return rest;
};
const $4708f0499e113eb5$var$useMutableCallback = (fn)=>{
    const ref = (0, $acw62.useRef)(fn);
    (0, $acw62.useEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return ref;
}; // External hooks
/**
 * Exposes the Rapier context, and world
 * @category Hooks
 */ const $4708f0499e113eb5$export$8dc89b465b2c50d = ()=>{
    return (0, $acw62.useContext)($4708f0499e113eb5$var$rapierContext);
};
/**
 * Registers a callback to be called before the physics step
 * @category Hooks
 */ const $4708f0499e113eb5$export$71d8a22eb566a518 = (callback)=>{
    const { beforeStepCallbacks: beforeStepCallbacks } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = $4708f0499e113eb5$var$useMutableCallback(callback);
    (0, $acw62.useEffect)(()=>{
        beforeStepCallbacks.add(ref);
        return ()=>{
            beforeStepCallbacks.delete(ref);
        };
    }, []);
};
/**
 * Registers a callback to be called after the physics step
 * @category Hooks
 */ const $4708f0499e113eb5$export$80bbb447550971ab = (callback)=>{
    const { afterStepCallbacks: afterStepCallbacks } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = $4708f0499e113eb5$var$useMutableCallback(callback);
    (0, $acw62.useEffect)(()=>{
        afterStepCallbacks.add(ref);
        return ()=>{
            afterStepCallbacks.delete(ref);
        };
    }, []);
}; // Internal hooks
/**
 * @internal
 */ const $4708f0499e113eb5$var$useChildColliderProps = (ref, options, ignoreMeshColliders = true)=>{
    const [colliderProps, setColliderProps] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const object = ref.current;
        if (object && options.colliders !== false) setColliderProps($4708f0499e113eb5$var$createColliderPropsFromChildren({
            object: ref.current,
            options: options,
            ignoreMeshColliders: ignoreMeshColliders
        }));
    }, [
        options.colliders
    ]);
    return colliderProps;
};
const $4708f0499e113eb5$var$Debug = /*#__PURE__*/ (0, $acw62.memo)(()=>{
    const { world: world } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = (0, $acw62.useRef)(null);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        const mesh = ref.current;
        if (!mesh) return;
        const buffers = world.debugRender();
        mesh.geometry.setAttribute("position", new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffers.vertices, 3));
        mesh.geometry.setAttribute("color", new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffers.colors, 4));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("group", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("lineSegments", {
        ref: ref,
        frustumCulled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("lineBasicMaterial", {
        color: 0xffffff,
        vertexColors: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bufferGeometry", null)));
});
/**
 * Creates a proxy that will create a singleton instance of the given class
 * when a property is accessed, and not before.
 *
 * @returns A proxy and a reset function, so that the instance can created again
 */ const $4708f0499e113eb5$var$createSingletonProxy = (createInstance)=>{
    let instance;
    const handler = {
        get (target, prop) {
            if (!instance) instance = createInstance();
            return Reflect.get(instance, prop);
        },
        set (target, prop, value) {
            if (!instance) instance = createInstance();
            return Reflect.set(instance, prop, value);
        }
    };
    const proxy = new Proxy({}, handler);
    const reset = ()=>{
        instance = undefined;
    };
    /**
   * Return the proxy and a reset function
   */ return {
        proxy: proxy,
        reset: reset
    };
};
const $4708f0499e113eb5$var$rapierContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $4708f0499e113eb5$var$getCollisionPayloadFromSource = (target, other)=>{
    var _target$collider$stat, _target$rigidBody$sta, _other$collider$state, _other$rigidBody$stat, _other$collider$state2, _other$rigidBody$stat2;
    return {
        target: {
            rigidBody: target.rigidBody.object,
            collider: target.collider.object,
            colliderObject: (_target$collider$stat = target.collider.state) === null || _target$collider$stat === void 0 ? void 0 : _target$collider$stat.object,
            rigidBodyObject: (_target$rigidBody$sta = target.rigidBody.state) === null || _target$rigidBody$sta === void 0 ? void 0 : _target$rigidBody$sta.object
        },
        other: {
            rigidBody: other.rigidBody.object,
            collider: other.collider.object,
            colliderObject: (_other$collider$state = other.collider.state) === null || _other$collider$state === void 0 ? void 0 : _other$collider$state.object,
            rigidBodyObject: (_other$rigidBody$stat = other.rigidBody.state) === null || _other$rigidBody$stat === void 0 ? void 0 : _other$rigidBody$stat.object
        },
        rigidBody: other.rigidBody.object,
        collider: other.collider.object,
        colliderObject: (_other$collider$state2 = other.collider.state) === null || _other$collider$state2 === void 0 ? void 0 : _other$collider$state2.object,
        rigidBodyObject: (_other$rigidBody$stat2 = other.rigidBody.state) === null || _other$rigidBody$stat2 === void 0 ? void 0 : _other$rigidBody$stat2.object
    };
};

const $4708f0499e113eb5$var$importRapier = async ()=>{
    let r = await Promise.resolve((parcelRequire("2LLMu")));
    await r.init();
    return r;
};
/**
 * The main physics component used to create a physics world.
 * @category Components
 */ const $4708f0499e113eb5$export$2f09efa5b67124a7 = (props)=>{
    const { colliders: colliders = "cuboid", children: children, timeStep: timeStep = 1 / 60, paused: paused = false, interpolate: interpolate = true, updatePriority: updatePriority, updateLoop: updateLoop = "follow", debug: debug = false, gravity: gravity = [
        0,
        -9.81,
        0
    ], maxStabilizationIterations: maxStabilizationIterations = 1, maxVelocityFrictionIterations: maxVelocityFrictionIterations = 8, maxVelocityIterations: maxVelocityIterations = 4, predictionDistance: predictionDistance = 0.002, erp: erp = 0.8 } = props;
    const rapier = (0, $30d3093f6e55667e$export$ee140a498869eaae)($4708f0499e113eb5$var$importRapier);
    const { invalidate: invalidate } = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)();
    const rigidBodyStates = $4708f0499e113eb5$var$useConst(()=>new Map());
    const colliderStates = $4708f0499e113eb5$var$useConst(()=>new Map());
    const rigidBodyEvents = $4708f0499e113eb5$var$useConst(()=>new Map());
    const colliderEvents = $4708f0499e113eb5$var$useConst(()=>new Map());
    const eventQueue = $4708f0499e113eb5$var$useConst(()=>new (0, $2LLMu.EventQueue)(false));
    const beforeStepCallbacks = $4708f0499e113eb5$var$useConst(()=>new Set());
    const afterStepCallbacks = $4708f0499e113eb5$var$useConst(()=>new Set());
    /**
   * Initiate the world
   * This creates a singleton proxy, so that the world is only created when
   * something within it is accessed.
   */ const { proxy: worldProxy, reset: resetWorldProxy } = $4708f0499e113eb5$var$useConst(()=>$4708f0499e113eb5$var$createSingletonProxy(()=>new rapier.World($4708f0499e113eb5$var$vectorArrayToVector3(gravity))));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            worldProxy.free();
            resetWorldProxy();
        };
    }, []); // Update mutable props
    (0, $acw62.useEffect)(()=>{
        worldProxy.gravity = $4708f0499e113eb5$var$vectorArrayToVector3(gravity);
        worldProxy.integrationParameters.maxStabilizationIterations = maxStabilizationIterations;
        worldProxy.integrationParameters.maxVelocityFrictionIterations = maxVelocityFrictionIterations;
        worldProxy.integrationParameters.maxVelocityIterations = maxVelocityIterations;
        worldProxy.integrationParameters.predictionDistance = predictionDistance;
        worldProxy.integrationParameters.erp = erp;
    }, [
        worldProxy,
        ...gravity,
        maxStabilizationIterations,
        maxVelocityIterations,
        maxVelocityFrictionIterations,
        predictionDistance,
        erp
    ]);
    const getSourceFromColliderHandle = (0, $acw62.useCallback)((handle)=>{
        var _collider$parent;
        const collider = worldProxy.getCollider(handle);
        const colEvents = colliderEvents.get(handle);
        const colliderState = colliderStates.get(handle);
        const rigidBodyHandle = collider === null || collider === void 0 ? void 0 : (_collider$parent = collider.parent()) === null || _collider$parent === void 0 ? void 0 : _collider$parent.handle;
        const rigidBody = rigidBodyHandle !== undefined ? worldProxy.getRigidBody(rigidBodyHandle) : undefined;
        const rbEvents = rigidBody && rigidBodyHandle !== undefined ? rigidBodyEvents.get(rigidBodyHandle) : undefined;
        const rigidBodyState = rigidBodyHandle !== undefined ? rigidBodyStates.get(rigidBodyHandle) : undefined;
        const source = {
            collider: {
                object: collider,
                events: colEvents,
                state: colliderState
            },
            rigidBody: {
                object: rigidBody,
                events: rbEvents,
                state: rigidBodyState
            }
        };
        return source;
    }, []);
    const [steppingState] = (0, $acw62.useState)({
        previousState: {},
        accumulator: 0
    });
    const step = (0, $acw62.useCallback)((dt)=>{
        const world = worldProxy;
        /* Check if the timestep is supposed to be variable. We'll do this here
      once so we don't have to string-check every frame. */ const timeStepVariable = timeStep === "vary";
        /**
     * Fixed timeStep simulation progression
     * @see https://gafferongames.com/post/fix_your_timestep/
     */ const clampedDelta = (0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).clamp(dt, 0, 0.5);
        const stepWorld = (delta)=>{
            // Trigger beforeStep callbacks
            beforeStepCallbacks.forEach((callback)=>{
                callback.current(world);
            });
            world.timestep = delta;
            world.step(eventQueue); // Trigger afterStep callbacks
            afterStepCallbacks.forEach((callback)=>{
                callback.current(world);
            });
        };
        if (timeStepVariable) stepWorld(clampedDelta);
        else {
            // don't step time forwards if paused
            // Increase accumulator
            steppingState.accumulator += clampedDelta;
            while(steppingState.accumulator >= timeStep){
                // Set up previous state
                // needed for accurate interpolations if the world steps more than once
                if (interpolate) {
                    steppingState.previousState = {};
                    world.forEachRigidBody((body)=>{
                        steppingState.previousState[body.handle] = {
                            position: body.translation(),
                            rotation: body.rotation()
                        };
                    });
                }
                stepWorld(timeStep);
                steppingState.accumulator -= timeStep;
            }
        }
        const interpolationAlpha = timeStepVariable || !interpolate || paused ? 1 : steppingState.accumulator / timeStep; // Update meshes
        rigidBodyStates.forEach((state, handle)=>{
            const rigidBody = world.getRigidBody(handle);
            const events = rigidBodyEvents.get(handle);
            if (events !== null && events !== void 0 && events.onSleep || events !== null && events !== void 0 && events.onWake) {
                if (rigidBody.isSleeping() && !state.isSleeping) {
                    var _events$onSleep;
                    events === null || events === void 0 || (_events$onSleep = events.onSleep) === null || _events$onSleep === void 0 || _events$onSleep.call(events);
                }
                if (!rigidBody.isSleeping() && state.isSleeping) {
                    var _events$onWake;
                    events === null || events === void 0 || (_events$onWake = events.onWake) === null || _events$onWake === void 0 || _events$onWake.call(events);
                }
                state.isSleeping = rigidBody.isSleeping();
            }
            if (!rigidBody || rigidBody.isSleeping() && !("isInstancedMesh" in state.object) || !state.setMatrix) return;
             // New states
            let t = rigidBody.translation();
            let r = rigidBody.rotation();
            let previousState = steppingState.previousState[handle];
            if (previousState) {
                // Get previous simulated world position
                $4708f0499e113eb5$var$_matrix4.compose(previousState.position, $4708f0499e113eb5$var$rapierQuaternionToQuaternion(previousState.rotation), state.scale).premultiply(state.invertedWorldMatrix).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale); // Apply previous tick position
                if (state.meshType == "mesh") {
                    state.object.position.copy($4708f0499e113eb5$var$_position);
                    state.object.quaternion.copy($4708f0499e113eb5$var$_rotation);
                }
            } // Get new position
            $4708f0499e113eb5$var$_matrix4.compose(t, $4708f0499e113eb5$var$rapierQuaternionToQuaternion(r), state.scale).premultiply(state.invertedWorldMatrix).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            if (state.meshType == "instancedMesh") state.setMatrix($4708f0499e113eb5$var$_matrix4);
            else {
                // Interpolate to new position
                state.object.position.lerp($4708f0499e113eb5$var$_position, interpolationAlpha);
                state.object.quaternion.slerp($4708f0499e113eb5$var$_rotation, interpolationAlpha);
            }
        });
        eventQueue.drainCollisionEvents((handle1, handle2, started)=>{
            const source1 = getSourceFromColliderHandle(handle1);
            const source2 = getSourceFromColliderHandle(handle2); // Collision Events
            if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) return;
            const collisionPayload1 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source1, source2);
            const collisionPayload2 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source2, source1);
            if (started) world.contactPair(source1.collider.object, source2.collider.object, (manifold, flipped)=>{
                var _source1$rigidBody$ev, _source1$rigidBody$ev2, _source2$rigidBody$ev, _source2$rigidBody$ev2, _source1$collider$eve, _source1$collider$eve2, _source2$collider$eve, _source2$collider$eve2;
                /* RigidBody events */ (_source1$rigidBody$ev = source1.rigidBody.events) === null || _source1$rigidBody$ev === void 0 || (_source1$rigidBody$ev2 = _source1$rigidBody$ev.onCollisionEnter) === null || _source1$rigidBody$ev2 === void 0 || _source1$rigidBody$ev2.call(_source1$rigidBody$ev, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                (_source2$rigidBody$ev = source2.rigidBody.events) === null || _source2$rigidBody$ev === void 0 || (_source2$rigidBody$ev2 = _source2$rigidBody$ev.onCollisionEnter) === null || _source2$rigidBody$ev2 === void 0 || _source2$rigidBody$ev2.call(_source2$rigidBody$ev, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                /* Collider events */ (_source1$collider$eve = source1.collider.events) === null || _source1$collider$eve === void 0 || (_source1$collider$eve2 = _source1$collider$eve.onCollisionEnter) === null || _source1$collider$eve2 === void 0 || _source1$collider$eve2.call(_source1$collider$eve, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                (_source2$collider$eve = source2.collider.events) === null || _source2$collider$eve === void 0 || (_source2$collider$eve2 = _source2$collider$eve.onCollisionEnter) === null || _source2$collider$eve2 === void 0 || _source2$collider$eve2.call(_source2$collider$eve, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
            });
            else {
                var _source1$rigidBody$ev3, _source1$rigidBody$ev4, _source2$rigidBody$ev3, _source2$rigidBody$ev4, _source1$collider$eve3, _source1$collider$eve4, _source2$collider$eve3, _source2$collider$eve4;
                (_source1$rigidBody$ev3 = source1.rigidBody.events) === null || _source1$rigidBody$ev3 === void 0 || (_source1$rigidBody$ev4 = _source1$rigidBody$ev3.onCollisionExit) === null || _source1$rigidBody$ev4 === void 0 || _source1$rigidBody$ev4.call(_source1$rigidBody$ev3, collisionPayload1);
                (_source2$rigidBody$ev3 = source2.rigidBody.events) === null || _source2$rigidBody$ev3 === void 0 || (_source2$rigidBody$ev4 = _source2$rigidBody$ev3.onCollisionExit) === null || _source2$rigidBody$ev4 === void 0 || _source2$rigidBody$ev4.call(_source2$rigidBody$ev3, collisionPayload2);
                (_source1$collider$eve3 = source1.collider.events) === null || _source1$collider$eve3 === void 0 || (_source1$collider$eve4 = _source1$collider$eve3.onCollisionExit) === null || _source1$collider$eve4 === void 0 || _source1$collider$eve4.call(_source1$collider$eve3, collisionPayload1);
                (_source2$collider$eve3 = source2.collider.events) === null || _source2$collider$eve3 === void 0 || (_source2$collider$eve4 = _source2$collider$eve3.onCollisionExit) === null || _source2$collider$eve4 === void 0 || _source2$collider$eve4.call(_source2$collider$eve3, collisionPayload2);
            } // Sensor Intersections
            if (started) {
                if (world.intersectionPair(source1.collider.object, source2.collider.object)) {
                    var _source1$rigidBody$ev5, _source1$rigidBody$ev6, _source2$rigidBody$ev5, _source2$rigidBody$ev6, _source1$collider$eve5, _source1$collider$eve6, _source2$collider$eve5, _source2$collider$eve6;
                    (_source1$rigidBody$ev5 = source1.rigidBody.events) === null || _source1$rigidBody$ev5 === void 0 || (_source1$rigidBody$ev6 = _source1$rigidBody$ev5.onIntersectionEnter) === null || _source1$rigidBody$ev6 === void 0 || _source1$rigidBody$ev6.call(_source1$rigidBody$ev5, collisionPayload1);
                    (_source2$rigidBody$ev5 = source2.rigidBody.events) === null || _source2$rigidBody$ev5 === void 0 || (_source2$rigidBody$ev6 = _source2$rigidBody$ev5.onIntersectionEnter) === null || _source2$rigidBody$ev6 === void 0 || _source2$rigidBody$ev6.call(_source2$rigidBody$ev5, collisionPayload2);
                    (_source1$collider$eve5 = source1.collider.events) === null || _source1$collider$eve5 === void 0 || (_source1$collider$eve6 = _source1$collider$eve5.onIntersectionEnter) === null || _source1$collider$eve6 === void 0 || _source1$collider$eve6.call(_source1$collider$eve5, collisionPayload1);
                    (_source2$collider$eve5 = source2.collider.events) === null || _source2$collider$eve5 === void 0 || (_source2$collider$eve6 = _source2$collider$eve5.onIntersectionEnter) === null || _source2$collider$eve6 === void 0 || _source2$collider$eve6.call(_source2$collider$eve5, collisionPayload2);
                }
            } else {
                var _source1$rigidBody$ev7, _source1$rigidBody$ev8, _source2$rigidBody$ev7, _source2$rigidBody$ev8, _source1$collider$eve7, _source1$collider$eve8, _source2$collider$eve7, _source2$collider$eve8;
                (_source1$rigidBody$ev7 = source1.rigidBody.events) === null || _source1$rigidBody$ev7 === void 0 || (_source1$rigidBody$ev8 = _source1$rigidBody$ev7.onIntersectionExit) === null || _source1$rigidBody$ev8 === void 0 || _source1$rigidBody$ev8.call(_source1$rigidBody$ev7, collisionPayload1);
                (_source2$rigidBody$ev7 = source2.rigidBody.events) === null || _source2$rigidBody$ev7 === void 0 || (_source2$rigidBody$ev8 = _source2$rigidBody$ev7.onIntersectionExit) === null || _source2$rigidBody$ev8 === void 0 || _source2$rigidBody$ev8.call(_source2$rigidBody$ev7, collisionPayload2);
                (_source1$collider$eve7 = source1.collider.events) === null || _source1$collider$eve7 === void 0 || (_source1$collider$eve8 = _source1$collider$eve7.onIntersectionExit) === null || _source1$collider$eve8 === void 0 || _source1$collider$eve8.call(_source1$collider$eve7, collisionPayload1);
                (_source2$collider$eve7 = source2.collider.events) === null || _source2$collider$eve7 === void 0 || (_source2$collider$eve8 = _source2$collider$eve7.onIntersectionExit) === null || _source2$collider$eve8 === void 0 || _source2$collider$eve8.call(_source2$collider$eve7, collisionPayload2);
            }
        });
        eventQueue.drainContactForceEvents((event)=>{
            var _source1$rigidBody$ev9, _source1$rigidBody$ev10, _source2$rigidBody$ev9, _source2$rigidBody$ev10, _source1$collider$eve9, _source1$collider$eve10, _source2$collider$eve9, _source2$collider$eve10;
            const source1 = getSourceFromColliderHandle(event.collider1());
            const source2 = getSourceFromColliderHandle(event.collider2()); // Collision Events
            if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) return;
            const collisionPayload1 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source1, source2);
            const collisionPayload2 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source2, source1);
            (_source1$rigidBody$ev9 = source1.rigidBody.events) === null || _source1$rigidBody$ev9 === void 0 || (_source1$rigidBody$ev10 = _source1$rigidBody$ev9.onContactForce) === null || _source1$rigidBody$ev10 === void 0 || _source1$rigidBody$ev10.call(_source1$rigidBody$ev9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source2$rigidBody$ev9 = source2.rigidBody.events) === null || _source2$rigidBody$ev9 === void 0 || (_source2$rigidBody$ev10 = _source2$rigidBody$ev9.onContactForce) === null || _source2$rigidBody$ev10 === void 0 || _source2$rigidBody$ev10.call(_source2$rigidBody$ev9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source1$collider$eve9 = source1.collider.events) === null || _source1$collider$eve9 === void 0 || (_source1$collider$eve10 = _source1$collider$eve9.onContactForce) === null || _source1$collider$eve10 === void 0 || _source1$collider$eve10.call(_source1$collider$eve9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source2$collider$eve9 = source2.collider.events) === null || _source2$collider$eve9 === void 0 || (_source2$collider$eve10 = _source2$collider$eve9.onContactForce) === null || _source2$collider$eve10 === void 0 || _source2$collider$eve10.call(_source2$collider$eve9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
        });
        world.forEachActiveRigidBody(()=>{
            invalidate();
        });
    }, [
        paused,
        timeStep,
        interpolate,
        worldProxy
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            rapier: rapier,
            world: worldProxy,
            physicsOptions: {
                colliders: colliders,
                gravity: gravity
            },
            rigidBodyStates: rigidBodyStates,
            colliderStates: colliderStates,
            rigidBodyEvents: rigidBodyEvents,
            colliderEvents: colliderEvents,
            beforeStepCallbacks: beforeStepCallbacks,
            afterStepCallbacks: afterStepCallbacks,
            isPaused: paused,
            isDebug: debug,
            step: step
        }), [
        paused,
        step,
        debug,
        colliders,
        gravity
    ]);
    const stepCallback = (0, $acw62.useCallback)((delta)=>{
        if (!paused) step(delta);
    }, [
        paused,
        step
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$rapierContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$FrameStepper$1, {
        onStep: stepCallback,
        type: updateLoop,
        updatePriority: updatePriority
    }), debug && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$Debug, null), children);
};
function $4708f0499e113eb5$var$_extends() {
    $4708f0499e113eb5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4708f0499e113eb5$var$_extends.apply(this, arguments);
}
/**
 * Initiate an instance and return a safe getter
 */ const $4708f0499e113eb5$var$useImperativeInstance = (createFn, destroyFn, dependencyList)=>{
    const ref = (0, $acw62.useRef)();
    const getInstance = (0, $acw62.useCallback)(()=>{
        if (!ref.current) ref.current = createFn();
        return ref.current;
    }, dependencyList);
    (0, $acw62.useEffect)(()=>{
        // Save the destroy function and instance
        const instance = getInstance();
        const destroy = ()=>destroyFn(instance);
        return ()=>{
            destroy();
            ref.current = undefined;
        };
    }, [
        getInstance
    ]);
    return getInstance;
};
/**
 * Takes an object resembling a Vector3 and returs a Three.Vector3
 * @category Math helpers
 */ const $4708f0499e113eb5$export$9100789c9d999364 = ({ x: x, y: y, z: z } = {
    x: 0,
    y: 0,
    z: 0
})=>{
    return new (0, $d5b33d7c30034067$export$64b5c384219d3699)(x, y, z);
};
/**
 * Takes an object resembling a Quaternion and returs a Three.Quaternion
 * @category Math helpers
 */ const $4708f0499e113eb5$export$331177b0f99cd06 = ({ x: x, y: y, z: z, w: w } = {
    x: 0,
    y: 0,
    z: 0,
    w: 1
})=>{
    return new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)(x, y, z, w);
};
/**
 * Takes an object resembling an Euler and returs a Three.Euler
 * @category Math helpers
 */ const $4708f0499e113eb5$export$dc799133ea41435b = ({ x: x, y: y, z: z } = {
    x: 0,
    y: 0,
    z: 0
})=>{
    return new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)(x, y, z);
};
const $4708f0499e113eb5$var$useForwardedRef = (forwardedRef, defaultValue = null)=>{
    const innerRef = (0, $acw62.useRef)(defaultValue); // Update the forwarded ref when the inner ref changes
    if (forwardedRef && typeof forwardedRef !== "function") {
        if (!forwardedRef.current) forwardedRef.current = innerRef.current;
        return forwardedRef;
    }
    return innerRef;
};
/**
 * A collider is a shape that can be attached to a rigid body to define its physical properties.
 * @internal
 */ const $4708f0499e113eb5$export$b624c47b0e3f44d = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, position: position, rotation: rotation, quaternion: quaternion, scale: scale, name: name } = props;
    const { world: world, colliderEvents: colliderEvents, colliderStates: colliderStates } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const rigidBodyContext = $4708f0499e113eb5$var$useRigidBodyContext();
    const colliderRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef);
    const objectRef = (0, $acw62.useRef)(null); // We spread the props out here to make sure that the ref is updated when the props change.
    const immutablePropArray = $4708f0499e113eb5$var$immutableColliderOptions.flatMap((key)=>Array.isArray(props[key]) ? [
            ...props[key]
        ] : props[key]);
    const getInstance = $4708f0499e113eb5$var$useImperativeInstance(()=>{
        const worldScale = objectRef.current.getWorldScale($4708f0499e113eb5$export$9100789c9d999364());
        const collider = $4708f0499e113eb5$var$createColliderFromOptions(props, world, worldScale, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.getRigidBody);
        if (typeof forwardedRef == "function") forwardedRef(collider);
        colliderRef.current = collider;
        return collider;
    }, (collider)=>{
        if (world.getCollider(collider.handle)) world.removeCollider(collider, true);
    }, [
        ...immutablePropArray,
        rigidBodyContext
    ]);
    (0, $acw62.useEffect)(()=>{
        const collider = getInstance();
        colliderStates.set(collider.handle, $4708f0499e113eb5$var$createColliderState(collider, objectRef.current, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.ref.current));
        return ()=>{
            colliderStates.delete(collider.handle);
        };
    }, [
        getInstance
    ]);
    const mergedProps = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options)), props);
    }, [
        props,
        rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options
    ]);
    $4708f0499e113eb5$var$useUpdateColliderOptions(getInstance, mergedProps, colliderStates);
    $4708f0499e113eb5$var$useColliderEvents(getInstance, mergedProps, colliderEvents, $4708f0499e113eb5$var$getActiveCollisionEventsFromProps(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale,
        ref: objectRef,
        name: name
    }, children);
}));
/**
 * A cuboid collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$4f9cc99de105c9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cuboid",
        ref: ref
    }));
});
$4708f0499e113eb5$export$4f9cc99de105c9e.displayName = "CuboidCollider";
/**
 * A round cuboid collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$a2d07aed607bbf03 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCuboid",
        ref: ref
    })));
$4708f0499e113eb5$export$a2d07aed607bbf03.displayName = "RoundCuboidCollider";
/**
 * A ball collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$4e29496cd9696853 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "ball",
        ref: ref
    })));
$4708f0499e113eb5$export$4e29496cd9696853.displayName = "BallCollider";
/**
 * A capsule collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$768a57ebe80015a2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "capsule",
        ref: ref
    })));
$4708f0499e113eb5$export$768a57ebe80015a2.displayName = "CapsuleCollider";
/**
 * A heightfield collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$8071a0186d9c89e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "heightfield",
        ref: ref
    })));
$4708f0499e113eb5$export$8071a0186d9c89e3.displayName = "HeightfieldCollider";
/**
 * A trimesh collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$411e457e9040e043 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "trimesh",
        ref: ref
    })));
$4708f0499e113eb5$export$411e457e9040e043.displayName = "TrimeshCollider";
/**
 * A cone collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$8ab1d7c353d2df8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cone",
        ref: ref
    })));
$4708f0499e113eb5$export$8ab1d7c353d2df8b.displayName = "ConeCollider";
/**
 * A round cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$3ade71538cb07b90 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCone",
        ref: ref
    })));
$4708f0499e113eb5$export$3ade71538cb07b90.displayName = "RoundConeCollider";
/**
 * A cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$d931dcfd959cbf5e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cylinder",
        ref: ref
    })));
$4708f0499e113eb5$export$d931dcfd959cbf5e.displayName = "CylinderCollider";
/**
 * A round cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$5654157303bb0b18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCylinder",
        ref: ref
    })));
$4708f0499e113eb5$export$d931dcfd959cbf5e.displayName = "RoundCylinderCollider";
/**
 * A convex hull collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$7244a38c3d9c72f9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "convexHull",
        ref: ref
    })));
$4708f0499e113eb5$export$7244a38c3d9c72f9.displayName = "ConvexHullCollider";
const $4708f0499e113eb5$var$rigidBodyDescFromOptions = (options)=>{
    var _options$canSleep;
    const type = $4708f0499e113eb5$var$rigidBodyTypeFromString((options === null || options === void 0 ? void 0 : options.type) || "dynamic");
    const desc = new (0, $2LLMu.RigidBodyDesc)(type); // Apply immutable options
    desc.canSleep = (_options$canSleep = options === null || options === void 0 ? void 0 : options.canSleep) !== null && _options$canSleep !== void 0 ? _options$canSleep : true;
    return desc;
};
const $4708f0499e113eb5$var$createRigidBodyState = ({ rigidBody: rigidBody, object: object, setMatrix: setMatrix, getMatrix: getMatrix, worldScale: worldScale, meshType: _meshType = "mesh" })=>{
    object.updateWorldMatrix(true, false);
    const invertedWorldMatrix = object.parent.matrixWorld.clone().invert();
    return {
        object: object,
        rigidBody: rigidBody,
        invertedWorldMatrix: invertedWorldMatrix,
        setMatrix: setMatrix ? setMatrix : (matrix)=>{
            object.matrix.copy(matrix);
        },
        getMatrix: getMatrix ? getMatrix : (matrix)=>matrix.copy(object.matrix),
        scale: worldScale || object.getWorldScale($4708f0499e113eb5$var$_scale).clone(),
        isSleeping: false,
        meshType: _meshType
    };
};
const $4708f0499e113eb5$var$immutableRigidBodyOptions = [
    "args",
    "colliders",
    "canSleep"
];
const $4708f0499e113eb5$var$mutableRigidBodyOptions = {
    gravityScale: (rb, value)=>{
        rb.setGravityScale(value, true);
    },
    linearDamping: (rb, value)=>{
        rb.setLinearDamping(value);
    },
    angularDamping: (rb, value)=>{
        rb.setAngularDamping(value);
    },
    dominanceGroup: (rb, value)=>{
        rb.setDominanceGroup(value);
    },
    enabledRotations: (rb, [x, y, z])=>{
        rb.setEnabledRotations(x, y, z, true);
    },
    enabledTranslations: (rb, [x, y, z])=>{
        rb.setEnabledTranslations(x, y, z, true);
    },
    lockRotations: (rb, value)=>{
        rb.lockRotations(value, true);
    },
    lockTranslations: (rb, value)=>{
        rb.lockTranslations(value, true);
    },
    angularVelocity: (rb, [x, y, z])=>{
        rb.setAngvel({
            x: x,
            y: y,
            z: z
        }, true);
    },
    linearVelocity: (rb, [x, y, z])=>{
        rb.setLinvel({
            x: x,
            y: y,
            z: z
        }, true);
    },
    ccd: (rb, value)=>{
        rb.enableCcd(value);
    },
    userData: (rb, value)=>{
        rb.userData = value;
    },
    type (rb, value) {
        rb.setBodyType($4708f0499e113eb5$var$rigidBodyTypeFromString(value), true);
    },
    position: ()=>{},
    rotation: ()=>{},
    quaternion: ()=>{},
    scale: ()=>{}
};
const $4708f0499e113eb5$var$mutableRigidBodyOptionKeys = Object.keys($4708f0499e113eb5$var$mutableRigidBodyOptions);
const $4708f0499e113eb5$var$setRigidBodyOptions = (rigidBody, options, states, updateTranslations = true)=>{
    if (!rigidBody) return;
    const state = states.get(rigidBody.handle);
    if (state) {
        if (updateTranslations) {
            state.object.updateWorldMatrix(true, false);
            $4708f0499e113eb5$var$_matrix4.copy(state.object.matrixWorld).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            rigidBody.setTranslation($4708f0499e113eb5$var$_position, false);
            rigidBody.setRotation($4708f0499e113eb5$var$_rotation, false);
        }
        $4708f0499e113eb5$var$mutableRigidBodyOptionKeys.forEach((key)=>{
            if (key in options) $4708f0499e113eb5$var$mutableRigidBodyOptions[key](rigidBody, options[key]);
        });
    }
};
const $4708f0499e113eb5$var$useUpdateRigidBodyOptions = (getRigidBody, props, states, updateTranslations = true)=>{
    // TODO: Improve this, split each prop into its own effect
    const mutablePropsAsFlatArray = (0, $acw62.useMemo)(()=>$4708f0499e113eb5$var$mutableRigidBodyOptionKeys.flatMap((key)=>{
            return $4708f0499e113eb5$var$vectorToTuple(props[key]);
        }), [
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        $4708f0499e113eb5$var$setRigidBodyOptions(rigidBody, props, states, updateTranslations);
    }, mutablePropsAsFlatArray);
};
const $4708f0499e113eb5$var$useRigidBodyEvents = (getRigidBody, props, events)=>{
    const { onWake: onWake, onSleep: onSleep, onCollisionEnter: onCollisionEnter, onCollisionExit: onCollisionExit, onIntersectionEnter: onIntersectionEnter, onIntersectionExit: onIntersectionExit, onContactForce: onContactForce } = props;
    const eventHandlers = {
        onWake: onWake,
        onSleep: onSleep,
        onCollisionEnter: onCollisionEnter,
        onCollisionExit: onCollisionExit,
        onIntersectionEnter: onIntersectionEnter,
        onIntersectionExit: onIntersectionExit,
        onContactForce: onContactForce
    };
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        events.set(rigidBody.handle, eventHandlers);
        return ()=>{
            events.delete(rigidBody.handle);
        };
    }, [
        onWake,
        onSleep,
        onCollisionEnter,
        onCollisionExit,
        onIntersectionEnter,
        onIntersectionExit,
        onContactForce
    ]);
};
const $4708f0499e113eb5$var$_excluded$1 = [
    "children",
    "type",
    "position",
    "rotation",
    "scale",
    "quaternion",
    "transformState"
];
const $4708f0499e113eb5$var$RigidBodyContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $4708f0499e113eb5$var$useRigidBodyContext = ()=>(0, $acw62.useContext)($4708f0499e113eb5$var$RigidBodyContext);
/**
 * A rigid body is a physical object that can be simulated by the physics engine.
 * @category Components
 */ const $4708f0499e113eb5$export$41c0a739a32ac4d = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, type: type, position: position, rotation: rotation, scale: scale, quaternion: quaternion, transformState: transformState } = props, objectProps = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded$1);
    const objectRef = (0, $acw62.useRef)(null);
    const rigidBodyRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef);
    const { world: world, rigidBodyStates: rigidBodyStates, physicsOptions: physicsOptions, rigidBodyEvents: rigidBodyEvents } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const mergedOptions = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, physicsOptions), props), {}, {
            children: undefined
        });
    }, [
        physicsOptions,
        props
    ]);
    const immutablePropArray = $4708f0499e113eb5$var$immutableRigidBodyOptions.flatMap((key)=>{
        return Array.isArray(mergedOptions[key]) ? [
            ...mergedOptions[key]
        ] : mergedOptions[key];
    });
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(objectRef, mergedOptions); // Provide a way to eagerly create rigidbody
    const getRigidBody = $4708f0499e113eb5$var$useImperativeInstance(()=>{
        const desc = $4708f0499e113eb5$var$rigidBodyDescFromOptions(mergedOptions);
        const rigidBody = world.createRigidBody(desc);
        if (typeof forwardedRef === "function") forwardedRef(rigidBody);
        rigidBodyRef.current = rigidBody;
        return rigidBody;
    }, (rigidBody)=>{
        if (world.getRigidBody(rigidBody.handle)) world.removeRigidBody(rigidBody);
    }, immutablePropArray); // Only provide a object state after the ref has been set
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        const state = $4708f0499e113eb5$var$createRigidBodyState({
            rigidBody: rigidBody,
            object: objectRef.current
        });
        rigidBodyStates.set(rigidBody.handle, props.transformState ? props.transformState(state) : state);
        return ()=>{
            rigidBodyStates.delete(rigidBody.handle);
        };
    }, [
        getRigidBody
    ]);
    $4708f0499e113eb5$var$useUpdateRigidBodyOptions(getRigidBody, mergedOptions, rigidBodyStates);
    $4708f0499e113eb5$var$useRigidBodyEvents(getRigidBody, mergedOptions, rigidBodyEvents);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            ref: objectRef,
            getRigidBody: getRigidBody,
            options: mergedOptions
        };
    }, [
        getRigidBody
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$RigidBodyContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", $4708f0499e113eb5$var$_extends({
        ref: objectRef
    }, objectProps, {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale
    }), children, childColliderProps.map((colliderProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
            key: index
        }, colliderProps)))));
}));
$4708f0499e113eb5$export$41c0a739a32ac4d.displayName = "RigidBody";
/**
 * A mesh collider is a collider that is automatically generated from the geometry of the children.
 * @category Colliders
 */ const $4708f0499e113eb5$export$a20a2583fa01000f = /*#__PURE__*/ (0, $acw62.memo)((props)=>{
    const { children: children, type: type } = props;
    const { physicsOptions: physicsOptions } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const object = (0, $acw62.useRef)(null);
    const { options: options } = $4708f0499e113eb5$var$useRigidBodyContext();
    const mergedOptions = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, physicsOptions), options), {}, {
            children: undefined,
            colliders: type
        });
    }, [
        physicsOptions,
        options
    ]);
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(object, mergedOptions, false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        ref: object,
        userData: {
            r3RapierType: "MeshCollider"
        }
    }, children, childColliderProps.map((colliderProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
            key: index
        }, colliderProps))));
});
$4708f0499e113eb5$export$a20a2583fa01000f.displayName = "MeshCollider";
const $4708f0499e113eb5$var$_excluded = [
    "children",
    "instances",
    "colliderNodes",
    "position",
    "rotation",
    "quaternion",
    "scale"
];
const $4708f0499e113eb5$export$b24ddbe47deafd22 = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const rigidBodiesRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef, []);
    const objectRef = (0, $acw62.useRef)(null);
    const instanceWrapperRef = (0, $acw62.useRef)(null);
    const { children: // instanced props
    children, instances: instances, colliderNodes: colliderNodes = [], position: // wrapper object props
    position, rotation: rotation, quaternion: quaternion, scale: scale } = props, rigidBodyProps = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded);
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(objectRef, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, props), {}, {
        children: undefined
    }));
    const getInstancedMesh = ()=>{
        const firstChild = instanceWrapperRef.current.children[0];
        if (firstChild && "isInstancedMesh" in firstChild) return firstChild;
        return undefined;
    };
    (0, $acw62.useEffect)(()=>{
        const instancedMesh = getInstancedMesh();
        if (instancedMesh) instancedMesh.instanceMatrix.setUsage((0, $d5b33d7c30034067$export$8505d14ac8546ca));
        else console.warn("InstancedRigidBodies expects exactly one child, which must be an InstancedMesh");
    }, []); // Update the RigidBodyStates whenever the instances change
    const applyInstancedState = (state, index)=>{
        const instancedMesh = getInstancedMesh();
        if (instancedMesh) return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, state), {}, {
            getMatrix: (matrix)=>{
                instancedMesh.getMatrixAt(index, matrix);
                return matrix;
            },
            setMatrix: (matrix)=>{
                instancedMesh.setMatrixAt(index, matrix);
                instancedMesh.instanceMatrix.needsUpdate = true;
            },
            meshType: "instancedMesh"
        });
        return state;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", $4708f0499e113eb5$var$_extends({
        ref: objectRef
    }, rigidBodyProps, {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        ref: instanceWrapperRef
    }, children), instances === null || instances === void 0 ? void 0 : instances.map((instance, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$41c0a739a32ac4d, $4708f0499e113eb5$var$_extends({}, rigidBodyProps, instance, {
            ref: (body)=>rigidBodiesRef.current[index] = body,
            transformState: (state)=>applyInstancedState(state, index)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, colliderNodes.map((node, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: index
            }, node)), childColliderProps.map((colliderProps, colliderIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
                key: colliderIndex
            }, colliderProps)))))));
}));
$4708f0499e113eb5$export$b24ddbe47deafd22.displayName = "InstancedRigidBodies";
/**
 * @internal
 */ const $4708f0499e113eb5$export$cbae601798080e14 = (body1, body2, params)=>{
    const { world: world } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const jointRef = (0, $acw62.useRef)();
    $4708f0499e113eb5$var$useImperativeInstance(()=>{
        if (body1.current && body2.current) {
            const newJoint = world.createImpulseJoint(params, body1.current, body2.current, true);
            jointRef.current = newJoint;
            return newJoint;
        }
    }, (joint)=>{
        if (joint) {
            jointRef.current = undefined;
            if (world.getImpulseJoint(joint.handle)) world.removeImpulseJoint(joint, true);
        }
    }, []);
    return jointRef;
};
/**
 * A fixed joint ensures that two rigid-bodies don't move relative to each other.
 * Fixed joints are characterized by one local frame (represented by an isometry) on each rigid-body.
 * The fixed-joint makes these frames coincide in world-space.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$76ae4ac5d9a23dbb = (body1, body2, [body1Anchor, body1LocalFrame, body2Anchor, body2LocalFrame])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, rapier.JointData.fixed($4708f0499e113eb5$var$vectorArrayToVector3(body1Anchor), $4708f0499e113eb5$var$tupleToObject(body1LocalFrame, [
        "x",
        "y",
        "z",
        "w"
    ]), $4708f0499e113eb5$var$vectorArrayToVector3(body2Anchor), $4708f0499e113eb5$var$tupleToObject(body2LocalFrame, [
        "x",
        "y",
        "z",
        "w"
    ])));
};
/**
 * The spherical joint ensures that two points on the local-spaces of two rigid-bodies always coincide (it prevents any relative
 * translational motion at this points). This is typically used to simulate ragdolls arms, pendulums, etc.
 * They are characterized by one local anchor on each rigid-body. Each anchor represents the location of the
 * points that need to coincide on the local-space of each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$c0fe3fee8fd7c4a = (body1, body2, [body1Anchor, body2Anchor])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, rapier.JointData.spherical($4708f0499e113eb5$var$vectorArrayToVector3(body1Anchor), $4708f0499e113eb5$var$vectorArrayToVector3(body2Anchor)));
};
/**
 * The revolute joint prevents any relative movement between two rigid-bodies, except for relative
 * rotations along one axis. This is typically used to simulate wheels, fans, etc.
 * They are characterized by one local anchor as well as one local axis on each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$7c70b7c87abc4d99 = (body1, body2, [body1Anchor, body2Anchor, axis, limits])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const params = rapier.JointData.revolute($4708f0499e113eb5$var$vectorArrayToVector3(body1Anchor), $4708f0499e113eb5$var$vectorArrayToVector3(body2Anchor), $4708f0499e113eb5$var$vectorArrayToVector3(axis));
    if (limits) {
        params.limitsEnabled = true;
        params.limits = limits;
    }
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * The prismatic joint prevents any relative movement between two rigid-bodies, except for relative translations along one axis.
 * It is characterized by one local anchor as well as one local axis on each rigid-body. In 3D, an optional
 * local tangent axis can be specified for each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$47d4981575a3525a = (body1, body2, [body1Anchor, body2Anchor, axis, limits])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const params = rapier.JointData.prismatic($4708f0499e113eb5$var$vectorArrayToVector3(body1Anchor), $4708f0499e113eb5$var$vectorArrayToVector3(body2Anchor), $4708f0499e113eb5$var$vectorArrayToVector3(axis));
    if (limits) {
        params.limitsEnabled = true;
        params.limits = limits;
    }
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * Calculates an InteractionGroup bitmask for use in the `collisionGroups` or `solverGroups`
 * properties of RigidBody or Collider components. The first argument represents a list of
 * groups the entity is in (expressed as numbers from 0 to 15). The second argument is a list
 * of groups that will be filtered against. When it is omitted, all groups are filtered against.
 *
 * @example
 * A RigidBody that is member of group 0 and will collide with everything from groups 0 and 1:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0], [0, 1])} />
 * ```
 *
 * A RigidBody that is member of groups 0 and 1 and will collide with everything else:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0, 1])} />
 * ```
 *
 * A RigidBody that is member of groups 0 and 1 and will not collide with anything:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0, 1], [])} />
 * ```
 *
 * Please note that Rapier needs interaction filters to evaluate to true between _both_ colliding
 * entities for collision events to trigger.
 *
 * @param memberships Groups the collider is a member of. (Values can range from 0 to 15.)
 * @param filters Groups the interaction group should filter against. (Values can range from 0 to 15.)
 * @returns An InteractionGroup bitmask.
 */ const $4708f0499e113eb5$export$81613e3b6ee37c2 = (memberships, filters)=>($4708f0499e113eb5$var$bitmask(memberships) << 16) + (filters !== undefined ? $4708f0499e113eb5$var$bitmask(filters) : 65535);
const $4708f0499e113eb5$var$bitmask = (groups)=>[
        groups
    ].flat().reduce((acc, layer)=>acc | 1 << layer, 0);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $c8bef202b4105b6b$export$8f1a831c963f9c51 = (0, $acw62.createContext)(undefined);
const { Consumer: $c8bef202b4105b6b$export$575021fe9f49fd24, Provider: $c8bef202b4105b6b$export$34b38cfc8c70dfc1 } = $c8bef202b4105b6b$export$8f1a831c963f9c51;
const $c8bef202b4105b6b$export$e0df397c1b48b9e2 = ()=>(0, $acw62.useContext)($c8bef202b4105b6b$export$8f1a831c963f9c51);



var $acw62 = parcelRequire("acw62");


function $10798a5033e8ec5c$export$491715d4fdcd0f6b(clips, root) {
    const ref = $acw62.useRef();
    const [actualRef] = $acw62.useState(()=>root ? root instanceof (0, $d5b33d7c30034067$export$e4dd07dff30cc924) ? {
            current: root
        } : root : ref); // eslint-disable-next-line prettier/prettier
    const [mixer] = $acw62.useState(()=>new (0, $d5b33d7c30034067$export$fbd77e5aefaa0102)(undefined));
    $acw62.useLayoutEffect(()=>void (mixer._root = actualRef.current), [
        mixer,
        root
    ]);
    const lazyActions = $acw62.useRef({});
    const [api] = $acw62.useState(()=>{
        const actions = {};
        clips.forEach((clip)=>Object.defineProperty(actions, clip.name, {
                enumerable: true,
                get () {
                    if (actualRef.current) return lazyActions.current[clip.name] || (lazyActions.current[clip.name] = mixer.clipAction(clip, actualRef.current));
                },
                configurable: true
            }));
        return {
            ref: actualRef,
            clips: clips,
            actions: actions,
            names: clips.map((c)=>c.name),
            mixer: mixer
        };
    });
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)((state, delta)=>mixer.update(delta));
    $acw62.useEffect(()=>{
        const currentRoot = actualRef.current;
        return ()=>{
            // Clean up only when clips change, wipe out lazy actions and uncache clips
            lazyActions.current = {};
            Object.values(api.actions).forEach((action)=>{
                if (currentRoot) mixer.uncacheAction(action, currentRoot);
            });
        };
    }, [
        clips
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            mixer.stopAllAction();
        };
    }, [
        mixer
    ]);
    return api;
}



const $384d310ca6ecee7b$export$c338f1d796ca0b28 = window.location.search.includes("dev");
const $384d310ca6ecee7b$export$54e64dc378dd5aa7 = window.location.search.includes("map");
const $384d310ca6ecee7b$export$d8bb41b5127a40dd = window.location.search.includes("perf");
const $384d310ca6ecee7b$export$9dbc1188d4e128a5 = {
    // Target FPS to maintain
    TARGET_FPS: 60,
    // Shadow quality settings
    SHADOWS: {
        HIGH: [
            2048,
            2048
        ],
        MEDIUM: [
            1024,
            1024
        ],
        LOW: [
            512,
            512
        ]
    },
    // LOD distance thresholds
    LOD: {
        HIGH_DETAIL_DISTANCE: 10,
        MEDIUM_DETAIL_DISTANCE: 30,
        LOW_DETAIL_DISTANCE: 60
    },
    // Enable automatic performance adjustments
    AUTO_ADJUST: true,
    // Low performance mode (can be enabled with ?low-perf in URL)
    LOW_PERFORMANCE_MODE: window.location.search.includes("low-perf")
};


// TRICKY: TypeScript is broken and removes values from this as a const, when used in SOME places.
// Changing it to an enum works. 👻
var $84e9c27f98916c89$export$5b35153480bdfc93;
(function(PropertyObjectNames) {
    PropertyObjectNames["Object"] = "fpe_context_props";
    PropertyObjectNames["Command"] = "fpe_command_context_props";
    PropertyObjectNames["Animation"] = "animation_data.action.fpe_anim_context_props";
    PropertyObjectNames["FrameCommands"] = "animation_data.action.fpe_frame_commands_context_props";
    PropertyObjectNames["Scene"] = "fpe_scene_context_props";
})($84e9c27f98916c89$export$5b35153480bdfc93 || ($84e9c27f98916c89$export$5b35153480bdfc93 = {}));


const $2c877e781b5b9064$export$c7254adac00646f7 = (type = "Object")=>(0, $84e9c27f98916c89$export$5b35153480bdfc93)[type].split(".").pop();
const $2c877e781b5b9064$export$917b7e58756601ef = (value = "")=>{
    const cleanValue = typeof value === "string" ? value.trim() : "";
    return cleanValue.split(",").map((c)=>c.trim()).filter((c)=>c.length > 0);
};
const $2c877e781b5b9064$export$fc59bd5d705bb77c = (contextName, props)=>(userData = {})=>{
        const { [contextName]: value } = userData;
        return !!value ? props : {};
    };
const $2c877e781b5b9064$export$d4e8add114feec96 = (userData = {})=>Object.keys(userData);
const $2c877e781b5b9064$export$a8e358d6d1c59c7b = (userData = {}, presetMap)=>$2c877e781b5b9064$export$d4e8add114feec96(userData).reduce((acc, context)=>({
            ...acc,
            ...presetMap[context] instanceof Function ? presetMap[context](userData) : presetMap[context]
        }), {});
const $2c877e781b5b9064$export$8eb0f5047dddd661 = (userData = {}, type = "Object")=>userData[$2c877e781b5b9064$export$c7254adac00646f7(type)] || {};
const $2c877e781b5b9064$export$65c64f7642dbc45c = (target, userData = {}, presetMap, userDataType = "Object")=>{
    if (target) Object.assign(target, $2c877e781b5b9064$export$a8e358d6d1c59c7b($2c877e781b5b9064$export$8eb0f5047dddd661(userData, userDataType), presetMap));
    return target;
};
const $2c877e781b5b9064$export$8213c2e75df21b0c = (userData = {}, contexts = [], userDataType = "Object")=>$2c877e781b5b9064$export$d4e8add114feec96($2c877e781b5b9064$export$8eb0f5047dddd661(userData, userDataType)).some((context)=>contexts.includes(context));



const $e7a75e9dc86e9672$export$469026bfecd59988 = {
    SinglePlay: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("SinglePlay", {
        repetitions: 0,
        clampWhenFinished: true
    })
};





const $9abb60800e68dafb$export$83dcb5a44d83b2c0 = (_mesh, userData, commandContext)=>{
    const { Animations: animations = "" } = userData;
    const cleanAnimations = (0, $2c877e781b5b9064$export$917b7e58756601ef)(animations);
    const { animationContext: { playAnimations: playAnimations, stopAnimations: stopAnimations } } = commandContext;
    stopAnimations(cleanAnimations);
    return ()=>{
        playAnimations(cleanAnimations);
    };
};
const $9abb60800e68dafb$export$528eb3d9898a7cd4 = (_mesh, userData, commandContext)=>{
    const { Animations: animations = "" } = userData;
    const cleanAnimations = (0, $2c877e781b5b9064$export$917b7e58756601ef)(animations);
    const { animationContext: { playAnimations: playAnimations } } = commandContext;
    return playAnimations(cleanAnimations);
};


const $5c00f5db950e9781$export$d1c7d3e6b489e79e = {
    Animations: (0, $9abb60800e68dafb$export$83dcb5a44d83b2c0)
};
const $5c00f5db950e9781$export$dff958abbf9fc22d = {
    LoadLevel: (0, $dd039c9abdc1873f$export$7a002bf1396da61),
    Animations: (0, $9abb60800e68dafb$export$528eb3d9898a7cd4)
};
const $5c00f5db950e9781$export$2c1bd7859e0689f5 = $5c00f5db950e9781$export$dff958abbf9fc22d;
const $5c00f5db950e9781$var$executeCommandsInternal = (mesh, userData, commandContext, commandMap, directCommandData)=>{
    const userDataCommandMap = directCommandData ? userData : (0, $2c877e781b5b9064$export$8eb0f5047dddd661)(userData, "Command");
    const output = Object.keys(userDataCommandMap).map((commandName)=>{
        const command = commandMap[commandName];
        if (command) return command(mesh, userDataCommandMap, commandContext);
    });
    return output.filter((value)=>value !== undefined);
};
const $5c00f5db950e9781$export$eae50c9ee4641251 = (mesh, userData, commandContext, directCommandData)=>$5c00f5db950e9781$var$executeCommandsInternal(mesh, userData, commandContext, $5c00f5db950e9781$export$d1c7d3e6b489e79e, directCommandData);
const $5c00f5db950e9781$export$dce6fb20742ff3d3 = (mesh, userData, commandContext, directCommandData)=>{
    $5c00f5db950e9781$var$executeCommandsInternal(mesh, userData, commandContext, $5c00f5db950e9781$export$2c1bd7859e0689f5, directCommandData);
};



const $0393cee1d7fa146f$export$11573353fc688c48 = 24;
const $0393cee1d7fa146f$export$f63da2dc21e94942 = 5;
const $0393cee1d7fa146f$export$de8849023047eec0 = 1000 / $0393cee1d7fa146f$export$11573353fc688c48;
const $0393cee1d7fa146f$export$c846d8aa2f43dfc8 = $0393cee1d7fa146f$export$de8849023047eec0 * $0393cee1d7fa146f$export$f63da2dc21e94942;
const $0393cee1d7fa146f$export$2c3f7de095b97df0 = (frameNumber)=>parseFloat(((frameNumber - frameNumber % $0393cee1d7fa146f$export$f63da2dc21e94942) * $0393cee1d7fa146f$export$de8849023047eec0).toFixed(5));
const $0393cee1d7fa146f$export$6a24566d9cb4f0f6 = (time)=>{
    const timeInMS = time * 1000;
    return parseFloat((timeInMS - timeInMS % $0393cee1d7fa146f$export$c846d8aa2f43dfc8).toFixed(5));
};
const $0393cee1d7fa146f$var$AnimationsControllerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    allAnimations: [],
    animationsMapRef: {
        current: {}
    },
    addAnimationsToContext: ()=>{},
    removeAnimationsFromContext: ()=>{},
    playAnimations: ()=>{},
    stopAnimations: ()=>{}
});
const { Provider: $0393cee1d7fa146f$var$Provider } = $0393cee1d7fa146f$var$AnimationsControllerContext;
const $0393cee1d7fa146f$export$1f0b5eae90eae667 = {
    Playing: "Playing",
    Stopped: "Stopped"
};
const $0393cee1d7fa146f$export$873b338c6218bf9 = ()=>(0, $acw62.useContext)($0393cee1d7fa146f$var$AnimationsControllerContext);
const $0393cee1d7fa146f$export$d4061152ec97e209 = ({ children: children })=>{
    const { animations: animations, scene: scene, parser: { json: { animations: unparsedAnims = [] } = {} } = {} } = (0, $c8bef202b4105b6b$export$e0df397c1b48b9e2)();
    const animExtrasMap = (0, $acw62.useMemo)(()=>unparsedAnims.reduce((acc, { name: name = "", extras: extras = {} } = {}, i)=>({
                ...acc,
                [name || `unknown${i}`]: extras
            }), {}), [
        unparsedAnims
    ]);
    const animCommandMap = (0, $acw62.useMemo)(()=>{
        const map = {};
        for(const aName in animExtrasMap){
            const { FrameCommands: frameCommands = [] } = (0, $2c877e781b5b9064$export$8eb0f5047dddd661)(animExtrasMap[aName], "FrameCommands");
            const frameMap = {};
            for (const fC of frameCommands){
                const fCC = fC;
                const { FrameNumber: frameNumber = 0 } = fCC;
                const newFCCArr = frameMap[frameNumber] || [];
                frameMap[$0393cee1d7fa146f$export$2c3f7de095b97df0(parseInt(`${frameNumber}`, 10))] = [
                    ...newFCCArr,
                    fCC
                ];
            }
            map[aName] = frameMap;
        }
        return map;
    }, [
        animExtrasMap
    ]);
    const { actions: unprocessedActions, names: names } = (0, $10798a5033e8ec5c$export$491715d4fdcd0f6b)(animations, scene);
    const actions = (0, $acw62.useMemo)(()=>{
        for (const n of names){
            const a = unprocessedActions[n];
            const userData = animExtrasMap[n];
            (0, $2c877e781b5b9064$export$65c64f7642dbc45c)(a, userData, (0, $e7a75e9dc86e9672$export$469026bfecd59988), "Animation");
        }
        return unprocessedActions;
    }, [
        unprocessedActions,
        names
    ]);
    const animationsMapRef = (0, $acw62.useRef)({
        [$0393cee1d7fa146f$export$1f0b5eae90eae667.Playing]: [],
        [$0393cee1d7fa146f$export$1f0b5eae90eae667.Stopped]: []
    });
    const setAnimationsMap = (0, $acw62.useCallback)((newAnimationsMap = {})=>{
        if (0, $384d310ca6ecee7b$export$c338f1d796ca0b28) Object.values(newAnimationsMap).reduce((acc, anims)=>[
                ...acc,
                ...anims
            ], []).forEach((animation)=>{
            if (!names.includes(animation)) console.warn(`Animation "${animation}" does not exist`, names);
        });
        animationsMapRef.current = newAnimationsMap;
    }, [
        names
    ]);
    const lastAnimMapRef = (0, $acw62.useRef)({});
    const addAnimationsToContext = (0, $acw62.useCallback)((contextName, animations)=>{
        const prevAnimations = animationsMapRef.current[contextName] || [];
        const newAnimations = animations.reduce((acc, animation)=>{
            if (!acc.includes(animation)) return [
                ...acc,
                animation
            ];
            return acc;
        }, prevAnimations);
        setAnimationsMap({
            ...animationsMapRef.current,
            [contextName]: newAnimations
        });
    }, []);
    const removeAnimationsFromContext = (0, $acw62.useCallback)((contextName, animations)=>{
        const prevAnimations = animationsMapRef.current[contextName] || [];
        const newAnimations = prevAnimations.filter((a)=>!animations.includes(a));
        setAnimationsMap({
            ...animationsMapRef.current,
            [contextName]: newAnimations
        });
    }, []);
    const play = (0, $acw62.useCallback)((animations = [])=>{
        animations.forEach((animation)=>{
            const action = actions[animation];
            if (action) action.reset().fadeIn(0.5).play();
        });
    }, [
        actions
    ]);
    const stop = (0, $acw62.useCallback)((animations = [])=>{
        animations.forEach((animation)=>{
            const action = actions[animation];
            if (action) action.fadeOut(0.5);
        });
    }, [
        actions
    ]);
    const playAnimations = (0, $acw62.useCallback)((animations = [])=>{
        addAnimationsToContext($0393cee1d7fa146f$export$1f0b5eae90eae667.Playing, animations);
        removeAnimationsFromContext($0393cee1d7fa146f$export$1f0b5eae90eae667.Stopped, animations);
    }, [
        addAnimationsToContext,
        removeAnimationsFromContext
    ]);
    const stopAnimations = (0, $acw62.useCallback)((animations = [])=>{
        addAnimationsToContext($0393cee1d7fa146f$export$1f0b5eae90eae667.Stopped, animations);
        removeAnimationsFromContext($0393cee1d7fa146f$export$1f0b5eae90eae667.Playing, animations);
    }, [
        addAnimationsToContext,
        removeAnimationsFromContext
    ]);
    const framePlayRangeTrackingMapRef = (0, $acw62.useRef)({});
    const animationContext = (0, $acw62.useMemo)(()=>({
            allAnimations: names,
            animationsMapRef: animationsMapRef,
            addAnimationsToContext: addAnimationsToContext,
            removeAnimationsFromContext: removeAnimationsFromContext,
            playAnimations: playAnimations,
            stopAnimations: stopAnimations
        }), []);
    const levelContext = (0, $eb94f9a7e3c6143e$export$4840719527ba78ad)();
    const commandContext = (0, $acw62.useMemo)(()=>({
            animationContext: animationContext,
            levelContext: levelContext
        }), [
        animationContext,
        levelContext
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (lastAnimMapRef.current !== animationsMapRef.current) {
            const animationsMap = animationsMapRef.current;
            const { [$0393cee1d7fa146f$export$1f0b5eae90eae667.Playing]: prevPlayingAnimations = [], [$0393cee1d7fa146f$export$1f0b5eae90eae667.Stopped]: prevStoppedAnimations = [] } = lastAnimMapRef.current;
            const { [$0393cee1d7fa146f$export$1f0b5eae90eae667.Playing]: playingAnimations = [], [$0393cee1d7fa146f$export$1f0b5eae90eae667.Stopped]: stoppedAnimations = [] } = animationsMap;
            const newPlayingAnimations = playingAnimations.filter((a)=>!prevPlayingAnimations.includes(a));
            const newStoppedAnimations = stoppedAnimations.filter((a)=>!prevStoppedAnimations.includes(a));
            lastAnimMapRef.current = animationsMap;
            play(newPlayingAnimations);
            stop(newStoppedAnimations);
        }
        // Frame Commands
        for (const n of names){
            const act = actions[n];
            if (act?.isRunning()) {
                const actCmdMap = animCommandMap[n];
                const time = act.time;
                const quantizedTime = $0393cee1d7fa146f$export$6a24566d9cb4f0f6(time);
                const { [quantizedTime]: frameCommands } = actCmdMap;
                const { [quantizedTime]: isFrameCommandExecuted = false } = framePlayRangeTrackingMapRef.current[n] || {};
                if (frameCommands && !isFrameCommandExecuted) {
                    framePlayRangeTrackingMapRef.current[n] = {
                        ...framePlayRangeTrackingMapRef.current[n],
                        [quantizedTime]: true
                    };
                    for (const fC of frameCommands)(0, $5c00f5db950e9781$export$dce6fb20742ff3d3)({}, fC, commandContext, true);
                }
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        // IMPORTANT: Track Action finish to reset framePlayRangeTrackingMapRef.
        const onFinish = (e)=>{
            framePlayRangeTrackingMapRef.current[e.action._clip.name] = {};
        };
        for (const n of names){
            const act = actions[n];
            if (act) act.getMixer().addEventListener("finished", onFinish);
        }
        return ()=>{
            for (const n of names){
                const act = actions[n];
                if (act) act.getMixer().removeEventListener("finished", onFinish);
            }
        };
    }, [
        names,
        actions
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0393cee1d7fa146f$var$Provider, {
        value: animationContext,
        children: children
    });
};


const $a4853fb0a895c480$var$REGISTERED_PLAYER_MAP = {};
const $a4853fb0a895c480$var$rumble = (gp = null)=>{
    try {
        if (gp?.vibrationActuator) gp.vibrationActuator.playEffect("dual-rumble", {
            startDelay: 200,
            duration: 25,
            weakMagnitude: 0.5,
            strongMagnitude: 0.5
        }).then(()=>undefined);
        else navigator.vibrate([
            0,
            200,
            25
        ]);
    } catch (error) {
    // Ignore.
    }
};
const $a4853fb0a895c480$export$77d3851a84004719 = 0.75;
const $a4853fb0a895c480$export$6a1a309f82b321f3 = 1.5;
const $a4853fb0a895c480$export$467bf7d91fdcaf36 = $a4853fb0a895c480$export$77d3851a84004719 * $a4853fb0a895c480$export$6a1a309f82b321f3;
const $a4853fb0a895c480$export$344b3cb5a2e7700f = $a4853fb0a895c480$export$6a1a309f82b321f3 * 0.75;
const $a4853fb0a895c480$export$1787101a6c14d6fa = $a4853fb0a895c480$export$344b3cb5a2e7700f / 1.25;
const $a4853fb0a895c480$export$818cdce3263fd9eb = 0.25;
const $a4853fb0a895c480$export$5864bce3a65dc17f = ({ running: running })=>{
    const speed = running ? $a4853fb0a895c480$export$467bf7d91fdcaf36 : $a4853fb0a895c480$export$77d3851a84004719;
    const jumpSpeed = running ? $a4853fb0a895c480$export$1787101a6c14d6fa : $a4853fb0a895c480$export$344b3cb5a2e7700f;
    return {
        speed: speed,
        jumpSpeed: jumpSpeed
    };
};
const $a4853fb0a895c480$export$996d2c9d9f29f4c1 = (direction, speed, useZ = false)=>{
    const { x: x, z: z } = direction;
    const angle = Math.atan2(Math.abs(z), Math.abs(x));
    const newXSpeed = Math.cos(angle) * speed;
    const newZSpeed = Math.sin(angle) * speed;
    return useZ ? new (0, $d5b33d7c30034067$export$64b5c384219d3699)(direction.x, direction.y, direction.z * newZSpeed) : new (0, $d5b33d7c30034067$export$64b5c384219d3699)(direction.x * newXSpeed, direction.y, direction.z);
};
var $a4853fb0a895c480$export$996405e1edf9e298;
(function(PlayerAnimationNames) {
    PlayerAnimationNames["Idle"] = "Idle";
    PlayerAnimationNames["Walking"] = "Walking";
    PlayerAnimationNames["Running"] = "Running";
    PlayerAnimationNames["Jumping"] = "Jumping";
})($a4853fb0a895c480$export$996405e1edf9e298 || ($a4853fb0a895c480$export$996405e1edf9e298 = {}));
var $a4853fb0a895c480$export$c5bfc2c34776cdd2;
(function(PlayerAnimations) {
    PlayerAnimations["Idle"] = "Idle";
    PlayerAnimations["Walking"] = "Walking";
    PlayerAnimations["Running"] = "Running";
    PlayerAnimations["Jumping"] = "Jumping";
})($a4853fb0a895c480$export$c5bfc2c34776cdd2 || ($a4853fb0a895c480$export$c5bfc2c34776cdd2 = {}));
var $a4853fb0a895c480$export$6b8fd8635b63fab;
(function(PlayerMirroredAnimations) {
    PlayerMirroredAnimations["Idle"] = "IdleMirror";
    PlayerMirroredAnimations["Walking"] = "WalkingMirror";
    PlayerMirroredAnimations["Running"] = "RunningMirror";
    PlayerMirroredAnimations["Jumping"] = "JumpingMirror";
})($a4853fb0a895c480$export$6b8fd8635b63fab || ($a4853fb0a895c480$export$6b8fd8635b63fab = {}));
const $a4853fb0a895c480$export$fbf91788fee47314 = [
    ...Object.values($a4853fb0a895c480$export$c5bfc2c34776cdd2),
    ...Object.values($a4853fb0a895c480$export$6b8fd8635b63fab)
];
const $a4853fb0a895c480$export$df6222cde754a672 = {
    Jump: " ",
    Forward: "w",
    Left: "a",
    Backward: "s",
    Right: "d",
    Run: "shift"
};
const $a4853fb0a895c480$export$e8825814b8a524cf = (active = false, playerKeyboardMapping = $a4853fb0a895c480$export$df6222cde754a672)=>{
    const { Jump: jumpKey, Forward: forwardKey, Left: leftKey, Backward: backwardKey, Right: rightKey, Run: runKey } = playerKeyboardMapping;
    const { stopAnimations: stopAnimations, playAnimations: playAnimations } = (0, $0393cee1d7fa146f$export$873b338c6218bf9)();
    const [gamepadListLength, setGamepadListLength] = (0, $acw62.useState)(navigator.getGamepads().length);
    const gamepadIndexRef = (0, $acw62.useRef)(-1);
    const getGamepad = (0, $acw62.useCallback)(()=>navigator.getGamepads()[gamepadIndexRef.current], []);
    const fallingTimestampRef = (0, $acw62.useRef)(0);
    const airControlEnabled = (0, $acw62.useCallback)(()=>{
        return Date.now() - fallingTimestampRef.current < 1000;
    }, []);
    const playerStateRef = (0, $acw62.useRef)({
        direction: new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        mirrored: false,
        idle: true,
        running: false,
        jumping: false,
        falling: false,
        airControlEnabled: airControlEnabled
    });
    const onUpdatePlayerState = (0, $acw62.useCallback)((newStateProps)=>{
        const preNewState = {
            ...playerStateRef.current,
            ...newStateProps
        };
        const { mirrored: wasMirrored = false } = playerStateRef.current;
        const mirrored = preNewState.direction.x < 0 ? false : preNewState.direction.x > 0 ? true : wasMirrored;
        const idle = preNewState.direction.toArray().every((v)=>v === 0);
        playerStateRef.current = {
            ...preNewState,
            mirrored: mirrored,
            idle: idle
        };
        const { running: running, jumping: jumping, falling: falling } = playerStateRef.current;
        const animKeyName = jumping ? $a4853fb0a895c480$export$996405e1edf9e298.Jumping : falling ? $a4853fb0a895c480$export$996405e1edf9e298.Jumping : running && !idle ? $a4853fb0a895c480$export$996405e1edf9e298.Running : idle ? $a4853fb0a895c480$export$996405e1edf9e298.Idle : $a4853fb0a895c480$export$996405e1edf9e298.Walking;
        const animMap = mirrored ? $a4853fb0a895c480$export$6b8fd8635b63fab : $a4853fb0a895c480$export$c5bfc2c34776cdd2;
        const anim = animMap[animKeyName];
        stopAnimations($a4853fb0a895c480$export$fbf91788fee47314);
        playAnimations([
            anim
        ]);
    }, [
        stopAnimations,
        playAnimations
    ]);
    const getCurrentSpeed = (0, $acw62.useCallback)(()=>$a4853fb0a895c480$export$5864bce3a65dc17f(playerStateRef.current), []);
    const canJump = (0, $acw62.useCallback)(()=>!(playerStateRef.current.jumping || playerStateRef.current.falling), []);
    const onFallStart = (0, $acw62.useCallback)(()=>{
        fallingTimestampRef.current = Date.now();
        onUpdatePlayerState({
            falling: true
        });
    }, [
        onUpdatePlayerState
    ]);
    const onFallEnd = (0, $acw62.useCallback)(()=>{
        // GP Vibes!
        $a4853fb0a895c480$var$rumble(getGamepad());
        onUpdatePlayerState({
            direction: new (0, $d5b33d7c30034067$export$64b5c384219d3699)(playerStateRef.current.direction.x, 0, playerStateRef.current.direction.z),
            jumping: false,
            falling: false
        });
    }, [
        onUpdatePlayerState,
        getGamepad
    ]);
    const onSetRunning = (0, $acw62.useCallback)((running = true)=>onUpdatePlayerState({
            running: // @ts-ignore
            running
        }), [
        onUpdatePlayerState
    ]);
    const onMoveX = (0, $acw62.useCallback)((speedMultiplier)=>{
        const { speed: speed } = getCurrentSpeed();
        onUpdatePlayerState({
            direction: $a4853fb0a895c480$export$996d2c9d9f29f4c1(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(speedMultiplier, playerStateRef.current.direction.y, playerStateRef.current.direction.z), speed, false)
        });
    }, [
        onUpdatePlayerState
    ]);
    const onMoveZ = (0, $acw62.useCallback)((speedMultiplier)=>{
        const { speed: speed } = getCurrentSpeed();
        onUpdatePlayerState({
            direction: $a4853fb0a895c480$export$996d2c9d9f29f4c1(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(playerStateRef.current.direction.x, playerStateRef.current.direction.y, speedMultiplier), speed, true)
        });
    }, [
        onUpdatePlayerState
    ]);
    const onJump = (0, $acw62.useCallback)((speedMultiplier = 1)=>{
        if (canJump()) {
            const { jumpSpeed: jumpSpeed } = getCurrentSpeed();
            onUpdatePlayerState({
                direction: new (0, $d5b33d7c30034067$export$64b5c384219d3699)(playerStateRef.current.direction.x, jumpSpeed * speedMultiplier, playerStateRef.current.direction.z),
                jumping: true
            });
            setTimeout(()=>{
                onUpdatePlayerState({
                    direction: new (0, $d5b33d7c30034067$export$64b5c384219d3699)(playerStateRef.current.direction.x, 0, playerStateRef.current.direction.z),
                    jumping: false
                });
            }, 300);
        }
    }, [
        onUpdatePlayerState,
        canJump
    ]);
    const playerKeyMap = (0, $acw62.useMemo)(()=>({
            keyDown: {
                [jumpKey]: ()=>onJump(1),
                [forwardKey]: ()=>onMoveZ(-1),
                [leftKey]: ()=>onMoveX(-1),
                [backwardKey]: ()=>onMoveZ(1),
                [rightKey]: ()=>onMoveX(1),
                [runKey]: ()=>onSetRunning(true)
            },
            keyUp: {
                [jumpKey]: ()=>undefined,
                [forwardKey]: ()=>onMoveZ(0),
                [leftKey]: ()=>onMoveX(0),
                [backwardKey]: ()=>onMoveZ(0),
                [rightKey]: ()=>onMoveX(0),
                [runKey]: ()=>onSetRunning(false)
            }
        }), [
        onJump,
        onMoveX,
        onMoveZ
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((e)=>{
        if (!getGamepad()) {
            const handler = playerKeyMap.keyDown[e.key.toLowerCase()];
            if (handler) handler();
        }
    }, [
        playerKeyMap,
        getGamepad
    ]);
    const handleKeyUp = (0, $acw62.useCallback)((e)=>{
        if (!getGamepad()) {
            const handler = playerKeyMap.keyUp[e.key.toLowerCase()];
            if (handler) handler();
        }
    }, [
        playerKeyMap,
        getGamepad
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (active) {
            const gpListLen = navigator.getGamepads().length;
            const gp = getGamepad();
            if (gpListLen !== gamepadListLength) setGamepadListLength(gpListLen);
            if (gp) {
                // Run
                if (gp.buttons[2].pressed) onSetRunning(true);
                else if (playerStateRef.current.running) onSetRunning(false);
                // Left/Right
                if (gp.axes[0] !== 0) onMoveX(gp.axes[0]);
                else onMoveX(0);
                // Forward/Backward
                if (gp.axes[1] !== 0) onMoveZ(gp.axes[1]);
                else onMoveZ(0);
                // Jump
                if (gp.buttons[0].pressed) onJump(gp.buttons[0].value);
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (active) {
            const gpList = navigator.getGamepads();
            window.addEventListener("keydown", handleKeyDown);
            window.addEventListener("keyup", handleKeyUp);
            stopAnimations($a4853fb0a895c480$export$fbf91788fee47314);
            onUpdatePlayerState(playerStateRef.current);
            if (gamepadIndexRef.current === -1) {
                for(let i = 0; i < gpList.length; i++)if (!$a4853fb0a895c480$var$REGISTERED_PLAYER_MAP[i]) {
                    $a4853fb0a895c480$var$REGISTERED_PLAYER_MAP[i] = true;
                    gamepadIndexRef.current = i;
                    break;
                }
            }
            return ()=>{
                const gamepadIndex = gamepadIndexRef.current;
                window.removeEventListener("keydown", handleKeyDown);
                window.removeEventListener("keyup", handleKeyUp);
                if (gamepadIndex > -1) delete $a4853fb0a895c480$var$REGISTERED_PLAYER_MAP[gamepadIndex];
            };
        }
    }, [
        active,
        stopAnimations,
        onUpdatePlayerState,
        gamepadListLength
    ]);
    return {
        playerStateRef: playerStateRef,
        onFallStart: onFallStart,
        onFallEnd: onFallEnd
    };
};




const $92f40557ccfecb04$export$ccbf0aa20eb76d76 = (object)=>{
    const box = new (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)();
    object.traverse((child)=>{
        if ("isMesh" in child && child.isMesh) box.expandByObject(child);
    });
    return box;
};
const $92f40557ccfecb04$export$18f2af2888c1a46b = (degs)=>degs * Math.PI / 180;
const $92f40557ccfecb04$export$3eb27537c08caf0f = (rads)=>rads * (180 / Math.PI);
const $92f40557ccfecb04$export$2e7d87c1a7a5bd03 = (x, y, z)=>new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)($92f40557ccfecb04$export$18f2af2888c1a46b(x), $92f40557ccfecb04$export$18f2af2888c1a46b(y), $92f40557ccfecb04$export$18f2af2888c1a46b(z));




var $0e664bfb31b87942$export$cdb17616e2c9b1db;
(function(CollisionShape) {
    CollisionShape["Sphere"] = "Sphere";
    CollisionShape["Box"] = "Box";
    CollisionShape["Trimesh"] = "Trimesh";
})($0e664bfb31b87942$export$cdb17616e2c9b1db || ($0e664bfb31b87942$export$cdb17616e2c9b1db = {}));
var $0e664bfb31b87942$export$ddb2ed749236e720;
(function(CollisionType) {
    CollisionType["Static"] = "Static";
    CollisionType["Dynamic"] = "Dynamic";
    CollisionType["KinematicPosition"] = "KinematicPosition";
    CollisionType["KinematicVelocity"] = "KinematicVelocity";
})($0e664bfb31b87942$export$ddb2ed749236e720 || ($0e664bfb31b87942$export$ddb2ed749236e720 = {}));
const $0e664bfb31b87942$export$23a657ba366c4413 = {
    [$0e664bfb31b87942$export$cdb17616e2c9b1db.Sphere]: "ball",
    [$0e664bfb31b87942$export$cdb17616e2c9b1db.Box]: "cuboid",
    [$0e664bfb31b87942$export$cdb17616e2c9b1db.Trimesh]: "trimesh"
};
const $0e664bfb31b87942$export$4c93b7f012426d0a = {
    [$0e664bfb31b87942$export$ddb2ed749236e720.Static]: "fixed",
    [$0e664bfb31b87942$export$ddb2ed749236e720.Dynamic]: "dynamic",
    [$0e664bfb31b87942$export$ddb2ed749236e720.KinematicPosition]: "kinematicPosition",
    [$0e664bfb31b87942$export$ddb2ed749236e720.KinematicVelocity]: "kinematicVelocity"
};
const $0e664bfb31b87942$export$8b80c61aef5ca6bc = [
    "Box",
    "Ball",
    "Wall",
    "ComplexWall",
    "Structure",
    "Platform",
    "Player"
];
const $0e664bfb31b87942$export$552752ec3871f4db = [
    "Player"
];


const $df5511caa798bf3c$export$70d0edda063eb6f1 = (origin, direction, distance, scene, contexts = (0, $0e664bfb31b87942$export$8b80c61aef5ca6bc), ignoreContexts = [])=>{
    const targetContexts = contexts.filter((context)=>!ignoreContexts.includes(context));
    const rc = new (0, $d5b33d7c30034067$export$8b7aaceff00bd2f)(origin, direction, 0, distance);
    const rawIntList = rc.intersectObjects(scene.children, true);
    const intList = rawIntList.filter((inter)=>{
        return inter.object.visible && ((0, $2c877e781b5b9064$export$8213c2e75df21b0c)(inter.object.userData, targetContexts) || (0, $2c877e781b5b9064$export$8213c2e75df21b0c)(inter.object.parent?.userData, targetContexts));
    });
    return intList.length > 0;
};



const $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD = 0.75;
const $e557c93a5ae5d0a3$var$HALF_PLAYER_RAY_CAST_SPREAD = $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD / 2;
const $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD_RATIO = $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD - $e557c93a5ae5d0a3$var$HALF_PLAYER_RAY_CAST_SPREAD;
const $e557c93a5ae5d0a3$var$PLAYER_DIAMOND_SIZE = 0.5;
const $e557c93a5ae5d0a3$var$SPEED = 5;
const $e557c93a5ae5d0a3$export$9bd87b94842242b3 = ({ meshNode: meshNode, isPlayer: isPlayer = false, mass: mass = 1, collisionShape: collisionShape, collisionType: collisionType = (0, $0e664bfb31b87942$export$ddb2ed749236e720).Static, collisionAttach: collisionAttach = false, collisionMatchRotation: collisionMatchRotation = false, parentToCollision: parentToCollision = false, friction: friction = 0.5, sensor: sensor = false, restitution: restitution = 0, onPlayerCollide: onPlayerCollide })=>{
    const correctedOrientation = (0, $acw62.useMemo)(()=>({
            // IMPORTANT: Don't initially offset the rigid body position when the collision object will be attached to it.
            position: collisionAttach ? new (0, $d5b33d7c30034067$export$64b5c384219d3699)() : meshNode.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()),
            rotation: new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)().setFromQuaternion(meshNode.getWorldQuaternion(new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)())),
            scale: meshNode.getWorldScale(new (0, $d5b33d7c30034067$export$64b5c384219d3699)())
        }), [
        meshNode,
        collisionAttach
    ]);
    const targetCollisionShape = (0, $acw62.useMemo)(()=>(0, $0e664bfb31b87942$export$23a657ba366c4413)[collisionShape], [
        collisionShape
    ]);
    const targetCollisionType = (0, $acw62.useMemo)(()=>(0, $0e664bfb31b87942$export$4c93b7f012426d0a)[collisionType], [
        collisionType
    ]);
    const { meshClone: meshClone, usingBounds: usingBounds } = (0, $acw62.useMemo)(()=>{
        let bounds = meshNode.clone(true), usingBounds = false;
        // IMPORTANT: Player needs collisionDiamond added automatically. Angles: 45,35,0
        if (isPlayer) {
            bounds = new (0, $d5b33d7c30034067$export$e176487c05830cc5)(new (0, $d5b33d7c30034067$export$33e43285f7406bd5)($e557c93a5ae5d0a3$var$PLAYER_DIAMOND_SIZE, $e557c93a5ae5d0a3$var$PLAYER_DIAMOND_SIZE, $e557c93a5ae5d0a3$var$PLAYER_DIAMOND_SIZE));
            bounds.position.copy(meshNode.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()));
            bounds.rotation.copy((0, $92f40557ccfecb04$export$2e7d87c1a7a5bd03)(45, 0, 45));
            bounds.scale.copy(meshNode.getWorldScale(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()));
            bounds.visible = false;
            usingBounds = true;
        }
        return {
            meshClone: bounds,
            usingBounds: usingBounds
        };
    }, [
        meshNode,
        isPlayer
    ]);
    const correctedCloneOrientation = (0, $acw62.useMemo)(()=>({
            // IMPORTANT: Don't initially offset the rigid body position when the collision object will be attached to it.
            position: collisionAttach ? new (0, $d5b33d7c30034067$export$64b5c384219d3699)() : meshClone.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()),
            rotation: new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)().setFromQuaternion(meshClone.getWorldQuaternion(new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)())),
            scale: meshClone.getWorldScale(new (0, $d5b33d7c30034067$export$64b5c384219d3699)())
        }), [
        meshClone,
        collisionAttach
    ]);
    const correctedMeshValues = (0, $acw62.useMemo)(()=>usingBounds ? correctedCloneOrientation : correctedOrientation, [
        usingBounds,
        correctedCloneOrientation,
        correctedOrientation
    ]);
    const rbRef = (0, $acw62.useRef)(null);
    const { playerStateRef: playerStateRef, onFallEnd: onFallEnd, onFallStart: onFallStart } = (0, $a4853fb0a895c480$export$e8825814b8a524cf)(isPlayer);
    const collisionMeshRef = (0, $acw62.useRef)(null);
    const boxArgs = (0, $acw62.useMemo)(()=>{
        const { x: x, y: y, z: z } = meshClone.geometry?.boundingBox?.getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()) || (0, $92f40557ccfecb04$export$ccbf0aa20eb76d76)(meshClone).getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
        return [
            x,
            y,
            z
        ];
    }, [
        meshClone
    ]);
    const sphereArgs = (0, $acw62.useMemo)(()=>{
        if (meshClone?.geometry?.boundingBox) {
            const { x: x, y: y, z: z } = meshClone.geometry?.boundingBox?.getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()) || (0, $92f40557ccfecb04$export$ccbf0aa20eb76d76)(meshClone).getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
            return [
                Math.max(x, y, z) / 2,
                32,
                32
            ];
        } else return [
            0,
            0,
            0
        ];
    }, [
        meshClone
    ]);
    const onIntersectionEnter = (0, $acw62.useCallback)((payload)=>{
        if (sensor && onPlayerCollide) {
            const { other: { rigidBody: rigidBody } = {} } = payload;
            if ((rigidBody?.userData)?.isPlayer) onPlayerCollide();
        }
    }, [
        sensor,
        onPlayerCollide,
        meshNode
    ]);
    const { scene: scene } = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)();
    (0, $4708f0499e113eb5$export$71d8a22eb566a518)(()=>{
        const rb = rbRef.current;
        if (rb) {
            if (collisionAttach) rb.setNextKinematicTranslation(meshNode.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()));
            if (collisionMatchRotation) {
                const rotQuat = meshNode.getWorldQuaternion(new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)());
                rb.setNextKinematicRotation(rotQuat);
            }
            if (isPlayer) {
                const direction = playerStateRef.current.direction;
                const linVel = rb.linvel();
                const { falling: falling, airControlEnabled: airControlEnabled } = playerStateRef.current;
                const rayPos = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(rb.translation().x + Math.random() * $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD_RATIO, rb.translation().y, rb.translation().z + Math.random() * $e557c93a5ae5d0a3$var$PLAYER_RAY_CAST_SPREAD_RATIO);
                const onGround = (0, $df5511caa798bf3c$export$70d0edda063eb6f1)(rayPos, new (0, $d5b33d7c30034067$export$64b5c384219d3699)(0, -1, 0), boxArgs[1] * 1.5, scene, (0, $0e664bfb31b87942$export$8b80c61aef5ca6bc), (0, $0e664bfb31b87942$export$552752ec3871f4db));
                const allowControl = airControlEnabled() || !falling;
                if (falling && onGround) onFallEnd();
                else if (!falling && !onGround) onFallStart();
                if (direction.toArray().some((x)=>x !== 0)) rb.setLinvel(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(direction.x !== 0 && allowControl ? direction.x * $e557c93a5ae5d0a3$var$SPEED : linVel.x, direction.y !== 0 ? direction.y * $e557c93a5ae5d0a3$var$SPEED : linVel.y, direction.z !== 0 && allowControl ? direction.z * $e557c93a5ae5d0a3$var$SPEED : linVel.z), true);
            }
        }
    });
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)((_rS, delta)=>{
        const rb = rbRef.current;
        if (parentToCollision && rb) {
            if (collisionMeshRef.current) {
                const pos = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(rb.translation().x, rb.translation().y, rb.translation().z);
                const rotEl = new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)().setFromQuaternion(collisionMeshRef.current.getWorldQuaternion(new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)()));
                const scl = collisionMeshRef.current.getWorldScale(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
                if (meshNode.parent) meshNode.position.lerp(meshNode.parent.worldToLocal(pos), 1 - delta * 10);
                else meshNode.position.copy(pos);
                if (!usingBounds) {
                    meshNode.quaternion.setFromEuler(rotEl);
                    meshNode.scale.set(scl.x, scl.y, scl.z);
                }
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        // Hide the collision mesh representation.
        if (collisionMeshRef.current) collisionMeshRef.current.visible = false;
        if (collisionAttach && rbRef.current) {
            const rb = rbRef.current;
            rb.setTranslation(meshNode.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()), true);
        }
        if (rbRef.current) {
            const newUserData = {
                ...meshNode?.userData,
                ...rbRef.current.userData,
                isPlayer: isPlayer
            };
            rbRef.current.userData = newUserData;
        }
    }, [
        meshNode,
        isPlayer,
        collisionAttach
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
            ref: rbRef,
            mass: mass,
            colliders: targetCollisionShape,
            type: targetCollisionType,
            friction: friction,
            lockRotations: isPlayer,
            includeInvisible: true,
            sensor: sensor,
            restitution: restitution,
            onIntersectionEnter: onIntersectionEnter,
            ...correctedMeshValues,
            children: targetCollisionShape === "trimesh" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("primitive", {
                ref: collisionMeshRef,
                object: meshClone,
                position: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                scale: [
                    1,
                    1,
                    1
                ],
                opacity: 0.5,
                visible: false
            }) : targetCollisionShape === "ball" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mesh", {
                ref: collisionMeshRef,
                position: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                scale: [
                    1,
                    1,
                    1
                ],
                visible: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("sphereGeometry", {
                    args: sphereArgs
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mesh", {
                ref: collisionMeshRef,
                position: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                scale: [
                    1,
                    1,
                    1
                ],
                visible: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("boxGeometry", {
                    args: boxArgs
                })
            })
        })
    });
};





var $acw62 = parcelRequire("acw62");

const $ab8157bd0b666433$export$833f59cb05520d78 = 0.006;
const $ab8157bd0b666433$var$getMeshVertices = (mesh)=>{
    const posAtt = mesh.geometry.getAttribute("position");
    const l = posAtt.count;
    return new Array(l).fill(0).map((_, i)=>mesh.getVertexPosition(i, new (0, $d5b33d7c30034067$export$64b5c384219d3699)()));
};
const $ab8157bd0b666433$export$bb9b22c781832226 = (mesh, userData = {})=>{
    const objectUserData = (0, $2c877e781b5b9064$export$8eb0f5047dddd661)(userData);
    const { Water: unprocessedValue } = objectUserData;
    const water = !!unprocessedValue;
    const waves = (0, $acw62.useMemo)(()=>{
        if (water && mesh?.isMesh) return $ab8157bd0b666433$var$getMeshVertices(mesh).map((_, i)=>{
            const v = mesh.getVertexPosition(i, new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
            return {
                y: v.y,
                x: v.x,
                z: v.z,
                ang: Math.random() * Math.PI * 2,
                amp: $ab8157bd0b666433$export$833f59cb05520d78,
                speed: 0.016 + Math.random() * 0.024
            };
        });
        else return [];
    }, [
        water,
        mesh
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (water) {
            const verts = $ab8157bd0b666433$var$getMeshVertices(mesh);
            const pos = mesh.geometry.getAttribute("position");
            const l = verts.length;
            for(let i = 0; i < l; i++){
                const v = verts[i];
                const vprops = waves[i];
                v.x = vprops.x + Math.cos(vprops.ang) * vprops.amp;
                v.y = vprops.y + Math.sin(vprops.ang) * vprops.amp;
                vprops.ang += vprops.speed;
                pos.setXYZ(i, v.x, v.y, v.z);
                pos.needsUpdate = true;
            }
        }
    });
};





var $acw62 = parcelRequire("acw62");
const $851471185954fd4b$export$dfb26d340ce3defd = (mesh, userData = {})=>{
    const { SpriteAnimate: unprocessedSpeed = 1 } = userData;
    const speed = (0, $acw62.useMemo)(()=>parseFloat(`${unprocessedSpeed}`), [
        unprocessedSpeed
    ]);
    const currentFrameRef = (0, $acw62.useRef)(1);
    const lastFrame = (0, $acw62.useMemo)(()=>{
        if (mesh && mesh.children?.length > 0) return mesh.children.length;
        return 1;
    }, [
        mesh
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (mesh && mesh.children?.length > 0) {
            const currentFrame = Math.floor(currentFrameRef.current);
            for(let i = 0; i < mesh.children.length; i++)mesh.children[i].visible = i + 1 === currentFrame;
            currentFrameRef.current += speed;
            if (currentFrame > lastFrame) currentFrameRef.current = 1;
        }
    });
};




var $acw62 = parcelRequire("acw62");





const $f7f1615d6a8d2220$export$47dc4bab70e3751e = {
    Box: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Box", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Box,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).Dynamic,
        parentToCollision: true
    }),
    Ball: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Ball", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Sphere,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).Dynamic,
        parentToCollision: true
    }),
    Wall: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Wall", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Box,
        friction: 0
    }),
    ComplexWall: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("ComplexWall", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh,
        friction: 0
    }),
    Structure: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Structure", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh
    }),
    Platform: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Platform", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).KinematicPosition,
        collisionAttach: true,
        friction: 1,
        restitution: -4
    }),
    RotatingPlatform: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("RotatingPlatform", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).KinematicPosition,
        collisionMatchRotation: true,
        friction: 1,
        restitution: -4
    }),
    Player: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Player", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Box,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).Dynamic,
        isPlayer: true,
        restitution: 0.5,
        parentToCollision: true
    }),
    Sticky: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Sticky", {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh,
        collisionType: (0, $0e664bfb31b87942$export$ddb2ed749236e720).KinematicPosition,
        friction: 5
    }),
    Mass: ({ Mass: Mass = 1 } = {})=>{
        const mass = parseFloat(`${Mass}`);
        return {
            mass: isNaN(mass) ? 1 : mass
        };
    },
    Trigger: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Trigger", {
        sensor: true
    }),
    Speaker: {
        sensor: true
    },
    SpeakerTrigger: {
        sensor: true
    }
};





const $81084463f2dcbd90$export$3b196fe93a948c18 = (mesh, userData = {})=>{
    const { Trigger: trigger = false } = (0, $2c877e781b5b9064$export$8eb0f5047dddd661)(userData, "Object");
    const animationContext = (0, $0393cee1d7fa146f$export$873b338c6218bf9)();
    const levelContext = (0, $eb94f9a7e3c6143e$export$4840719527ba78ad)();
    const commandContext = (0, $acw62.useMemo)(()=>({
            animationContext: animationContext,
            levelContext: levelContext
        }), [
        animationContext,
        levelContext
    ]);
    const contextPresetProps = (0, $acw62.useMemo)(()=>(0, $2c877e781b5b9064$export$65c64f7642dbc45c)({}, userData, (0, $f7f1615d6a8d2220$export$47dc4bab70e3751e)), [
        userData
    ]);
    const onPlayerCollide = (0, $acw62.useCallback)(()=>{
        if (trigger) (0, $5c00f5db950e9781$export$dce6fb20742ff3d3)(mesh, userData, commandContext);
    }, [
        trigger,
        mesh,
        userData,
        commandContext
    ]);
    (0, $acw62.useEffect)(()=>{
        if (trigger) {
            const unmountMethods = (0, $5c00f5db950e9781$export$eae50c9ee4641251)(mesh, userData, commandContext);
            return ()=>{
                for (const unmountMethod of unmountMethods)if (unmountMethod instanceof Function) unmountMethod();
            };
        }
    }, [
        trigger,
        mesh,
        userData,
        commandContext
    ]);
    return trigger ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e557c93a5ae5d0a3$export$9bd87b94842242b3), {
        collisionShape: (0, $0e664bfb31b87942$export$cdb17616e2c9b1db).Trimesh,
        ...contextPresetProps,
        meshNode: mesh,
        onPlayerCollide: onPlayerCollide
    }) : undefined;
};



const $249605d1a517624a$export$357629edf815a302 = {
    Invisible: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Invisible", {
        visible: false
    })
};



const $2828293783204cab$export$c27eec34524c7ea5 = {
    Shadow: (0, $2c877e781b5b9064$export$fc59bd5d705bb77c)("Shadow", {
        castShadow: true,
        receiveShadow: true
    })
};





var $acw62 = parcelRequire("acw62");



const $aa89e90121715c1f$var$OmitFromCameraPhysicalContexts = [
    "Wall",
    "ComplexWall",
    "Player"
];
const $aa89e90121715c1f$var$CAMERA_OFFSET = {
    x: 0,
    y: 1,
    z: 4
};
const $aa89e90121715c1f$export$349657edfab55a7c = (pos1, pos2, threshold)=>{
    return Math.abs(pos1.x - pos2.x) < threshold && Math.abs(pos1.y - pos2.y) < threshold && Math.abs(pos1.z - pos2.z) < threshold;
};
const $aa89e90121715c1f$export$34b9163122ac5708 = (mesh)=>{
    const firstRunRef = (0, $acw62.useRef)(true);
    const getMeshGlobalPos = (0, $acw62.useCallback)(()=>mesh ? mesh.localToWorld(new (0, $d5b33d7c30034067$export$64b5c384219d3699)()) : new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), [
        mesh
    ]);
    const getNewCamPos = (0, $acw62.useCallback)(()=>getMeshGlobalPos().add(new (0, $d5b33d7c30034067$export$64b5c384219d3699)($aa89e90121715c1f$var$CAMERA_OFFSET.x, $aa89e90121715c1f$var$CAMERA_OFFSET.y, $aa89e90121715c1f$var$CAMERA_OFFSET.z)), [
        getMeshGlobalPos
    ]);
    const getTargetPoint = (0, $acw62.useCallback)((scene, camera)=>{
        const newCamPos = getNewCamPos();
        const intersects = (0, $df5511caa798bf3c$export$70d0edda063eb6f1)(newCamPos, camera.position.clone().sub(newCamPos).normalize(), newCamPos.distanceTo(camera.position), scene, (0, $0e664bfb31b87942$export$8b80c61aef5ca6bc), $aa89e90121715c1f$var$OmitFromCameraPhysicalContexts);
        return intersects ? camera.position : newCamPos;
    }, [
        getNewCamPos
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(({ scene: scene, camera: camera })=>{
        if (!(0, $384d310ca6ecee7b$export$54e64dc378dd5aa7) && mesh && camera) {
            const lookPos = getMeshGlobalPos();
            const targetPoint = getTargetPoint(scene, camera);
            if (firstRunRef.current) {
                firstRunRef.current = false;
                camera.position.copy(targetPoint);
            }
            camera.position.lerp(targetPoint, 0.1);
            lookPos.x = camera.position.x;
            camera.lookAt(lookPos);
        }
    });
};


const $46932ee2adc0f6b4$export$93cf95840b212592 = {
    Trigger: true
};
const $46932ee2adc0f6b4$export$4d231ecdcb35adcf = (contexts = [])=>contexts.some((context)=>$46932ee2adc0f6b4$export$93cf95840b212592[context]);
const $46932ee2adc0f6b4$export$43e2bca376c3715b = {
    Water: (0, $ab8157bd0b666433$export$bb9b22c781832226),
    SpriteAnimate: (0, $851471185954fd4b$export$dfb26d340ce3defd),
    Trigger: (0, $81084463f2dcbd90$export$3b196fe93a948c18),
    CameraFollow: (0, $aa89e90121715c1f$export$34b9163122ac5708)
};
const $46932ee2adc0f6b4$export$df22b5bb0d78d37e = ({ mesh: mesh, context: context, userData: userData = {} })=>{
    const hook = $46932ee2adc0f6b4$export$43e2bca376c3715b[context];
    (0, $2c877e781b5b9064$export$65c64f7642dbc45c)(mesh, userData, (0, $2828293783204cab$export$c27eec34524c7ea5));
    (0, $2c877e781b5b9064$export$65c64f7642dbc45c)(mesh, userData, (0, $249605d1a517624a$export$357629edf815a302));
    if (hook) return hook(mesh, userData) ?? undefined;
    return undefined;
};







var $acw62 = parcelRequire("acw62");
const $0b412e8a2b43afde$export$576380cfa99ddf20 = /*#__PURE__*/ (0, $acw62.createContext)({
    setSkyColor: ()=>{}
});
const { Provider: $0b412e8a2b43afde$export$3d3ea0c52f2f6877, Consumer: $0b412e8a2b43afde$export$a67786fd37de28 } = $0b412e8a2b43afde$export$576380cfa99ddf20;
const $0b412e8a2b43afde$export$a79b0edf9a7e6bdf = ()=>(0, $acw62.useContext)($0b412e8a2b43afde$export$576380cfa99ddf20);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


// Distance thresholds for LOD levels (in world units)
const $ed50349dfca6b9d6$var$LOD_DISTANCES = {
    HIGH: (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.HIGH_DETAIL_DISTANCE,
    MEDIUM: (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.MEDIUM_DETAIL_DISTANCE,
    LOW: (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.LOW_DETAIL_DISTANCE
};
const $ed50349dfca6b9d6$export$b6984af846eefa98 = (object)=>{
    const [lodLevel, setLodLevel] = (0, $acw62.useState)("HIGH");
    const objectPosition = (0, $acw62.useRef)(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
    const cameraPosition = (0, $acw62.useRef)(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
    // This hook must be used within a component that is a child of the Canvas component
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(({ camera: camera })=>{
        if (!object) return;
        // Get positions
        object.getWorldPosition(objectPosition.current);
        camera.getWorldPosition(cameraPosition.current);
        // Calculate distance
        const distance = objectPosition.current.distanceTo(cameraPosition.current);
        // Determine LOD level based on distance
        let newLodLevel;
        if (distance <= $ed50349dfca6b9d6$var$LOD_DISTANCES.HIGH) newLodLevel = "HIGH";
        else if (distance <= $ed50349dfca6b9d6$var$LOD_DISTANCES.MEDIUM) newLodLevel = "MEDIUM";
        else newLodLevel = "LOW";
        // Update LOD level if changed
        if (newLodLevel !== lodLevel) setLodLevel(newLodLevel);
    });
    return lodLevel;
}; // Shadow quality functions have been moved to AdaptiveShadows.tsx




const $789b3d31284a8713$export$2dfe14e707eb1db1 = ({ children: children, highDetailDistance: highDetailDistance = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.HIGH_DETAIL_DISTANCE, mediumDetailDistance: mediumDetailDistance = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.MEDIUM_DETAIL_DISTANCE, lowDetailDistance: lowDetailDistance = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOD.LOW_DETAIL_DISTANCE })=>{
    const groupRef = (0, $acw62.useRef)(null);
    const lodLevel = (0, $ed50349dfca6b9d6$export$b6984af846eefa98)(groupRef.current);
    // Apply optimizations based on LOD level
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (!groupRef.current) return;
        lodLevel;
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("group", {
        ref: groupRef,
        children: children
    });
};
const $789b3d31284a8713$export$2db42b935c6ba13f = ({ children: children, minLevel: minLevel, object: object })=>{
    const lodLevel = (0, $ed50349dfca6b9d6$export$b6984af846eefa98)(object);
    // Determine if this component should render based on LOD level
    const shouldRender = ()=>{
        switch(minLevel){
            case "HIGH":
                return lodLevel === "HIGH";
            case "MEDIUM":
                return lodLevel === "HIGH" || lodLevel === "MEDIUM";
            case "LOW":
                return true; // Render for all LOD levels
            default:
                return true;
        }
    };
    return shouldRender() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    }) : null;
};


const $41f9b4bbfd047b62$var$fourPartArrayToColor = (floatVector)=>{
    if (floatVector.length !== 4) throw new Error("Input array must have 4 components (RGBA).");
    const [r, g, b, a] = floatVector;
    const rHex = Math.floor(r * 255).toString(16).padStart(2, "0");
    const gHex = Math.floor(g * 255).toString(16).padStart(2, "0");
    const bHex = Math.floor(b * 255).toString(16).padStart(2, "0");
    const aHex = Math.floor(a * 255).toString(16).padStart(2, "0");
    return `#${rHex}${gHex}${bHex}${aHex}`;
};
const $41f9b4bbfd047b62$var$lightblueRGBA = [
    173 / 255,
    216 / 255,
    230 / 255,
    1
];
const $41f9b4bbfd047b62$var$AnimationPlayer = ()=>{
    const { allAnimations: allAnimations, playAnimations: playAnimations, stopAnimations: stopAnimations } = (0, $0393cee1d7fa146f$export$873b338c6218bf9)();
    (0, $acw62.useEffect)(()=>{
        playAnimations(allAnimations);
        return ()=>stopAnimations(allAnimations);
    }, [
        allAnimations,
        playAnimations,
        stopAnimations
    ]);
    return undefined;
};
const $41f9b4bbfd047b62$export$c7a07f1e5b939dfd = ({ url: url = "" })=>{
    const gltfModel = (0, $b13bb2a707c13142$export$cf1b4e938a4da41b)(url);
    // @ts-ignore
    const { nodes: nodes, scene: scene } = gltfModel;
    const nodeArray = (0, $acw62.useMemo)(()=>Object.values(nodes), [
        nodes
    ]);
    const { setSkyColor: setSkyColor } = (0, $0b412e8a2b43afde$export$a79b0edf9a7e6bdf)();
    (0, $acw62.useEffect)(()=>{
        const { SkyColor: skyColorFourPartArray = $41f9b4bbfd047b62$var$lightblueRGBA } = (0, $2c877e781b5b9064$export$8eb0f5047dddd661)(scene.userData, "Scene");
        const skyColor = $41f9b4bbfd047b62$var$fourPartArrayToColor(skyColorFourPartArray);
        setSkyColor(skyColor);
    }, [
        scene,
        setSkyColor
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8bef202b4105b6b$export$34b38cfc8c70dfc1), {
            value: gltfModel,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0393cee1d7fa146f$export$d4061152ec97e209), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41f9b4bbfd047b62$var$AnimationPlayer, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $789b3d31284a8713$export$2dfe14e707eb1db1), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("primitive", {
                                object: scene
                            }),
                            nodeArray.map((node, index)=>{
                                const { userData: userData = {} } = node || {};
                                const meshContextList = Object.keys(userData[(0, $2c877e781b5b9064$export$c7254adac00646f7)()] || {});
                                const interactionContextProps = (0, $2c877e781b5b9064$export$65c64f7642dbc45c)({}, userData, (0, $f7f1615d6a8d2220$export$47dc4bab70e3751e));
                                const { collisionShape: collisionShape } = interactionContextProps;
                                const useCollision = !!collisionShape && !(0, $46932ee2adc0f6b4$export$4d231ecdcb35adcf)(meshContextList);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        useCollision ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e557c93a5ae5d0a3$export$9bd87b94842242b3), {
                                            collisionShape: collisionShape,
                                            ...interactionContextProps,
                                            meshNode: node
                                        }) : undefined,
                                        meshContextList.map((mc, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46932ee2adc0f6b4$export$df22b5bb0d78d37e), {
                                                mesh: node,
                                                context: mc,
                                                userData: userData
                                            }, `${mc}:${i}`))
                                    ]
                                }, index);
                            })
                        ]
                    })
                ]
            })
        })
    });
};



function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}




var $acw62 = parcelRequire("acw62");

var $c0da5b136d37bb68$var$__defProp = Object.defineProperty;
var $c0da5b136d37bb68$var$__defNormalProp = (obj, key, value)=>key in obj ? $c0da5b136d37bb68$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c0da5b136d37bb68$var$__publicField = (obj, key, value)=>{
    $c0da5b136d37bb68$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $c0da5b136d37bb68$var$moduloWrapAround = (offset, capacity)=>(offset % capacity + capacity) % capacity;
class $c0da5b136d37bb68$export$8ff7788029dfdf52 extends (0, $d5b33d7c30034067$export$ec8b666c5fe2c75a) {
    constructor(object, domElement){
        super();
        $c0da5b136d37bb68$var$__publicField(this, "object");
        $c0da5b136d37bb68$var$__publicField(this, "domElement");
        // Set to false to disable this control
        $c0da5b136d37bb68$var$__publicField(this, "enabled", true);
        // "target" sets the location of focus, where the object orbits around
        $c0da5b136d37bb68$var$__publicField(this, "target", new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
        // How far you can dolly in and out ( PerspectiveCamera only )
        $c0da5b136d37bb68$var$__publicField(this, "minDistance", 0);
        $c0da5b136d37bb68$var$__publicField(this, "maxDistance", Infinity);
        // How far you can zoom in and out ( OrthographicCamera only )
        $c0da5b136d37bb68$var$__publicField(this, "minZoom", 0);
        $c0da5b136d37bb68$var$__publicField(this, "maxZoom", Infinity);
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        $c0da5b136d37bb68$var$__publicField(this, "minPolarAngle", 0);
        // radians
        $c0da5b136d37bb68$var$__publicField(this, "maxPolarAngle", Math.PI);
        // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        $c0da5b136d37bb68$var$__publicField(this, "minAzimuthAngle", -Infinity);
        // radians
        $c0da5b136d37bb68$var$__publicField(this, "maxAzimuthAngle", Infinity);
        // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        $c0da5b136d37bb68$var$__publicField(this, "enableDamping", false);
        $c0da5b136d37bb68$var$__publicField(this, "dampingFactor", 0.05);
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        $c0da5b136d37bb68$var$__publicField(this, "enableZoom", true);
        $c0da5b136d37bb68$var$__publicField(this, "zoomSpeed", 1);
        // Set to false to disable rotating
        $c0da5b136d37bb68$var$__publicField(this, "enableRotate", true);
        $c0da5b136d37bb68$var$__publicField(this, "rotateSpeed", 1);
        // Set to false to disable panning
        $c0da5b136d37bb68$var$__publicField(this, "enablePan", true);
        $c0da5b136d37bb68$var$__publicField(this, "panSpeed", 1);
        $c0da5b136d37bb68$var$__publicField(this, "screenSpacePanning", true);
        // if false, pan orthogonal to world-space direction camera.up
        $c0da5b136d37bb68$var$__publicField(this, "keyPanSpeed", 7);
        // pixels moved per arrow key push
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        $c0da5b136d37bb68$var$__publicField(this, "autoRotate", false);
        $c0da5b136d37bb68$var$__publicField(this, "autoRotateSpeed", 2);
        // 30 seconds per orbit when fps is 60
        $c0da5b136d37bb68$var$__publicField(this, "reverseOrbit", false);
        // true if you want to reverse the orbit to mouse drag from left to right = orbits left
        // The four arrow keys
        $c0da5b136d37bb68$var$__publicField(this, "keys", {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        });
        // Mouse buttons
        $c0da5b136d37bb68$var$__publicField(this, "mouseButtons", {
            LEFT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN
        });
        // Touch fingers
        $c0da5b136d37bb68$var$__publicField(this, "touches", {
            ONE: (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_PAN
        });
        $c0da5b136d37bb68$var$__publicField(this, "target0");
        $c0da5b136d37bb68$var$__publicField(this, "position0");
        $c0da5b136d37bb68$var$__publicField(this, "zoom0");
        // the target DOM element for key events
        $c0da5b136d37bb68$var$__publicField(this, "_domElementKeyEvents", null);
        $c0da5b136d37bb68$var$__publicField(this, "getPolarAngle");
        $c0da5b136d37bb68$var$__publicField(this, "getAzimuthalAngle");
        $c0da5b136d37bb68$var$__publicField(this, "setPolarAngle");
        $c0da5b136d37bb68$var$__publicField(this, "setAzimuthalAngle");
        $c0da5b136d37bb68$var$__publicField(this, "getDistance");
        $c0da5b136d37bb68$var$__publicField(this, "listenToKeyEvents");
        $c0da5b136d37bb68$var$__publicField(this, "saveState");
        $c0da5b136d37bb68$var$__publicField(this, "reset");
        $c0da5b136d37bb68$var$__publicField(this, "update");
        $c0da5b136d37bb68$var$__publicField(this, "connect");
        $c0da5b136d37bb68$var$__publicField(this, "dispose");
        this.object = object;
        this.domElement = domElement;
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        this.getPolarAngle = ()=>spherical.phi;
        this.getAzimuthalAngle = ()=>spherical.theta;
        this.setPolarAngle = (value)=>{
            let phi = $c0da5b136d37bb68$var$moduloWrapAround(value, 2 * Math.PI);
            let currentPhi = spherical.phi;
            if (currentPhi < 0) currentPhi += 2 * Math.PI;
            if (phi < 0) phi += 2 * Math.PI;
            let phiDist = Math.abs(phi - currentPhi);
            if (2 * Math.PI - phiDist < phiDist) {
                if (phi < currentPhi) phi += 2 * Math.PI;
                else currentPhi += 2 * Math.PI;
            }
            sphericalDelta.phi = phi - currentPhi;
            scope.update();
        };
        this.setAzimuthalAngle = (value)=>{
            let theta = $c0da5b136d37bb68$var$moduloWrapAround(value, 2 * Math.PI);
            let currentTheta = spherical.theta;
            if (currentTheta < 0) currentTheta += 2 * Math.PI;
            if (theta < 0) theta += 2 * Math.PI;
            let thetaDist = Math.abs(theta - currentTheta);
            if (2 * Math.PI - thetaDist < thetaDist) {
                if (theta < currentTheta) theta += 2 * Math.PI;
                else currentTheta += 2 * Math.PI;
            }
            sphericalDelta.theta = theta - currentTheta;
            scope.update();
        };
        this.getDistance = ()=>scope.object.position.distanceTo(scope.target);
        this.listenToKeyEvents = (domElement2)=>{
            domElement2.addEventListener("keydown", onKeyDown);
            this._domElementKeyEvents = domElement2;
        };
        this.saveState = ()=>{
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;
        };
        this.reset = ()=>{
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent(changeEvent);
            scope.update();
            state = STATE.NONE;
        };
        this.update = (()=>{
            const offset = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
            const quat = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $d5b33d7c30034067$export$64b5c384219d3699)(0, 1, 0));
            const quatInverse = quat.clone().invert();
            const lastPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
            const lastQuaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
            const twoPI = 2 * Math.PI;
            return function update() {
                const position = scope.object.position;
                offset.copy(position).sub(scope.target);
                offset.applyQuaternion(quat);
                spherical.setFromVector3(offset);
                if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                }
                let min = scope.minAzimuthAngle;
                let max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                    else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
                }
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
                spherical.makeSafe();
                spherical.radius *= scale;
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offset.setFromSpherical(spherical);
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                scope.object.lookAt(scope.target);
                if (scope.enableDamping === true) {
                    sphericalDelta.theta *= 1 - scope.dampingFactor;
                    sphericalDelta.phi *= 1 - scope.dampingFactor;
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                } else {
                    sphericalDelta.set(0, 0, 0);
                    panOffset.set(0, 0, 0);
                }
                scale = 1;
                if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    scope.dispatchEvent(changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        })();
        this.connect = (domElement2)=>{
            if (domElement2 === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
            scope.domElement = domElement2;
            scope.domElement.style.touchAction = "none";
            scope.domElement.addEventListener("contextmenu", onContextMenu);
            scope.domElement.addEventListener("pointerdown", onPointerDown);
            scope.domElement.addEventListener("pointercancel", onPointerCancel);
            scope.domElement.addEventListener("wheel", onMouseWheel);
        };
        this.dispose = ()=>{
            var _a, _b, _c, _d, _e, _f;
            (_a = scope.domElement) == null || _a.removeEventListener("contextmenu", onContextMenu);
            (_b = scope.domElement) == null || _b.removeEventListener("pointerdown", onPointerDown);
            (_c = scope.domElement) == null || _c.removeEventListener("pointercancel", onPointerCancel);
            (_d = scope.domElement) == null || _d.removeEventListener("wheel", onMouseWheel);
            (_e = scope.domElement) == null || _e.ownerDocument.removeEventListener("pointermove", onPointerMove);
            (_f = scope.domElement) == null || _f.ownerDocument.removeEventListener("pointerup", onPointerUp);
            if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
        };
        const scope = this;
        const changeEvent = {
            type: "change"
        };
        const startEvent = {
            type: "start"
        };
        const endEvent = {
            type: "end"
        };
        const STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        let state = STATE.NONE;
        const EPS = 1e-6;
        const spherical = new (0, $d5b33d7c30034067$export$d712cd887b4a00f7)();
        const sphericalDelta = new (0, $d5b33d7c30034067$export$d712cd887b4a00f7)();
        let scale = 1;
        const panOffset = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        let zoomChanged = false;
        const rotateStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const rotateEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const rotateDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const panStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const panEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const panDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const dollyStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const dollyEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const dollyDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        const pointers = [];
        const pointerPositions = {};
        function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        }
        function getZoomScale() {
            return Math.pow(0.95, scope.zoomSpeed);
        }
        function rotateLeft(angle) {
            if (scope.reverseOrbit) sphericalDelta.theta += angle;
            else sphericalDelta.theta -= angle;
        }
        function rotateUp(angle) {
            if (scope.reverseOrbit) sphericalDelta.phi += angle;
            else sphericalDelta.phi -= angle;
        }
        const panLeft = (()=>{
            const v = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
            return function panLeft2(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0);
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        })();
        const panUp = (()=>{
            const v = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
            return function panUp2(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        })();
        const pan = (()=>{
            const offset = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
            return function pan2(deltaX, deltaY) {
                const element = scope.domElement;
                if (element && scope.object instanceof (0, $d5b33d7c30034067$export$74e4ae24825f68d7) && scope.object.isPerspectiveCamera) {
                    const position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();
                    targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180);
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
                } else if (element && scope.object instanceof (0, $d5b33d7c30034067$export$9ebf355ee4ed261b) && scope.object.isOrthographicCamera) {
                    panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
                } else {
                    console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
                    scope.enablePan = false;
                }
            };
        })();
        function dollyOut(dollyScale) {
            if (scope.object instanceof (0, $d5b33d7c30034067$export$74e4ae24825f68d7) && scope.object.isPerspectiveCamera) scale /= dollyScale;
            else if (scope.object instanceof (0, $d5b33d7c30034067$export$9ebf355ee4ed261b) && scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        function dollyIn(dollyScale) {
            if (scope.object instanceof (0, $d5b33d7c30034067$export$74e4ae24825f68d7) && scope.object.isPerspectiveCamera) scale *= dollyScale;
            else if (scope.object instanceof (0, $d5b33d7c30034067$export$9ebf355ee4ed261b) && scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        function handleMouseDownRotate(event) {
            rotateStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        }
        function handleMouseMoveRotate(event) {
            rotateEnd.set(event.clientX, event.clientY);
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            if (element) {
                rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight);
                rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            }
            rotateStart.copy(rotateEnd);
            scope.update();
        }
        function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        }
        function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        }
        function handleMouseWheel(event) {
            if (event.deltaY < 0) dollyIn(getZoomScale());
            else if (event.deltaY > 0) dollyOut(getZoomScale());
            scope.update();
        }
        function handleKeyDown(event) {
            let needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                event.preventDefault();
                scope.update();
            }
        }
        function handleTouchStartRotate() {
            if (pointers.length == 1) rotateStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                rotateStart.set(x, y);
            }
        }
        function handleTouchStartPan() {
            if (pointers.length == 1) panStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                panStart.set(x, y);
            }
        }
        function handleTouchStartDolly() {
            const dx = pointers[0].pageX - pointers[1].pageX;
            const dy = pointers[0].pageY - pointers[1].pageY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        }
        function handleTouchStartDollyPan() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enablePan) handleTouchStartPan();
        }
        function handleTouchStartDollyRotate() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enableRotate) handleTouchStartRotate();
        }
        function handleTouchMoveRotate(event) {
            if (pointers.length == 1) rotateEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                rotateEnd.set(x, y);
            }
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            if (element) {
                rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight);
                rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            }
            rotateStart.copy(rotateEnd);
        }
        function handleTouchMovePan(event) {
            if (pointers.length == 1) panEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        }
        function handleTouchMoveDolly(event) {
            const position = getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            dollyOut(dollyDelta.y);
            dollyStart.copy(dollyEnd);
        }
        function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        }
        function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        }
        function onPointerDown(event) {
            var _a, _b;
            if (scope.enabled === false) return;
            if (pointers.length === 0) {
                (_a = scope.domElement) == null || _a.ownerDocument.addEventListener("pointermove", onPointerMove);
                (_b = scope.domElement) == null || _b.ownerDocument.addEventListener("pointerup", onPointerUp);
            }
            addPointer(event);
            if (event.pointerType === "touch") onTouchStart(event);
            else onMouseDown(event);
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === "touch") onTouchMove(event);
            else onMouseMove(event);
        }
        function onPointerUp(event) {
            var _a, _b, _c;
            removePointer(event);
            if (pointers.length === 0) {
                (_a = scope.domElement) == null || _a.releasePointerCapture(event.pointerId);
                (_b = scope.domElement) == null || _b.ownerDocument.removeEventListener("pointermove", onPointerMove);
                (_c = scope.domElement) == null || _c.ownerDocument.removeEventListener("pointerup", onPointerUp);
            }
            scope.dispatchEvent(endEvent);
            state = STATE.NONE;
        }
        function onPointerCancel(event) {
            removePointer(event);
        }
        function onMouseDown(event) {
            let mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    state = STATE.DOLLY;
                    break;
                case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    }
                    break;
                case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent(startEvent);
        }
        function onMouseMove(event) {
            if (scope.enabled === false) return;
            switch(state){
                case STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        }
        function onMouseWheel(event) {
            if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE) return;
            event.preventDefault();
            scope.dispatchEvent(startEvent);
            handleMouseWheel(event);
            scope.dispatchEvent(endEvent);
        }
        function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        }
        function onTouchStart(event) {
            trackPointer(event);
            switch(pointers.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate();
                            state = STATE.TOUCH_ROTATE;
                            break;
                        case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan();
                            state = STATE.TOUCH_PAN;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan();
                            state = STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate();
                            state = STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent(startEvent);
        }
        function onTouchMove(event) {
            trackPointer(event);
            switch(state){
                case STATE.TOUCH_ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    state = STATE.NONE;
            }
        }
        function onContextMenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        }
        function addPointer(event) {
            pointers.push(event);
        }
        function removePointer(event) {
            delete pointerPositions[event.pointerId];
            for(let i = 0; i < pointers.length; i++)if (pointers[i].pointerId == event.pointerId) {
                pointers.splice(i, 1);
                return;
            }
        }
        function trackPointer(event) {
            let position = pointerPositions[event.pointerId];
            if (position === void 0) {
                position = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
                pointerPositions[event.pointerId] = position;
            }
            position.set(event.pageX, event.pageY);
        }
        function getSecondPointerPosition(event) {
            const pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
            return pointerPositions[pointer.pointerId];
        }
        if (domElement !== void 0) this.connect(domElement);
        this.update();
    }
}
class $c0da5b136d37bb68$export$7628ccdac312035f extends $c0da5b136d37bb68$export$8ff7788029dfdf52 {
    constructor(object, domElement){
        super(object, domElement);
        this.screenSpacePanning = false;
        this.mouseButtons.LEFT = (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN;
        this.mouseButtons.RIGHT = (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE;
        this.touches.ONE = (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).PAN;
        this.touches.TWO = (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_ROTATE;
    }
}


const $c89dc83b99beb843$export$7628ccdac312035f = /*#__PURE__*/ $acw62.forwardRef((props = {
    enableDamping: true
}, ref)=>{
    const { domElement: domElement, camera: camera, makeDefault: makeDefault, onChange: onChange, onStart: onStart, onEnd: onEnd, ...rest } = props;
    const invalidate = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.invalidate);
    const defaultCamera = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.camera);
    const gl = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.gl);
    const events = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.events);
    const set = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.set);
    const get = (0, $4157c7a4095bdc2b$export$df995fae86a55f06)((state)=>state.get);
    const explDomElement = domElement || events.connected || gl.domElement;
    const explCamera = camera || defaultCamera;
    const controls = $acw62.useMemo(()=>new (0, $c0da5b136d37bb68$export$7628ccdac312035f)(explCamera), [
        explCamera
    ]);
    $acw62.useEffect(()=>{
        controls.connect(explDomElement);
        const callback = (e)=>{
            invalidate();
            if (onChange) onChange(e);
        };
        controls.addEventListener("change", callback);
        if (onStart) controls.addEventListener("start", onStart);
        if (onEnd) controls.addEventListener("end", onEnd);
        return ()=>{
            controls.dispose();
            controls.removeEventListener("change", callback);
            if (onStart) controls.removeEventListener("start", onStart);
            if (onEnd) controls.removeEventListener("end", onEnd);
        };
    }, [
        onChange,
        onStart,
        onEnd,
        controls,
        invalidate,
        explDomElement
    ]);
    $acw62.useEffect(()=>{
        if (makeDefault) {
            const old = get().controls;
            set({
                controls: controls
            });
            return ()=>set({
                    controls: old
                });
        }
    }, [
        makeDefault,
        controls
    ]);
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>controls.update(), -1);
    return /*#__PURE__*/ $acw62.createElement("primitive", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        object: controls,
        enableDamping: true
    }, rest));
});






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $2b57139d557ea67a$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $2b57139d557ea67a$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$2b57139d557ea67a$var$debounce.debounce = $2b57139d557ea67a$var$debounce;
$2b57139d557ea67a$exports = $2b57139d557ea67a$var$debounce;


function $de3a6e46fb51cdce$export$2e2bcd8739ae039(_temp) {
    let { debounce: debounce, scroll: scroll, polyfill: polyfill, offsetSize: offsetSize } = _temp === void 0 ? {
        debounce: 0,
        scroll: false,
        offsetSize: false
    } : _temp;
    const ResizeObserver = polyfill || (typeof window === "undefined" ? class ResizeObserver {
    } : window.ResizeObserver);
    if (!ResizeObserver) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [bounds, set] = (0, $acw62.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }); // keep all state in a ref
    const state = (0, $acw62.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: bounds
    }); // set actual debounce values early, so effects know if they should react accordingly
    const scrollDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.scroll : null;
    const resizeDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.resize : null; // make sure to update state only as long as the component is truly mounted
    const mounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>void (mounted.current = false);
    }); // memoize handlers, so event-listeners know when they should update
    const [forceRefresh, resizeChange, scrollChange] = (0, $acw62.useMemo)(()=>{
        const callback = ()=>{
            if (!state.current.element) return;
            const { left: left, top: top, width: width, height: height, bottom: bottom, right: right, x: x, y: y } = state.current.element.getBoundingClientRect();
            const size = {
                left: left,
                top: top,
                width: width,
                height: height,
                bottom: bottom,
                right: right,
                x: x,
                y: y
            };
            if (state.current.element instanceof HTMLElement && offsetSize) {
                size.height = state.current.element.offsetHeight;
                size.width = state.current.element.offsetWidth;
            }
            Object.freeze(size);
            if (mounted.current && !$de3a6e46fb51cdce$var$areBoundsEqual(state.current.lastBounds, size)) set(state.current.lastBounds = size);
        };
        return [
            callback,
            resizeDebounce ? (0, (/*@__PURE__*/$parcel$interopDefault($2b57139d557ea67a$exports)))(callback, resizeDebounce) : callback,
            scrollDebounce ? (0, (/*@__PURE__*/$parcel$interopDefault($2b57139d557ea67a$exports)))(callback, scrollDebounce) : callback
        ];
    }, [
        set,
        offsetSize,
        scrollDebounce,
        resizeDebounce
    ]); // cleanup current scroll-listeners / observers
    function removeListeners() {
        if (state.current.scrollContainers) {
            state.current.scrollContainers.forEach((element)=>element.removeEventListener("scroll", scrollChange, true));
            state.current.scrollContainers = null;
        }
        if (state.current.resizeObserver) {
            state.current.resizeObserver.disconnect();
            state.current.resizeObserver = null;
        }
    } // add scroll-listeners / observers
    function addListeners() {
        if (!state.current.element) return;
        state.current.resizeObserver = new ResizeObserver(scrollChange);
        state.current.resizeObserver.observe(state.current.element);
        if (scroll && state.current.scrollContainers) state.current.scrollContainers.forEach((scrollContainer)=>scrollContainer.addEventListener("scroll", scrollChange, {
                capture: true,
                passive: true
            }));
    } // the ref we expose to the user
    const ref = (node)=>{
        if (!node || node === state.current.element) return;
        removeListeners();
        state.current.element = node;
        state.current.scrollContainers = $de3a6e46fb51cdce$var$findScrollContainers(node);
        addListeners();
    }; // add general event listeners
    $de3a6e46fb51cdce$var$useOnWindowScroll(scrollChange, Boolean(scroll));
    $de3a6e46fb51cdce$var$useOnWindowResize(resizeChange); // respond to changes that are relevant for the listeners
    (0, $acw62.useEffect)(()=>{
        removeListeners();
        addListeners();
    }, [
        scroll,
        scrollChange,
        resizeChange
    ]); // remove all listeners when the components unmounts
    (0, $acw62.useEffect)(()=>removeListeners, []);
    return [
        ref,
        bounds,
        forceRefresh
    ];
} // Adds native resize listener to window
function $de3a6e46fb51cdce$var$useOnWindowResize(onWindowResize) {
    (0, $acw62.useEffect)(()=>{
        const cb = onWindowResize;
        window.addEventListener("resize", cb);
        return ()=>void window.removeEventListener("resize", cb);
    }, [
        onWindowResize
    ]);
}
function $de3a6e46fb51cdce$var$useOnWindowScroll(onScroll, enabled) {
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            const cb = onScroll;
            window.addEventListener("scroll", cb, {
                capture: true,
                passive: true
            });
            return ()=>void window.removeEventListener("scroll", cb, true);
        }
    }, [
        onScroll,
        enabled
    ]);
} // Returns a list of scroll offsets
function $de3a6e46fb51cdce$var$findScrollContainers(element) {
    const result = [];
    if (!element || element === document.body) return result;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = window.getComputedStyle(element);
    if ([
        overflow,
        overflowX,
        overflowY
    ].some((prop)=>prop === "auto" || prop === "scroll")) result.push(element);
    return [
        ...result,
        ...$de3a6e46fb51cdce$var$findScrollContainers(element.parentElement)
    ];
} // Checks if element boundaries are equal
const $de3a6e46fb51cdce$var$keys = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
];
const $de3a6e46fb51cdce$var$areBoundsEqual = (a, b)=>$de3a6e46fb51cdce$var$keys.every((key)=>a[key] === b[key]);



var $acw62 = parcelRequire("acw62");
var $766f6a56a9206ba0$var$__defProp = Object.defineProperty;
var $766f6a56a9206ba0$var$__defProps = Object.defineProperties;
var $766f6a56a9206ba0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $766f6a56a9206ba0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $766f6a56a9206ba0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $766f6a56a9206ba0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $766f6a56a9206ba0$var$__defNormalProp = (obj, key, value)=>key in obj ? $766f6a56a9206ba0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $766f6a56a9206ba0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($766f6a56a9206ba0$var$__hasOwnProp.call(b, prop)) $766f6a56a9206ba0$var$__defNormalProp(a, prop, b[prop]);
    if ($766f6a56a9206ba0$var$__getOwnPropSymbols) {
        for (var prop of $766f6a56a9206ba0$var$__getOwnPropSymbols(b))if ($766f6a56a9206ba0$var$__propIsEnum.call(b, prop)) $766f6a56a9206ba0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $766f6a56a9206ba0$var$__spreadProps = (a, b)=>$766f6a56a9206ba0$var$__defProps(a, $766f6a56a9206ba0$var$__getOwnPropDescs(b));
function $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $766f6a56a9206ba0$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $766f6a56a9206ba0$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $766f6a56a9206ba0$var$FiberContext = $766f6a56a9206ba0$var$wrapContext($acw62.createContext(null));
class $766f6a56a9206ba0$export$5a20fcbfd44d38b7 extends $acw62.Component {
    render() {
        return /* @__PURE__ */ $acw62.createElement($766f6a56a9206ba0$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
const { ReactCurrentOwner: $766f6a56a9206ba0$var$ReactCurrentOwner, ReactCurrentDispatcher: $766f6a56a9206ba0$var$ReactCurrentDispatcher } = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
function $766f6a56a9206ba0$export$69c8591d5df5c7d6() {
    const root = $acw62.useContext($766f6a56a9206ba0$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $acw62.useId();
    const fiber = $acw62.useMemo(()=>{
        for (const maybeFiber of [
            $766f6a56a9206ba0$var$ReactCurrentOwner == null ? void 0 : $766f6a56a9206ba0$var$ReactCurrentOwner.current,
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $766f6a56a9206ba0$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $766f6a56a9206ba0$export$b537cf6ebaf7ff54() {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const root = $acw62.useMemo(()=>$766f6a56a9206ba0$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a;
            return ((_a = node.stateNode) == null ? void 0 : _a.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $766f6a56a9206ba0$export$aec415ac1d7388b6(type) {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const childRef = $acw62.useRef();
    $acw62.useLayoutEffect(()=>{
        var _a;
        childRef.current = (_a = $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $766f6a56a9206ba0$export$b57c9fdd1434988b(type) {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const parentRef = $acw62.useRef();
    $acw62.useLayoutEffect(()=>{
        var _a;
        parentRef.current = (_a = $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $766f6a56a9206ba0$export$8859381a76e56404() {
    var _a, _b;
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const [contextMap] = $acw62.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        const context = (_a = node.type) == null ? void 0 : _a._context;
        if (context && context !== $766f6a56a9206ba0$var$FiberContext && !contextMap.has(context)) contextMap.set(context, (_b = $766f6a56a9206ba0$var$ReactCurrentDispatcher == null ? void 0 : $766f6a56a9206ba0$var$ReactCurrentDispatcher.current) == null ? void 0 : _b.readContext($766f6a56a9206ba0$var$wrapContext(context)));
        node = node.return;
    }
    return contextMap;
}
function $766f6a56a9206ba0$export$39579d26c695d393() {
    const contextMap = $766f6a56a9206ba0$export$8859381a76e56404();
    return $acw62.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $acw62.createElement(Prev, null, /* @__PURE__ */ $acw62.createElement(context.Provider, $766f6a56a9206ba0$var$__spreadProps($766f6a56a9206ba0$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $acw62.createElement($766f6a56a9206ba0$export$5a20fcbfd44d38b7, $766f6a56a9206ba0$var$__spreadValues({}, props))), [
        contextMap
    ]);
}





parcelRequire("fO90s");

const $f24fded2ba3df096$var$DOM_EVENTS = {
    onClick: [
        "click",
        false
    ],
    onContextMenu: [
        "contextmenu",
        false
    ],
    onDoubleClick: [
        "dblclick",
        false
    ],
    onWheel: [
        "wheel",
        true
    ],
    onPointerDown: [
        "pointerdown",
        true
    ],
    onPointerUp: [
        "pointerup",
        true
    ],
    onPointerLeave: [
        "pointerleave",
        true
    ],
    onPointerMove: [
        "pointermove",
        true
    ],
    onPointerCancel: [
        "pointercancel",
        true
    ],
    onLostPointerCapture: [
        "lostpointercapture",
        true
    ]
};
/** Default R3F event manager for web */ function $f24fded2ba3df096$export$4bf9923669ad6c63(store) {
    const { handlePointer: handlePointer } = (0, $4157c7a4095bdc2b$export$db3b6bfb95261072)(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($f24fded2ba3df096$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events, internal: internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            var _events$handlers;
            const { set: set, events: events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event])=>{
                const [eventName, passive] = $f24fded2ba3df096$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            });
        },
        disconnect: ()=>{
            const { set: set, events: events } = store.getState();
            if (events.connected) {
                var _events$handlers2;
                Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event])=>{
                    if (events && events.connected instanceof HTMLElement) {
                        const [eventName] = $f24fded2ba3df096$var$DOM_EVENTS[name];
                        events.connected.removeEventListener(eventName, event);
                    }
                });
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}
const $f24fded2ba3df096$var$CanvasImpl = /*#__PURE__*/ $acw62.forwardRef(function Canvas({ children: children, fallback: fallback, resize: resize, style: style, gl: gl, events: events = $f24fded2ba3df096$export$4bf9923669ad6c63, eventSource: eventSource, eventPrefix: eventPrefix, shadows: shadows, linear: linear, flat: flat, legacy: legacy, orthographic: orthographic, frameloop: frameloop, dpr: dpr, performance: performance, raycaster: raycaster, camera: camera, onPointerMissed: onPointerMissed, onCreated: onCreated, ...props }, forwardedRef) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $acw62.useMemo(()=>(0, $4157c7a4095bdc2b$export$f1e1789686576879)($d5b33d7c30034067$exports), []);
    const Bridge = (0, $766f6a56a9206ba0$export$39579d26c695d393)();
    const [containerRef, containerRect] = (0, $de3a6e46fb51cdce$export$2e2bcd8739ae039)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $acw62.useRef(null);
    const divRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(forwardedRef, ()=>canvasRef.current);
    const handlePointerMissed = (0, $4157c7a4095bdc2b$export$3b14a55fb2447963)(onPointerMissed);
    const [block, setBlock] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $acw62.useRef(null);
    (0, $4157c7a4095bdc2b$export$407448d2b89b1813)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $4157c7a4095bdc2b$export$8b22cf2602fb60ce)(canvas);
            root.current.configure({
                gl: gl,
                events: events,
                shadows: shadows,
                linear: linear,
                flat: flat,
                legacy: legacy,
                orthographic: orthographic,
                frameloop: frameloop,
                dpr: dpr,
                performance: performance,
                raycaster: raycaster,
                camera: camera,
                size: containerRect,
                // Pass mutable reference to onPointerMissed so it's free to update
                onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                onCreated: (state)=>{
                    // Connect to event source
                    state.events.connect == null || state.events.connect(eventSource ? (0, $4157c7a4095bdc2b$export$23f2a1d2818174ef)(eventSource) ? eventSource.current : eventSource : divRef.current);
                    // Set up compute function
                    if (eventPrefix) state.setEvents({
                        compute: (event, state)=>{
                            const x = event[eventPrefix + "X"];
                            const y = event[eventPrefix + "Y"];
                            state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                            state.raycaster.setFromCamera(state.pointer, state.camera);
                        }
                    });
                    // Call onCreated callback
                    onCreated == null || onCreated(state);
                }
            });
            root.current.render(/*#__PURE__*/ $acw62.createElement(Bridge, null, /*#__PURE__*/ $acw62.createElement((0, $4157c7a4095bdc2b$export$a9c23c6ac3fc3eca), {
                set: setError
            }, /*#__PURE__*/ $acw62.createElement($acw62.Suspense, {
                fallback: /*#__PURE__*/ $acw62.createElement((0, $4157c7a4095bdc2b$export$ef35774e6d314e91), {
                    set: setBlock
                })
            }, children))));
        }
    });
    $acw62.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $4157c7a4095bdc2b$export$4368d992c4eafac0)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? "none" : "auto";
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: divRef,
        style: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: pointerEvents,
            ...style
        }
    }, props), /*#__PURE__*/ $acw62.createElement("div", {
        ref: containerRef,
        style: {
            width: "100%",
            height: "100%"
        }
    }, /*#__PURE__*/ $acw62.createElement("canvas", {
        ref: canvasRef,
        style: {
            display: "block"
        }
    }, fallback)));
});
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ const $f24fded2ba3df096$export$8d01c972ee8b14a9 = /*#__PURE__*/ $acw62.forwardRef(function CanvasWrapper(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $766f6a56a9206ba0$export$5a20fcbfd44d38b7), null, /*#__PURE__*/ $acw62.createElement($f24fded2ba3df096$var$CanvasImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    })));
});





var $acw62 = parcelRequire("acw62");


const $058269c418483026$export$f926f849f3ee7a2c = ({ targetFPS: targetFPS = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).TARGET_FPS, onShadowQualityChange: onShadowQualityChange })=>{
    const frameRates = (0, $acw62.useRef)([]);
    const lastFrameTime = (0, $acw62.useRef)(performance.now());
    const [currentQuality, setCurrentQuality] = (0, $acw62.useState)((0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.MEDIUM);
    // If auto-adjust is disabled, use fixed shadow quality based on performance mode
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!(0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).AUTO_ADJUST) {
            const quality = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOW_PERFORMANCE_MODE ? (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.LOW : (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.HIGH;
            setCurrentQuality(quality);
            onShadowQualityChange(quality);
        }
    }, [
        onShadowQualityChange
    ]);
    // Monitor frame rate and adjust shadow quality
    (0, $4157c7a4095bdc2b$export$ebd11618f299a286)(()=>{
        if (!(0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).AUTO_ADJUST) return;
        const now = performance.now();
        const deltaTime = now - lastFrameTime.current;
        lastFrameTime.current = now;
        // Calculate current FPS
        const currentFPS = 1000 / deltaTime;
        // Keep track of recent frame rates (last 30 frames)
        frameRates.current.push(currentFPS);
        if (frameRates.current.length > 30) frameRates.current.shift();
        // Calculate average FPS
        const avgFPS = frameRates.current.reduce((sum, fps)=>sum + fps, 0) / frameRates.current.length;
        // Adjust shadow quality based on performance
        let newQuality = currentQuality;
        if (avgFPS < targetFPS * 0.8) // If FPS is below 80% of target, reduce shadow quality
        newQuality = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.LOW;
        else if (avgFPS > targetFPS * 1.2) // If FPS is above 120% of target, increase shadow quality
        newQuality = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.HIGH;
        else // If FPS is within acceptable range, use medium quality
        newQuality = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.MEDIUM;
        // Update shadow quality if changed
        if (newQuality !== currentQuality) {
            setCurrentQuality(newQuality);
            onShadowQualityChange(newQuality);
        }
    });
    // This component doesn't render anything
    return null;
};
const $058269c418483026$export$dc66ed611e6303dd = (performanceMode = (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).LOW_PERFORMANCE_MODE)=>{
    if (performanceMode) return (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.LOW;
    return (0, $384d310ca6ecee7b$export$9dbc1188d4e128a5).SHADOWS.HIGH;
};


const { Perf: $14032a57e76cdb6d$var$Perf } = {};
const $14032a57e76cdb6d$var$SUN_POSITION = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(15, 25, 25);
const $14032a57e76cdb6d$export$985739bfa5723e08 = ()=>{
    const [skyColor, setSkyColor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("lightblue");
    const [shadowMapSize, setShadowMapSize] = (0, $acw62.useState)((0, $058269c418483026$export$dc66ed611e6303dd)());
    const sceneContext = (0, $acw62.useMemo)(()=>({
            setSkyColor: setSkyColor
        }), [
        setSkyColor
    ]);
    const { levelUrl: levelUrl } = (0, $eb94f9a7e3c6143e$export$4840719527ba78ad)();
    const onCanvasClick = (0, $acw62.useCallback)(({ currentTarget: currentTarget })=>{
        if (!(0, $384d310ca6ecee7b$export$54e64dc378dd5aa7)) {
            currentTarget.requestPointerLock();
            if (currentTarget.requestFullscreen) currentTarget.requestFullscreen().then(()=>undefined);
        }
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b412e8a2b43afde$export$3d3ea0c52f2f6877), {
        value: sceneContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f24fded2ba3df096$export$8d01c972ee8b14a9), {
            camera: {
                position: [
                    0,
                    1,
                    3
                ],
                rotation: [
                    0.05,
                    0,
                    0
                ],
                fov: 80,
                near: 0.01,
                far: 1000
            },
            shadows: "soft",
            onClick: onCanvasClick,
            style: {
                backgroundColor: skyColor
            },
            gl: {
                antialias: true,
                powerPreference: "high-performance",
                alpha: false,
                stencil: false
            },
            dpr: [
                1,
                2
            ],
            performance: {
                min: 0.5
            },
            children: [
                (0, $384d310ca6ecee7b$export$54e64dc378dd5aa7) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c89dc83b99beb843$export$7628ccdac312035f), {}) : undefined,
                (0, $384d310ca6ecee7b$export$d8bb41b5127a40dd) && $14032a57e76cdb6d$var$Perf ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($14032a57e76cdb6d$var$Perf, {}) : undefined,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $058269c418483026$export$f926f849f3ee7a2c), {
                    targetFPS: 60,
                    onShadowQualityChange: setShadowMapSize
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ambientLight", {
                    intensity: 0.25
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("directionalLight", {
                    intensity: 1,
                    position: $14032a57e76cdb6d$var$SUN_POSITION,
                    castShadow: true,
                    "shadow-camera-near": 0.1,
                    "shadow-camera-far": 1000,
                    "shadow-camera-left": -100,
                    "shadow-camera-right": 100,
                    "shadow-camera-top": 100,
                    "shadow-camera-bottom": -100,
                    "shadow-bias": -0.00009999,
                    "shadow-mapSize": shadowMapSize,
                    "shadow-radius": 3
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$2f09efa5b67124a7), {
                    debug: (0, $384d310ca6ecee7b$export$c338f1d796ca0b28),
                    gravity: [
                        0,
                        -19.6,
                        0
                    ],
                    erp: 0.8,
                    updateLoop: "independent",
                    timeStep: 1 / 60,
                    maxStabilizationIterations: 4,
                    maxVelocityIterations: 8,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41f9b4bbfd047b62$export$c7a07f1e5b939dfd), {
                        url: levelUrl
                    }, levelUrl)
                })
            ]
        })
    });
};


const $cd93687958c8007e$var$BASE_FOLDER_URL = "./src/Game/3d-object-files";
const $cd93687958c8007e$var$GlobalStyle = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`
  html,
  body,
  #react-root {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
`;
const $cd93687958c8007e$export$86fbec116b87613f = ()=>{
    const levelParameter = new URLSearchParams(window.location.search).get("level");
    const initialLevelUrl = levelParameter ? (0, $dd039c9abdc1873f$export$c5d2402d2daf99c7)(levelParameter, $cd93687958c8007e$var$BASE_FOLDER_URL) || (0, (/*@__PURE__*/$parcel$interopDefault($aa28a38f21e9dc60$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($aa28a38f21e9dc60$exports)));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$GlobalStyle, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb94f9a7e3c6143e$export$fcf2368bd3dde5ab), {
                baseFolderUrl: $cd93687958c8007e$var$BASE_FOLDER_URL,
                initialLevelUrl: initialLevelUrl,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14032a57e76cdb6d$export$985739bfa5723e08), {})
            })
        ]
    });
};


const $70fc9a727fa662ae$var$reactRoot = document.getElementById("react-root");
if ($70fc9a727fa662ae$var$reactRoot) (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$reactRoot).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.d9eabdc8.js.map
